const lcMsUvvisChemstationJcamp = `

$$ === CHEMSPECTRA UVVIS PEAK TABLE ===
##TITLE=618becfe-a0ce-4983-ba36-5fdcbb7ed595
##JCAMP-DX=5.00
##DATA TYPE=LC/MS
##DATA CLASS=PEAK TABLE
##SYMBOL=X, Y
##ORIGIN=
##OWNER=
##XUNITS=RETENTION TIME
##YUNITS=DETECTOR SIGNAL
##UNITS=, MINUTES, ARBITRARY UNITS
##$CSCATEGORY=UVVIS PEAK TABLE
##PAGE=230
##NPOINTS=3001
##DATA TABLE= (XY..XY), PEAKS
-0.0435, -4374704305.0;
-0.03683333333333333, -4479966680.0;
-0.03016666666666666, -4505229650.0;
-0.023499999999999997, -3907339360.0;
-0.01683333333333333, -3482079365.0;
-0.010166666666666664, -3195765705.0;
-0.003499999999999996, -3309449070.0;
0.003166666666666672, -3498921345.0;
0.00983333333333334, -3389448475.0;
0.016500000000000008, -3667341145.0;
0.02316666666666667, -3886286885.0;
0.029833333333333337, -3915760350.0;
0.036500000000000005, -3553657780.0;
0.04316666666666667, -3347343525.0;
0.04983333333333334, -3461026890.0;
0.05650000000000001, -4273652425.0;
0.06316666666666668, -4892595190.0;
0.06983333333333334, -4648386480.0;
0.07650000000000001, -3625236195.0;
0.08316666666666668, -2888399570.0;
0.08983333333333333, -2863136600.0;
0.09650000000000002, -2938925510.0;
0.10316666666666667, -3178923725.0;
0.10983333333333335, -3663130650.0;
0.1165, -4383125295.0;
0.12316666666666669, -4543124105.0;
0.12983333333333336, -4147337575.0;
0.1365, -3056819370.0;
0.14316666666666666, -1675777010.0;
0.14983333333333337, -581048310.0;
0.15650000000000003, 67367920.0;
0.16316666666666668, 298945145.0;
0.16983333333333334, 593679795.0;
0.1765, 610521775.0;
0.1831666666666667, 513680390.0;
0.18983333333333335, 239998215.0;
0.1965, 214735245.0;
0.20316666666666666, -172630295.0;
0.20983333333333337, -871572465.0;
0.21650000000000003, -1629461565.0;
0.22316666666666668, -2223141360.0;
0.2298333333333334, -2172615420.0;
0.23650000000000004, -2399982150.0;
0.2431666666666667, -2408403140.0;
0.24983333333333335, -2319982745.0;
0.25650000000000006, -1903143740.0;
0.2631666666666667, -1827354830.0;
0.26983333333333337, -2025248095.0;
0.2765, -1793670870.0;
0.2831666666666667, -989466325.0;
0.2898333333333334, -168419800.0;
0.29650000000000004, 324208115.0;
0.3031666666666667, 597890290.0;
0.30983333333333335, 669468705.0;
0.31650000000000006, 134735840.0;
0.3231666666666667, -1246306520.0;
0.32983333333333337, -2766295215.0;
0.3365, -3692604115.0;
0.34316666666666673, -3461026890.0;
0.3498333333333334, -3023135410.0;
0.35650000000000004, -2715769275.0;
0.3631666666666667, -2126299975.0;
0.3698333333333334, -1237885530.0;
0.37650000000000006, -526311875.0;
0.3831666666666667, -922098405.0;
0.38983333333333337, -1612619585.0;
0.3965, -1625251070.0;
0.40316666666666673, -955782365.0;
0.4098333333333334, -383155045.0;
0.41650000000000004, -383155045.0;
0.4231666666666667, -416839005.0;
0.4298333333333334, -172630295.0;
0.43650000000000005, -155788315.0;
0.4431666666666667, -235787720.0;
0.44983333333333336, -143156830.0;
0.4565, 193682770.0;
0.4631666666666667, 328418610.0;
0.46983333333333344, 122104355.0;
0.47650000000000003, 101051880.0;
0.48316666666666674, -442101975.0;
0.48983333333333334, -1448410280.0;
0.49650000000000005, -2724190265.0;
0.5031666666666668, -3406290455.0;
0.5098333333333334, -3267344120.0;
0.5165000000000001, -3162081745.0;
0.5231666666666667, -2850505115.0;
0.5298333333333334, -2446297595.0;
0.5365000000000001, -1755776415.0;
0.5431666666666667, -1650514040.0;
0.5498333333333334, -2597875415.0;
0.5565000000000001, -3355764515.0;
0.5631666666666667, -3494710850.0;
0.5698333333333334, -2947346500.0;
0.5765, -2732611255.0;
0.5831666666666667, -2703137790.0;
0.5898333333333334, -2433666110.0;
0.5965, -2218930865.0;
0.6031666666666667, -2079984530.0;
0.6098333333333333, -2458929080.0;
0.6165, -2922083530.0;
0.6231666666666668, -3292607090.0;
0.6298333333333334, -3035766895.0;
0.6365000000000001, -3132608280.0;
0.6431666666666668, -3469447880.0;
0.6498333333333334, -3835760945.0;
0.6565000000000001, -3785235005.0;
0.6631666666666667, -3414711445.0;
0.6698333333333334, -3932602330.0;
0.6765000000000001, -4433651235.0;
0.6831666666666667, -5174698355.0;
0.6898333333333334, -5507327460.0;
0.6965000000000001, -5789430625.0;
0.7031666666666667, -5932587455.0;
0.7098333333333334, -5835746070.0;
0.7165, -5705220725.0;
0.7231666666666667, -5759957160.0;
0.7298333333333334, -6029428840.0;
0.7365, -5919955970.0;
0.7431666666666668, -5612589835.0;
0.7498333333333334, -5056804495.0;
0.7565000000000001, -4652596975.0;
0.7631666666666668, -4332599355.0;
0.7698333333333334, -4530492620.0;
0.7765000000000001, -5612589835.0;
0.7831666666666668, -6884159325.0;
0.7898333333333334, -7873625650.0;
0.7965000000000001, -8399937525.0;
0.8031666666666667, -8610462275.0;
0.8098333333333334, -8260991190.0;
0.8165000000000001, -7536786050.0;
0.8231666666666667, -6547319725.0;
0.8298333333333334, -5987323890.0;
0.8365, -5494695975.0;
0.8431666666666667, -4816806280.0;
0.8498333333333334, -4122074605.0;
0.8565, -3536815800.0;
0.8631666666666667, -4033654210.0;
0.8698333333333335, -4871542715.0;
0.8765000000000001, -5427328055.0;
0.8831666666666668, -5722062705.0;
0.8898333333333334, -5726273200.0;
0.8965000000000001, -5570484885.0;
0.9031666666666668, -4265231435.0;
0.9098333333333334, -1869459780.0;
0.9165000000000001, 324208115.0;
0.9231666666666667, 2037879580.0;
0.9298333333333334, 2846294620.0;
0.9365000000000001, 3031556400.0;
0.9431666666666667, 2745242740.0;
0.9498333333333334, 1705250475.0;
0.9565, 905256425.0;
0.9631666666666668, 218945740.0;
0.9698333333333334, 290524155.0;
0.9765, 437891480.0;
0.9831666666666669, 75788910.0;
0.9898333333333335, -572627320.0;
0.9965, -1435778795.0;
1.0031666666666665, -1818933840.0;
1.0098333333333334, -1747355425.0;
1.0165, -164209305.0;
1.0231666666666666, 3191555210.0;
1.0298333333333334, 9730453945.0;
1.0365, 24092452390.0;
1.0431666666666666, 56008004490.0;
1.0498333333333334, 117893860000.0;
1.0565, 212124738100.0;
1.0631666666666666, 320443932470.0;
1.0698333333333334, 405133828900.0;
1.0765, 428615759515.0;
1.0831666666666666, 370898294055.0;
1.0898333333333332, 231749855295.0;
1.0965, 28231368975.0;
1.1031666666666666, -204806897790.0;
1.1098333333333332, -421891599000.0;
1.1165, -588446149715.0;
1.1231666666666666, -698790592180.0;
1.1298333333333332, -770305849755.0;
1.1365, -820781263815.0;
1.1431666666666667, -857008362795.0;
1.1498333333333333, -875054544365.0;
1.1565, -867681967620.0;
1.1631666666666667, -827433845915.0;
1.1698333333333333, -750756521470.0;
1.1764999999999999, -642222591855.0;
1.1831666666666667, -513937230195.0;
1.1898333333333333, -379597176725.0;
1.1965, -249130778655.0;
1.2031666666666667, -125203279320.0;
1.2098333333333333, -5233645285.0;
1.2165, 114424412120.0;
1.2231666666666667, 236204559005.0;
1.2298333333333333, 359647851415.0;
1.2365, 485141654890.0;
1.2431666666666668, 609582834615.0;
1.2498333333333334, 725485130480.0;
1.2565, 818503386020.0;
1.2631666666666665, 867943018310.0;
1.2698333333333334, 855429427170.0;
1.2765, 774390029905.0;
1.2831666666666666, 638546829720.0;
1.2898333333333334, 473735423935.0;
1.2965, 306574561940.0;
1.3031666666666666, 163384047980.0;
1.3098333333333334, 63890051130.0;
1.3165, 14054632310.0;
1.3231666666666666, 1221043550.0;
1.3298333333333334, 5141014395.0;
1.3365, 12871483215.0;
1.3431666666666666, 18698808295.0;
1.3498333333333332, 22286150035.0;
1.3565, 23961927045.0;
1.3631666666666666, 25077708220.0;
1.3698333333333332, 26147173950.0;
1.3765, 26871379090.0;
1.3831666666666667, 27317691560.0;
1.3898333333333333, 27439795915.0;
1.3965, 27528216310.0;
1.4031666666666667, 27764004030.0;
1.4098333333333333, 28479788180.0;
1.4165, 29448202030.0;
1.4231666666666667, 30340826970.0;
1.4298333333333333, 30732403005.0;
1.4365, 30846086370.0;
1.4431666666666667, 30643982610.0;
1.4498333333333333, 30323984990.0;
1.4565, 30100828755.0;
1.4631666666666667, 29936619450.0;
1.4698333333333333, 30096618260.0;
1.4765, 30147144200.0;
1.4831666666666667, 29734515690.0;
1.4898333333333333, 28837680255.0;
1.4965, 27818740465.0;
1.5031666666666668, 26921905030.0;
1.5098333333333334, 25540862670.0;
1.5165, 23671402890.0;
1.5231666666666668, 22433517360.0;
1.5298333333333334, 22050362315.0;
1.5365, 22164045680.0;
1.5431666666666666, 21987204890.0;
1.5498333333333334, 21822995585.0;
1.5565, 22037730830.0;
1.5631666666666666, 21822995585.0;
1.5698333333333334, 21225105295.0;
1.5765, 20151429070.0;
1.5831666666666666, 18799860175.0;
1.5898333333333334, 17208293065.0;
1.5965, 15705146350.0;
1.6031666666666666, 15094624575.0;
1.6098333333333334, 14804100420.0;
1.6165, 14454629335.0;
1.6231666666666666, 14429366365.0;
1.6298333333333332, 15178834475.0;
1.6365, 16033564960.0;
1.6431666666666667, 15978828525.0;
1.6498333333333333, 15528305560.0;
1.6565, 15717777835.0;
1.6631666666666667, 16433561985.0;
1.6698333333333333, 16433561985.0;
1.6765, 15797777240.0;
1.6831666666666667, 15178834475.0;
1.6898333333333333, 14753574480.0;
1.6965000000000001, 13806213105.0;
1.7031666666666667, 12319908370.0;
1.7098333333333333, 11835701445.0;
1.7165, 12058857680.0;
1.7231666666666667, 12711484405.0;
1.7298333333333333, 12522012130.0;
1.7365, 11717807585.0;
1.7431666666666668, 11279916105.0;
1.7498333333333334, 10812551160.0;
1.7565, 10547289975.0;
1.7631666666666668, 10143082455.0;
1.7698333333333334, 10345186215.0;
1.7765, 11612545210.0;
1.7831666666666668, 12652537475.0;
1.7898333333333334, 13515688950.0;
1.7965, 14307262010.0;
1.8031666666666666, 15014625170.0;
1.8098333333333334, 15873566150.0;
1.8165, 15852513675.0;
1.8231666666666666, 15524095065.0;
1.8298333333333334, 14829363390.0;
1.8365, 14138842210.0;
1.8431666666666666, 13734634690.0;
1.8498333333333334, 12530433120.0;
1.8565, 10913603040.0;
1.8631666666666666, 9477824245.0;
1.8698333333333335, 8610462275.0;
1.8765, 7810468225.0;
1.8831666666666667, 6741002495.0;
1.8898333333333333, 6004165870.0;
1.8965, 5953639930.0;
1.9031666666666667, 5974692405.0;
1.9098333333333333, 6117849235.0;
1.9165, 6808370415.0;
1.9231666666666667, 7549417535.0;
1.9298333333333333, 8117834360.0;
1.9365, 8159939310.0;
1.9431666666666667, 8774671580.0;
1.9498333333333333, 9919926220.0;
1.9565, 11460967390.0;
1.9631666666666667, 13839897065.0;
1.9698333333333335, 16968294850.0;
1.9765, 20374585305.0;
1.9831666666666667, 22761935970.0;
1.9898333333333336, 23696665860.0;
1.9965, 23393510220.0;
2.003166666666667, 22084046275.0;
2.009833333333334, 20176692040.0;
2.0165, 18446178595.0;
2.023166666666667, 17237766530.0;
2.0298333333333334, 16025143970.0;
2.0365, 15065151110.0;
2.043166666666667, 14867257845.0;
2.0498333333333334, 16412509510.0;
2.0565, 19545117790.0;
2.063166666666667, 23738770810.0;
2.0698333333333334, 28985047580.0;
2.0765000000000002, 34012378610.0;
2.083166666666667, 38269189055.0;
2.0898333333333334, 40601803285.0;
2.0965000000000003, 40669171205.0;
2.103166666666667, 38576555190.0;
2.1098333333333334, 34799741175.0;
2.1165000000000003, 30269248555.0;
2.123166666666667, 25102971190.0;
2.1298333333333335, 19907220360.0;
2.1365000000000003, 14841994875.0;
2.143166666666667, 10420975125.0;
2.1498333333333335, 7031526650.0;
2.1565000000000003, 4517861135.0;
2.163166666666667, 2467350070.0;
2.1698333333333335, 501048905.0;
2.1765000000000003, -888414445.0;
2.183166666666667, -1781039385.0;
2.1898333333333335, -2551559970.0;
2.1965000000000003, -3574710255.0;
2.2031666666666667, -4471545690.0;
2.2098333333333335, -4997857565.0;
2.2165000000000004, -3284186100.0;
2.2231666666666667, 141796840115.0;
2.2298333333333336, 914944773995.0;
2.2365000000000004, 2570831405615.0;
2.2431666666666668, 4995524950770.0;
2.2498333333333336, 7695205924375.0;
2.2565000000000004, 10407640487335.0;
2.2631666666666668, 12933272229125.0;
2.2698333333333336, 14724879956575.0;
2.2765000000000004, 15489366902240.0;
2.283166666666667, 15322151303810.0;
2.2898333333333336, 14769334362785.0;
2.2965000000000004, 14125890727380.0;
2.303166666666667, 13492190177405.0;
2.3098333333333336, 12940935330025.0;
2.3165000000000004, 12520525825265.0;
2.323166666666667, 12254919379675.0;
2.3298333333333336, 12101122628810.0;
2.3365000000000005, 12020508491540.0;
2.343166666666667, 11971755169935.0;
2.3498333333333337, 11942972226115.0;
2.3565000000000005, 11936437537875.0;
2.363166666666667, 11946816408050.0;
2.3698333333333337, 11965216271200.0;
2.3765000000000005, 11988411888155.0;
2.383166666666667, 12011236981550.0;
2.3898333333333337, 12030807362310.0;
2.3965, 12033708393365.0;
2.403166666666667, 12031123149435.0;
2.4098333333333337, 12018420086020.0;
2.4165, 11997409715970.0;
2.423166666666667, 11966054159705.0;
2.4298333333333337, 11934584920075.0;
2.4365, 11904736721020.0;
2.443166666666667, 11870240135485.0;
2.4498333333333338, 11834000405020.0;
2.4565, 11799394346615.0;
2.463166666666667, 11771032452295.0;
2.4698333333333338, 11750472605210.0;
2.4765, 11750586288575.0;
2.483166666666667, 11759874640545.0;
2.489833333333334, 11773588222760.0;
2.4965, 11777630297960.0;
2.503166666666667, 11777390299745.0;
2.509833333333334, 11770358773095.0;
2.5165, 11749516822845.0;
2.523166666666667, 11729390656745.0;
2.529833333333334, 11717799164010.0;
2.5365, 11714228664250.0;
2.543166666666667, 11701079288365.0;
2.549833333333334, 11670502673675.0;
2.5565, 11631665067795.0;
2.563166666666667, 11577787573775.0;
2.5698333333333334, 11505514427100.0;
2.5765000000000002, 11433093913100.0;
2.583166666666667, 11372968044500.0;
2.5898333333333334, 11323178941125.0;
2.5965000000000003, 11270130914620.0;
2.603166666666667, 11211108195710.0;
2.6098333333333334, 11144157114715.0;
2.6165000000000003, 11066827163545.0;
2.623166666666667, 10984810931440.0;
2.6298333333333335, 10907944134720.0;
2.6365000000000003, 10822336350380.0;
2.643166666666667, 10732021232630.0;
2.6498333333333335, 10649057639150.0;
2.6565000000000003, 10575289766750.0;
2.663166666666667, 10501201896730.0;
2.6698333333333335, 10427055079780.0;
2.6765000000000003, 10366339741880.0;
2.683166666666667, 10315173806640.0;
2.6898333333333335, 10255860563575.0;
2.6965000000000003, 10184160044220.0;
2.703166666666667, 10109411126485.0;
2.7098333333333335, 10026594900330.0;
2.7165000000000004, 9942898680720.0;
2.723166666666667, 9852423564160.0;
2.7298333333333336, 9772613631435.0;
2.7365000000000004, 9704689926095.0;
2.7431666666666668, 9645326157090.0;
2.7498333333333336, 9578897177475.0;
2.7565000000000004, 9493373603035.0;
2.7631666666666668, 9403555323695.0;
2.7698333333333336, 9309004447975.0;
2.7765000000000004, 9209240979445.0;
2.783166666666667, 9108715411320.0;
2.7898333333333336, 9012034025130.0;
2.7965000000000004, 8923453631320.0;
2.803166666666667, 8831100633990.0;
2.8098333333333336, 8727135091450.0;
2.8165000000000004, 8610521221930.0;
2.823166666666667, 8474808547090.0;
2.8298333333333336, 8338497981960.0;
2.8365000000000005, 8202098996435.0;
2.843166666666667, 8072735748055.0;
2.8498333333333337, 7950345079395.0;
2.8565000000000005, 7835971193215.0;
2.863166666666667, 7726999372120.0;
2.8698333333333337, 7620208587435.0;
2.8765000000000005, 7519211443870.0;
2.883166666666667, 7420138496520.0;
2.8898333333333337, 7319739243245.0;
2.8965000000000005, 7217697896920.0;
2.903166666666667, 7120629145190.0;
2.9098333333333337, 7020065682610.0;
2.9165000000000005, 6917594865795.0;
2.923166666666667, 6814201950575.0;
2.9298333333333337, 6715200581640.0;
2.9365, 6622388640355.0;
2.943166666666667, 6528869335910.0;
2.9498333333333338, 6434234250290.0;
2.9565, 6336559187280.0;
2.963166666666667, 6241595683050.0;
2.9698333333333338, 6146442706545.0;
2.9765, 6049773951840.0;
2.983166666666667, 5956347278285.0;
2.989833333333334, 5870642652560.0;
2.9965, 5788609578475.0;
3.003166666666667, 5705894404200.0;
3.009833333333334, 5623617121405.0;
3.0165, 5535655670360.0;
3.023166666666667, 5434094320465.0;
3.029833333333334, 5319998326955.0;
3.0365, 5191110864510.0;
3.043166666666667, 5048939290340.0;
3.049833333333334, 4891753091000.0;
3.0565, 4732293224360.0;
3.063166666666667, 4580942771090.0;
3.069833333333334, 4442017488565.0;
3.0765000000000002, 4318233146060.0;
3.083166666666667, 4208250806165.0;
3.089833333333334, 4115590442700.0;
3.0965000000000003, 4037683653715.0;
3.103166666666667, 3970315733715.0;
3.1098333333333334, 3909575132845.0;
3.1165000000000003, 3856080793870.0;
3.123166666666667, 3808679041160.0;
3.1298333333333335, 3762557278930.0;
3.1365000000000003, 3714902896520.0;
3.143166666666667, 3668200085980.0;
3.1498333333333335, 3622781476415.0;
3.1565000000000003, 3578701804260.0;
3.163166666666667, 3534154767160.0;
3.1698333333333335, 3490075095005.0;
3.1765000000000003, 3447435412140.0;
3.183166666666667, 3408096757355.0;
3.1898333333333335, 3373014913015.0;
3.1965000000000003, 3340227788450.0;
3.203166666666667, 3308101711600.0;
3.2098333333333335, 3276000897720.0;
3.2165000000000004, 3244628499475.0;
3.223166666666667, 3213188733310.0;
3.2298333333333336, 3181344759625.0;
3.2365000000000004, 3147816587940.0;
3.243166666666667, 3114452625560.0;
3.2498333333333336, 3083370751470.0;
3.2565000000000004, 3055943587040.0;
3.263166666666667, 3030680617040.0;
3.2698333333333336, 3004558706060.0;
3.2765000000000004, 2977064173710.0;
3.283166666666667, 2948740173845.0;
3.2898333333333336, 2921321430405.0;
3.2965000000000004, 2892761642820.0;
3.303166666666667, 2864302907115.0;
3.3098333333333336, 2837667315745.0;
3.3165000000000004, 2815216956405.0;
3.323166666666667, 2795621312675.0;
3.3298333333333336, 2775730934295.0;
3.3365000000000005, 2756072133140.0;
3.343166666666667, 2735849125655.0;
3.3498333333333337, 2715146121740.0;
3.3565000000000005, 2693078917445.0;
3.363166666666667, 2670990660675.0;
3.3698333333333337, 2650342393195.0;
3.3765000000000005, 2629790967100.0;
3.383166666666667, 2608869017445.0;
3.3898333333333337, 2584608145255.0;
3.3965000000000005, 2558696759025.0;
3.403166666666667, 2532600111015.0;
3.4098333333333337, 2508368712290.0;
3.4165000000000005, 2485981510375.0;
3.423166666666667, 2463164837970.0;
3.4298333333333337, 2441922890695.0;
3.4365000000000006, 2422714612505.0;
3.443166666666667, 2406491575270.0;
3.4498333333333338, 2389552753885.0;
3.4565000000000006, 2371973937260.0;
3.463166666666667, 2354584592910.0;
3.4698333333333338, 2338588922405.0;
3.4765, 2322260622795.0;
3.483166666666667, 2303827075685.0;
3.489833333333334, 2285393528575.0;
3.4965, 2267406293935.0;
3.503166666666667, 2250244316315.0;
3.509833333333334, 2232560237315.0;
3.5165, 2214046690800.0;
3.523166666666667, 2195891036360.0;
3.529833333333334, 2178489060525.0;
3.5365, 2162274444280.0;
3.543166666666667, 2146788243670.0;
3.549833333333334, 2131238885635.0;
3.5565, 2115942157300.0;
3.563166666666667, 2099424385415.0;
3.569833333333334, 2081348730380.0;
3.5765000000000002, 2061563614375.0;
3.583166666666667, 2041471132235.0;
3.589833333333334, 2021012337030.0;
3.5965000000000003, 2001450377260.0;
3.603166666666667, 1982953672725.0;
3.609833333333334, 1965265383230.0;
3.6165000000000003, 1948254983430.0;
3.623166666666667, 1932074051145.0;
3.629833333333334, 1917547843395.0;
3.6365000000000003, 1902015327340.0;
3.643166666666667, 1884567036060.0;
3.6498333333333335, 1866238751325.0;
3.6565000000000003, 1847986255500.0;
3.663166666666667, 1828799029785.0;
3.6698333333333335, 1808778126060.0;
3.6765000000000003, 1789157219360.0;
3.683166666666667, 1771557350260.0;
3.6898333333333335, 1754951157980.0;
3.6965000000000003, 1738046020555.0;
3.703166666666667, 1721456670255.0;
3.7098333333333335, 1704639953225.0;
3.7165000000000004, 1688181128270.0;
3.723166666666667, 1671410726685.0;
3.7298333333333336, 1654084539760.0;
3.7365000000000004, 1636787826300.0;
3.743166666666667, 1618910064530.0;
3.7498333333333336, 1600535464350.0;
3.7565000000000004, 1581533500415.0;
3.763166666666667, 1562030487575.0;
3.7698333333333336, 1543575887990.0;
3.7765000000000004, 1525066551970.0;
3.7831666666666672, 1507319315545.0;
3.7898333333333336, 1489445764270.0;
3.7965000000000004, 1471643791410.0;
3.8031666666666673, 1453808134590.0;
3.8098333333333336, 1434275648285.0;
3.8165000000000004, 1414768424950.0;
3.823166666666667, 1394372787170.0;
3.8298333333333336, 1374280305030.0;
3.8365000000000005, 1354074139525.0;
3.843166666666667, 1334385864905.0;
3.8498333333333337, 1315388111465.0;
3.8565000000000005, 1295282997840.0;
3.863166666666667, 1275228410155.0;
3.8698333333333337, 1255396978705.0;
3.8765000000000005, 1236361330810.0;
3.883166666666667, 1216626740745.0;
3.8898333333333337, 1196264786925.0;
3.8965000000000005, 1176273356665.0;
3.903166666666667, 1155414564435.0;
3.9098333333333337, 1134244195575.0;
3.9165000000000005, 1112400147515.0;
3.923166666666667, 1091545565780.0;
3.9298333333333337, 1071482557105.0;
3.9365000000000006, 1051634283675.0;
3.943166666666667, 1031773378760.0;
3.9498333333333338, 1010923007520.0;
3.9565, 989314747180.0;
3.963166666666667, 966325444480.0;
3.9698333333333338, 942443516840.0;
3.9765000000000006, 918363695935.0;
3.9831666666666674, 894864923340.0;
3.9898333333333333, 872174565785.0;
3.9965, 850077888025.0;
4.003166666666667, 828309628875.0;
4.009833333333334, 806730842000.0;
4.016500000000001, 784853109980.0;
4.0231666666666674, 762714327270.0;
4.029833333333333, 740870279210.0;
4.0365, 718967284220.0;
4.043166666666667, 696853764480.0;
4.049833333333334, 674546561970.0;
4.056500000000001, 652365674310.0;
4.0631666666666675, 630172155165.0;
4.069833333333333, 607839689685.0;
4.0765, 585620907570.0;
4.083166666666667, 564012647230.0;
4.089833333333334, 542193862140.0;
4.096500000000001, 520172973290.0;
4.103166666666667, 498497345030.0;
4.1098333333333334, 476788032810.0;
4.1165, 454623987130.0;
4.123166666666667, 431946261060.0;
4.129833333333334, 410030634585.0;
4.136500000000001, 389192894830.0;
4.143166666666667, 368136209335.0;
4.1498333333333335, 346906893545.0;
4.1565, 326928094770.0;
4.163166666666667, 309130332405.0;
4.169833333333334, 292562034580.0;
4.176500000000001, 276141104080.0;
4.183166666666667, 260419115750.0;
4.1898333333333335, 245909749980.0;
4.1965, 232760374095.0;
4.203166666666667, 221008882550.0;
4.209833333333334, 210878431580.0;
4.216500000000001, 202558493460.0;
4.223166666666667, 195674334135.0;
4.229833333333334, 190520688255.0;
4.2365, 186225983355.0;
4.243166666666667, 182007067365.0;
4.249833333333334, 177758677910.0;
4.256500000000001, 173948179935.0;
4.263166666666667, 170925044525.0;
4.269833333333334, 168087170895.0;
4.2765, 165514558450.0;
4.283166666666667, 162718789770.0;
4.289833333333334, 160407228015.0;
4.2965, 158664083085.0;
4.303166666666667, 157838826065.0;
4.309833333333334, 157771458145.0;
4.3165000000000004, 157741984680.0;
4.323166666666667, 158369348435.0;
4.329833333333334, 158655662095.0;
4.3365, 158285138535.0;
4.343166666666667, 156819886275.0;
4.349833333333334, 154950426495.0;
4.3565000000000005, 153771487895.0;
4.363166666666667, 153219913050.0;
4.369833333333334, 153236755030.0;
4.3765, 153969381160.0;
4.383166666666667, 155864103910.0;
4.389833333333334, 158024087845.0;
4.3965000000000005, 159308288820.0;
4.403166666666667, 159047238130.0;
4.409833333333334, 158659872590.0;
4.4165, 158899870805.0;
4.423166666666667, 159375656740.0;
4.429833333333334, 159763022280.0;
4.4365000000000006, 160516700885.0;
4.443166666666667, 162596685415.0;
4.449833333333333, 164550355095.0;
4.4565, 165177718850.0;
4.463166666666667, 164933510140.0;
4.469833333333334, 164424040245.0;
4.476500000000001, 164617723015.0;
4.483166666666667, 164592460045.0;
4.489833333333333, 165034562020.0;
4.4965, 165889292505.0;
4.503166666666667, 166958758235.0;
4.509833333333334, 168512430890.0;
4.516500000000001, 169548212660.0;
4.5231666666666674, 170411364135.0;
4.529833333333333, 170832413635.0;
4.5365, 171110306305.0;
4.543166666666667, 171649249665.0;
4.549833333333334, 172457664705.0;
4.556500000000001, 173687129245.0;
4.5631666666666675, 174659753590.0;
4.569833333333333, 175455537145.0;
4.5765, 176958683860.0;
4.583166666666667, 178428146615.0;
4.589833333333334, 179531296305.0;
4.596500000000001, 179716558085.0;
4.6031666666666675, 179893398875.0;
4.6098333333333334, 180226027980.0;
4.6165, 180268132930.0;
4.623166666666667, 180642866985.0;
4.629833333333334, 180731287380.0;
4.636500000000001, 180693392925.0;
4.643166666666667, 180550236095.0;
4.6498333333333335, 180760760845.0;
4.6565, 181312335690.0;
4.663166666666667, 181573386380.0;
4.669833333333334, 182087066770.0;
4.676500000000001, 183455477645.0;
4.683166666666667, 185333358415.0;
4.6898333333333335, 186967030475.0;
4.6965, 188070180165.0;
4.703166666666667, 189505958960.0;
4.709833333333334, 191442786660.0;
4.716500000000001, 193308035945.0;
4.723166666666667, 194356449200.0;
4.729833333333334, 195131180280.0;
4.7365, 196171172545.0;
4.743166666666667, 196882746200.0;
4.749833333333334, 197143796890.0;
4.756500000000001, 196811167785.0;
4.763166666666667, 197072218475.0;
4.769833333333334, 197396426590.0;
4.7765, 197796423615.0;
4.783166666666667, 198550102220.0;
4.789833333333334, 199160623995.0;
4.796500000000001, 199813250720.0;
4.803166666666667, 200234300220.0;
4.809833333333334, 201160609120.0;
4.8165000000000004, 202175338415.0;
4.823166666666667, 202739544745.0;
4.829833333333334, 203779537010.0;
4.8365, 205324788675.0;
4.843166666666667, 207177406475.0;
4.849833333333334, 208457396955.0;
4.8565000000000005, 209627914565.0;
4.863166666666667, 211168955735.0;
4.869833333333334, 212082633150.0;
4.8765, 212651049975.0;
4.883166666666667, 212680523440.0;
4.889833333333334, 212853153735.0;
4.8965000000000005, 212992100070.0;
4.903166666666667, 212878416705.0;
4.909833333333334, 213181572345.0;
4.9165, 213202624820.0;
4.923166666666667, 213804725605.0;
4.929833333333334, 214983664205.0;
4.9365000000000006, 216646809730.0;
4.943166666666667, 218095220010.0;
4.949833333333334, 218987844950.0;
4.9565, 220057310680.0;
4.963166666666667, 221459405515.0;
4.969833333333334, 222853079360.0;
4.976500000000001, 223859387665.0;
4.983166666666667, 225055168245.0;
4.989833333333333, 226318316745.0;
4.9965, 227261467625.0;
5.003166666666667, 227631991185.0;
5.009833333333334, 227893041875.0;
5.016500000000001, 228831982260.0;
5.0231666666666674, 229686712745.0;
5.029833333333333, 230351970955.0;
5.0365, 231514067575.0;
5.043166666666667, 233114055675.0;
5.049833333333334, 235311934065.0;
5.056500000000001, 236831922760.0;
5.0631666666666675, 238461384325.0;
5.069833333333333, 240339265095.0;
5.0765, 242162409430.0;
5.083166666666667, 243505557335.0;
5.089833333333334, 243766608025.0;
5.096500000000001, 243252927635.0;
5.1031666666666675, 242781352195.0;
5.1098333333333334, 242903456550.0;
5.1165, 243833975945.0;
5.123166666666667, 244899231180.0;
5.129833333333334, 246309747005.0;
5.136500000000001, 248473941435.0;
5.1431666666666676, 250760240220.0;
5.1498333333333335, 252983381580.0;
5.1565, 254835999380.0;
5.163166666666667, 257004404305.0;
5.169833333333334, 258520182505.0;
5.176500000000001, 259732805065.0;
5.183166666666667, 260305432385.0;
5.1898333333333335, 260444378720.0;
5.1965, 260570693570.0;
5.203166666666667, 260705429410.0;
5.209833333333334, 261240162275.0;
5.216500000000001, 261543317915.0;
5.223166666666667, 261804368605.0;
5.229833333333334, 262591731170.0;
5.2365, 262835939880.0;
5.243166666666667, 262979096710.0;
5.249833333333334, 263126464035.0;
5.256500000000001, 263795932740.0;
5.263166666666667, 265185396090.0;
5.269833333333334, 266675911320.0;
5.2765, 268899052680.0;
5.283166666666667, 270856932855.0;
5.289833333333334, 272280080165.0;
5.296500000000001, 273240073025.0;
5.303166666666667, 273905331235.0;
5.309833333333334, 274330591230.0;
5.3165000000000004, 274208486875.0;
5.323166666666667, 274461116575.0;
5.329833333333334, 275446372405.0;
5.336500000000001, 276818993775.0;
5.343166666666667, 278591612170.0;
5.349833333333334, 280418967000.0;
5.3565000000000005, 282583161430.0;
5.363166666666667, 284174728540.0;
5.369833333333334, 285922083965.0;
5.3765, 287446283155.0;
5.383166666666667, 288423117995.0;
5.389833333333334, 288907324920.0;
5.3965000000000005, 289412584320.0;
5.403166666666667, 290427313615.0;
5.409833333333334, 291623094195.0;
5.4165, 293164135365.0;
5.423166666666667, 294894648810.0;
5.429833333333334, 296949370370.0;
5.4365000000000006, 298915671535.0;
5.443166666666667, 300983024580.0;
5.449833333333334, 302423013870.0;
5.4565, 303041956635.0;
5.463166666666667, 303307217820.0;
5.469833333333334, 303458795640.0;
5.476500000000001, 303694583360.0;
5.483166666666667, 303858792665.0;
5.489833333333334, 304014580980.0;
5.4965, 305134572650.0;
5.503166666666667, 306776665700.0;
5.509833333333334, 308629283500.0;
5.516500000000001, 309846116555.0;
5.5231666666666674, 310742951990.0;
5.529833333333333, 312123994350.0;
5.5365, 313635562055.0;
5.543166666666667, 315041867385.0;
5.549833333333334, 316149227570.0;
5.556500000000001, 317479743990.0;
5.5631666666666675, 319159731495.0;
5.569833333333333, 320831298010.0;
5.5765, 322069183540.0;
5.583166666666667, 323033386895.0;
5.589833333333334, 324342850840.0;
5.596500000000001, 326081785275.0;
5.6031666666666675, 327841772185.0;
5.6098333333333334, 329475444245.0;
5.6165, 331088063830.0;
5.623166666666667, 333231205785.0;
5.629833333333334, 335003824180.0;
5.636500000000001, 336464865945.0;
5.6431666666666676, 337568015635.0;
5.6498333333333335, 338700638790.0;
5.6565, 340262732435.0;
5.663166666666667, 341782721130.0;
5.669833333333334, 343795337740.0;
5.676500000000001, 346140583455.0;
5.683166666666668, 348574249565.0;
5.6898333333333335, 350671076075.0;
5.6965, 352001592495.0;
5.703166666666667, 353066847730.0;
5.709833333333334, 354191049895.0;
5.716500000000001, 355386830475.0;
5.723166666666667, 356637347490.0;
5.729833333333334, 357858391040.0;
5.7365, 359134171025.0;
5.743166666666667, 360144689825.0;
5.749833333333334, 360603633780.0;
5.756500000000001, 360418372000.0;
5.763166666666667, 359828902700.0;
5.769833333333334, 359673114385.0;
5.7765, 360279425665.0;
5.783166666666667, 361319417930.0;
5.789833333333334, 362287831780.0;
5.796500000000001, 363626769190.0;
5.803166666666667, 365816226590.0;
5.809833333333334, 368073051910.0;
5.8165000000000004, 369475146745.0;
5.823166666666667, 370494086535.0;
5.829833333333334, 371816181965.0;
5.836500000000001, 373513011450.0;
5.843166666666667, 375222472420.0;
5.849833333333334, 376780355570.0;
5.8565000000000005, 378207713375.0;
5.863166666666667, 379256126630.0;
5.869833333333334, 379752965040.0;
5.876500000000001, 379677176130.0;
5.883166666666667, 379226653165.0;
5.889833333333334, 378700341290.0;
5.8965000000000005, 378611920895.0;
5.903166666666667, 379007707425.0;
5.909833333333334, 379534019300.0;
5.9165, 379811911970.0;
5.923166666666667, 379390862470.0;
5.929833333333334, 378637183865.0;
5.9365000000000006, 378254028820.0;
5.943166666666667, 378401396145.0;
5.949833333333334, 379517177320.0;
5.9565, 380851904235.0;
5.963166666666667, 382253999070.0;
5.969833333333334, 383500305590.0;
5.976500000000001, 384708717655.0;
5.983166666666667, 385832919820.0;
5.989833333333334, 386641334860.0;
5.9965, 387685537620.0;
6.003166666666667, 389247631265.0;
6.009833333333334, 391378141735.0;
6.016500000000001, 393576020125.0;
6.0231666666666674, 395677057130.0;
6.029833333333334, 397613884830.0;
6.0365, 399378082235.0;
6.043166666666667, 401129648155.0;
6.049833333333334, 402893845560.0;
6.056500000000001, 404767515835.0;
6.0631666666666675, 406826447890.0;
6.069833333333333, 408658013215.0;
6.0765, 410199054385.0;
6.083166666666667, 411748516545.0;
6.089833333333334, 413516924445.0;
6.096500000000001, 415580066995.0;
6.1031666666666675, 417512684200.0;
6.1098333333333334, 420093717635.0;
6.1165, 422881065325.0;
6.123166666666667, 425988410635.0;
6.129833333333334, 429272596735.0;
6.136500000000001, 432531519865.0;
6.1431666666666676, 435596760225.0;
6.1498333333333335, 438287266530.0;
6.1565, 441798819360.0;
6.163166666666667, 445579843870.0;
6.169833333333334, 448729294130.0;
6.176500000000001, 450758752720.0;
6.183166666666668, 452969262595.0;
6.1898333333333335, 455411349695.0;
6.1965, 457676596005.0;
6.203166666666667, 459739738555.0;
6.209833333333334, 462501823275.0;
6.216500000000001, 465802851355.0;
6.223166666666668, 468998617060.0;
6.229833333333334, 472282803160.0;
6.2365, 475806987475.0;
6.243166666666667, 479878536140.0;
6.249833333333334, 483891137875.0;
6.256500000000001, 488055317430.0;
6.263166666666667, 491731079565.0;
6.269833333333334, 494733162500.0;
6.2765, 497571036130.0;
6.283166666666667, 499945755310.0;
6.289833333333334, 501962582415.0;
6.296500000000001, 502994153690.0;
6.303166666666667, 503962567540.0;
6.309833333333334, 504926770895.0;
6.3165000000000004, 504977296835.0;
6.323166666666667, 503655201405.0;
6.329833333333334, 501554164400.0;
6.336500000000001, 500160490555.0;
6.343166666666667, 499777335510.0;
6.349833333333334, 499903650360.0;
6.3565000000000005, 500771012330.0;
6.363166666666667, 502450999835.0;
6.369833333333334, 504749930105.0;
6.376500000000001, 507444646905.0;
6.383166666666667, 510539360730.0;
6.389833333333334, 514042492570.0;
6.3965000000000005, 517322468175.0;
6.403166666666667, 520560338830.0;
6.409833333333334, 523806630475.0;
6.416500000000001, 526825555390.0;
6.423166666666667, 529276063480.0;
6.429833333333334, 531785518500.0;
6.4365000000000006, 534956021235.0;
6.443166666666667, 538993885940.0;
6.449833333333334, 543697008855.0;
6.4565, 548631708995.0;
6.463166666666667, 553296937455.0;
6.469833333333334, 557242171270.0;
6.476500000000001, 561200036570.0;
6.483166666666667, 564922114150.0;
6.489833333333334, 568959978855.0;
6.4965, 573292578210.0;
6.503166666666667, 577999911620.0;
6.509833333333334, 583178820470.0;
6.516500000000001, 588231414470.0;
6.5231666666666674, 594054529055.0;
6.529833333333334, 600071326410.0;
6.5365, 606344963960.0;
6.543166666666667, 611961764290.0;
6.549833333333334, 615742788800.0;
6.556500000000001, 615675420880.0;
6.5631666666666675, 610698615790.0;
6.569833333333334, 600648164225.0;
6.5765, 586383007165.0;
6.583166666666667, 569212608555.0;
6.589833333333334, 551520108565.0;
6.596500000000001, 536122328350.0;
6.6031666666666675, 524097154630.0;
6.6098333333333334, 515621428195.0;
6.6165, 510118311230.0;
6.623166666666667, 507389910470.0;
6.629833333333334, 506274129295.0;
6.636500000000001, 506173077415.0;
6.6431666666666676, 506472022560.0;
6.6498333333333335, 506724652260.0;
6.6565, 506998334435.0;
6.663166666666667, 507920432840.0;
6.669833333333334, 509600420345.0;
6.676500000000001, 510893042310.0;
6.683166666666668, 511861456160.0;
6.6898333333333335, 513305655945.0;
6.6965, 515798268985.0;
6.703166666666667, 518248777075.0;
6.709833333333334, 520480339425.0;
6.716500000000001, 522105590495.0;
6.723166666666668, 522779269695.0;
6.729833333333334, 521448753275.0;
6.7365, 517785622625.0;
6.743166666666667, 511983560515.0;
6.749833333333334, 504253091695.0;
6.756500000000001, 495903680110.0;
6.763166666666668, 487440585160.0;
6.769833333333334, 479575380500.0;
6.7765, 472110172865.0;
6.783166666666667, 466084954520.0;
6.789833333333334, 461617619325.0;
6.796500000000001, 458897639555.0;
6.803166666666667, 457487123730.0;
6.809833333333334, 457394492840.0;
6.8165000000000004, 458169223920.0;
6.823166666666667, 458535536985.0;
6.829833333333334, 458876587080.0;
6.836500000000001, 458581852430.0;
6.843166666666667, 458034488080.0;
6.849833333333334, 457609228085.0;
6.8565000000000005, 458047119565.0;
6.863166666666667, 459432372420.0;
6.869833333333334, 460493417160.0;
6.876500000000001, 461276569230.0;
6.883166666666667, 461891301500.0;
6.889833333333334, 462354455950.0;
6.8965000000000005, 462362876940.0;
6.903166666666667, 462148141695.0;
6.909833333333334, 462531296740.0;
6.916500000000001, 463996549000.0;
6.923166666666667, 466682844810.0;
6.929833333333334, 469680717250.0;
6.9365000000000006, 472901745925.0;
6.943166666666667, 475646988665.0;
6.949833333333334, 477811183095.0;
6.956500000000001, 478868017340.0;
6.963166666666667, 478973279715.0;
6.969833333333334, 478922753775.0;
6.976500000000001, 478253285070.0;
6.983166666666667, 477971181905.0;
6.989833333333334, 477954339925.0;
6.9965, 478918543280.0;
7.003166666666667, 480038534950.0;
7.009833333333334, 481188000085.0;
7.016500000000001, 482699567790.0;
7.0231666666666674, 484451133710.0;
7.029833333333334, 486131121215.0;
7.0365, 487550058030.0;
7.043166666666667, 489074257220.0;
7.049833333333334, 490552140965.0;
7.056500000000001, 492067919165.0;
7.0631666666666675, 493166858360.0;
7.069833333333334, 494177377160.0;
7.0765, 494977371210.0;
7.083166666666667, 495962627040.0;
7.089833333333334, 496834199505.0;
7.096500000000001, 497962612165.0;
7.1031666666666675, 498998393935.0;
7.109833333333334, 500699433915.0;
7.1165, 502501525775.0;
7.123166666666667, 503958357045.0;
7.129833333333334, 504884665945.0;
7.136500000000001, 504762561590.0;
7.1431666666666676, 504598352285.0;
7.1498333333333335, 504387827535.0;
7.1565, 504737298620.0;
7.163166666666667, 504825719015.0;
7.169833333333334, 505061506735.0;
7.176500000000001, 505701501975.0;
7.183166666666668, 507330963540.0;
7.1898333333333335, 508884636195.0;
7.1965, 510109890240.0;
7.203166666666667, 511149882505.0;
7.209833333333334, 511941455565.0;
7.216500000000001, 512400399520.0;
7.223166666666668, 512080401900.0;
7.229833333333334, 512013033980.0;
7.2365, 512265663680.0;
7.243166666666667, 513242498520.0;
7.249833333333334, 514783539690.0;
7.256500000000001, 516867734715.0;
7.263166666666668, 519431926170.0;
7.269833333333334, 521604541590.0;
7.2765, 523486632855.0;
7.283166666666667, 525120304915.0;
7.289833333333334, 526728714005.0;
7.296500000000001, 528193966265.0;
7.303166666666668, 529267642490.0;
7.309833333333334, 530320266240.0;
7.3165000000000004, 531288680090.0;
7.323166666666667, 532214988990.0;
7.329833333333334, 533650767785.0;
7.336500000000001, 535814962215.0;
7.343166666666667, 538480205550.0;
7.349833333333334, 540682294435.0;
7.3565000000000005, 542324387485.0;
7.363166666666667, 544012795980.0;
7.369833333333334, 545890676750.0;
7.376500000000001, 547890661875.0;
7.383166666666667, 549819068585.0;
7.389833333333334, 552054841430.0;
7.3965000000000005, 554640085360.0;
7.403166666666667, 557019015035.0;
7.409833333333334, 558581108680.0;
7.416500000000001, 558896895805.0;
7.423166666666667, 558176901160.0;
7.429833333333334, 557633747305.0;
7.4365000000000006, 557650589285.0;
7.443166666666667, 558421109870.0;
7.449833333333334, 559103210060.0;
7.456500000000001, 560816881525.0;
7.463166666666667, 563865279905.0;
7.469833333333334, 567233675905.0;
7.476500000000001, 570037865575.0;
7.483166666666667, 571730484565.0;
7.489833333333334, 573650470285.0;
7.496500000000001, 575027302150.0;
7.503166666666667, 575747296795.0;
7.509833333333334, 575637823925.0;
7.516500000000001, 575406246700.0;
7.5231666666666674, 575591508480.0;
7.529833333333334, 575877822140.0;
7.5365, 576328345105.0;
7.543166666666667, 576947287870.0;
7.549833333333334, 578042016570.0;
7.556500000000001, 579094640320.0;
7.5631666666666675, 580185158525.0;
7.569833333333334, 580580945055.0;
7.5765, 580488314165.0;
7.583166666666667, 579128324280.0;
7.589833333333334, 577709387465.0;
7.596500000000001, 576362029065.0;
7.6031666666666675, 574682041560.0;
7.609833333333334, 572901002175.0;
7.6165, 571385223975.0;
7.623166666666667, 571254698630.0;
7.629833333333334, 571347329520.0;
7.636500000000001, 571393644965.0;
7.6431666666666676, 571692590110.0;
7.649833333333334, 572875739205.0;
7.6565, 574627305125.0;
7.663166666666667, 575995716000.0;
7.669833333333334, 576500975400.0;
7.676500000000001, 576837815000.0;
7.683166666666668, 577536757170.0;
7.6898333333333335, 578610433395.0;
7.6965, 579220955170.0;
7.703166666666667, 579734635560.0;
7.709833333333334, 580530419115.0;
7.716500000000001, 581410412570.0;
7.723166666666668, 582256722065.0;
7.729833333333334, 583178820470.0;
7.7365, 584244075705.0;
7.743166666666667, 585229331535.0;
7.749833333333334, 586206166375.0;
7.756500000000001, 587877732890.0;
7.763166666666668, 589456668515.0;
7.769833333333334, 590513502760.0;
7.7765, 591768230270.0;
7.783166666666667, 593338744905.0;
7.789833333333334, 594867154590.0;
7.796500000000001, 595528202305.0;
7.803166666666668, 595835568440.0;
7.809833333333334, 595974514775.0;
7.8165000000000004, 595557675770.0;
7.823166666666667, 595174520725.0;
7.829833333333334, 595793463490.0;
7.836500000000001, 597043980505.0;
7.843166666666668, 598850282860.0;
7.849833333333334, 600669216700.0;
7.8565000000000005, 602694464795.0;
7.863166666666667, 604475504180.0;
7.869833333333334, 605414444565.0;
7.876500000000001, 606639698610.0;
7.883166666666667, 607372324740.0;
7.889833333333334, 608395475025.0;
7.8965000000000005, 609810201345.0;
7.903166666666667, 611949132805.0;
7.909833333333334, 614163853175.0;
7.916500000000001, 615751209790.0;
7.923166666666667, 616972253340.0;
7.929833333333334, 617620669570.0;
7.9365000000000006, 617637511550.0;
7.943166666666667, 616732255125.0;
7.949833333333334, 615730157315.0;
7.9565, 614450166835.0;
7.963166666666668, 613797540110.0;
7.969833333333334, 613439648035.0;
7.9765000000000015, 613923854960.0;
7.983166666666667, 615001741680.0;
7.989833333333333, 616391205030.0;
7.996500000000001, 617961719665.0;
8.003166666666667, 618231191345.0;
8.009833333333335, 618151191940.0;
8.0165, 618168033920.0;
8.023166666666667, 619288025590.0;
8.029833333333334, 620959592105.0;
8.0365, 622142741200.0;
8.043166666666668, 624332198600.0;
8.049833333333334, 626723759760.0;
8.0565, 628572167065.0;
8.063166666666667, 628841638745.0;
8.069833333333333, 628218485485.0;
8.076500000000001, 628323747860.0;
8.083166666666667, 628904796170.0;
8.089833333333335, 630344785460.0;
8.0965, 631932142075.0;
8.103166666666667, 633965811160.0;
8.109833333333334, 636016322225.0;
8.1165, 638323673485.0;
8.123166666666668, 640479446925.0;
8.129833333333334, 641658385525.0;
8.1365, 642845745115.0;
8.143166666666668, 644517311630.0;
8.149833333333333, 646546770220.0;
8.156500000000001, 647818339710.0;
8.163166666666667, 648361493565.0;
8.169833333333335, 649620431570.0;
8.1765, 651056210365.0;
8.183166666666667, 651860414910.0;
8.189833333333334, 652479357675.0;
8.1965, 653397245585.0;
8.203166666666668, 654913023785.0;
8.209833333333334, 655873016645.0;
8.2165, 656862482970.0;
8.223166666666668, 658062474045.0;
8.229833333333334, 659367727495.0;
8.236500000000001, 660630875995.0;
8.243166666666667, 661666657765.0;
8.249833333333333, 663022437155.0;
8.2565, 664079271400.0;
8.263166666666667, 664592951790.0;
8.269833333333334, 664820318520.0;
8.2765, 664769792580.0;
8.283166666666668, 664879265450.0;
8.289833333333334, 664778213570.0;
8.2965, 665030843270.0;
8.303166666666668, 666395043650.0;
8.309833333333334, 668508712140.0;
8.316500000000001, 671131850525.0;
8.323166666666667, 673536043170.0;
8.329833333333333, 675868657400.0;
8.336500000000001, 677771801140.0;
8.343166666666667, 678950739740.0;
8.349833333333335, 679775996760.0;
8.3565, 680495991405.0;
8.363166666666668, 681927559705.0;
8.369833333333334, 683481232360.0;
8.3765, 685013852540.0;
8.383166666666668, 686348579455.0;
8.389833333333334, 687868568150.0;
8.396500000000001, 690340128715.0;
8.403166666666667, 692546428095.0;
8.409833333333333, 694639044110.0;
8.416500000000001, 696251663695.0;
8.423166666666667, 697321129425.0;
8.429833333333335, 697607443085.0;
8.4365, 697089552200.0;
8.443166666666666, 696697976165.0;
8.449833333333334, 696702186660.0;
8.4565, 697022184280.0;
8.463166666666668, 697716915955.0;
8.469833333333334, 698516910005.0;
8.476500000000001, 699413745440.0;
8.483166666666667, 700601105030.0;
8.489833333333333, 701447414525.0;
8.496500000000001, 701708465215.0;
8.503166666666667, 701763201650.0;
8.509833333333335, 702255829565.0;
8.5165, 703060034110.0;
8.523166666666667, 702975824210.0;
8.529833333333334, 702706352530.0;
8.5365, 702777930945.0;
8.543166666666668, 703523188560.0;
8.549833333333334, 704420023995.0;
8.556500000000002, 704554759835.0;
8.563166666666667, 704415813500.0;
8.569833333333333, 704205288750.0;
8.576500000000001, 704866336465.0;
8.583166666666667, 705674751505.0;
8.589833333333335, 706331588725.0;
8.5965, 707489474850.0;
8.603166666666667, 709510512450.0;
8.609833333333334, 711977862520.0;
8.6165, 713918900715.0;
8.623166666666668, 715169417730.0;
8.629833333333334, 716377829795.0;
8.6365, 717274665230.0;
8.643166666666668, 718036764825.0;
8.649833333333333, 718495708780.0;
8.656500000000001, 718992547190.0;
8.663166666666667, 719295702830.0;
8.669833333333335, 719177808970.0;
8.6765, 719266229365.0;
8.683166666666667, 719695699855.0;
8.689833333333334, 720592535290.0;
8.6965, 721459897260.0;
8.703166666666668, 722904097045.0;
8.709833333333334, 724714609895.0;
8.7165, 725986179385.0;
8.723166666666668, 726592490665.0;
8.729833333333334, 726739857990.0;
8.736500000000001, 727544062535.0;
8.743166666666667, 728824053015.0;
8.749833333333335, 729670362510.0;
8.7565, 730407199135.0;
8.763166666666667, 730714565270.0;
8.769833333333334, 731581927240.0;
8.7765, 731598769220.0;
8.783166666666668, 731405086450.0;
8.789833333333334, 731948240305.0;
8.7965, 733872436520.0;
8.803166666666668, 736449259460.0;
8.809833333333334, 737981879640.0;
8.816500000000001, 739303975070.0;
8.823166666666667, 740411335255.0;
8.829833333333333, 742301847510.0;
8.836500000000001, 743783941750.0;
8.843166666666667, 745013406290.0;
8.849833333333335, 746036556575.0;
8.8565, 747253389630.0;
8.863166666666668, 748280750410.0;
8.869833333333334, 748103909620.0;
8.8765, 747118653790.0;
8.883166666666668, 746558657955.0;
8.889833333333334, 746381817165.0;
8.896500000000001, 745872347270.0;
8.903166666666667, 744870249460.0;
8.909833333333333, 743674468880.0;
8.916500000000001, 743076578590.0;
8.923166666666667, 742765001960.0;
8.929833333333335, 744032360955.0;
8.9365, 746470237560.0;
8.943166666666666, 749261795745.0;
8.949833333333334, 751931249575.0;
8.9565, 754310179250.0;
8.963166666666668, 755851220420.0;
8.969833333333334, 755981745765.0;
8.976500000000001, 755202804190.0;
8.983166666666667, 754773333700.0;
8.989833333333333, 754735439245.0;
8.996500000000001, 754790175680.0;
9.003166666666667, 754954384985.0;
9.009833333333335, 755619643195.0;
9.0165, 756625951500.0;
9.023166666666667, 757518576440.0;
9.029833333333334, 757960678415.0;
9.0365, 758676462565.0;
9.043166666666668, 759665928890.0;
9.049833333333334, 760693289670.0;
9.056500000000002, 761505915205.0;
9.063166666666667, 762583801925.0;
9.069833333333333, 763788003495.0;
9.076500000000001, 764790101305.0;
9.083166666666667, 765707989215.0;
9.089833333333335, 766781665440.0;
9.0965, 768124813345.0;
9.103166666666667, 769042701255.0;
9.109833333333334, 769889010750.0;
9.1165, 770630057870.0;
9.123166666666668, 771594261225.0;
9.129833333333334, 772145836070.0;
9.1365, 772571096065.0;
9.143166666666668, 772941619625.0;
9.149833333333333, 774116347730.0;
9.156500000000001, 775122656035.0;
9.163166666666667, 775577389495.0;
9.169833333333335, 775712125335.0;
9.1765, 776006859985.0;
9.183166666666667, 776874221955.0;
9.189833333333334, 777400533830.0;
9.1965, 777910003725.0;
9.203166666666668, 778651050845.0;
9.209833333333334, 779888936375.0;
9.2165, 781122611410.0;
9.223166666666668, 782482601295.0;
9.229833333333334, 784512059885.0;
9.236500000000001, 787383617475.0;
9.243166666666667, 790482541795.0;
9.249833333333335, 793328836415.0;
9.2565, 796154078560.0;
9.263166666666667, 798221431605.0;
9.269833333333334, 800124575345.0;
9.2765, 802078245025.0;
9.283166666666668, 805198221820.0;
9.289833333333334, 809084508705.0;
9.2965, 813741316175.0;
9.303166666666668, 820309688375.0;
9.309833333333334, 827391740965.0;
9.316500000000001, 834558003455.0;
9.323166666666667, 840701115660.0;
9.329833333333333, 847218961920.0;
9.336500000000001, 854242067580.0;
9.343166666666667, 861100963935.0;
9.349833333333335, 868355646820.0;
9.3565, 876014537225.0;
9.363166666666668, 883812373965.0;
9.369833333333334, 890431272105.0;
9.3765, 896043861940.0;
9.383166666666668, 900717511390.0;
9.389833333333334, 904734323620.0;
9.396500000000001, 908410085755.0;
9.403166666666667, 912894262930.0;
9.409833333333333, 918325801480.0;
9.416500000000001, 923504710330.0;
9.423166666666667, 928178359780.0;
9.429833333333335, 932376223295.0;
9.4365, 936241457705.0;
9.443166666666668, 939382486975.0;
9.449833333333334, 942321412485.0;
9.4565, 945795070860.0;
9.463166666666668, 949289781710.0;
9.469833333333334, 951466607625.0;
9.476500000000001, 950721350010.0;
9.483166666666667, 945816123335.0;
9.489833333333333, 936051985430.0;
9.496500000000001, 922018405595.0;
9.503166666666667, 905458528760.0;
9.509833333333335, 888330235100.0;
9.5165, 872279828160.0;
9.523166666666667, 859370450490.0;
9.529833333333334, 850284202280.0;
9.5365, 844755822345.0;
9.543166666666668, 841345321395.0;
9.549833333333334, 839745333295.0;
9.556500000000002, 839753754285.0;
9.563166666666667, 840280066160.0;
9.569833333333333, 840987429320.0;
9.576500000000001, 841787423370.0;
9.583166666666667, 843012677415.0;
9.589833333333335, 843863197405.0;
9.5965, 844789506305.0;
9.603166666666667, 846431599355.0;
9.609833333333334, 848406321510.0;
9.6165, 850456832575.0;
9.623166666666668, 852397870770.0;
9.629833333333334, 854823115890.0;
9.636500000000002, 857189414080.0;
9.643166666666668, 858625192875.0;
9.649833333333333, 859593606725.0;
9.656500000000001, 860789387305.0;
9.663166666666667, 862536742730.0;
9.669833333333335, 864515675380.0;
9.6765, 866014611600.0;
9.683166666666667, 867239865645.0;
9.689833333333334, 868393541275.0;
9.6965, 869046168000.0;
9.703166666666668, 868999852555.0;
9.709833333333334, 868216700485.0;
9.7165, 867172497725.0;
9.723166666666668, 866448292585.0;
9.729833333333334, 865820928830.0;
9.736500000000001, 865143039135.0;
9.743166666666667, 864338834590.0;
9.749833333333335, 863555682520.0;
9.7565, 863454630640.0;
9.763166666666667, 863884101130.0;
9.769833333333334, 864376729045.0;
9.7765, 864347255580.0;
9.783166666666668, 864027257960.0;
9.789833333333334, 863997784495.0;
9.7965, 863745154795.0;
9.803166666666668, 863092528070.0;
9.809833333333334, 862616742135.0;
9.816500000000001, 863092528070.0;
9.823166666666667, 863930416575.0;
9.829833333333335, 864608306270.0;
9.836500000000001, 865517773190.0;
9.843166666666667, 866338819715.0;
9.849833333333335, 866915657530.0;
9.8565, 867138813765.0;
9.863166666666668, 868069333160.0;
9.869833333333334, 869147219880.0;
9.8765, 869686163240.0;
9.883166666666668, 869955634920.0;
9.889833333333334, 870406157885.0;
9.896500000000001, 870919838275.0;
9.903166666666667, 871399834705.0;
9.909833333333333, 872705088155.0;
9.916500000000001, 875467172875.0;
9.923166666666667, 878772411450.0;
9.929833333333335, 881214498550.0;
9.9365, 882869223085.0;
9.943166666666668, 883681848620.0;
9.949833333333334, 884111319110.0;
9.9565, 883980793765.0;
9.963166666666668, 883959741290.0;
9.969833333333334, 884839734745.0;
9.976500000000001, 886195514135.0;
9.983166666666667, 888086026390.0;
9.989833333333333, 889424963800.0;
9.996500000000001, 890271273295.0;
10.003166666666667, 890869163585.0;
10.009833333333335, 891433369915.0;
10.0165, 892704939405.0;
10.023166666666667, 893631248305.0;
10.029833333333334, 894010192855.0;
10.0365, 893454407515.0;
10.043166666666668, 892751254850.0;
10.049833333333334, 891900734860.0;
10.056500000000002, 890784953685.0;
10.063166666666667, 890401798640.0;
10.069833333333333, 891820735455.0;
10.076500000000001, 894949133240.0;
10.083166666666667, 898410160130.0;
10.089833333333335, 901808029595.0;
10.0965, 905130110150.0;
10.103166666666667, 907892194870.0;
10.109833333333334, 909357447130.0;
10.1165, 909866917025.0;
10.123166666666668, 909909021975.0;
10.129833333333334, 909959547915.0;
10.136500000000002, 909639550295.0;
10.143166666666668, 910014284350.0;
10.149833333333333, 911466905125.0;
10.156500000000001, 913908992225.0;
10.163166666666667, 916490025660.0;
10.169833333333335, 918890007810.0;
10.1765, 921748933915.0;
10.183166666666667, 924191021015.0;
10.189833333333334, 925668904760.0;
10.1965, 925454169515.0;
10.203166666666668, 924784700810.0;
10.209833333333334, 924763648335.0;
10.2165, 925428906545.0;
10.223166666666668, 926279426535.0;
10.229833333333334, 927239419395.0;
10.236500000000001, 928915196405.0;
10.243166666666667, 930713077770.0;
10.249833333333335, 932148856565.0;
10.2565, 932961482100.0;
10.263166666666667, 933323584670.0;
10.269833333333334, 932932008635.0;
10.2765, 932102541120.0;
10.283166666666668, 931719386075.0;
10.289833333333334, 932110962110.0;
10.2965, 932220434980.0;
10.303166666666668, 932342539335.0;
10.309833333333334, 932641484480.0;
10.316500000000001, 934085684265.0;
10.323166666666667, 935588830980.0;
10.329833333333335, 936553034335.0;
10.336500000000001, 937458290760.0;
10.343166666666667, 938258284810.0;
10.349833333333335, 939883535880.0;
10.3565, 941049842995.0;
10.363166666666668, 942472990305.0;
10.369833333333334, 943517193065.0;
10.3765, 944835078000.0;
10.383166666666668, 946561380950.0;
10.389833333333334, 947946633805.0;
10.396500000000001, 948864521715.0;
10.403166666666667, 949260308245.0;
10.409833333333333, 950624508625.0;
10.416500000000001, 951837131185.0;
10.423166666666667, 952224496725.0;
10.429833333333335, 952161339300.0;
10.4365, 953150805625.0;
10.443166666666668, 954910792535.0;
10.449833333333334, 955340263025.0;
10.4565, 955315000055.0;
10.463166666666668, 955782365000.0;
10.469833333333334, 956569727565.0;
10.476500000000001, 956367623805.0;
10.483166666666667, 955470788370.0;
10.489833333333333, 955677102625.0;
10.496500000000001, 956872883205.0;
10.503166666666667, 958325503980.0;
10.509833333333335, 959765493270.0;
10.5165, 961226535035.0;
10.523166666666668, 962578103930.0;
10.529833333333334, 963407571445.0;
10.5365, 964030724705.0;
10.543166666666668, 965348609640.0;
10.549833333333334, 967243332390.0;
10.556500000000002, 969117002665.0;
10.563166666666667, 970927515515.0;
10.569833333333333, 973045394500.0;
10.576500000000001, 975399061205.0;
10.583166666666667, 977335888905.0;
10.589833333333335, 978889561560.0;
10.5965, 980316919365.0;
10.603166666666667, 981310596185.0;
10.609833333333334, 981807434595.0;
10.6165, 982464271815.0;
10.623166666666668, 982813742900.0;
10.629833333333334, 983091635570.0;
10.636500000000002, 983933734570.0;
10.643166666666668, 985580038115.0;
10.649833333333333, 987487392350.0;
10.656500000000001, 988451595705.0;
10.663166666666667, 989011591540.0;
10.669833333333335, 989874743015.0;
10.6765, 990565264195.0;
10.683166666666667, 991398942205.0;
10.689833333333334, 992249462195.0;
10.6965, 993975765145.0;
10.703166666666668, 996750481350.0;
10.709833333333334, 998826255385.0;
10.716500000000002, 1000876766450.0;
10.723166666666668, 1003142012760.0;
10.729833333333334, 1005790414115.0;
10.736500000000001, 1007339876275.0;
10.743166666666667, 1007083036080.0;
10.749833333333335, 1006649355095.0;
10.7565, 1006123043220.0;
10.763166666666667, 1005617783820.0;
10.769833333333334, 1005415680060.0;
10.7765, 1006687249550.0;
10.783166666666668, 1008493551905.0;
10.789833333333334, 1010295643765.0;
10.7965, 1012320891860.0;
10.803166666666668, 1014451402330.0;
10.809833333333334, 1015744024295.0;
10.816500000000001, 1015036661135.0;
10.823166666666667, 1014657716585.0;
10.829833333333335, 1015613498950.0;
10.836500000000001, 1017226118535.0;
10.843166666666667, 1018165058920.0;
10.849833333333335, 1019112420295.0;
10.8565, 1021002932550.0;
10.863166666666668, 1023558703015.0;
10.869833333333334, 1025706055465.0;
10.8765, 1027529199800.0;
10.883166666666668, 1029739709675.0;
10.889833333333334, 1031369171240.0;
10.896500000000001, 1032476531425.0;
10.903166666666667, 1032922843895.0;
10.909833333333335, 1033465997750.0;
10.916500000000001, 1034430201105.0;
10.923166666666667, 1034952302485.0;
10.929833333333335, 1035651244655.0;
10.9365, 1036324923855.0;
10.943166666666668, 1037087023450.0;
10.949833333333334, 1037832281065.0;
10.9565, 1038131226210.0;
10.963166666666668, 1038063858290.0;
10.969833333333334, 1037748071165.0;
10.976500000000001, 1038089121260.0;
10.983166666666667, 1038897536300.0;
10.989833333333333, 1040232263215.0;
10.996500000000001, 1041659621020.0;
11.003166666666667, 1044190128515.0;
11.009833333333335, 1047760628275.0;
11.0165, 1051364811995.0;
11.023166666666668, 1055048995120.0;
11.029833333333334, 1057790027365.0;
11.0365, 1060067905160.0;
11.043166666666668, 1060842636240.0;
11.049833333333334, 1060366850305.0;
11.056500000000002, 1059078438835.0;
11.063166666666667, 1057103716680.0;
11.069833333333333, 1055861620655.0;
11.076500000000001, 1054872154330.0;
11.083166666666667, 1054560577700.0;
11.089833333333335, 1054387947405.0;
11.0965, 1054956364230.0;
11.103166666666667, 1056261617680.0;
11.109833333333334, 1057305820440.0;
11.1165, 1058017394095.0;
11.123166666666668, 1058657389335.0;
11.129833333333334, 1060021589715.0;
11.136500000000002, 1061798418605.0;
11.143166666666668, 1064143664320.0;
11.149833333333333, 1066425752610.0;
11.156500000000001, 1068939418125.0;
11.163166666666667, 1072139394325.0;
11.169833333333335, 1076202522000.0;
11.1765, 1080627752245.0;
11.183166666666667, 1084063516165.0;
11.189833333333334, 1086749811975.0;
11.1965, 1089966630155.0;
11.203166666666668, 1093579234865.0;
11.209833333333334, 1096749737600.0;
11.216500000000002, 1098800248665.0;
11.223166666666668, 1101006548045.0;
11.229833333333334, 1104046525435.0;
11.236500000000001, 1106345455705.0;
11.243166666666667, 1107608604205.0;
11.249833333333335, 1108669648945.0;
11.2565, 1110429635855.0;
11.263166666666667, 1112341200585.0;
11.269833333333334, 1114619078380.0;
11.2765, 1118522207245.0;
11.283166666666668, 1123322171545.0;
11.289833333333334, 1127557929515.0;
11.2965, 1130538959975.0;
11.303166666666668, 1133048414995.0;
11.309833333333334, 1135385239720.0;
11.316500000000001, 1136917859900.0;
11.323166666666667, 1138214692360.0;
11.329833333333335, 1139835732935.0;
11.336500000000001, 1142332556470.0;
11.343166666666667, 1143764124770.0;
11.349833333333335, 1143570442000.0;
11.3565, 1141444142025.0;
11.363166666666668, 1137919957710.0;
11.369833333333334, 1133309465685.0;
11.3765, 1127372667735.0;
11.383166666666668, 1122349547200.0;
11.389833333333334, 1118071684280.0;
11.396500000000001, 1115027496395.0;
11.403166666666667, 1112791723550.0;
11.409833333333335, 1111743310295.0;
11.416500000000001, 1111924361580.0;
11.423166666666667, 1111861204155.0;
11.429833333333335, 1111659100395.0;
11.4365, 1111040157630.0;
11.443166666666668, 1110530687735.0;
11.449833333333334, 1110012796850.0;
11.4565, 1109970691900.0;
11.463166666666668, 1110652792090.0;
11.469833333333334, 1111928572075.0;
11.476500000000001, 1114703288280.0;
11.483166666666667, 1118955888230.0;
11.489833333333333, 1123991640250.0;
11.496500000000001, 1129044234250.0;
11.503166666666667, 1134475772800.0;
11.509833333333335, 1140155730555.0;
11.5165, 1144517803375.0;
11.523166666666668, 1147684095615.0;
11.529833333333334, 1151195648445.0;
11.5365, 1155616668195.0;
11.543166666666668, 1160004003985.0;
11.549833333333334, 1163507135825.0;
11.556500000000002, 1167241844890.0;
11.563166666666667, 1171283920090.0;
11.569833333333333, 1175317574300.0;
11.576500000000001, 1179191229700.0;
11.583166666666667, 1183085937575.0;
11.589833333333335, 1187279590595.0;
11.5965, 1191199561440.0;
11.603166666666668, 1194799534665.0;
11.609833333333334, 1197995300370.0;
11.6165, 1200812121525.0;
11.623166666666668, 1203603679710.0;
11.629833333333334, 1206778392940.0;
11.636500000000002, 1210428892105.0;
11.643166666666668, 1213953076420.0;
11.649833333333333, 1217136210640.0;
11.656500000000001, 1219654086650.0;
11.663166666666667, 1220727762875.0;
11.669833333333335, 1219704612590.0;
11.6765, 1215910956595.0;
11.683166666666667, 1209788896865.0;
11.689833333333334, 1202386846655.0;
11.6965, 1194930060010.0;
11.703166666666668, 1187603798710.0;
11.709833333333334, 1180062802165.0;
11.716500000000002, 1173557587390.0;
11.723166666666668, 1168846043485.0;
11.729833333333334, 1165376595605.0;
11.736500000000001, 1162332407720.0;
11.743166666666667, 1160555578830.0;
11.749833333333335, 1160324001605.0;
11.7565, 1161018733280.0;
11.763166666666667, 1161717675450.0;
11.769833333333334, 1162298723760.0;
11.7765, 1162715562765.0;
11.783166666666668, 1162239776830.0;
11.789833333333334, 1161987147130.0;
11.796500000000002, 1162012410100.0;
11.803166666666668, 1162656615835.0;
11.809833333333334, 1163540819785.0;
11.816500000000001, 1164281866905.0;
11.823166666666667, 1165267122735.0;
11.829833333333335, 1165991327875.0;
11.836500000000001, 1166989215190.0;
11.843166666666667, 1167755525280.0;
11.849833333333335, 1168020786465.0;
11.8565, 1168109206860.0;
11.863166666666668, 1168580782300.0;
11.869833333333334, 1170155507430.0;
11.8765, 1172382859285.0;
11.883166666666668, 1175300732320.0;
11.889833333333334, 1178332288720.0;
11.896500000000001, 1181102794430.0;
11.903166666666667, 1183073306090.0;
11.909833333333335, 1184904871415.0;
11.916500000000001, 1186189072390.0;
11.923166666666667, 1186765910205.0;
11.929833333333335, 1187153275745.0;
11.9365, 1188054321675.0;
11.943166666666668, 1189544836905.0;
11.949833333333334, 1190319567985.0;
11.9565, 1191553243020.0;
11.963166666666668, 1193380597850.0;
11.969833333333334, 1195346899015.0;
11.976500000000001, 1196930045135.0;
11.983166666666667, 1198597401155.0;
11.989833333333335, 1200260546680.0;
11.996500000000001, 1200955278355.0;
12.003166666666667, 1201186855580.0;
12.009833333333335, 1201502642705.0;
12.0165, 1202247900320.0;
12.023166666666668, 1202407899130.0;
12.029833333333334, 1203275261100.0;
12.0365, 1204424726235.0;
12.043166666666668, 1205729979685.0;
12.049833333333334, 1206744708980.0;
12.056500000000002, 1207784701245.0;
12.063166666666667, 1209649950530.0;
12.069833333333333, 1211241517640.0;
12.076500000000001, 1212946768115.0;
12.083166666666667, 1214037286320.0;
12.089833333333335, 1215052015615.0;
12.0965, 1215456223135.0;
12.103166666666668, 1215329908285.0;
12.109833333333334, 1215363592245.0;
12.1165, 1216079376395.0;
12.123166666666668, 1217338314400.0;
12.129833333333334, 1218866724085.0;
12.136500000000002, 1220639342480.0;
12.143166666666668, 1222618275130.0;
12.149833333333333, 1223393006210.0;
12.156500000000001, 1223287743835.0;
12.163166666666667, 1223502479080.0;
12.169833333333335, 1224243526200.0;
12.1765, 1225691936480.0;
12.183166666666667, 1227649816655.0;
12.189833333333334, 1230243481575.0;
12.1965, 1232382413035.0;
12.203166666666668, 1233220301540.0;
12.209833333333334, 1233565562130.0;
12.216500000000002, 1233725560940.0;
12.223166666666668, 1233767665890.0;
12.229833333333334, 1234096084500.0;
12.236500000000001, 1234496081525.0;
12.243166666666667, 1235658178145.0;
12.249833333333335, 1237283429215.0;
12.2565, 1238681313555.0;
12.263166666666667, 1239809726215.0;
12.269833333333334, 1241637081045.0;
12.2765, 1245241264765.0;
12.283166666666668, 1249300181945.0;
12.289833333333334, 1252277001910.0;
12.296500000000002, 1254167514165.0;
12.303166666666668, 1255771712760.0;
12.309833333333334, 1256411708000.0;
12.316500000000001, 1256516970375.0;
12.323166666666667, 1256992756310.0;
12.329833333333335, 1258521165995.0;
12.336500000000001, 1260799043790.0;
12.343166666666667, 1262681135055.0;
12.349833333333335, 1264634804735.0;
12.3565, 1266041110065.0;
12.363166666666668, 1267081102330.0;
12.369833333333334, 1268066358160.0;
12.3765, 1269097929435.0;
12.383166666666668, 1270108448235.0;
12.389833333333334, 1270668444070.0;
12.396500000000001, 1271236860895.0;
12.403166666666667, 1271683173365.0;
12.409833333333335, 1272041065440.0;
12.416500000000001, 1272495798900.0;
12.423166666666667, 1274171575910.0;
12.429833333333335, 1277106290925.0;
12.4365, 1280167320790.0;
12.443166666666668, 1282234673835.0;
12.449833333333334, 1283455717385.0;
12.4565, 1283897819360.0;
12.463166666666668, 1282942036995.0;
12.469833333333334, 1280731527120.0;
12.476500000000001, 1278929435260.0;
12.483166666666667, 1278537859225.0;
12.489833333333335, 1279161012485.0;
12.496500000000001, 1280929420385.0;
12.503166666666667, 1283687294610.0;
12.509833333333335, 1287211478925.0;
12.5165, 1290200930375.0;
12.523166666666668, 1292588281040.0;
12.529833333333334, 1295021947150.0;
12.5365, 1297169299600.0;
12.543166666666668, 1299005075420.0;
12.549833333333334, 1300162961545.0;
12.556500000000002, 1301535582915.0;
12.563166666666667, 1303165044480.0;
12.569833333333333, 1304057669420.0;
12.576500000000001, 1304356614565.0;
12.583166666666667, 1304765032580.0;
12.589833333333335, 1306070286030.0;
12.5965, 1307173435720.0;
12.603166666666668, 1308322900855.0;
12.609833333333334, 1309312367180.0;
12.6165, 1311392351710.0;
12.623166666666668, 1314259698805.0;
12.629833333333334, 1317716515200.0;
12.636500000000002, 1320828071005.0;
12.643166666666668, 1322301744255.0;
12.649833333333333, 1323628050180.0;
12.656500000000001, 1324225940470.0;
12.663166666666667, 1324166993540.0;
12.669833333333335, 1322225955345.0;
12.6765, 1320103865865.0;
12.683166666666668, 1319501765080.0;
12.689833333333334, 1320617546255.0;
12.6965, 1322945949990.0;
12.703166666666668, 1325017513530.0;
12.709833333333334, 1327745914290.0;
12.716500000000002, 1330225895845.0;
12.723166666666668, 1332743771855.0;
12.729833333333334, 1333834290060.0;
12.736500000000001, 1333905868475.0;
12.743166666666667, 1333307978185.0;
12.749833333333335, 1332600615025.0;
12.7565, 1333051137990.0;
12.763166666666667, 1333691133230.0;
12.769833333333334, 1334840598365.0;
12.7765, 1335556382515.0;
12.783166666666668, 1337606893580.0;
12.789833333333334, 1340512135130.0;
12.796500000000002, 1343194220445.0;
12.803166666666668, 1345320520420.0;
12.809833333333334, 1347008928915.0;
12.816500000000001, 1348840494240.0;
12.823166666666667, 1349421542550.0;
12.829833333333335, 1349042598000.0;
12.836500000000001, 1348225761970.0;
12.843166666666667, 1348133131080.0;
12.849833333333335, 1348684705925.0;
12.8565, 1350255220560.0;
12.863166666666668, 1352314152615.0;
12.869833333333334, 1354730976745.0;
12.876500000000002, 1357724638690.0;
12.883166666666668, 1360827773505.0;
12.889833333333334, 1364095117625.0;
12.896500000000001, 1366554046705.0;
12.903166666666667, 1369665602510.0;
12.909833333333335, 1373092945440.0;
12.916500000000001, 1376478183420.0;
12.923166666666667, 1378852902600.0;
12.929833333333335, 1380852887725.0;
12.9365, 1383593919970.0;
12.943166666666668, 1386810738150.0;
12.949833333333334, 1390078082270.0;
12.9565, 1393223322035.0;
12.963166666666668, 1396747506350.0;
12.969833333333334, 1400419057990.0;
12.976500000000001, 1403690612605.0;
12.983166666666667, 1406111647230.0;
12.989833333333335, 1408498997895.0;
12.996500000000001, 1410692665790.0;
13.003166666666667, 1413669485755.0;
13.009833333333335, 1416637884730.0;
13.0165, 1419997859740.0;
13.023166666666668, 1423294677325.0;
13.029833333333334, 1426094656500.0;
13.0365, 1428372534295.0;
13.043166666666668, 1429673577250.0;
13.049833333333334, 1431004093670.0;
13.056500000000002, 1432149348310.0;
13.063166666666667, 1433303023940.0;
13.069833333333335, 1435075642335.0;
13.076500000000001, 1438035620320.0;
13.083166666666667, 1441770329385.0;
13.089833333333335, 1444755570340.0;
13.0965, 1446806081405.0;
13.103166666666668, 1448469226930.0;
13.109833333333334, 1449833427310.0;
13.1165, 1450721841755.0;
13.123166666666668, 1451382889470.0;
13.129833333333334, 1453046034995.0;
13.136500000000002, 1455492332590.0;
13.143166666666668, 1457669158505.0;
13.149833333333333, 1459109147795.0;
13.156500000000001, 1460384927780.0;
13.163166666666667, 1462515438250.0;
13.169833333333335, 1464540686345.0;
13.1765, 1466725933250.0;
13.183166666666668, 1469568017375.0;
13.189833333333334, 1473239569015.0;
13.1965, 1476410071750.0;
13.203166666666668, 1478574266180.0;
13.209833333333334, 1480102675865.0;
13.216500000000002, 1480839512490.0;
13.223166666666668, 1480224780220.0;
13.229833333333334, 1479593205970.0;
13.236500000000001, 1479694257850.0;
13.243166666666667, 1479243734885.0;
13.249833333333335, 1477930060445.0;
13.2565, 1476498492145.0;
13.263166666666667, 1476296388385.0;
13.269833333333334, 1475845865420.0;
13.2765, 1474338508210.0;
13.283166666666668, 1473041675750.0;
13.289833333333334, 1472671152190.0;
13.296500000000002, 1473247990005.0;
13.303166666666668, 1473235358520.0;
13.309833333333334, 1472111156355.0;
13.316500000000001, 1470591167660.0;
13.323166666666667, 1468826970255.0;
13.329833333333335, 1466978562950.0;
13.336500000000001, 1464658580205.0;
13.343166666666667, 1463041750125.0;
13.349833333333335, 1462485964785.0;
13.3565, 1463197538440.0;
13.363166666666668, 1464456476445.0;
13.369833333333334, 1465210155050.0;
13.376500000000002, 1465016472280.0;
13.383166666666668, 1463959638035.0;
13.389833333333334, 1463104907550.0;
13.396500000000001, 1461867022020.0;
13.403166666666667, 1459875457885.0;
13.409833333333335, 1457770210385.0;
13.416500000000001, 1456237590205.0;
13.423166666666667, 1456140748820.0;
13.429833333333335, 1456637587230.0;
13.4365, 1457955472165.0;
13.443166666666668, 1459387040465.0;
13.449833333333334, 1461067027970.0;
13.4565, 1461921758455.0;
13.463166666666668, 1461311236680.0;
13.469833333333334, 1459307041060.0;
13.476500000000001, 1456898637920.0;
13.483166666666667, 1455302860315.0;
13.489833333333335, 1454389182900.0;
13.496500000000001, 1454591286660.0;
13.503166666666667, 1454873389825.0;
13.509833333333335, 1454877600320.0;
13.5165, 1454658654580.0;
13.523166666666668, 1454321814980.0;
13.529833333333334, 1453892344490.0;
13.5365, 1453113402915.0;
13.543166666666668, 1453020772025.0;
13.549833333333334, 1453993396370.0;
13.556500000000002, 1454671286065.0;
13.563166666666667, 1454570234185.0;
13.569833333333335, 1454081816765.0;
13.576500000000001, 1454018659340.0;
13.583166666666667, 1453656556770.0;
13.589833333333335, 1452957614600.0;
13.5965, 1452014463720.0;
13.603166666666668, 1451496572835.0;
13.609833333333334, 1450309213245.0;
13.6165, 1448928170885.0;
13.623166666666668, 1448123966340.0;
13.629833333333334, 1448065019410.0;
13.636500000000002, 1448726067125.0;
13.643166666666668, 1449572376620.0;
13.649833333333333, 1451332363530.0;
13.656500000000001, 1453008140540.0;
13.663166666666667, 1453766029640.0;
13.669833333333335, 1453829187065.0;
13.6765, 1453858660530.0;
13.683166666666668, 1453732345680.0;
13.689833333333334, 1453959712410.0;
13.6965, 1455210229425.0;
13.703166666666668, 1457791262860.0;
13.709833333333334, 1460203876495.0;
13.716500000000002, 1461307026185.0;
13.723166666666668, 1461841759050.0;
13.729833333333334, 1462338597460.0;
13.736500000000001, 1462953329730.0;
13.743166666666667, 1462978592700.0;
13.749833333333335, 1463088065570.0;
13.7565, 1464313319615.0;
13.763166666666669, 1466826985130.0;
13.769833333333334, 1468923811640.0;
13.7765, 1469466965495.0;
13.783166666666668, 1469113283915.0;
13.789833333333334, 1468208027490.0;
13.796500000000002, 1467391191460.0;
13.803166666666668, 1466195410880.0;
13.809833333333334, 1465614362570.0;
13.816500000000001, 1465462784750.0;
13.823166666666667, 1465538573660.0;
13.829833333333335, 1466115411475.0;
13.836500000000001, 1466881721565.0;
13.843166666666667, 1467344876015.0;
13.849833333333335, 1466961720970.0;
13.8565, 1465993307120.0;
13.863166666666668, 1465205944555.0;
13.869833333333334, 1465121734655.0;
13.876500000000002, 1465302785940.0;
13.883166666666668, 1465892255240.0;
13.889833333333334, 1466574355430.0;
13.896500000000001, 1468405920755.0;
13.903166666666667, 1470683798550.0;
13.909833333333335, 1472860624465.0;
13.916500000000001, 1474346929200.0;
13.923166666666667, 1474549032960.0;
13.929833333333335, 1475146923250.0;
13.9365, 1475551130770.0;
13.943166666666668, 1476549018085.0;
13.949833333333334, 1476835331745.0;
13.956500000000002, 1476645859470.0;
13.963166666666668, 1476650069965.0;
13.969833333333334, 1476123758090.0;
13.976500000000001, 1475546920275.0;
13.983166666666667, 1474970082460.0;
13.989833333333335, 1475311132555.0;
13.996500000000001, 1475938496310.0;
14.003166666666667, 1477180592335.0;
14.009833333333335, 1478612160635.0;
14.0165, 1479647942405.0;
14.023166666666668, 1479761625770.0;
14.029833333333334, 1479172156470.0;
14.0365, 1480056360420.0;
14.043166666666668, 1481071089715.0;
14.049833333333334, 1482839497615.0;
14.056500000000002, 1485563687880.0;
14.063166666666667, 1489774182880.0;
14.069833333333335, 1494683620050.0;
14.076500000000001, 1497807807340.0;
14.083166666666667, 1500586734040.0;
14.089833333333335, 1503155135990.0;
14.0965, 1505449855765.0;
14.103166666666668, 1506839319115.0;
14.109833333333334, 1507369841485.0;
14.1165, 1509142459880.0;
14.123166666666668, 1510868762830.0;
14.129833333333334, 1512136121825.0;
14.136500000000002, 1512506645385.0;
14.143166666666668, 1513129798645.0;
14.149833333333333, 1513719267945.0;
14.156500000000001, 1513214008545.0;
14.163166666666667, 1512148753310.0;
14.169833333333335, 1510338240460.0;
14.1765, 1508001415735.0;
14.183166666666668, 1504350916570.0;
14.189833333333334, 1500881468690.0;
14.1965, 1497833070310.0;
14.203166666666668, 1495176247965.0;
14.209833333333334, 1492780476310.0;
14.216500000000002, 1490889964055.0;
14.223166666666668, 1488898399920.0;
14.229833333333334, 1486599469650.0;
14.236500000000001, 1482881602565.0;
14.243166666666667, 1478784790930.0;
14.249833333333335, 1474894293550.0;
14.2565, 1471559581510.0;
14.263166666666669, 1468869075205.0;
14.269833333333334, 1465812255835.0;
14.2765, 1463955427540.0;
14.283166666666668, 1462187019640.0;
14.289833333333334, 1460557558075.0;
14.296500000000002, 1459795458480.0;
14.303166666666668, 1459492302840.0;
14.309833333333334, 1459913352340.0;
14.316500000000001, 1459723880065.0;
14.323166666666667, 1460667030945.0;
14.329833333333335, 1461984915880.0;
14.336500000000001, 1462629121615.0;
14.343166666666667, 1462864909335.0;
14.349833333333335, 1463635429920.0;
14.3565, 1465753308905.0;
14.363166666666668, 1467395401955.0;
14.369833333333334, 1468532235605.0;
14.376500000000002, 1468869075205.0;
14.383166666666668, 1469698542720.0;
14.389833333333334, 1470186960140.0;
14.396500000000001, 1470523799740.0;
14.403166666666667, 1471445898145.0;
14.409833333333335, 1473466935745.0;
14.416500000000001, 1476692174915.0;
14.423166666666667, 1479551101020.0;
14.429833333333335, 1481100563180.0;
14.4365, 1481420560800.0;
14.443166666666668, 1481041616250.0;
14.449833333333334, 1480923722390.0;
14.456500000000002, 1480624777245.0;
14.463166666666668, 1480662671700.0;
14.469833333333334, 1481879504755.0;
14.476500000000001, 1483845805920.0;
14.483166666666667, 1485450004515.0;
14.489833333333335, 1485538424910.0;
14.496500000000001, 1485795265105.0;
14.503166666666667, 1485887895995.0;
14.509833333333335, 1486064736785.0;
14.5165, 1485626845305.0;
14.523166666666668, 1485828949065.0;
14.529833333333334, 1487483673600.0;
14.5365, 1488708927645.0;
14.543166666666668, 1489163661105.0;
14.549833333333334, 1488860505465.0;
14.556500000000002, 1490565755940.0;
14.563166666666667, 1492637319480.0;
14.569833333333335, 1493799416100.0;
14.576500000000001, 1494460463815.0;
14.583166666666667, 1496068872905.0;
14.589833333333335, 1498228856840.0;
14.5965, 1498633064360.0;
14.603166666666668, 1498405697630.0;
14.609833333333334, 1497896227735.0;
14.6165, 1497205706555.0;
14.623166666666668, 1495795190730.0;
14.629833333333334, 1494275202035.0;
14.636500000000002, 1493108894920.0;
14.643166666666668, 1492060481665.0;
14.649833333333335, 1491323645040.0;
14.656500000000001, 1491201540685.0;
14.663166666666667, 1490940489995.0;
14.669833333333335, 1490544703465.0;
14.6765, 1490127864460.0;
14.683166666666668, 1490359441685.0;
14.689833333333334, 1491045752370.0;
14.6965, 1491736273550.0;
14.703166666666668, 1493045737495.0;
14.709833333333334, 1494073098275.0;
14.716500000000002, 1494889934305.0;
14.723166666666668, 1494435200845.0;
14.729833333333334, 1493681522240.0;
14.736500000000001, 1493626785805.0;
14.743166666666667, 1493605733330.0;
14.749833333333335, 1494169939660.0;
14.7565, 1494889934305.0;
14.763166666666669, 1496363607555.0;
14.769833333333334, 1497525704175.0;
14.7765, 1497159391110.0;
14.783166666666668, 1496692026165.0;
14.789833333333334, 1496557290325.0;
14.796500000000002, 1497630966550.0;
14.803166666666668, 1499104639800.0;
14.809833333333334, 1501033046510.0;
14.816500000000001, 1502847769855.0;
14.823166666666667, 1504094076375.0;
14.829833333333335, 1504136181325.0;
14.836500000000001, 1503950919545.0;
14.843166666666669, 1504110918355.0;
14.849833333333335, 1504881438940.0;
14.8565, 1506283533775.0;
14.863166666666668, 1507790890985.0;
14.869833333333334, 1510249820065.0;
14.876500000000002, 1512169805785.0;
14.883166666666668, 1512843484985.0;
14.889833333333334, 1512359278060.0;
14.896500000000001, 1511761387770.0;
14.903166666666667, 1511538231535.0;
14.909833333333335, 1511323496290.0;
14.916500000000001, 1510628764615.0;
14.923166666666667, 1510119294720.0;
14.929833333333335, 1509348774135.0;
14.9365, 1508872988200.0;
14.943166666666668, 1508515096125.0;
14.949833333333334, 1507828785440.0;
14.956500000000002, 1506986686440.0;
14.963166666666668, 1506026693580.0;
14.969833333333334, 1505997220115.0;
14.976500000000001, 1506940370995.0;
14.983166666666667, 1508371939295.0;
14.989833333333335, 1510144557690.0;
14.996500000000001, 1512157174300.0;
15.003166666666667, 1514451894075.0;
15.009833333333335, 1515971882770.0;
15.0165, 1515887672870.0;
15.023166666666668, 1514927680010.0;
15.029833333333334, 1514022423585.0;
15.036500000000002, 1513647689530.0;
15.043166666666668, 1513639268540.0;
15.049833333333334, 1513774004380.0;
15.056500000000002, 1514152948930.0;
15.063166666666667, 1513997160615.0;
15.069833333333335, 1513525585175.0;
15.076500000000001, 1512915063400.0;
15.083166666666667, 1512068753905.0;
15.089833333333335, 1510982446195.0;
15.0965, 1509601403835.0;
15.103166666666668, 1509538246410.0;
15.109833333333334, 1509887717495.0;
15.1165, 1510152978680.0;
15.123166666666668, 1511045603620.0;
15.129833333333334, 1513176114090.0;
15.136500000000002, 1516889770680.0;
15.143166666666668, 1519639223915.0;
15.149833333333335, 1521403421320.0;
15.156500000000001, 1522367624675.0;
15.163166666666667, 1521386579340.0;
15.169833333333335, 1519357120750.0;
15.1765, 1516249775440.0;
15.183166666666668, 1514376105165.0;
15.189833333333334, 1512586644790.0;
15.1965, 1511331917280.0;
15.203166666666668, 1511719282820.0;
15.209833333333334, 1512805590530.0;
15.216500000000002, 1513967687150.0;
15.223166666666668, 1513243482010.0;
15.229833333333334, 1512510855880.0;
15.236500000000001, 1512531908355.0;
15.243166666666667, 1513049799240.0;
15.249833333333335, 1513921371705.0;
15.2565, 1514641366350.0;
15.263166666666669, 1516068724155.0;
15.269833333333334, 1517967657400.0;
15.2765, 1519390804710.0;
15.283166666666668, 1520312903115.0;
15.289833333333334, 1520384481530.0;
15.296500000000002, 1520599216775.0;
15.303166666666668, 1520784478555.0;
15.309833333333334, 1520763426080.0;
15.316500000000001, 1519795012230.0;
15.323166666666667, 1518296076010.0;
15.329833333333335, 1517251873250.0;
15.336500000000001, 1516936086125.0;
15.343166666666669, 1517601344335.0;
15.349833333333335, 1518409759375.0;
15.3565, 1519795012230.0;
15.363166666666668, 1521672893000.0;
15.369833333333334, 1523512879315.0;
15.376500000000002, 1524599187025.0;
15.383166666666668, 1524359188810.0;
15.389833333333334, 1524679186430.0;
15.396500000000001, 1525529706420.0;
15.403166666666667, 1526085491760.0;
15.409833333333335, 1525104446425.0;
15.416500000000001, 1524157085050.0;
15.423166666666667, 1524599187025.0;
15.429833333333335, 1525260234740.0;
15.4365, 1525559179885.0;
15.443166666666668, 1525382339095.0;
15.449833333333334, 1526102333740.0;
15.456500000000002, 1527037063630.0;
15.463166666666668, 1526889696305.0;
15.469833333333334, 1525365497115.0;
15.476500000000001, 1523870771390.0;
15.483166666666667, 1523268670605.0;
15.489833333333335, 1523403406445.0;
15.496500000000001, 1522872884075.0;
15.503166666666667, 1522030785075.0;
15.509833333333335, 1521563420130.0;
15.5165, 1520919214395.0;
15.523166666666668, 1520813952020.0;
15.529833333333334, 1520498164895.0;
15.536500000000002, 1521049739740.0;
15.543166666666668, 1521874996760.0;
15.549833333333334, 1522952883480.0;
15.556500000000002, 1524262347425.0;
15.563166666666667, 1524342346830.0;
15.569833333333335, 1523672878125.0;
15.576500000000001, 1521870786265.0;
15.583166666666667, 1520275008660.0;
15.589833333333335, 1519226595405.0;
15.5965, 1518178182150.0;
15.603166666666668, 1517117137410.0;
15.609833333333334, 1516203459995.0;
15.6165, 1516001356235.0;
15.623166666666668, 1515887672870.0;
15.629833333333334, 1515327677035.0;
15.636500000000002, 1515942409305.0;
15.643166666666668, 1517702396215.0;
15.649833333333335, 1520426586480.0;
15.656500000000001, 1522839200115.0;
15.663166666666667, 1525348655135.0;
15.669833333333335, 1527714953325.0;
15.6765, 1528464421435.0;
15.683166666666668, 1528397053515.0;
15.689833333333334, 1527929688570.0;
15.6965, 1528072845400.0;
15.703166666666668, 1528388632525.0;
15.709833333333334, 1529373888355.0;
15.716500000000002, 1531150717245.0;
15.723166666666668, 1532397023765.0;
15.729833333333335, 1533277017220.0;
15.736500000000001, 1534312798990.0;
15.743166666666667, 1535260160365.0;
15.749833333333335, 1535272791850.0;
15.7565, 1534759111460.0;
15.763166666666669, 1535251739375.0;
15.769833333333334, 1535883313625.0;
15.7765, 1535634894420.0;
15.783166666666668, 1535622262935.0;
15.789833333333334, 1537382249845.0;
15.796500000000002, 1540152755555.0;
15.803166666666668, 1542843261860.0;
15.809833333333334, 1545424295295.0;
15.816500000000001, 1548826375255.0;
15.823166666666667, 1552434769470.0;
15.829833333333335, 1555769481510.0;
15.836500000000001, 1559462085625.0;
15.843166666666669, 1563794684980.0;
15.849833333333335, 1569508326695.0;
15.8565, 1576480906415.0;
15.863166666666668, 1585175578590.0;
15.869833333333334, 1594404983630.0;
15.876500000000002, 1604270173415.0;
15.883166666666668, 1614855357845.0;
15.889833333333334, 1626922636515.0;
15.896500000000001, 1640366747050.0;
15.903166666666667, 1653806647090.0;
15.909833333333335, 1666918128520.0;
15.916500000000001, 1679301194315.0;
15.923166666666669, 1691608471200.0;
15.929833333333335, 1703246279380.0;
15.9365, 1713919884205.0;
15.943166666666668, 1723511391815.0;
15.949833333333334, 1732071328150.0;
15.9565, 1739317590045.0;
15.963166666666668, 1744445972955.0;
15.969833333333336, 1747422792920.0;
15.9765, 1748403838255.0;
15.983166666666667, 1749115411910.0;
15.989833333333335, 1750071194275.0;
15.996500000000003, 1751266974855.0;
16.003166666666665, 1752546965335.0;
16.009833333333333, 1754546950460.0;
16.0165, 1758180607645.0;
16.023166666666665, 1762151104430.0;
16.029833333333332, 1765734235675.0;
16.0365, 1767944745550.0;
16.043166666666664, 1769595259590.0;
16.049833333333332, 1770500516015.0;
16.0565, 1769986835625.0;
16.063166666666667, 1767334223775.0;
16.06983333333333, 1763216359665.0;
16.0765, 1759115337535.0;
16.083166666666667, 1754723791250.0;
16.08983333333333, 1749052254485.0;
16.0965, 1741667046255.0;
16.103166666666667, 1733595527340.0;
16.109833333333334, 1724761908830.0;
16.1165, 1714888298055.0;
16.123166666666666, 1703511540565.0;
16.129833333333334, 1691179000710.0;
16.136499999999998, 1677124368400.0;
16.143166666666666, 1662236058080.0;
16.149833333333333, 1647019329150.0;
16.156499999999998, 1632152071305.0;
16.163166666666665, 1617600600585.0;
16.169833333333333, 1601849138790.0;
16.1765, 1586000835610.0;
16.183166666666665, 1569015698780.0;
16.189833333333333, 1551575828490.0;
16.1965, 1533584383355.0;
16.203166666666664, 1515748726535.0;
16.209833333333332, 1499222533660.0;
16.2165, 1483702649090.0;
16.223166666666668, 1469041705500.0;
16.229833333333332, 1454848126855.0;
16.2365, 1440869283455.0;
16.243166666666667, 1426911492530.0;
16.24983333333333, 1412010550725.0;
16.2565, 1396499087145.0;
16.263166666666667, 1381252884750.0;
16.269833333333334, 1366305627500.0;
16.2765, 1351194160945.0;
16.283166666666666, 1335977432015.0;
16.289833333333334, 1322449111580.0;
16.296499999999998, 1310297623010.0;
16.303166666666666, 1298520868495.0;
16.309833333333334, 1286908323285.0;
16.316499999999998, 1275497881835.0;
16.323166666666665, 1264533752855.0;
16.329833333333333, 1253304362690.0;
16.3365, 1242070762030.0;
16.343166666666665, 1230816108895.0;
16.349833333333333, 1219620402690.0;
16.3565, 1208828904005.0;
16.363166666666665, 1198391086900.0;
16.369833333333332, 1187928006825.0;
16.3765, 1177355453880.0;
16.383166666666668, 1167313423305.0;
16.389833333333332, 1157111393920.0;
16.3965, 1147347256015.0;
16.403166666666667, 1137482066230.0;
16.40983333333333, 1127970558025.0;
16.4165, 1118307472000.0;
16.423166666666667, 1108391756275.0;
16.42983333333333, 1098901300545.0;
16.4365, 1089448739270.0;
16.443166666666666, 1080013019975.0;
16.449833333333334, 1070547827215.0;
16.4565, 1061065792475.0;
16.463166666666666, 1052198490005.0;
16.469833333333334, 1043470133870.0;
16.476499999999998, 1034484937540.0;
16.483166666666666, 1025053428740.0;
16.489833333333333, 1014771399950.0;
16.4965, 1004628317495.0;
16.503166666666665, 994106290490.0;
16.509833333333333, 983689525860.0;
16.5165, 973390655090.0;
16.523166666666665, 964220196980.0;
16.529833333333332, 956102362620.0;
16.5365, 948329788850.0;
16.543166666666664, 940515110130.0;
16.549833333333332, 932788851805.0;
16.5565, 925871008520.0;
16.563166666666667, 918418432370.0;
16.56983333333333, 911146907505.0;
16.5765, 903597489970.0;
16.583166666666667, 895993336000.0;
16.58983333333333, 888262867180.0;
16.5965, 879875561140.0;
16.603166666666667, 871724042820.0;
16.609833333333334, 863555682520.0;
16.6165, 855833634690.0;
16.623166666666666, 848920001900.0;
16.629833333333334, 842461102570.0;
16.636499999999998, 836625356500.0;
16.643166666666666, 830907504290.0;
16.649833333333333, 824688603175.0;
16.6565, 818267598300.0;
16.663166666666665, 811758173030.0;
16.669833333333333, 805572955875.0;
16.6765, 799055109615.0;
16.683166666666665, 792229897220.0;
16.689833333333333, 785573104625.0;
16.6965, 779265783115.0;
16.703166666666664, 772979514080.0;
16.709833333333332, 766124828220.0;
16.7165, 759185932460.0;
16.723166666666668, 752360720065.0;
16.729833333333332, 746310238750.0;
16.7365, 740680806935.0;
16.743166666666667, 735859790160.0;
16.74983333333333, 731304034570.0;
16.7565, 726714595020.0;
16.763166666666667, 721981998640.0;
16.769833333333334, 716790458305.0;
16.7765, 711611549455.0;
16.783166666666666, 705472647745.0;
16.789833333333334, 698967432970.0;
16.796499999999998, 692373797800.0;
16.803166666666666, 685957003420.0;
16.809833333333334, 679961258540.0;
16.816499999999998, 673927619205.0;
16.823166666666665, 668639237485.0;
16.829833333333333, 664441373970.0;
16.8365, 660651928470.0;
16.843166666666665, 657153007125.0;
16.849833333333333, 653696190730.0;
16.8565, 650664634330.0;
16.863166666666665, 647026766650.0;
16.869833333333332, 641708911465.0;
16.8765, 635730008565.0;
16.883166666666668, 629953209425.0;
16.889833333333332, 624066937415.0;
16.8965, 617405934325.0;
16.903166666666667, 610652300345.0;
16.90983333333333, 605532338425.0;
16.9165, 601296580455.0;
16.923166666666667, 597043980505.0;
16.92983333333333, 592681907685.0;
16.9365, 588387202785.0;
16.943166666666666, 584761966590.0;
16.949833333333334, 580728312380.0;
16.9565, 577162023115.0;
16.963166666666666, 573372577615.0;
16.969833333333334, 569604184590.0;
16.976499999999998, 565667371765.0;
16.983166666666666, 561018985285.0;
16.989833333333333, 556231652470.0;
16.9965, 551419056685.0;
17.003166666666665, 547309613565.0;
17.009833333333333, 543612798955.0;
17.0165, 540358086320.0;
17.023166666666665, 537608633085.0;
17.029833333333332, 534762338465.0;
17.0365, 531010787420.0;
17.043166666666664, 526652925095.0;
17.049833333333332, 522290852275.0;
17.0565, 518598248160.0;
17.063166666666667, 514779329195.0;
17.06983333333333, 510724622510.0;
17.0765, 506135182960.0;
17.083166666666667, 501335218660.0;
17.08983333333333, 496994198315.0;
17.0965, 492699493415.0;
17.103166666666667, 488758470095.0;
17.109833333333334, 484670079450.0;
17.1165, 481634312555.0;
17.123166666666666, 479453276145.0;
17.129833333333334, 477103819935.0;
17.136499999999998, 474038579575.0;
17.143166666666666, 470148082195.0;
17.149833333333333, 466623897880.0;
17.1565, 462632348620.0;
17.163166666666665, 457958699170.0;
17.169833333333333, 452472424185.0;
17.1765, 446754571975.0;
17.183166666666665, 442093554010.0;
17.189833333333333, 438299898015.0;
17.1965, 435192552705.0;
17.203166666666664, 431971524030.0;
17.209833333333332, 429184176340.0;
17.2165, 426674721320.0;
17.223166666666668, 424060003925.0;
17.229833333333332, 420952658615.0;
17.2365, 417622157070.0;
17.243166666666667, 414531653740.0;
17.24983333333333, 411373782490.0;
17.2565, 408371699555.0;
17.263166666666667, 405036987515.0;
17.269833333333334, 401100174690.0;
17.2765, 397180203845.0;
17.283166666666666, 393466547255.0;
17.289833333333334, 389912889475.0;
17.296499999999998, 386157127935.0;
17.303166666666666, 382249788575.0;
17.309833333333334, 378759288220.0;
17.316499999999998, 375096157570.0;
17.323166666666665, 370986714450.0;
17.329833333333333, 366995165190.0;
17.3365, 363117299295.0;
17.343166666666665, 359559431020.0;
17.349833333333333, 355925773835.0;
17.3565, 352633166745.0;
17.363166666666665, 349917397470.0;
17.369833333333332, 346881630575.0;
17.3765, 343567971010.0;
17.383166666666668, 339946945310.0;
17.389833333333332, 336658548715.0;
17.3965, 333753307165.0;
17.403166666666667, 330877539080.0;
17.40983333333333, 327799667235.0;
17.4165, 324856531230.0;
17.423166666666667, 322326023735.0;
17.42983333333333, 320077619405.0;
17.4365, 317016589540.0;
17.443166666666666, 313105039685.0;
17.449833333333334, 309315594185.0;
17.4565, 305618779575.0;
17.463166666666666, 301669335265.0;
17.469833333333334, 297488313730.0;
17.476499999999998, 293707289220.0;
17.483166666666666, 290974677965.0;
17.489833333333333, 288077857405.0;
17.4965, 285105247935.0;
17.503166666666665, 281930534705.0;
17.509833333333333, 279029503650.0;
17.5165, 276296892395.0;
17.523166666666665, 273092705700.0;
17.529833333333332, 269837993065.0;
17.5365, 266414860630.0;
17.543166666666668, 263290673340.0;
17.549833333333332, 260132802090.0;
17.5565, 256457039955.0;
17.563166666666667, 252604437030.0;
17.56983333333333, 249109726180.0;
17.5765, 246419219875.0;
17.583166666666667, 243631872185.0;
17.58983333333333, 240027688465.0;
17.5965, 236394031280.0;
17.603166666666667, 233055108745.0;
17.609833333333334, 229876185020.0;
17.6165, 226099371005.0;
17.623166666666666, 222057295805.0;
17.629833333333334, 217627855065.0;
17.636499999999998, 213312097690.0;
17.643166666666666, 209505810210.0;
17.649833333333333, 206246887080.0;
17.6565, 203366908500.0;
17.663166666666665, 200293247150.0;
17.669833333333333, 197838528565.0;
17.6765, 195514335325.0;
17.683166666666665, 192617514765.0;
17.689833333333333, 189211224310.0;
17.6965, 185240727525.0;
17.703166666666664, 181733385190.0;
17.709833333333332, 178432357110.0;
17.7165, 175089224080.0;
17.723166666666668, 171779775010.0;
17.729833333333332, 168120854855.0;
17.7365, 164908247170.0;
17.743166666666667, 161750375920.0;
17.74983333333333, 158516715760.0;
17.7565, 155337792035.0;
17.763166666666667, 151531504555.0;
17.769833333333334, 147721006580.0;
17.7765, 143123146040.0;
17.783166666666666, 138533706490.0;
17.789833333333334, 134133739215.0;
17.796499999999998, 129822192335.0;
17.803166666666666, 126188535150.0;
17.809833333333334, 122689613805.0;
17.816499999999998, 120011738985.0;
17.823166666666665, 117439126540.0;
17.829833333333333, 114445464595.0;
17.8365, 111544433540.0;
17.843166666666665, 108331825855.0;
17.849833333333333, 105300269455.0;
17.8565, 101936083950.0;
17.863166666666665, 98281374290.0;
17.869833333333332, 94706664035.0;
17.8765, 90908797545.0;
17.883166666666668, 87073036600.0;
17.889833333333332, 83136223775.0;
17.8965, 79035201645.0;
17.903166666666667, 74757338725.0;
17.90983333333333, 70357371450.0;
17.9165, 65877404770.0;
17.923166666666667, 61490068980.0;
17.92983333333333, 56525895375.0;
17.9365, 51351197020.0;
17.943166666666666, 46732284005.0;
17.949833333333334, 43195468205.0;
17.9565, 39940755570.0;
17.963166666666666, 36353413830.0;
17.969833333333334, 32947123375.0;
17.976499999999998, 29949250935.0;
17.983166666666666, 27102956315.0;
17.989833333333333, 23486141110.0;
17.9965, 19928272835.0;
18.003166666666665, 16425140995.0;
18.009833333333333, 12980956085.0;
18.0165, 9894663250.0;
18.023166666666665, 6985211205.0;
18.029833333333332, 4581018560.0;
18.0365, 2134720965.0;
18.043166666666668, -21052475.0;
18.049833333333332, -2172615420.0;
18.0565, -4547334600.0;
18.063166666666667, -7536786050.0;
18.06983333333333, -11174653730.0;
18.0765, -15039888140.0;
18.083166666666667, -18614598395.0;
18.08983333333333, -21237736780.0;
18.0965, -23692455365.0;
18.103166666666667, -25540862670.0;
18.109833333333334, -26905063050.0;
18.1165, -28260842440.0;
18.123166666666666, -30008197865.0;
18.129833333333334, -32163971305.0;
18.136499999999998, -33789222375.0;
18.143166666666666, -35839733440.0;
18.149833333333333, -37717614210.0;
18.1565, -38736554000.0;
18.163166666666665, -38340767470.0;
18.169833333333333, -37481826490.0;
18.1765, -37233407285.0;
18.183166666666665, -37157618375.0;
18.189833333333333, -37578667875.0;
18.1965, -38450240340.0;
18.203166666666664, -40029175965.0;
18.209833333333332, -41747057925.0;
18.2165, -42829155140.0;
18.223166666666668, -43107047810.0;
18.229833333333332, -42446000095.0;
18.2365, -41456533770.0;
18.243166666666667, -40121806855.0;
18.24983333333333, -38774448455.0;
18.2565, -37709193220.0;
18.263166666666667, -36900778180.0;
18.269833333333334, -36395518780.0;
18.2765, -35675524135.0;
18.283166666666666, -35292369090.0;
18.289833333333334, -34719741770.0;
18.296499999999998, -34092378015.0;
18.303166666666666, -32900807930.0;
18.309833333333334, -31351345770.0;
18.316499999999998, -29772410145.0;
18.323166666666665, -28138738085.0;
18.329833333333333, -26509276520.0;
18.3365, -24593501295.0;
18.343166666666665, -23246142895.0;
18.349833333333333, -22820882900.0;
18.3565, -22825093395.0;
18.363166666666665, -22829303890.0;
18.369833333333332, -22841935375.0;
18.3765, -23094565075.0;
18.383166666666668, -22884040325.0;
18.389833333333332, -21662996775.0;
18.3965, -20058798180.0;
18.403166666666667, -18404073645.0;
18.40983333333333, -17103030690.0;
18.4165, -16016722980.0;
18.423166666666667, -14964099230.0;
18.429833333333335, -13587267365.0;
18.4365, -11882016890.0;
18.443166666666666, -9936768200.0;
18.449833333333334, -7667311395.0;
18.4565, -5330486670.0;
18.463166666666666, -4008391240.0;
18.469833333333334, -3658920155.0;
18.476499999999998, -3528394810.0;
18.483166666666666, -3301028080.0;
18.489833333333333, -3469447880.0;
18.4965, -3402079960.0;
18.503166666666665, -2134720965.0;
18.509833333333333, -282103165.0;
18.5165, 1069465730.0;
18.523166666666665, 1675777010.0;
18.529833333333332, 2214720370.0;
18.5365, 2277877795.0;
18.543166666666668, 1898933245.0;
18.549833333333332, 1359989885.0;
18.5565, 1385252855.0;
18.563166666666667, 2037879580.0;
18.56983333333333, 3111555805.0;
18.5765, 4614702520.0;
18.583166666666667, 6399952400.0;
18.58983333333333, 8020992975.0;
18.5965, 9006248805.0;
18.603166666666667, 9170458110.0;
18.609833333333334, 8850460490.0;
18.6165, 8416779505.0;
18.623166666666666, 7557838525.0;
18.629833333333334, 6610477150.0;
18.636499999999998, 5907324485.0;
18.643166666666666, 6025218345.0;
18.649833333333333, 6581003685.0;
18.6565, 7183104470.0;
18.663166666666665, 7435734170.0;
18.669833333333333, 7309419320.0;
18.6765, 6993632195.0;
18.683166666666665, 6707318535.0;
18.689833333333333, 6888369820.0;
18.6965, 7494681100.0;
18.703166666666664, 8404148020.0;
18.709833333333332, 9199931575.0;
18.7165, 10180976910.0;
18.723166666666668, 11077812345.0;
18.729833333333332, 11460967390.0;
18.7365, 11170443235.0;
18.743166666666667, 10812551160.0;
18.74983333333333, 11052549375.0;
18.7565, 11385178480.0;
18.763166666666667, 11658860655.0;
18.769833333333334, 11700965605.0;
18.7765, 11511493330.0;
18.783166666666666, 11229390165.0;
18.789833333333334, 11153601255.0;
18.796499999999998, 10837814130.0;
18.803166666666666, 10303081265.0;
18.809833333333334, 9793611370.0;
18.8165, 9852558300.0;
18.823166666666665, 10277818295.0;
18.829833333333333, 10420975125.0;
18.8365, 10450448590.0;
18.843166666666665, 10239923840.0;
18.849833333333333, 10004136120.0;
18.8565, 9465192760.0;
18.863166666666665, 8682040690.0;
18.869833333333332, 7949414560.0;
18.8765, 7242051400.0;
18.883166666666668, 7187314965.0;
18.889833333333332, 7566259515.0;
18.8965, 8686251185.0;
18.903166666666667, 9970452160.0;
18.90983333333333, 10850445615.0;
18.9165, 11940963820.0;
18.923166666666667, 12711484405.0;
18.929833333333335, 13385163605.0;
18.9365, 13162007370.0;
18.943166666666666, 12517801635.0;
18.949833333333334, 12172541045.0;
18.9565, 11945174315.0;
18.963166666666666, 11882016890.0;
18.969833333333334, 11254653135.0;
18.976499999999998, 11031496900.0;
18.983166666666666, 11132548780.0;
18.989833333333333, 11254653135.0;
18.9965, 11073601850.0;
19.003166666666665, 10665183835.0;
19.009833333333333, 10644131360.0;
19.0165, 10442027600.0;
19.023166666666665, 10218871365.0;
19.029833333333332, 10092556515.0;
19.0365, 10105188000.0;
19.043166666666668, 9793611370.0;
19.049833333333332, 9583086620.0;
19.0565, 9633612560.0;
19.063166666666667, 9684138500.0;
19.06983333333333, 9562034145.0;
19.0765, 9258878505.0;
19.083166666666667, 9140984645.0;
19.08983333333333, 8568357325.0;
19.0965, 7860994165.0;
19.103166666666667, 7482049615.0;
19.109833333333334, 7305208825.0;
19.1165, 6749423485.0;
19.123166666666666, 5949429435.0;
19.129833333333334, 5322065680.0;
19.136499999999998, 5376802115.0;
19.143166666666666, 5625221320.0;
19.149833333333333, 5966271415.0;
19.1565, 6585214180.0;
19.163166666666665, 7153631005.0;
19.169833333333333, 7793626245.0;
19.1765, 7886257135.0;
19.183166666666665, 7511523080.0;
19.189833333333333, 6850475365.0;
19.1965, 6239953590.0;
19.203166666666664, 6623108635.0;
19.209833333333332, 7077842095.0;
19.2165, 7317840310.0;
19.223166666666668, 6926264275.0;
19.229833333333332, 6568372200.0;
19.2365, 6311532005.0;
19.243166666666667, 5802062110.0;
19.24983333333333, 5233645285.0;
19.2565, 4976805090.0;
19.263166666666667, 5414696570.0;
19.269833333333334, 5650484290.0;
19.2765, 5507327460.0;
19.283166666666666, 4530492620.0;
19.289833333333334, 3418921940.0;
19.296499999999998, 2319982745.0;
19.303166666666666, 1658935030.0;
19.309833333333334, 1549462160.0;
19.3165, 1650514040.0;
19.323166666666665, 1772618395.0;
19.329833333333333, 2172615420.0;
19.3365, 2934715015.0;
19.343166666666665, 3709446095.0;
19.349833333333333, 3941023320.0;
19.3565, 3642078175.0;
19.363166666666665, 3385237980.0;
19.369833333333332, 3393658970.0;
19.3765, 2922083530.0;
19.383166666666668, 2067353045.0;
19.389833333333332, 1128412660.0;
19.3965, 1153675630.0;
19.403166666666667, 1696829485.0;
19.40983333333333, 1890512255.0;
19.4165, 2147352450.0;
19.423166666666667, 2492613040.0;
19.429833333333335, 3233660160.0;
19.4365, 3465237385.0;
19.443166666666666, 3507342335.0;
19.449833333333334, 3372606495.0;
19.4565, 3136818775.0;
19.463166666666666, 2698927295.0;
19.469833333333334, 1928406710.0;
19.476499999999998, 1132623155.0;
19.483166666666666, 787362565.0;
19.489833333333333, 1128412660.0;
19.4965, 1713671465.0;
19.503166666666665, 2067353045.0;
19.509833333333333, 2997872440.0;
19.5165, 4517861135.0;
19.523166666666665, 5806272605.0;
19.529833333333332, 6349426460.0;
19.5365, 6467320320.0;
19.543166666666668, 6854685860.0;
19.549833333333332, 6555740715.0;
19.5565, 5444170035.0;
19.563166666666667, 4096811635.0;
19.56983333333333, 3132608280.0;
19.5765, 2479981555.0;
19.583166666666667, 1212622560.0;
19.58983333333333, 4210495.0;
19.5965, -395786530.0;
19.603166666666667, -71578415.0;
19.609833333333334, 244208710.0;
19.6165, -138946335.0;
19.623166666666666, -345260590.0;
19.629833333333334, -307366135.0;
19.636499999999998, -227366730.0;
19.643166666666666, -298945145.0;
19.649833333333333, -181051285.0;
19.6565, 425259995.0;
19.663166666666665, 1595777605.0;
19.669833333333333, 2816821155.0;
19.6765, 3869444905.0;
19.683166666666665, 4159969060.0;
19.689833333333333, 3650499165.0;
19.6965, 2665243335.0;
19.703166666666668, 1338937410.0;
19.709833333333332, 25262970.0;
19.7165, -976834840.0;
19.723166666666668, -1355779390.0;
19.729833333333332, -1250517015.0;
19.7365, -808415040.0;
19.743166666666667, -96841385.0;
19.74983333333333, 1141044145.0;
19.7565, 1974722155.0;
19.763166666666667, 2341035220.0;
19.769833333333334, 2884189075.0;
19.7765, 3692604115.0;
19.783166666666666, 4239968465.0;
19.789833333333334, 3726288075.0;
19.796499999999998, 2964188480.0;
19.803166666666666, 2399982150.0;
19.809833333333334, 1406305330.0;
19.8165, 530522370.0;
19.823166666666665, 446312470.0;
19.829833333333333, 1726302950.0;
19.8365, 3511552830.0;
19.843166666666665, 4757859350.0;
19.849833333333333, 5738904685.0;
19.8565, 5873640525.0;
19.863166666666665, 5279960730.0;
19.869833333333332, 3696814610.0;
19.8765, 1785249880.0;
19.883166666666668, 277892670.0;
19.889833333333332, -341050095.0;
19.8965, -58946930.0;
19.903166666666667, 534732865.0;
19.90983333333333, 1002097810.0;
19.9165, 1023150285.0;
19.923166666666667, 783152070.0;
19.929833333333335, 50525940.0;
19.9365, -673679200.0;
19.943166666666666, -1258938005.0;
19.949833333333334, -1343147905.0;
19.9565, -1128412660.0;
##END=

$$ === CHEMSPECTRA INTEGRALS AND MULTIPLETS ===
##PAGE=230
##$OBSERVEDINTEGRALS= (X Y Z)
(2.0, 4.2, 15489366902240.0)
##$OBSERVEDMULTIPLETS=
##$OBSERVEDMULTIPLETSPEAKS=
##END=

$$ === CHEMSPECTRA PEAK TABLE EDIT ===
##TITLE=618becfe-a0ce-4983-ba36-5fdcbb7ed595
##JCAMP-DX=5.00
##DATA TYPE=LC/MSPEAKTABLE
##DATA CLASS=PEAKTABLE
##$CSCATEGORY=EDIT_PEAK
##$CSTHRESHOLD=0.05
##MAXX=19.9565
##MAXY=15489366902240.0
##MINX=-0.0435
##MINY=-875054544365.0
##PAGE=230
##NPOINTS=2
##PEAKTABLE= (XY..XY)
14.149833333333333, 1513719267945.0
14.883166666666668, 1512843484985.0
##END=

$$ === CHEMSPECTRA PEAK TABLE AUTO ===
##TITLE=618becfe-a0ce-4983-ba36-5fdcbb7ed595
##JCAMP-DX=5.00
##DATA TYPE=LC/MSPEAKTABLE
##DATA CLASS=PEAKTABLE
##$CSCATEGORY=AUTO_PEAK
##$CSTHRESHOLD=0.05
##MAXX=19.9565
##MAXY=15489366902240.0
##MINX=-0.0435
##MINY=-875054544365.0
##PAGE=230
##NPOINTS=0
##PEAKTABLE= (XY..XY)
##END=

$$ === CHEMSPECTRA UVVIS PEAK TABLE ===
##TITLE=618becfe-a0ce-4983-ba36-5fdcbb7ed595
##JCAMP-DX=5.00
##DATA TYPE=LC/MS
##DATA CLASS=PEAK TABLE
##ORIGIN=
##OWNER=
##XUNITS=RETENTION TIME
##YUNITS=DETECTOR SIGNAL
##$CSCATEGORY=UVVIS PEAK TABLE
##PAGE=254
##NPOINTS=3001
##DATA TABLE= (XY..XY), PEAKS
-0.0435, -3671551640.0;
-0.03683333333333333, -3355764515.0;
-0.03016666666666666, -2930504520.0;
-0.023499999999999997, -2269456805.0;
-0.01683333333333333, -1730513445.0;
-0.010166666666666664, -1376831865.0;
-0.003499999999999996, -1461041765.0;
0.003166666666666672, -2004195620.0;
0.00983333333333334, -2576822940.0;
0.016500000000000008, -3010503925.0;
0.02316666666666667, -3069450855.0;
0.029833333333333337, -2850505115.0;
0.036500000000000005, -2362087695.0;
0.04316666666666667, -1696829485.0;
0.04983333333333334, -1094728700.0;
0.05650000000000001, -930519395.0;
0.06316666666666668, -993676820.0;
0.06983333333333334, -1056834245.0;
0.07650000000000001, -1065255235.0;
0.08316666666666668, -1044202760.0;
0.08983333333333333, -964203355.0;
0.09650000000000002, -867361970.0;
0.10316666666666667, -1052623750.0;
0.10983333333333335, -1376831865.0;
0.1165, -1591567110.0;
0.12316666666666669, -1448410280.0;
0.12983333333333336, -1191570085.0;
0.1365, -627363755.0;
0.14316666666666666, 134735840.0;
0.14983333333333337, 673679200.0;
0.15650000000000003, 981045335.0;
0.16316666666666668, 837888505.0;
0.16983333333333334, 501048905.0;
0.1765, -138946335.0;
0.1831666666666667, -492627915.0;
0.18983333333333335, -517890885.0;
0.1965, -454733460.0;
0.20316666666666666, -707363160.0;
0.20983333333333337, -1170517610.0;
0.21650000000000003, -1410515825.0;
0.22316666666666668, -1515778200.0;
0.2298333333333334, -1166307115.0;
0.23650000000000004, -816836030.0;
0.2431666666666667, -147367325.0;
0.24983333333333335, 673679200.0;
0.25650000000000006, 1343147905.0;
0.2631666666666667, 1402094835.0;
0.26983333333333337, 749468110.0;
0.2765, 138946335.0;
0.2831666666666667, -202103760.0;
0.2898333333333334, -534732865.0;
0.29650000000000004, -821046525.0;
0.3031666666666667, -959992860.0;
0.30983333333333335, -1048413255.0;
0.31650000000000006, -1347358400.0;
0.3231666666666667, -1873670275.0;
0.32983333333333337, -2092616015.0;
0.3365, -2181036410.0;
0.34316666666666673, -1966301165.0;
0.3498333333333334, -1587356615.0;
0.35650000000000004, -1237885530.0;
0.3631666666666667, -909466920.0;
0.3698333333333334, -901045930.0;
0.37650000000000006, -644205735.0;
0.3831666666666667, -568416825.0;
0.38983333333333337, -479996430.0;
0.3965, -79999405.0;
0.40316666666666673, 551574845.0;
0.4098333333333334, 1061044740.0;
0.41650000000000004, 677889695.0;
0.4231666666666667, -122104355.0;
0.4298333333333334, -1035781770.0;
0.43650000000000005, -2046300570.0;
0.4431666666666667, -3035766895.0;
0.44983333333333336, -3650499165.0;
0.4565, -3684183125.0;
0.4631666666666667, -3330501545.0;
0.46983333333333344, -2926294025.0;
0.47650000000000003, -2513665515.0;
0.48316666666666674, -2324193240.0;
0.48983333333333334, -2218930865.0;
0.49650000000000005, -2075774035.0;
0.5031666666666668, -1962090670.0;
0.5098333333333334, -1890512255.0;
0.5165000000000001, -2075774035.0;
0.5231666666666667, -2227351855.0;
0.5298333333333334, -2501034030.0;
0.5365000000000001, -2854715610.0;
0.5431666666666667, -3187344715.0;
0.5498333333333334, -3389448475.0;
0.5565000000000001, -2930504520.0;
0.5631666666666667, -2147352450.0;
0.5698333333333334, -1216833055.0;
0.5765, -673679200.0;
0.5831666666666667, -703152665.0;
0.5898333333333334, -947361375.0;
0.5965, -1402094835.0;
0.6031666666666667, -1776828890.0;
0.6098333333333333, -2138931460.0;
0.6165, -2374719180.0;
0.6231666666666668, -2298930270.0;
0.6298333333333334, -1978932650.0;
0.6365000000000001, -2202088885.0;
0.6431666666666668, -2934715015.0;
0.6498333333333334, -3882076390.0;
0.6565000000000001, -4315757375.0;
0.6631666666666667, -4138916585.0;
0.6698333333333334, -3903128865.0;
0.6765000000000001, -3414711445.0;
0.6831666666666667, -3010503925.0;
0.6898333333333334, -2471560565.0;
0.6965000000000001, -1999985125.0;
0.7031666666666667, -1612619585.0;
0.7098333333333334, -1785249880.0;
0.7165, -2105247500.0;
0.7231666666666667, -2273667300.0;
0.7298333333333334, -2370508685.0;
0.7365, -2345245715.0;
0.7431666666666668, -2778926700.0;
0.7498333333333334, -2833663135.0;
0.7565000000000001, -2715769275.0;
0.7631666666666668, -2341035220.0;
0.7698333333333334, -1949459185.0;
0.7765000000000001, -2084195025.0;
0.7831666666666668, -2214720370.0;
0.7898333333333334, -2421034625.0;
0.7965000000000001, -2433666110.0;
0.8031666666666667, -2362087695.0;
0.8098333333333334, -2294719775.0;
0.8165000000000001, -2016827105.0;
0.8231666666666667, -1835775820.0;
0.8298333333333334, -1713671465.0;
0.8365, -1642093050.0;
0.8431666666666667, -1633672060.0;
0.8498333333333334, -1427357805.0;
0.8565, -1279990480.0;
0.8631666666666667, -1077886720.0;
0.8698333333333335, -997887315.0;
0.8765000000000001, -808415040.0;
0.8831666666666668, -736836625.0;
0.8898333333333334, -1258938005.0;
0.8965000000000001, -2126299975.0;
0.9031666666666668, -2635769870.0;
0.9098333333333334, -2547349475.0;
0.9165000000000001, -2458929080.0;
0.9231666666666667, -2231562350.0;
0.9298333333333334, -1347358400.0;
0.9365000000000001, 197893265.0;
0.9431666666666667, 1882091265.0;
0.9498333333333334, 3204186695.0;
0.9565, 4248389455.0;
0.9631666666666668, 4639965490.0;
0.9698333333333334, 4530492620.0;
0.9765, 4021022725.0;
0.9831666666666669, 3225239170.0;
0.9898333333333335, 2227351855.0;
0.9965, 1376831865.0;
1.0031666666666665, 1141044145.0;
1.0098333333333334, 1094728700.0;
1.0165, 1309463945.0;
1.0231666666666666, 1528409685.0;
1.0298333333333334, 2025248095.0;
1.0365, 2492613040.0;
1.0431666666666666, 2863136600.0;
1.0498333333333334, 3705235600.0;
1.0565, 4892595190.0;
1.0631666666666666, 6421004875.0;
1.0698333333333334, 7764152780.0;
1.0765, 8631514750.0;
1.0831666666666666, 8829408015.0;
1.0898333333333332, 7705205850.0;
1.0965, 5111540930.0;
1.1031666666666666, 1275779985.0;
1.1098333333333332, -3852602925.0;
1.1165, -12660958465.0;
1.1231666666666666, -29477675495.0;
1.1298333333333332, -56496421910.0;
1.1365, -90121434980.0;
1.1431666666666667, -122222248860.0;
1.1498333333333333, -143657878905.0;
1.1565, -146142070955.0;
1.1631666666666667, -124984333580.0;
1.1698333333333333, -81363605380.0;
1.1764999999999999, -23094565075.0;
1.1831666666666667, 38349188460.0;
1.1898333333333333, 92369839310.0;
1.1965, 131784283005.0;
1.2031666666666667, 155619895200.0;
1.2098333333333333, 167207177440.0;
1.2165, 170916623535.0;
1.2231666666666667, 170070314040.0;
1.2298333333333333, 166440867350.0;
1.2365, 161973532155.0;
1.2431666666666668, 156933569640.0;
1.2498333333333334, 150133620215.0;
1.2565, 136946349875.0;
1.2631666666666665, 111161278495.0;
1.2698333333333334, 69730007695.0;
1.2765, 15334622790.0;
1.2831666666666666, -43561781270.0;
1.2898333333333334, -97835061820.0;
1.2965, -139552646280.0;
1.3031666666666666, -161708270970.0;
1.3098333333333334, -162285108785.0;
1.3165, -145304182450.0;
1.3231666666666666, -120167527300.0;
1.3298333333333334, -95321396305.0;
1.3365, -74239447840.0;
1.3431666666666666, -58033252585.0;
1.3498333333333332, -45911237480.0;
1.3565, -37102881940.0;
1.3631666666666666, -30109249745.0;
1.3698333333333332, -24639816740.0;
1.3765, -20538794610.0;
1.3831666666666667, -17241977025.0;
1.3898333333333333, -14277788545.0;
1.3965, -11962016295.0;
1.4031666666666667, -10500974530.0;
1.4098333333333333, -9183089595.0;
1.4165, -7722047830.0;
1.4231666666666667, -6416794380.0;
1.4298333333333333, -5802062110.0;
1.4365, -5330486670.0;
1.4431666666666667, -4778911825.0;
1.4498333333333333, -4159969060.0;
1.4565, -3418921940.0;
1.4631666666666667, -2543138980.0;
1.4698333333333333, -1242096025.0;
1.4765, 101051880.0;
1.4831666666666667, 1178938600.0;
1.4898333333333333, 2029458590.0;
1.4965, 2555770465.0;
1.5031666666666668, 2884189075.0;
1.5098333333333334, 2821031650.0;
1.5165, 2391561160.0;
1.5231666666666668, 1772618395.0;
1.5298333333333334, 888414445.0;
1.5365, -202103760.0;
1.5431666666666666, -1515778200.0;
1.5498333333333334, -2669453830.0;
1.5565, -3077871845.0;
1.5631666666666666, -2719979770.0;
1.5698333333333334, -1797881365.0;
1.5765, -703152665.0;
1.5831666666666666, 79999405.0;
1.5898333333333334, 530522370.0;
1.5965, 694731675.0;
1.6031666666666666, 913677415.0;
1.6098333333333334, 1107360185.0;
1.6165, 1199991075.0;
1.6231666666666666, 1477883745.0;
1.6298333333333332, 1705250475.0;
1.6365, 1671566515.0;
1.6431666666666667, 1191570085.0;
1.6498333333333333, 799994050.0;
1.6565, 825257020.0;
1.6631666666666667, 1115781175.0;
1.6698333333333333, 1621040575.0;
1.6765, 2357877200.0;
1.6831666666666667, 3343133030.0;
1.6898333333333333, 4071548665.0;
1.6965000000000001, 4033654210.0;
1.7031666666666667, 3637867680.0;
1.7098333333333333, 3507342335.0;
1.7165, 3528394810.0;
1.7231666666666667, 3785235005.0;
1.7298333333333333, 3907339360.0;
1.7365, 4353651830.0;
1.7431666666666668, 5056804495.0;
1.7498333333333334, 5482064490.0;
1.7565, 5604168845.0;
1.7631666666666668, 5027331030.0;
1.7698333333333334, 4450493215.0;
1.7765, 4159969060.0;
1.7831666666666668, 3759972035.0;
1.7898333333333334, 3385237980.0;
1.7965, 3065240360.0;
1.8031666666666666, 2884189075.0;
1.8098333333333334, 3086292835.0;
1.8165, 3157871250.0;
1.8231666666666666, 3258923130.0;
1.8298333333333334, 3178923725.0;
1.8365, 2871557590.0;
1.8431666666666666, 2589454425.0;
1.8498333333333334, 1789460375.0;
1.8565, 665258210.0;
1.8631666666666666, -21052475.0;
1.8698333333333335, -117893860.0;
1.8765, 252629700.0;
1.8831666666666667, 652626725.0;
1.8898333333333333, 993676820.0;
1.8965, 1254727510.0;
1.9031666666666667, 774731080.0;
1.9098333333333333, 214735245.0;
1.9165, 63157425.0;
1.9231666666666667, 109472870.0;
1.9298333333333333, 265261185.0;
1.9365, 378944550.0;
1.9431666666666667, 837888505.0;
1.9498333333333333, 1035781770.0;
1.9565, 736836625.0;
1.9631666666666667, 627363755.0;
1.9698333333333335, 938940385.0;
1.9765, 1621040575.0;
1.9831666666666667, 2029458590.0;
1.9898333333333336, 1844196810.0;
1.9965, 1389463350.0;
2.003166666666667, 829467515.0;
2.009833333333334, 509469895.0;
2.0165, 294734650.0;
2.023166666666667, 223156235.0;
2.0298333333333334, 261050690.0;
2.0365, 395786530.0;
2.043166666666667, 509469895.0;
2.0498333333333334, 311576630.0;
2.0565, 206314255.0;
2.063166666666667, 429470490.0;
2.0698333333333334, 1233675035.0;
2.0765000000000002, 1966301165.0;
2.083166666666667, 2454718585.0;
2.0898333333333334, 2479981555.0;
2.0965000000000003, 2050511065.0;
2.103166666666667, 1250517015.0;
2.1098333333333334, 589469300.0;
2.1165000000000003, 408418015.0;
2.123166666666667, 353681580.0;
2.1298333333333335, 425259995.0;
2.1365000000000003, 538943360.0;
2.143166666666667, 837888505.0;
2.1498333333333335, 1061044740.0;
2.1565000000000003, 1010518800.0;
2.163166666666667, 913677415.0;
2.1698333333333335, 1061044740.0;
2.1765000000000003, 1494725725.0;
2.183166666666667, 1911564730.0;
2.1898333333333335, 1978932650.0;
2.1965000000000003, 1709460970.0;
2.2031666666666667, 1111570680.0;
2.2098333333333335, 484206925.0;
2.2165000000000004, 248419205.0;
2.2231666666666667, 36454465710.0;
2.2298333333333336, 348161621055.0;
2.2365000000000004, 1257279069970.0;
2.2431666666666668, 2802164421905.0;
2.2498333333333336, 4591645849380.0;
2.2565000000000004, 6084055802130.0;
2.2631666666666668, 7006175259605.0;
2.2698333333333336, 7198165410615.0;
2.2765000000000004, 6529252490955.0;
2.283166666666667, 5110909355750.0;
2.2898333333333336, 3399431558645.0;
2.2965000000000004, 1960309630615.0;
2.303166666666667, 1042177511905.0;
2.3098333333333336, 571263119620.0;
2.3165000000000004, 359563641515.0;
2.323166666666667, 258848601115.0;
2.3298333333333336, 204512163140.0;
2.3365000000000005, 172802925295.0;
2.343166666666667, 152950441370.0;
2.3498333333333337, 139982116770.0;
2.3565000000000005, 131295865585.0;
2.363166666666667, 125253805260.0;
2.3698333333333337, 120959100360.0;
2.3765000000000005, 117797018615.0;
2.383166666666667, 115165459240.0;
2.3898333333333337, 112816003030.0;
2.3965, 110681282065.0;
2.403166666666667, 109178135350.0;
2.4098333333333337, 108184458530.0;
2.4165, 107590778735.0;
2.423166666666667, 107384464480.0;
2.4298333333333337, 107839197940.0;
2.4365, 108251826450.0;
2.443166666666667, 108247615955.0;
2.4498333333333338, 107885513385.0;
2.4565, 107797092990.0;
2.463166666666667, 108083406650.0;
2.4698333333333338, 107948670810.0;
2.4765, 107552884280.0;
2.483166666666667, 106736048250.0;
2.489833333333334, 106032895585.0;
2.4965, 105064481735.0;
2.503166666666667, 103738175810.0;
2.509833333333334, 102357133450.0;
2.5165, 101228720790.0;
2.523166666666667, 101211878810.0;
2.529833333333334, 101957136425.0;
2.5365, 103098180570.0;
2.543166666666667, 104209751250.0;
2.549833333333334, 105321321930.0;
2.5565, 106719206270.0;
2.563166666666667, 107893934375.0;
2.5698333333333334, 108849716740.0;
2.5765000000000002, 109797078115.0;
2.583166666666667, 111232856910.0;
2.5898333333333334, 113342314905.0;
2.5965000000000003, 115691771115.0;
2.603166666666667, 117775966140.0;
2.6098333333333334, 119190692460.0;
2.6165000000000003, 120058054430.0;
2.623166666666667, 120175948290.0;
2.6298333333333335, 119304375825.0;
2.6365000000000003, 117514915450.0;
2.643166666666667, 115641245175.0;
2.6498333333333335, 113986520640.0;
2.6565000000000003, 112087587395.0;
2.663166666666667, 109498132970.0;
2.6698333333333335, 106584470430.0;
2.6765000000000003, 103927648085.0;
2.683166666666667, 101590823360.0;
2.6898333333333335, 99249788140.0;
2.6965000000000003, 96807701040.0;
2.703166666666667, 94967714725.0;
2.7098333333333335, 93910880480.0;
2.7165000000000004, 93388779100.0;
2.723166666666667, 92677205445.0;
2.7298333333333336, 91738265060.0;
2.7365000000000004, 90917218535.0;
2.7431666666666668, 90108803495.0;
2.7498333333333336, 89073021725.0;
2.7565000000000004, 87814083720.0;
2.7631666666666668, 86529882745.0;
2.7698333333333336, 85430943550.0;
2.7765000000000004, 84517266135.0;
2.783166666666667, 83894112875.0;
2.7898333333333336, 83334117040.0;
2.7965000000000004, 82580438435.0;
2.803166666666667, 81948864185.0;
2.8098333333333336, 81388868350.0;
2.8165000000000004, 81026765780.0;
2.823166666666667, 80483611925.0;
2.8298333333333336, 79915195100.0;
2.8365000000000005, 79081517090.0;
2.843166666666667, 77540475920.0;
2.8498333333333337, 75456280895.0;
2.8565000000000005, 72921562905.0;
2.863166666666667, 70315266500.0;
2.8698333333333337, 67687917620.0;
2.8765000000000005, 64988990325.0;
2.883166666666667, 62774269955.0;
2.8898333333333337, 61245860270.0;
2.8965000000000005, 60092184640.0;
2.903166666666667, 59090086830.0;
2.9098333333333337, 57755359915.0;
2.9165000000000005, 56934313390.0;
2.923166666666667, 56113266865.0;
2.9298333333333337, 55048011630.0;
2.9365, 54054334810.0;
2.943166666666667, 53149078385.0;
2.9498333333333338, 52576451065.0;
2.9565, 51906982360.0;
2.963166666666667, 51380670485.0;
2.9698333333333338, 50837516630.0;
2.9765, 49944891690.0;
2.983166666666667, 48643848735.0;
2.989833333333334, 47224911920.0;
2.9965, 45961763420.0;
3.003166666666667, 44858613730.0;
3.009833333333334, 43915462850.0;
3.0165, 43077574345.0;
3.023166666666667, 42454421085.0;
3.029833333333334, 42231264850.0;
3.0365, 41839688815.0;
3.043166666666667, 41490217730.0;
3.049833333333334, 41027063280.0;
3.0565, 40791275560.0;
3.063166666666667, 40509172395.0;
3.069833333333334, 40096543885.0;
3.0765000000000002, 39309181320.0;
3.083166666666667, 37683930250.0;
3.089833333333334, 35544998790.0;
3.0965000000000003, 33195542580.0;
3.103166666666667, 31006085180.0;
3.1098333333333334, 28652418475.0;
3.1165000000000003, 26770327210.0;
3.123166666666667, 25494547225.0;
3.1298333333333335, 24652448225.0;
3.1365000000000003, 23629297940.0;
3.143166666666667, 22627200130.0;
3.1498333333333335, 21869311030.0;
3.1565000000000003, 21246157770.0;
3.163166666666667, 20576689065.0;
3.1698333333333335, 19860904915.0;
3.1765000000000003, 19191436210.0;
3.183166666666667, 18429336615.0;
3.1898333333333335, 17540922170.0;
3.1965000000000003, 16795664555.0;
3.203166666666667, 16029354465.0;
3.2098333333333335, 15427253680.0;
3.2165000000000004, 15132519030.0;
3.223166666666667, 15296728335.0;
3.2298333333333336, 15776724765.0;
3.2365000000000004, 15983039020.0;
3.243166666666667, 15823040210.0;
3.2498333333333336, 15254623385.0;
3.2565000000000004, 14753574480.0;
3.263166666666667, 14260946565.0;
3.2698333333333336, 13629372315.0;
3.2765000000000004, 12926219650.0;
3.283166666666667, 12496749160.0;
3.2898333333333336, 12610432525.0;
3.2965000000000004, 12391486785.0;
3.303166666666667, 11726228575.0;
3.3098333333333336, 10762025220.0;
3.3165000000000004, 9802032360.0;
3.323166666666667, 8816776530.0;
3.3298333333333336, 7553628030.0;
3.3365000000000005, 6757844475.0;
3.343166666666667, 6399952400.0;
3.3498333333333337, 6442057350.0;
3.3565000000000005, 6408373390.0;
3.363166666666667, 6399952400.0;
3.3698333333333337, 6509425270.0;
3.3765000000000005, 6484162300.0;
3.383166666666667, 6218901115.0;
3.3898333333333337, 5473643500.0;
3.3965000000000005, 4816806280.0;
3.403166666666667, 4277862920.0;
3.4098333333333337, 3827339955.0;
3.4165000000000005, 3288396595.0;
3.423166666666667, 2677874820.0;
3.4298333333333337, 2269456805.0;
3.4365000000000006, 1713671465.0;
3.443166666666667, 1208412065.0;
3.4498333333333338, 602100785.0;
3.4565000000000006, -235787720.0;
3.463166666666667, -1119991670.0;
3.4698333333333338, -1439989290.0;
3.4765, -1153675630.0;
3.483166666666667, -1086307710.0;
3.489833333333334, -1482094240.0;
3.4965, -1536830675.0;
3.503166666666667, -968413850.0;
3.509833333333334, -433680985.0;
3.5165, -463154450.0;
3.523166666666667, -618942765.0;
3.529833333333334, -517890885.0;
3.5365, -509469895.0;
3.543166666666667, -1090518205.0;
3.549833333333334, -2105247500.0;
3.5565, -2648401355.0;
3.563166666666667, -2652611850.0;
3.569833333333334, -2492613040.0;
3.5765000000000002, -2509455020.0;
3.583166666666667, -2298930270.0;
3.589833333333334, -2071563540.0;
3.5965000000000003, -2265246310.0;
3.603166666666667, -3077871845.0;
3.609833333333334, -4050496190.0;
3.6165000000000003, -4724175390.0;
3.623166666666667, -5233645285.0;
3.629833333333334, -5490485480.0;
3.6365000000000003, -5587326865.0;
3.643166666666667, -5317855185.0;
3.6498333333333335, -4867332220.0;
3.6565000000000003, -4433651235.0;
3.663166666666667, -4332599355.0;
3.6698333333333335, -4602071035.0;
3.6765000000000003, -5301013205.0;
3.683166666666667, -6096796760.0;
3.6898333333333335, -6669424080.0;
3.6965000000000003, -6926264275.0;
3.703166666666667, -6787317940.0;
3.7098333333333335, -6488372795.0;
3.7165000000000004, -5919955970.0;
3.723166666666667, -5486274985.0;
3.7298333333333336, -5381012610.0;
3.7365000000000004, -5461012015.0;
3.743166666666667, -5768378150.0;
3.7498333333333336, -6387320915.0;
3.7565000000000004, -7254682885.0;
3.763166666666667, -8037834955.0;
3.7698333333333336, -8311517130.0;
3.7765000000000004, -8766250590.0;
3.7831666666666672, -9229405040.0;
3.7898333333333336, -9410456325.0;
3.7965000000000004, -8993617320.0;
3.8031666666666673, -8159939310.0;
3.8098333333333336, -7642048425.0;
3.8165000000000004, -7023105660.0;
3.823166666666667, -6766265465.0;
3.8298333333333336, -6677845070.0;
3.8365000000000005, -6842054375.0;
3.843166666666667, -7128368035.0;
3.8498333333333337, -7482049615.0;
3.8565000000000005, -8324148615.0;
3.863166666666667, -8766250590.0;
3.8698333333333337, -8875723460.0;
3.8765000000000005, -8555725840.0;
3.883166666666667, -8572567820.0;
3.8898333333333337, -8795724055.0;
3.8965000000000005, -8660988215.0;
3.903166666666667, -8513620890.0;
3.9098333333333337, -8210465250.0;
3.9165000000000005, -8336780100.0;
3.923166666666667, -8319938120.0;
3.9298333333333337, -8210465250.0;
3.9365000000000006, -8075729410.0;
3.943166666666667, -8332569605.0;
3.9498333333333338, -9199931575.0;
3.9565, -10180976910.0;
3.963166666666667, -11014654920.0;
3.9698333333333338, -11734649565.0;
3.9765000000000006, -12555696090.0;
3.9831666666666674, -13090428955.0;
3.9898333333333333, -13140954895.0;
3.9965, -12842009750.0;
4.003166666666667, -12589380050.0;
4.009833333333334, -12138857085.0;
4.016500000000001, -11456756895.0;
4.0231666666666674, -10917813535.0;
4.029833333333333, -10993602445.0;
4.0365, -11587282240.0;
4.043166666666667, -12130436095.0;
4.049833333333334, -12517801635.0;
4.056500000000001, -13014640045.0;
4.0631666666666675, -13726213700.0;
4.069833333333333, -13962001420.0;
4.0765, -13637793305.0;
4.083166666666667, -13098849945.0;
4.089833333333334, -13044113510.0;
4.096500000000001, -13355690140.0;
4.103166666666667, -13545162415.0;
4.1098333333333334, -13886212510.0;
4.1165, -14576733690.0;
4.123166666666667, -15528305560.0;
4.129833333333334, -16151458820.0;
4.136500000000001, -16012512485.0;
4.143166666666667, -15444095660.0;
4.1498333333333335, -14863047350.0;
4.1565, -14273578050.0;
4.163166666666667, -13827265580.0;
4.169833333333334, -13557793900.0;
4.176500000000001, -13663056275.0;
4.183166666666667, -13983053895.0;
4.1898333333333335, -14324103990.0;
4.1965, -14728311510.0;
4.203166666666667, -15187255465.0;
4.209833333333334, -15591462985.0;
4.216500000000001, -16016722980.0;
4.223166666666667, -16450403965.0;
4.229833333333334, -16820927525.0;
4.2365, -17081978215.0;
4.243166666666667, -17107241185.0;
4.249833333333334, -17119872670.0;
4.256500000000001, -17376712865.0;
4.263166666666667, -17860919790.0;
4.269833333333334, -18500915030.0;
4.2765, -18964069480.0;
4.283166666666667, -19435644920.0;
4.289833333333334, -19545117790.0;
4.2965, -19237751655.0;
4.303166666666667, -18555651465.0;
4.309833333333334, -17578816625.0;
4.3165000000000004, -16909347920.0;
4.323166666666667, -16260931690.0;
4.329833333333334, -16113564365.0;
4.3365, -16037775455.0;
4.343166666666667, -16357773075.0;
4.349833333333334, -16867242970.0;
4.3565000000000005, -17111451680.0;
4.363166666666667, -17237766530.0;
4.369833333333334, -17372502370.0;
4.3765, -17877761770.0;
4.383166666666667, -18050392065.0;
4.389833333333334, -18075655035.0;
4.3965000000000005, -18033550085.0;
4.403166666666667, -18176706915.0;
4.409833333333334, -18210390875.0;
4.4165, -17776709890.0;
4.423166666666667, -17385133855.0;
4.429833333333334, -17132504155.0;
4.4365000000000006, -17300923955.0;
4.443166666666667, -17355660390.0;
4.449833333333333, -17465133260.0;
4.4565, -18147233450.0;
4.463166666666667, -18867228095.0;
4.469833333333334, -19456697395.0;
4.476500000000001, -19157752250.0;
4.483166666666667, -18804070670.0;
4.489833333333333, -18168285925.0;
4.4965, -17448291280.0;
4.503166666666667, -16926189900.0;
4.509833333333334, -16252510700.0;
4.516500000000001, -15671462390.0;
4.5231666666666674, -14711469530.0;
4.529833333333333, -14100947755.0;
4.5365, -13966211915.0;
4.543166666666667, -14189368150.0;
4.549833333333334, -14669364580.0;
4.556500000000001, -15309359820.0;
4.5631666666666675, -16340931095.0;
4.569833333333333, -17317765935.0;
4.5765, -17444080785.0;
4.583166666666667, -17208293065.0;
4.589833333333334, -17014610295.0;
4.596500000000001, -17220924550.0;
4.6031666666666675, -17389344350.0;
4.6098333333333334, -17359870885.0;
4.6165, -17503027715.0;
4.623166666666667, -17389344350.0;
4.629833333333334, -17355660390.0;
4.636500000000001, -17473554250.0;
4.643166666666667, -17730394445.0;
4.6498333333333335, -17966182165.0;
4.6565, -17894603750.0;
4.663166666666667, -18016708105.0;
4.669833333333334, -18143022955.0;
4.676500000000001, -17961971670.0;
4.683166666666667, -17545132665.0;
4.6898333333333335, -17250398015.0;
4.6965, -17519869695.0;
4.703166666666667, -17625132070.0;
4.709833333333334, -17237766530.0;
4.716500000000001, -16559876835.0;
4.723166666666667, -16210405750.0;
4.729833333333334, -16033564960.0;
4.7365, -15557779025.0;
4.743166666666667, -15014625170.0;
4.749833333333334, -14825152895.0;
4.756500000000001, -15292517840.0;
4.763166666666667, -15860934665.0;
4.769833333333334, -16315668125.0;
4.7765, -16534613865.0;
4.783166666666667, -16829348515.0;
4.789833333333334, -17208293065.0;
4.796500000000001, -17570395635.0;
4.803166666666667, -17709341970.0;
4.809833333333334, -17785130880.0;
4.8165000000000004, -17978813650.0;
4.823166666666667, -18244074835.0;
4.829833333333334, -18151443945.0;
4.8365, -17599869100.0;
4.843166666666667, -16896716435.0;
4.849833333333334, -16446193470.0;
4.8565000000000005, -16256721195.0;
4.863166666666667, -16004091495.0;
4.869833333333334, -16143037830.0;
4.8765, -16429351490.0;
4.883166666666667, -17073557225.0;
4.889833333333334, -17448291280.0;
4.8965000000000005, -17524080190.0;
4.903166666666667, -17595658605.0;
4.909833333333334, -17254608510.0;
4.9165, -17145135640.0;
4.923166666666667, -17035662770.0;
4.929833333333334, -17233556035.0;
4.9365000000000006, -17279871480.0;
4.943166666666667, -17178819600.0;
4.949833333333334, -17149346135.0;
4.9565, -16926189900.0;
4.963166666666667, -16429351490.0;
4.969833333333334, -15768303775.0;
4.976500000000001, -15612515460.0;
4.983166666666667, -15507253085.0;
4.989833333333333, -15595673480.0;
4.9965, -16016722980.0;
5.003166666666667, -16926189900.0;
5.009833333333334, -17785130880.0;
5.016500000000001, -17848288305.0;
5.0231666666666674, -17679868505.0;
5.029833333333333, -17633553060.0;
5.0365, -17313555440.0;
5.043166666666667, -16336720600.0;
5.049833333333334, -14900941805.0;
5.056500000000001, -14113579240.0;
5.0631666666666675, -13877791520.0;
5.069833333333333, -13465163010.0;
5.0765, -12825167770.0;
5.083166666666667, -12530433120.0;
5.089833333333334, -12652537475.0;
5.096500000000001, -12989377075.0;
5.1031666666666675, -13035692520.0;
5.1098333333333334, -13124112915.0;
5.1165, -13002008560.0;
5.123166666666667, -12829378265.0;
5.129833333333334, -12732536880.0;
5.136500000000001, -12404118270.0;
5.1431666666666676, -12218856490.0;
5.1498333333333335, -11759912535.0;
5.1565, -11524124815.0;
5.163166666666667, -10896761060.0;
5.169833333333334, -10172555920.0;
5.176500000000001, -9178879100.0;
5.183166666666667, -8189412775.0;
5.1898333333333335, -8020992975.0;
5.1965, -8307306635.0;
5.203166666666667, -9056774745.0;
5.209833333333334, -9743085430.0;
5.216500000000001, -10698867795.0;
5.223166666666667, -11839911940.0;
5.229833333333334, -12164120055.0;
5.2365, -12147278075.0;
5.243166666666667, -11915700850.0;
5.249833333333334, -12193593520.0;
5.256500000000001, -12728326385.0;
5.263166666666667, -13023061035.0;
5.269833333333334, -13246217270.0;
5.2765, -13279901230.0;
5.283166666666667, -13528320435.0;
5.289833333333334, -13469373505.0;
5.296500000000001, -12896746185.0;
5.303166666666667, -11987279265.0;
5.309833333333334, -11119917295.0;
5.3165000000000004, -10576763440.0;
5.323166666666667, -10113608990.0;
5.329833333333334, -9768348400.0;
5.336500000000001, -9654665035.0;
5.343166666666667, -9448350780.0;
5.349833333333334, -9233615535.0;
5.3565000000000005, -8762040095.0;
5.363166666666667, -8660988215.0;
5.369833333333334, -8589409800.0;
5.3765, -8703093165.0;
5.383166666666667, -9077827220.0;
5.389833333333334, -9532560680.0;
5.3965000000000005, -9995715130.0;
5.403166666666667, -9949399685.0;
5.409833333333334, -9595718105.0;
5.4165, -8694672175.0;
5.423166666666667, -7700995355.0;
5.429833333333334, -6829422890.0;
5.4365000000000006, -6345215965.0;
5.443166666666667, -6117849235.0;
5.449833333333334, -6231532600.0;
5.4565, -6669424080.0;
5.463166666666667, -6926264275.0;
5.469833333333334, -6976790215.0;
5.476500000000001, -6753633980.0;
5.483166666666667, -6159954185.0;
5.489833333333334, -5326276175.0;
5.4965, -4374704305.0;
5.503166666666667, -4202074010.0;
5.509833333333334, -4172600545.0;
5.516500000000001, -4202074010.0;
5.5231666666666674, -4193653020.0;
5.529833333333333, -4168390050.0;
5.5365, -4130495595.0;
5.543166666666667, -3802076985.0;
5.549833333333334, -3671551640.0;
5.556500000000001, -3553657780.0;
5.5631666666666675, -3372606495.0;
5.569833333333333, -3149450260.0;
5.5765, -3115766300.0;
5.583166666666667, -3149450260.0;
5.589833333333334, -3073661350.0;
5.596500000000001, -2728400760.0;
5.6031666666666675, -2193667895.0;
5.6098333333333334, -1482094240.0;
5.6165, -799994050.0;
5.623166666666667, -16841980.0;
5.629833333333334, 715784150.0;
5.636500000000001, 1090518205.0;
5.6431666666666676, 989466325.0;
5.6498333333333335, 812625535.0;
5.6565, 1094728700.0;
5.663166666666667, 1322095430.0;
5.669833333333334, 1431568300.0;
5.676500000000001, 1701039980.0;
5.683166666666668, 2261035815.0;
5.6898333333333335, 2879978580.0;
5.6965, 3149450260.0;
5.703166666666667, 3490500355.0;
5.709833333333334, 3848392430.0;
5.716500000000001, 4176811040.0;
5.723166666666667, 4408388265.0;
5.729833333333334, 4572597570.0;
5.7365, 5035752020.0;
5.743166666666667, 5717852210.0;
5.749833333333334, 6618898140.0;
5.756500000000001, 7124157540.0;
5.763166666666667, 7220998925.0;
5.769833333333334, 7313629815.0;
5.7765, 7427313180.0;
5.783166666666667, 7448365655.0;
5.789833333333334, 7347313775.0;
5.796500000000001, 7747310800.0;
5.803166666666667, 8690461680.0;
5.809833333333334, 9423087810.0;
5.8165000000000004, 9380982860.0;
5.823166666666667, 8964143855.0;
5.829833333333334, 8660988215.0;
5.836500000000001, 8387306040.0;
5.843166666666667, 7919941095.0;
5.849833333333334, 7637837930.0;
5.8565000000000005, 7882046640.0;
5.863166666666667, 8437831980.0;
5.869833333333334, 8808355540.0;
5.876500000000001, 8875723460.0;
5.883166666666667, 8757829600.0;
5.889833333333334, 8311517130.0;
5.8965000000000005, 7498891595.0;
5.903166666666667, 6543109230.0;
5.909833333333334, 5427328055.0;
5.9165, 4479966680.0;
5.923166666666667, 3730498570.0;
5.929833333333334, 3503131840.0;
5.9365000000000006, 3726288075.0;
5.943166666666667, 3844181935.0;
5.949833333333334, 4033654210.0;
5.9565, 4248389455.0;
5.963166666666667, 4513650640.0;
5.969833333333334, 4863121725.0;
5.976500000000001, 5444170035.0;
5.983166666666667, 6244164085.0;
5.989833333333334, 6951527245.0;
5.9965, 7465207635.0;
6.003166666666667, 8079939905.0;
6.009833333333334, 8526252375.0;
6.016500000000001, 8732566630.0;
6.0231666666666674, 8930459895.0;
6.029833333333334, 9536771175.0;
6.0365, 10277818295.0;
6.043166666666667, 10825182645.0;
6.049833333333334, 11258863630.0;
6.056500000000001, 11780965010.0;
6.0631666666666675, 12551485595.0;
6.069833333333333, 13204112320.0;
6.0765, 13759897660.0;
6.083166666666667, 14067263795.0;
6.089833333333334, 14117789735.0;
6.096500000000001, 14248315080.0;
6.1031666666666675, 14328314485.0;
6.1098333333333334, 14884099825.0;
6.1165, 15574621005.0;
6.123166666666667, 16589350300.0;
6.129833333333334, 17898814245.0;
6.136500000000001, 19220909675.0;
6.1431666666666676, 20290375405.0;
6.1498333333333335, 21014580545.0;
6.1565, 22222992610.0;
6.163166666666667, 24016663480.0;
6.169833333333334, 25890333755.0;
6.176500000000001, 27178745225.0;
6.183166666666668, 28627155505.0;
6.1898333333333335, 30126091725.0;
6.1965, 31330293295.0;
6.203166666666667, 31751342795.0;
6.209833333333334, 32227128730.0;
6.216500000000001, 33250279015.0;
6.223166666666668, 34559742960.0;
6.229833333333334, 35957627300.0;
6.2365, 37279722730.0;
6.243166666666667, 38984973205.0;
6.249833333333334, 40627066255.0;
6.256500000000001, 42446000095.0;
6.263166666666667, 44210197500.0;
6.269833333333334, 45957552925.0;
6.2765, 47772276270.0;
6.283166666666667, 49208055065.0;
6.289833333333334, 50290152280.0;
6.296500000000001, 50673307325.0;
6.303166666666667, 50900674055.0;
6.309833333333334, 50968041975.0;
6.3165000000000004, 50681728315.0;
6.323166666666667, 50252257825.0;
6.329833333333334, 50155416440.0;
6.336500000000001, 50643833860.0;
6.343166666666667, 51334355040.0;
6.349833333333334, 52184875030.0;
6.3565000000000005, 53822757585.0;
6.363166666666667, 56016425480.0;
6.369833333333334, 58361671195.0;
6.376500000000001, 60437445230.0;
6.383166666666667, 62471114315.0;
6.389833333333334, 64462678450.0;
6.3965000000000005, 66020561600.0;
6.403166666666667, 67355288515.0;
6.409833333333334, 68681594440.0;
6.416500000000001, 70273161550.0;
6.423166666666667, 71818413215.0;
6.429833333333334, 73460506265.0;
6.4365000000000006, 75224703670.0;
6.443166666666667, 76997322065.0;
6.449833333333334, 78374153930.0;
6.4565, 79452040650.0;
6.463166666666667, 80508874895.0;
6.469833333333334, 81414131320.0;
6.476500000000001, 82134125965.0;
6.483166666666667, 82753068730.0;
6.489833333333334, 83877270895.0;
6.4965, 85481469490.0;
6.503166666666667, 87077247095.0;
6.509833333333334, 88458289455.0;
6.516500000000001, 89746700925.0;
6.5231666666666674, 91355110015.0;
6.529833333333334, 92963519105.0;
6.5365, 94298246020.0;
6.543166666666667, 94963504230.0;
6.549833333333334, 94723506015.0;
6.556500000000001, 92904572175.0;
6.5631666666666675, 89211968060.0;
6.569833333333334, 83174118230.0;
6.5765, 74967863475.0;
6.583166666666667, 65144778640.0;
6.589833333333334, 54824855395.0;
6.596500000000001, 45102822440.0;
6.6031666666666675, 36408150265.0;
6.6098333333333334, 29288203220.0;
6.6165, 23953506055.0;
6.623166666666667, 20500900155.0;
6.629833333333334, 18496704535.0;
6.636500000000001, 17456712270.0;
6.6431666666666676, 16951452870.0;
6.6498333333333335, 16378825550.0;
6.6565, 15789356250.0;
6.663166666666667, 15566200015.0;
6.669833333333334, 15743040805.0;
6.676500000000001, 15835671695.0;
6.683166666666668, 15633567935.0;
6.6898333333333335, 15608304965.0;
6.6965, 15898829120.0;
6.703166666666667, 16071459415.0;
6.709833333333334, 15978828525.0;
6.716500000000001, 15713567340.0;
6.723166666666668, 15717777835.0;
6.729833333333334, 15721988330.0;
6.7365, 15376727740.0;
6.743166666666667, 14597786165.0;
6.749833333333334, 13355690140.0;
6.756500000000001, 12054647185.0;
6.763166666666668, 10665183835.0;
6.769833333333334, 9490455730.0;
6.7765, 8265201685.0;
6.783166666666667, 7334682290.0;
6.789833333333334, 6736792000.0;
6.796500000000001, 6682055565.0;
6.803166666666667, 6652582100.0;
6.809833333333334, 6501004280.0;
6.8165000000000004, 6652582100.0;
6.823166666666667, 6665213585.0;
6.829833333333334, 6791528435.0;
6.836500000000001, 6311532005.0;
6.843166666666667, 5839956565.0;
6.849833333333334, 5835746070.0;
6.8565000000000005, 6101007255.0;
6.863166666666667, 6602056160.0;
6.869833333333334, 6736792000.0;
6.876500000000001, 7052579125.0;
6.883166666666667, 7498891595.0;
6.889833333333334, 7789415750.0;
6.8965000000000005, 7616785455.0;
6.903166666666667, 7069421105.0;
6.909833333333334, 6610477150.0;
6.916500000000001, 6454688835.0;
6.923166666666667, 6538898735.0;
6.929833333333334, 6501004280.0;
6.9365000000000006, 6753633980.0;
6.943166666666667, 7288366845.0;
6.949833333333334, 8008361490.0;
6.956500000000001, 8513620890.0;
6.963166666666667, 8934670390.0;
6.969833333333334, 9460982265.0;
6.976500000000001, 9936768200.0;
6.983166666666667, 10437817105.0;
6.989833333333334, 10787288190.0;
6.9965, 11107285810.0;
7.003166666666667, 11145180265.0;
7.009833333333334, 11242021650.0;
7.016500000000001, 11094654325.0;
7.0231666666666674, 10778867200.0;
7.029833333333334, 10631499875.0;
7.0365, 10846235120.0;
7.043166666666667, 11284126600.0;
7.049833333333334, 11376757490.0;
7.056500000000001, 11835701445.0;
7.0631666666666675, 12627274505.0;
7.069833333333334, 13288322220.0;
7.0765, 13267269745.0;
7.083166666666667, 12968324600.0;
7.089833333333334, 12593590545.0;
7.096500000000001, 12109383620.0;
7.1031666666666675, 11482019865.0;
7.109833333333334, 11435704420.0;
7.1165, 11966226790.0;
7.123166666666667, 12551485595.0;
7.129833333333334, 12989377075.0;
7.136500000000001, 12812536285.0;
7.1431666666666676, 12332539855.0;
7.1498333333333335, 11658860655.0;
7.1565, 11322021055.0;
7.163166666666667, 10943076505.0;
7.169833333333334, 10829393140.0;
7.176500000000001, 11263074125.0;
7.183166666666668, 12399907775.0;
7.1898333333333335, 13220954300.0;
7.1965, 13317795685.0;
7.203166666666667, 13448321030.0;
7.209833333333334, 13780950135.0;
7.216500000000001, 14046211320.0;
7.223166666666668, 13780950135.0;
7.229833333333334, 13431479050.0;
7.2365, 13254638260.0;
7.243166666666667, 13275690735.0;
7.249833333333334, 13225164795.0;
7.256500000000001, 13212533310.0;
7.263166666666668, 13149375885.0;
7.269833333333334, 13073586975.0;
7.2765, 13166217865.0;
7.283166666666667, 13162007370.0;
7.289833333333334, 13103060440.0;
7.296500000000001, 12985166580.0;
7.303166666666668, 13018850540.0;
7.309833333333334, 13271480240.0;
7.3165000000000004, 13284111725.0;
7.323166666666667, 13170428360.0;
7.329833333333334, 13250427765.0;
7.336500000000001, 13528320435.0;
7.343166666666667, 13970422410.0;
7.349833333333334, 14100947755.0;
7.3565000000000005, 14113579240.0;
7.363166666666667, 13835686570.0;
7.369833333333334, 13414637070.0;
7.376500000000001, 13170428360.0;
7.383166666666667, 13056744995.0;
7.389833333333334, 13288322220.0;
7.3965000000000005, 13696740235.0;
7.403166666666667, 14635680620.0;
7.409833333333334, 15924092090.0;
7.416500000000001, 16951452870.0;
7.423166666666667, 17380923360.0;
7.429833333333334, 17481975240.0;
7.4365000000000006, 17625132070.0;
7.443166666666667, 17844077810.0;
7.449833333333334, 17705131475.0;
7.456500000000001, 17646184545.0;
7.463166666666667, 18210390875.0;
7.469833333333334, 19199857200.0;
7.476500000000001, 20164060555.0;
7.483166666666667, 20618794015.0;
7.489833333333334, 21060895990.0;
7.496500000000001, 21326157175.0;
7.503166666666667, 21166158365.0;
7.509833333333334, 20736687875.0;
7.516500000000001, 20555636590.0;
7.5231666666666674, 20871423715.0;
7.529833333333334, 21317736185.0;
7.5365, 21700891230.0;
7.543166666666667, 21890363505.0;
7.549833333333334, 21839837565.0;
7.556500000000001, 21456682520.0;
7.5631666666666675, 21317736185.0;
7.569833333333334, 21300894205.0;
7.5765, 21364051630.0;
7.583166666666667, 21284052225.0;
7.589833333333334, 21481945490.0;
7.596500000000001, 21865100535.0;
7.6031666666666675, 21742996180.0;
7.609833333333334, 21246157770.0;
7.6165, 20879844705.0;
7.623166666666667, 20985107080.0;
7.629833333333334, 20943002130.0;
7.636500000000001, 20454584710.0;
7.6431666666666676, 19810378975.0;
7.649833333333334, 19334593040.0;
7.6565, 18959858985.0;
7.663166666666667, 18964069480.0;
7.669833333333334, 19044068885.0;
7.676500000000001, 19330382545.0;
7.683166666666668, 19473539375.0;
7.6898333333333335, 19625117195.0;
7.6965, 19684064125.0;
7.703166666666667, 19469328880.0;
7.709833333333334, 19250383140.0;
7.716500000000001, 18829333640.0;
7.723166666666668, 18665124335.0;
7.729833333333334, 18783018195.0;
7.7365, 18968279975.0;
7.743166666666667, 18947227500.0;
7.749833333333334, 18871438590.0;
7.756500000000001, 19233541160.0;
7.763166666666668, 19599854225.0;
7.769833333333334, 19709327095.0;
7.7765, 19818799965.0;
7.783166666666667, 20197744515.0;
7.789833333333334, 20601952035.0;
7.796500000000001, 20673530450.0;
7.803166666666668, 20829318765.0;
7.809833333333334, 21174579355.0;
7.8165000000000004, 21414577570.0;
7.823166666666667, 21347209650.0;
7.829833333333334, 21574576380.0;
7.836500000000001, 22404043895.0;
7.843166666666668, 23608245465.0;
7.849833333333334, 24395608030.0;
7.8565000000000005, 24593501295.0;
7.863166666666667, 24677711195.0;
7.869833333333334, 24576659315.0;
7.876500000000001, 24222977735.0;
7.883166666666667, 23321931805.0;
7.889833333333334, 22597726665.0;
7.8965000000000005, 22471411815.0;
7.903166666666667, 22627200130.0;
7.909833333333334, 22850356365.0;
7.916500000000001, 23284037350.0;
7.923166666666667, 24100873380.0;
7.929833333333334, 24938761885.0;
7.9365000000000006, 25376653365.0;
7.943166666666667, 25368232375.0;
7.949833333333334, 25132444655.0;
7.9565, 24530343870.0;
7.963166666666668, 23751402295.0;
7.969833333333334, 22749304485.0;
7.9765000000000015, 22328254985.0;
7.983166666666667, 22791409435.0;
7.989833333333333, 23637718930.0;
7.996500000000001, 24509291395.0;
8.003166666666667, 24888235945.0;
8.009833333333335, 25490336730.0;
8.0165, 25835597320.0;
8.023166666666667, 25684019500.0;
8.029833333333334, 25364021880.0;
8.0365, 24947182875.0;
8.043166666666668, 25212444060.0;
8.049833333333334, 25536652175.0;
8.0565, 25928228210.0;
8.063166666666667, 26105069000.0;
8.069833333333333, 26206120880.0;
8.076500000000001, 26597696915.0;
8.083166666666667, 26867168595.0;
8.089833333333335, 26985062455.0;
8.0965, 26795590180.0;
8.103166666666667, 26896642060.0;
8.109833333333334, 27140850770.0;
8.1165, 27599794725.0;
8.123166666666668, 28046107195.0;
8.129833333333334, 28349262835.0;
8.1365, 28669260455.0;
8.143166666666668, 28799785800.0;
8.149833333333333, 28778733325.0;
8.156500000000001, 28496630160.0;
8.163166666666667, 28117685610.0;
8.169833333333335, 27919792345.0;
8.1765, 27692425615.0;
8.183166666666667, 27502953340.0;
8.189833333333334, 27566110765.0;
8.1965, 27827161455.0;
8.203166666666668, 28273473925.0;
8.209833333333334, 28593471545.0;
8.2165, 29216624805.0;
8.223166666666668, 29873462025.0;
8.229833333333334, 30302932515.0;
8.236500000000001, 30349247960.0;
8.243166666666667, 30029250340.0;
8.249833333333333, 29709252720.0;
8.2565, 29456623020.0;
8.263166666666667, 29321887180.0;
8.269833333333334, 29267150745.0;
8.2765, 29094520450.0;
8.283166666666668, 29107151935.0;
8.289833333333334, 29283992725.0;
8.2965, 29469254505.0;
8.303166666666668, 29705042225.0;
8.309833333333334, 29953461430.0;
8.316500000000001, 30471352315.0;
8.323166666666667, 31149242010.0;
8.329833333333333, 31890289130.0;
8.336500000000001, 32665020210.0;
8.343166666666667, 33182911095.0;
8.349833333333335, 33785011880.0;
8.3565, 34269218805.0;
8.363166666666668, 34963950480.0;
8.369833333333334, 35827101955.0;
8.3765, 36601833035.0;
8.383166666666668, 37178670850.0;
8.389833333333334, 37372353620.0;
8.396500000000001, 38024980345.0;
8.403166666666667, 38542871230.0;
8.409833333333333, 38980762710.0;
8.416500000000001, 39380759735.0;
8.423166666666667, 40079701905.0;
8.429833333333335, 41056536745.0;
8.4365, 41662848025.0;
8.443166666666666, 41957582675.0;
8.449833333333334, 41848109805.0;
8.4565, 41633374560.0;
8.463166666666668, 41755478915.0;
8.469833333333334, 42003898120.0;
8.476500000000001, 42134423465.0;
8.483166666666667, 42521789005.0;
8.489833333333333, 43250204640.0;
8.496500000000001, 44092303640.0;
8.503166666666667, 44656509970.0;
8.509833333333335, 45174400855.0;
8.5165, 46054394310.0;
8.523166666666667, 46597548165.0;
8.529833333333334, 47128070535.0;
8.5365, 47540699045.0;
8.543166666666668, 48033326960.0;
8.549833333333334, 48547007350.0;
8.556500000000002, 48677532695.0;
8.563166666666667, 48610164775.0;
8.569833333333333, 48088063395.0;
8.576500000000001, 47772276270.0;
8.583166666666667, 47502804590.0;
8.589833333333335, 46930177270.0;
8.5965, 46248077080.0;
8.603166666666667, 45738607185.0;
8.609833333333334, 45485977485.0;
8.6165, 44976507590.0;
8.623166666666668, 43915462850.0;
8.629833333333334, 42723892765.0;
8.6365, 41721794955.0;
8.643166666666668, 41271271990.0;
8.649833333333333, 41102852190.0;
8.656500000000001, 41170220110.0;
8.663166666666667, 41574427630.0;
8.669833333333335, 42281790790.0;
8.6765, 42808102665.0;
8.683166666666667, 42774418705.0;
8.689833333333334, 42290211780.0;
8.6965, 41523901690.0;
8.703166666666668, 40584961305.0;
8.709833333333334, 39464969635.0;
8.7165, 38378661925.0;
8.723166666666668, 37616562330.0;
8.729833333333334, 37351301145.0;
8.736500000000001, 37561825895.0;
8.743166666666667, 38075506285.0;
8.749833333333335, 38622870635.0;
8.7565, 39262865875.0;
8.763166666666667, 39536548050.0;
8.769833333333334, 39389180725.0;
8.7765, 38576555190.0;
8.783166666666668, 37936559950.0;
8.789833333333334, 37616562330.0;
8.7965, 37839718565.0;
8.803166666666668, 38357609450.0;
8.809833333333334, 38875500335.0;
8.816500000000001, 39477601120.0;
8.823166666666667, 39612336960.0;
8.829833333333333, 39675494385.0;
8.836500000000001, 39401812210.0;
8.843166666666667, 39267076370.0;
8.849833333333335, 39456548645.0;
8.8565, 39940755570.0;
8.863166666666668, 40467067445.0;
8.869833333333334, 40728118135.0;
8.8765, 40829170015.0;
8.883166666666668, 41073378725.0;
8.889833333333334, 41401797335.0;
8.896500000000001, 41949161685.0;
8.903166666666667, 42584946430.0;
8.909833333333333, 42989153950.0;
8.916500000000001, 43254415135.0;
8.923166666666667, 43216520680.0;
8.929833333333335, 43389150975.0;
8.9365, 43511255330.0;
8.943166666666666, 43772306020.0;
8.949833333333334, 44290196905.0;
8.9565, 44997560065.0;
8.963166666666668, 45671239265.0;
8.969833333333334, 45860711540.0;
8.976500000000001, 45763870155.0;
8.983166666666667, 45481766990.0;
8.989833333333333, 45401767585.0;
8.996500000000001, 45325978675.0;
9.003166666666667, 45136506400.0;
9.009833333333335, 44930192145.0;
9.0165, 44698614920.0;
9.023166666666667, 44909139670.0;
9.029833333333334, 45043875510.0;
9.0365, 45250189765.0;
9.043166666666668, 45401767585.0;
9.049833333333334, 45393346595.0;
9.056500000000002, 45439662040.0;
9.063166666666667, 45359662635.0;
9.069833333333333, 45321768180.0;
9.076500000000001, 45191242835.0;
9.083166666666667, 45136506400.0;
9.089833333333335, 45544924415.0;
9.0965, 46252287575.0;
9.103166666666667, 46770178460.0;
9.109833333333334, 46942808755.0;
9.1165, 46888072320.0;
9.123166666666668, 47031229150.0;
9.129833333333334, 47027018655.0;
9.1365, 47005966180.0;
9.143166666666668, 46942808755.0;
9.149833333333333, 47351226770.0;
9.156500000000001, 47911222605.0;
9.163166666666667, 48256483195.0;
9.169833333333335, 48311219630.0;
9.1765, 48205957255.0;
9.183166666666667, 48298588145.0;
9.189833333333334, 48340693095.0;
9.1965, 48277535670.0;
9.203166666666668, 48370166560.0;
9.209833333333334, 48808058040.0;
9.2165, 49073319225.0;
9.223166666666668, 49111213680.0;
9.229833333333334, 48841742000.0;
9.236500000000001, 48820689525.0;
9.243166666666667, 48824900020.0;
9.249833333333335, 48951214870.0;
9.2565, 49456474270.0;
9.263166666666667, 50155416440.0;
9.269833333333334, 51469090880.0;
9.2765, 53056447495.0;
9.283166666666668, 55005906680.0;
9.289833333333334, 56551158345.0;
9.2965, 57957463675.0;
9.303166666666668, 59683766625.0;
9.309833333333334, 61170071360.0;
9.316500000000001, 62492166790.0;
9.323166666666667, 63372160245.0;
9.329833333333333, 64757413100.0;
9.336500000000001, 66386874665.0;
9.343166666666667, 68201598010.0;
9.349833333333335, 70281582540.0;
9.3565, 72513144890.0;
9.363166666666668, 74820496150.0;
9.369833333333334, 76908901670.0;
9.3765, 78942570755.0;
9.383166666666668, 80382560045.0;
9.389833333333334, 81228869540.0;
9.396500000000001, 81923601215.0;
9.403166666666667, 83258328130.0;
9.409833333333333, 85035157020.0;
9.416500000000001, 86647776605.0;
9.423166666666667, 88260396190.0;
9.429833333333335, 89978278150.0;
9.4365, 91578266250.0;
9.443166666666668, 92538259110.0;
9.449833333333334, 93022466035.0;
9.4565, 93447726030.0;
9.463166666666668, 93780355135.0;
9.469833333333334, 94007721865.0;
9.476500000000001, 93620356325.0;
9.483166666666667, 92171946045.0;
9.489833333333333, 89304598950.0;
9.496500000000001, 85254102760.0;
9.503166666666667, 80605716280.0;
9.509833333333335, 75612069210.0;
9.5165, 70694211050.0;
9.523166666666667, 66677398820.0;
9.529833333333334, 64180575285.0;
9.5365, 63186898465.0;
9.543166666666668, 63136372525.0;
9.549833333333334, 63742683805.0;
9.556500000000002, 64942674880.0;
9.563166666666667, 66163718430.0;
9.569833333333333, 67081606340.0;
9.576500000000001, 67704759600.0;
9.583166666666667, 68247913455.0;
9.589833333333335, 68694225925.0;
9.5965, 69460536015.0;
9.603166666666667, 70744736990.0;
9.609833333333334, 72323672615.0;
9.6165, 73700504480.0;
9.623166666666668, 74711023280.0;
9.629833333333334, 75666805645.0;
9.636500000000002, 76260485440.0;
9.643166666666668, 76572062070.0;
9.649833333333333, 76807849790.0;
9.656500000000001, 77359424635.0;
9.663166666666667, 78142576705.0;
9.669833333333335, 79144674515.0;
9.6765, 79982563020.0;
9.683166666666667, 80517295885.0;
9.689833333333334, 80681505190.0;
9.6965, 80508874895.0;
9.703166666666668, 79948879060.0;
9.709833333333334, 78588889175.0;
9.7165, 76702587415.0;
9.723166666666668, 74584708430.0;
9.729833333333334, 72243673210.0;
9.736500000000001, 69628955815.0;
9.743166666666667, 67199500200.0;
9.749833333333335, 65338461410.0;
9.7565, 64045839445.0;
9.763166666666667, 62972163220.0;
9.769833333333334, 62146906200.0;
9.7765, 61620594325.0;
9.783166666666668, 61199544825.0;
9.789833333333334, 60685864435.0;
9.7965, 59995343255.0;
9.803166666666668, 59376400490.0;
9.809833333333334, 59199559700.0;
9.816500000000001, 59363769005.0;
9.823166666666667, 59473241875.0;
9.829833333333335, 59481662865.0;
9.836500000000001, 59772187020.0;
9.843166666666667, 60315340875.0;
9.849833333333335, 60614286020.0;
9.8565, 60711127405.0;
9.863166666666668, 61005862055.0;
9.869833333333334, 61431122050.0;
9.8765, 61687962245.0;
9.883166666666668, 61645857295.0;
9.889833333333334, 61730067195.0;
9.896500000000001, 61860592540.0;
9.903166666666667, 61730067195.0;
9.909833333333333, 61422701060.0;
9.916500000000001, 61296386210.0;
9.923166666666667, 61473227000.0;
9.929833333333335, 61671120265.0;
9.9365, 61730067195.0;
9.943166666666668, 62079538280.0;
9.949833333333334, 62807953915.0;
9.9565, 63325844800.0;
9.963166666666668, 63515317075.0;
9.969833333333334, 63309002820.0;
9.976500000000001, 62917426785.0;
9.983166666666667, 62378483425.0;
9.989833333333333, 61734277690.0;
9.996500000000001, 61494279475.0;
10.003166666666667, 61447964030.0;
10.009833333333335, 61532173930.0;
10.0165, 61919539470.0;
10.023166666666667, 62189011150.0;
10.029833333333334, 62433219860.0;
10.0365, 62517429760.0;
10.043166666666668, 62820585400.0;
10.049833333333334, 63182687970.0;
10.056500000000002, 63405844205.0;
10.063166666666667, 63788999250.0;
10.069833333333333, 64395310530.0;
10.076500000000001, 64795307555.0;
10.083166666666667, 64685834685.0;
10.089833333333335, 64306890135.0;
10.0965, 64155312315.0;
10.103166666666667, 64302679640.0;
10.109833333333334, 64563730330.0;
10.1165, 65081621215.0;
10.123166666666668, 65772142395.0;
10.129833333333334, 66715293275.0;
10.136500000000002, 67468971880.0;
10.143166666666668, 67885810885.0;
10.149833333333333, 67864758410.0;
10.156500000000001, 67746864550.0;
10.163166666666667, 67847916430.0;
10.169833333333335, 68130019595.0;
10.1765, 68391070285.0;
10.183166666666667, 68567911075.0;
10.189833333333334, 68807909290.0;
10.1965, 68828961765.0;
10.203166666666668, 68664752460.0;
10.209833333333334, 68538437610.0;
10.2165, 68626858005.0;
10.223166666666668, 68816330280.0;
10.229833333333334, 68900540180.0;
10.236500000000001, 69191064335.0;
10.243166666666667, 69452115025.0;
10.249833333333335, 69637376805.0;
10.2565, 69713165715.0;
10.263166666666667, 69544745915.0;
10.269833333333334, 69148959385.0;
10.2765, 68647910480.0;
10.283166666666668, 68508964145.0;
10.289833333333334, 68887908695.0;
10.2965, 69363694630.0;
10.303166666666668, 70125794225.0;
10.309833333333334, 70938419760.0;
10.316500000000001, 71683677375.0;
10.323166666666667, 71940517570.0;
10.329833333333335, 71536310050.0;
10.336500000000001, 70972103720.0;
10.343166666666667, 70243688085.0;
10.349833333333335, 69763691655.0;
10.3565, 69494219975.0;
10.363166666666668, 69637376805.0;
10.369833333333334, 69852112050.0;
10.3765, 70104741750.0;
10.383166666666668, 70445791845.0;
10.389833333333334, 70997366690.0;
10.396500000000001, 71536310050.0;
10.403166666666667, 71965780540.0;
10.409833333333333, 72551039345.0;
10.416500000000001, 73191034585.0;
10.423166666666667, 73969976160.0;
10.429833333333335, 74445762095.0;
10.4365, 74765759715.0;
10.443166666666668, 74929969020.0;
10.449833333333334, 75068915355.0;
10.4565, 75292071590.0;
10.463166666666668, 75393123470.0;
10.469833333333334, 75460491390.0;
10.476500000000001, 75447859905.0;
10.483166666666667, 75346808025.0;
10.489833333333333, 75241545650.0;
10.496500000000001, 75165756740.0;
10.503166666666667, 75376281490.0;
10.509833333333335, 75624700695.0;
10.5165, 76222590985.0;
10.523166666666668, 77182583845.0;
10.529833333333334, 78239418090.0;
10.5365, 78900465805.0;
10.543166666666668, 79359409760.0;
10.549833333333334, 80066772920.0;
10.556500000000002, 80605716280.0;
10.563166666666667, 80938345385.0;
10.569833333333333, 81165712115.0;
10.576500000000001, 81830970325.0;
10.583166666666667, 82614122395.0;
10.589833333333335, 83532010305.0;
10.5965, 84761474845.0;
10.603166666666667, 85931992455.0;
10.609833333333334, 86955142740.0;
10.6165, 87637242930.0;
10.623166666666668, 88024608470.0;
10.629833333333334, 88336185100.0;
10.636500000000002, 88605656780.0;
10.643166666666668, 89161442120.0;
10.649833333333333, 89721437955.0;
10.656500000000001, 90209855375.0;
10.663166666666667, 90496169035.0;
10.669833333333335, 90470906065.0;
10.6765, 89978278150.0;
10.683166666666667, 89321440930.0;
10.689833333333334, 88921443905.0;
10.6965, 89102495190.0;
10.703166666666668, 89628807065.0;
10.709833333333334, 89919331220.0;
10.716500000000002, 90353012205.0;
10.723166666666668, 90925639525.0;
10.729833333333334, 91523529815.0;
10.736500000000001, 91851948425.0;
10.743166666666667, 92251945450.0;
10.749833333333335, 92769836335.0;
10.7565, 92854046235.0;
10.763166666666667, 92475101685.0;
10.769833333333334, 92197209015.0;
10.7765, 92294050400.0;
10.783166666666668, 91881421890.0;
10.789833333333334, 91291952590.0;
10.7965, 90942481505.0;
10.803166666666668, 90862482100.0;
10.809833333333334, 90096172010.0;
10.816500000000001, 88677235195.0;
10.823166666666667, 88251975200.0;
10.829833333333335, 88622498760.0;
10.836500000000001, 89047758755.0;
10.843166666666667, 88837234005.0;
10.849833333333335, 88942496380.0;
10.8565, 89624596570.0;
10.863166666666668, 90087751020.0;
10.869833333333334, 90150908445.0;
10.8765, 90496169035.0;
10.883166666666668, 92070894165.0;
10.889833333333334, 94142457705.0;
10.896500000000001, 95683498875.0;
10.903166666666667, 96365599065.0;
10.909833333333335, 96832964010.0;
10.916500000000001, 97414012320.0;
10.923166666666667, 97152961630.0;
10.929833333333335, 96079285405.0;
10.9365, 94727716510.0;
10.943166666666668, 93729829195.0;
10.949833333333334, 93195096330.0;
10.9565, 92668784455.0;
10.963166666666668, 92441417725.0;
10.969833333333334, 92588785050.0;
10.976500000000001, 93531935930.0;
10.983166666666667, 94811926410.0;
10.989833333333333, 95822445210.0;
10.996500000000001, 96239284215.0;
11.003166666666667, 96352967580.0;
11.009833333333335, 96512966390.0;
11.0165, 96289810155.0;
11.023166666666668, 96129811345.0;
11.029833333333334, 95940339070.0;
11.0365, 96382441045.0;
11.043166666666668, 96950857870.0;
11.049833333333334, 97106646185.0;
11.056500000000002, 96626649755.0;
11.063166666666667, 95435079670.0;
11.069833333333333, 94378245425.0;
11.076500000000001, 93224569795.0;
11.083166666666667, 92445628220.0;
11.089833333333335, 92239313965.0;
11.0965, 92984571580.0;
11.103166666666667, 94327719485.0;
11.109833333333334, 95670867390.0;
11.1165, 96820332525.0;
11.123166666666668, 97620326575.0;
11.129833333333334, 98218216865.0;
11.136500000000002, 98900317055.0;
11.143166666666668, 100205570505.0;
11.149833333333333, 101898189495.0;
11.156500000000001, 103536072050.0;
11.163166666666667, 104963429855.0;
11.169833333333335, 106609733400.0;
11.1765, 108180248035.0;
11.183166666666667, 109232871785.0;
11.189833333333334, 109961287420.0;
11.1965, 111241277900.0;
11.203166666666668, 113300209955.0;
11.209833333333334, 115253879635.0;
11.216500000000002, 116824394270.0;
11.223166666666668, 118234910095.0;
11.229833333333334, 119738056810.0;
11.236500000000001, 121055941745.0;
11.243166666666667, 122209617375.0;
11.249833333333335, 123502239340.0;
11.2565, 124971702095.0;
11.263166666666667, 126529585245.0;
11.269833333333334, 128192730770.0;
11.2765, 129944296690.0;
11.283166666666668, 131455864395.0;
11.289833333333334, 132836906755.0;
11.2965, 134011634860.0;
11.303166666666668, 135140047520.0;
11.309833333333334, 136041093450.0;
11.316500000000001, 136710562155.0;
11.323166666666667, 137228453040.0;
11.329833333333335, 137342136405.0;
11.336500000000001, 137220032050.0;
11.343166666666667, 136112671865.0;
11.349833333333335, 134024266345.0;
11.3565, 130811658660.0;
11.363166666666668, 126799056925.0;
11.369833333333334, 122247511830.0;
11.3765, 117329653670.0;
11.383166666666668, 112820213525.0;
11.389833333333334, 108681296940.0;
11.396500000000001, 105342374405.0;
11.403166666666667, 102693973050.0;
11.409833333333335, 100946617625.0;
11.416500000000001, 99999256250.0;
11.423166666666667, 99662416650.0;
11.429833333333335, 99902414865.0;
11.4365, 100235043970.0;
11.443166666666668, 100883460200.0;
11.449833333333334, 101557139400.0;
11.4565, 102180292660.0;
11.463166666666668, 102672920575.0;
11.469833333333334, 103102391065.0;
11.476500000000001, 103952911055.0;
11.483166666666667, 104786589065.0;
11.489833333333333, 105578162125.0;
11.496500000000001, 106597101915.0;
11.503166666666667, 108079196155.0;
11.509833333333335, 110331810980.0;
11.5165, 112660214715.0;
11.523166666666668, 115283353100.0;
11.529833333333334, 118053858810.0;
11.5365, 120698049670.0;
11.543166666666668, 123215925680.0;
11.549833333333334, 125295910210.0;
11.556500000000002, 127489578105.0;
11.563166666666667, 129679035505.0;
11.569833333333333, 131834808945.0;
11.576500000000001, 133969529910.0;
11.583166666666667, 136015830480.0;
11.589833333333335, 138066341545.0;
11.5965, 139780013010.0;
11.603166666666668, 141135792400.0;
11.609833333333334, 142457887830.0;
11.6165, 143893666625.0;
11.623166666666668, 145464181260.0;
11.629833333333334, 147097853320.0;
11.636500000000002, 148626263005.0;
11.643166666666668, 150007305365.0;
11.649833333333333, 151144139015.0;
11.656500000000001, 152175710290.0;
11.663166666666667, 152226236230.0;
11.669833333333335, 150933614265.0;
11.6765, 148179950535.0;
11.683166666666667, 144432609985.0;
11.689833333333334, 139666329645.0;
11.6965, 134007424365.0;
11.703166666666668, 128125362850.0;
11.709833333333334, 122563298955.0;
11.716500000000002, 117935964950.0;
11.723166666666668, 114331781230.0;
11.729833333333334, 111801273735.0;
11.736500000000001, 109982339895.0;
11.743166666666667, 109169714360.0;
11.749833333333335, 109270766240.0;
11.7565, 109898129995.0;
11.763166666666667, 110226548605.0;
11.769833333333334, 110062339300.0;
11.7765, 109637079305.0;
11.783166666666668, 109001294560.0;
11.789833333333334, 108487614170.0;
11.796500000000002, 108007617740.0;
11.803166666666668, 107700251605.0;
11.809833333333334, 107632883685.0;
11.816500000000001, 107919197345.0;
11.823166666666667, 108369720310.0;
11.829833333333335, 108230773975.0;
11.836500000000001, 107961302295.0;
11.843166666666667, 107889723880.0;
11.849833333333335, 108226563480.0;
11.8565, 108613929020.0;
11.863166666666668, 108891821690.0;
11.869833333333334, 109451817525.0;
11.8765, 110037076330.0;
11.883166666666668, 110458125830.0;
11.889833333333334, 110491809790.0;
11.896500000000001, 110159180685.0;
11.903166666666667, 109792867620.0;
11.909833333333335, 109771815145.0;
11.916500000000001, 110049707815.0;
11.923166666666667, 110609703650.0;
11.929833333333335, 111274961860.0;
11.9365, 111936009575.0;
11.943166666666668, 112411795510.0;
11.949833333333334, 112458110955.0;
11.9565, 112483373925.0;
11.963166666666668, 112546531350.0;
11.969833333333334, 112525478875.0;
11.976500000000001, 112588636300.0;
11.983166666666667, 112841266000.0;
11.989833333333335, 113152842630.0;
11.996500000000001, 113291788965.0;
12.003166666666667, 113304420450.0;
12.009833333333335, 113409682825.0;
12.0165, 113944415690.0;
12.023166666666668, 114479148555.0;
12.029833333333334, 115077038845.0;
12.0365, 115068617855.0;
12.043166666666668, 115018091915.0;
12.049833333333334, 114984407955.0;
12.056500000000002, 114967565975.0;
12.063166666666667, 115131775280.0;
12.069833333333333, 115346510525.0;
12.076500000000001, 115767560025.0;
12.083166666666667, 115818085965.0;
12.089833333333335, 115611771710.0;
12.0965, 115072828350.0;
12.103166666666668, 114441254100.0;
12.109833333333334, 114091783015.0;
12.1165, 114394938655.0;
12.123166666666668, 115148617260.0;
12.129833333333334, 116112820615.0;
12.136500000000002, 116845446745.0;
12.143166666666668, 117422284560.0;
12.149833333333333, 117350706145.0;
12.156500000000001, 116967551100.0;
12.163166666666667, 116542291105.0;
12.169833333333335, 116415976255.0;
12.1765, 116773868330.0;
12.183166666666667, 117093865950.0;
12.189833333333334, 117220180800.0;
12.1965, 117152812880.0;
12.203166666666668, 117274917235.0;
12.209833333333334, 117514915450.0;
12.216500000000002, 117683335250.0;
12.223166666666668, 117801229110.0;
12.229833333333334, 118159121185.0;
12.236500000000001, 118281225540.0;
12.243166666666667, 118091753265.0;
12.249833333333335, 117742282180.0;
12.2565, 117350706145.0;
12.263166666666667, 117157023375.0;
12.269833333333334, 117279127730.0;
12.2765, 117944385940.0;
12.283166666666668, 118761221970.0;
12.289833333333334, 119283323350.0;
12.296500000000002, 119645425920.0;
12.303166666666668, 120112790865.0;
12.309833333333334, 120744365115.0;
12.316500000000001, 121388570850.0;
12.323166666666667, 121679095005.0;
12.329833333333335, 121712778965.0;
12.336500000000001, 121788567875.0;
12.343166666666667, 121780146885.0;
12.349833333333335, 121405412830.0;
12.3565, 120655944720.0;
12.363166666666668, 120344368090.0;
12.369833333333334, 120858048480.0;
12.3765, 121603306095.0;
12.383166666666668, 122201196385.0;
12.389833333333334, 122630666875.0;
12.396500000000001, 123060137365.0;
12.403166666666667, 123215925680.0;
12.409833333333335, 123093821325.0;
12.416500000000001, 123064347860.0;
12.423166666666667, 123300135580.0;
12.429833333333335, 123796973990.0;
12.4365, 124521179130.0;
12.443166666666668, 125194858330.0;
12.449833333333334, 125771696145.0;
12.4565, 126150640695.0;
12.463166666666668, 126361165445.0;
12.469833333333334, 126108535745.0;
12.476500000000001, 125653802285.0;
12.483166666666667, 125321173180.0;
12.489833333333335, 125102227440.0;
12.496500000000001, 124740124870.0;
12.503166666666667, 124150655570.0;
12.509833333333335, 123910657355.0;
12.5165, 124104340125.0;
12.523166666666668, 124883281700.0;
12.529833333333334, 125868537530.0;
12.5365, 126748530985.0;
12.543166666666668, 127405368205.0;
12.549833333333334, 127590629985.0;
12.556500000000002, 127527472560.0;
12.563166666666667, 127300105830.0;
12.569833333333333, 127253790385.0;
12.576500000000001, 127413789195.0;
12.583166666666667, 127792733745.0;
12.589833333333335, 128348519085.0;
12.5965, 128647464230.0;
12.603166666666668, 128967461850.0;
12.609833333333334, 129009566800.0;
12.6165, 129203249570.0;
12.623166666666668, 129451668775.0;
12.629833333333334, 130196926390.0;
12.636500000000002, 131569547760.0;
12.643166666666668, 132668486955.0;
12.649833333333333, 133636900805.0;
12.656500000000001, 134340053470.0;
12.663166666666667, 135304256825.0;
12.669833333333335, 135998988500.0;
12.6765, 136251618200.0;
12.683166666666668, 136630562750.0;
12.689833333333334, 137165295615.0;
12.6965, 137872658775.0;
12.703166666666668, 137994763130.0;
12.709833333333334, 138062131050.0;
12.716500000000002, 137944237190.0;
12.723166666666668, 137674765510.0;
12.729833333333334, 136937928885.0;
12.736500000000001, 136407406515.0;
12.743166666666667, 136028461965.0;
12.749833333333335, 135569518010.0;
12.7565, 135266362370.0;
12.763166666666667, 135135837025.0;
12.769833333333334, 135464255635.0;
12.7765, 135169520985.0;
12.783166666666668, 135106363560.0;
12.789833333333334, 135346361775.0;
12.796500000000002, 135918989095.0;
12.803166666666668, 136504247900.0;
12.809833333333334, 136878981955.0;
12.816500000000001, 137662134025.0;
12.823166666666667, 138238971840.0;
12.829833333333335, 138424233620.0;
12.836500000000001, 138180024910.0;
12.843166666666667, 137594766105.0;
12.849833333333335, 136878981955.0;
12.8565, 136327407110.0;
12.863166666666668, 136247407705.0;
12.869833333333334, 136605299780.0;
12.876500000000002, 136937928885.0;
12.883166666666668, 137354767890.0;
12.889833333333334, 137805290855.0;
12.896500000000001, 137708449470.0;
12.903166666666667, 137262137000.0;
12.909833333333335, 136824245520.0;
12.916500000000001, 136900034430.0;
12.923166666666667, 137076875220.0;
12.929833333333335, 137451609275.0;
12.9365, 138142130455.0;
12.943166666666668, 139047386880.0;
12.949833333333334, 139573698755.0;
12.9565, 139624224695.0;
12.963166666666668, 139409489450.0;
12.969833333333334, 139177912225.0;
12.976500000000001, 139047386880.0;
12.983166666666667, 139034755395.0;
12.989833333333335, 139342121530.0;
12.996500000000001, 139531593805.0;
13.003166666666667, 139716855585.0;
13.009833333333335, 139809486475.0;
13.0165, 140230535975.0;
13.023166666666668, 140710532405.0;
13.029833333333334, 140971583095.0;
13.0365, 141236844280.0;
13.043166666666668, 141485263485.0;
13.049833333333334, 141674735760.0;
13.056500000000002, 141380001110.0;
13.063166666666667, 140933688640.0;
13.069833333333335, 140765268840.0;
13.076500000000001, 141102108440.0;
13.083166666666667, 141822103085.0;
13.089833333333335, 142424203870.0;
13.0965, 142853674360.0;
13.103166666666668, 143005252180.0;
13.109833333333334, 142862095350.0;
13.1165, 142386309415.0;
13.123166666666668, 141518947445.0;
13.129833333333334, 140824215770.0;
13.136500000000002, 140420008250.0;
13.143166666666668, 140260009440.0;
13.149833333333333, 140272640925.0;
13.156500000000001, 140226325480.0;
13.163166666666667, 140592638545.0;
13.169833333333335, 140748426860.0;
13.1765, 140874741710.0;
13.183166666666668, 140824215770.0;
13.189833333333334, 140769479335.0;
13.1965, 140647374980.0;
13.203166666666668, 140297903895.0;
13.209833333333334, 140070537165.0;
13.216500000000002, 139780013010.0;
13.223166666666668, 139144228265.0;
13.229833333333334, 138706336785.0;
13.236500000000001, 138765283715.0;
13.243166666666667, 138975808465.0;
13.249833333333335, 138908440545.0;
13.2565, 138765283715.0;
13.263166666666667, 139274753610.0;
13.269833333333334, 139758960535.0;
13.2765, 139691592615.0;
13.283166666666668, 139497909845.0;
13.289833333333334, 139624224695.0;
13.296500000000002, 139906327860.0;
13.303166666666668, 139611593210.0;
13.309833333333334, 139064228860.0;
13.316500000000001, 139232648660.0;
13.323166666666667, 139843170435.0;
13.329833333333335, 140491586665.0;
13.336500000000001, 140702111415.0;
13.343166666666667, 141118950420.0;
13.349833333333335, 141257896755.0;
13.3565, 140693690425.0;
13.363166666666668, 139489488855.0;
13.369833333333334, 138276866295.0;
13.376500000000002, 137763185905.0;
13.383166666666668, 137598976600.0;
13.389833333333334, 137809501350.0;
13.396500000000001, 137931605705.0;
13.403166666666667, 138083183525.0;
13.409833333333335, 138137919960.0;
13.416500000000001, 137758975410.0;
13.423166666666667, 137123190665.0;
13.429833333333335, 136588457800.0;
13.4365, 136630562750.0;
13.443166666666668, 137089506705.0;
13.449833333333334, 137716870460.0;
13.4565, 138196866890.0;
13.463166666666668, 138676863320.0;
13.469833333333334, 139097912820.0;
13.476500000000001, 139611593210.0;
13.483166666666667, 139792644495.0;
13.489833333333335, 139556856775.0;
13.496500000000001, 139371594995.0;
13.503166666666667, 139283174600.0;
13.509833333333335, 139278964105.0;
13.5165, 138895809060.0;
13.523166666666668, 138504233025.0;
13.529833333333334, 138188445900.0;
13.5365, 137973710655.0;
13.543166666666668, 137775817390.0;
13.549833333333334, 137417925315.0;
13.556500000000002, 137110559180.0;
13.563166666666667, 136942139380.0;
13.569833333333335, 137076875220.0;
13.576500000000001, 137312662940.0;
13.583166666666667, 137346346900.0;
13.589833333333335, 137426346305.0;
13.5965, 137716870460.0;
13.603166666666668, 138386339165.0;
13.609833333333334, 138895809060.0;
13.6165, 139329490045.0;
13.623166666666668, 139721066080.0;
13.629833333333334, 140137905085.0;
13.636500000000002, 140592638545.0;
13.643166666666668, 140958951610.0;
13.649833333333333, 141316843685.0;
13.656500000000001, 141283159725.0;
13.663166666666667, 141013688045.0;
13.669833333333335, 140904215175.0;
13.6765, 140828426265.0;
13.683166666666668, 140436850230.0;
13.689833333333334, 139965274790.0;
13.6965, 140078958155.0;
13.703166666666668, 140685269435.0;
13.709833333333334, 140824215770.0;
13.716500000000002, 140285272410.0;
13.723166666666668, 139451594400.0;
13.729833333333334, 138862125100.0;
13.736500000000001, 138403181145.0;
13.743166666666667, 138053710060.0;
13.749833333333335, 137876869270.0;
13.7565, 137952658180.0;
13.763166666666669, 138668442330.0;
13.769833333333334, 139350542520.0;
13.7765, 139683171625.0;
13.783166666666668, 139598961725.0;
13.789833333333334, 139434752420.0;
13.796500000000002, 139527383310.0;
13.803166666666668, 139401068460.0;
13.809833333333334, 139468436380.0;
13.816500000000001, 139666329645.0;
13.823166666666667, 139990537760.0;
13.829833333333335, 140542112605.0;
13.836500000000001, 141102108440.0;
13.843166666666667, 141337896160.0;
13.849833333333335, 141152634380.0;
13.8565, 140845268245.0;
13.863166666666668, 140803163295.0;
13.869833333333334, 140782110820.0;
13.876500000000002, 140403166270.0;
13.883166666666668, 140045274195.0;
13.889833333333334, 139750539545.0;
13.896500000000001, 139851591425.0;
13.903166666666667, 139780013010.0;
13.909833333333335, 139695803110.0;
13.916500000000001, 139691592615.0;
13.923166666666667, 139615803705.0;
13.929833333333335, 139767381525.0;
13.9365, 139838959940.0;
13.943166666666668, 140331587855.0;
13.949833333333334, 140575796565.0;
13.956500000000002, 140744216365.0;
13.963166666666668, 141144213390.0;
13.969833333333334, 141552631405.0;
13.976500000000001, 142036838330.0;
13.983166666666667, 142104206250.0;
13.989833333333335, 141826313580.0;
13.996500000000001, 141085266460.0;
14.003166666666667, 140154747065.0;
14.009833333333335, 139329490045.0;
14.0165, 138306339760.0;
14.023166666666668, 137363188880.0;
14.029833333333334, 136857929480.0;
14.0365, 137607397590.0;
14.043166666666668, 138798967675.0;
14.049833333333334, 140028432215.0;
14.056500000000002, 141102108440.0;
14.063166666666667, 142062101300.0;
14.069833333333335, 142908410795.0;
14.076500000000001, 142992620695.0;
14.083166666666667, 142857884855.0;
14.089833333333335, 142592623670.0;
14.0965, 142327362485.0;
14.103166666666668, 142116837735.0;
14.109833333333334, 141952628430.0;
14.1165, 142209468625.0;
14.123166666666668, 142293678525.0;
14.129833333333334, 142205258130.0;
14.136500000000002, 141817892590.0;
14.143166666666668, 141548420910.0;
14.149833333333333, 141215791805.0;
14.156500000000001, 140554744090.0;
14.163166666666667, 139746329050.0;
14.169833333333335, 138878967080.0;
14.1765, 138411602135.0;
14.183166666666668, 138028447090.0;
14.189833333333334, 138154761940.0;
14.1965, 138512654015.0;
14.203166666666668, 138958966485.0;
14.209833333333334, 139527383310.0;
14.216500000000002, 140205273005.0;
14.223166666666668, 140769479335.0;
14.229833333333334, 141182107845.0;
14.236500000000001, 141304212200.0;
14.243166666666667, 141674735760.0;
14.249833333333335, 141619999325.0;
14.2565, 141013688045.0;
14.263166666666669, 140213693995.0;
14.269833333333334, 139540014795.0;
14.2765, 139712645090.0;
14.283166666666668, 139767381525.0;
14.289833333333334, 139944222315.0;
14.296500000000002, 140373692805.0;
14.303166666666668, 141123160915.0;
14.309833333333334, 141809471600.0;
14.316500000000001, 141489473980.0;
14.323166666666667, 141110529430.0;
14.329833333333335, 140900004680.0;
14.336500000000001, 141110529430.0;
14.343166666666667, 141161055370.0;
14.349833333333335, 140992635570.0;
14.3565, 141051582500.0;
14.363166666666668, 141085266460.0;
14.369833333333334, 141291580715.0;
14.376500000000002, 141426316555.0;
14.383166666666668, 141834734570.0;
14.389833333333334, 142163153180.0;
14.396500000000001, 142462098325.0;
14.403166666666667, 142832621885.0;
14.409833333333335, 142950515745.0;
14.416500000000001, 142899989805.0;
14.423166666666667, 142331572980.0;
14.429833333333335, 141645262295.0;
14.4365, 140963162105.0;
14.443166666666668, 140331587855.0;
14.449833333333334, 139977906275.0;
14.456500000000002, 139518962320.0;
14.463166666666668, 139497909845.0;
14.469833333333334, 140036853205.0;
14.476500000000001, 140689479930.0;
14.483166666666667, 141177897350.0;
14.489833333333335, 141468421505.0;
14.496500000000001, 141990522885.0;
14.503166666666667, 142259994565.0;
14.509833333333335, 142116837735.0;
14.5165, 141779998135.0;
14.523166666666668, 141582104870.0;
14.529833333333334, 141716840710.0;
14.5365, 141834734570.0;
14.543166666666668, 141961049420.0;
14.549833333333334, 141986312390.0;
14.556500000000002, 142664202085.0;
14.563166666666667, 143455775145.0;
14.569833333333335, 143931561080.0;
14.576500000000001, 143927350585.0;
14.583166666666667, 144108401870.0;
14.589833333333335, 144563135330.0;
14.5965, 144605240280.0;
14.603166666666668, 144398926025.0;
14.609833333333334, 143918929595.0;
14.6165, 143729457320.0;
14.623166666666668, 143666299895.0;
14.629833333333334, 143678931380.0;
14.636500000000002, 143548406035.0;
14.643166666666668, 143358933760.0;
14.649833333333335, 143422091185.0;
14.656500000000001, 143535774550.0;
14.663166666666667, 143055778120.0;
14.669833333333335, 142508413770.0;
14.6765, 142154732190.0;
14.683166666666668, 142487361295.0;
14.689833333333334, 142828411390.0;
14.6965, 142958936735.0;
14.703166666666668, 143476827620.0;
14.709833333333334, 143801035735.0;
14.716500000000002, 144049454940.0;
14.723166666666668, 143552616530.0;
14.729833333333334, 143430512175.0;
14.736500000000001, 143775772765.0;
14.743166666666667, 144062086425.0;
14.749833333333335, 144521030380.0;
14.7565, 145026289780.0;
14.763166666666669, 145813652345.0;
14.769833333333334, 146163123430.0;
14.7765, 146015756105.0;
14.783166666666668, 145822073335.0;
14.789833333333334, 145278919480.0;
14.796500000000002, 144499977905.0;
14.803166666666668, 143666299895.0;
14.809833333333334, 143228408415.0;
14.816500000000001, 143009462675.0;
14.823166666666667, 142988410200.0;
14.829833333333335, 143047357130.0;
14.836500000000001, 143472617125.0;
14.843166666666669, 143998929000.0;
14.849833333333335, 144424188995.0;
14.8565, 144841028000.0;
14.863166666666668, 144950500870.0;
14.869833333333334, 145228393540.0;
14.876500000000002, 145236814530.0;
14.883166666666668, 144899974930.0;
14.889833333333334, 144588398300.0;
14.896500000000001, 144546293350.0;
14.903166666666667, 144904185425.0;
14.909833333333335, 145106289185.0;
14.916500000000001, 145131552155.0;
14.923166666666667, 145316813935.0;
14.929833333333335, 145173657105.0;
14.9365, 144659976715.0;
14.943166666666668, 143948403060.0;
14.949833333333334, 143342091780.0;
14.956500000000002, 142862095350.0;
14.963166666666668, 142339993970.0;
14.969833333333334, 142095785260.0;
14.976500000000001, 142407361890.0;
14.983166666666667, 142878937330.0;
14.989833333333335, 143586300490.0;
14.996500000000001, 144344189590.0;
15.003166666666667, 145291550965.0;
15.009833333333335, 146003124620.0;
15.0165, 145935756700.0;
15.023166666666668, 145451549775.0;
15.029833333333334, 144819975525.0;
15.036500000000002, 144445241470.0;
15.043166666666668, 144078928405.0;
15.049833333333334, 143699983855.0;
15.056500000000002, 143489459105.0;
15.063166666666667, 143245250395.0;
15.069833333333335, 142857884855.0;
15.076500000000001, 142445256345.0;
15.083166666666667, 142352625455.0;
15.089833333333335, 142537887235.0;
15.0965, 142622097135.0;
15.103166666666668, 142773674955.0;
15.109833333333334, 142752622480.0;
15.1165, 142638939115.0;
15.123166666666668, 142588413175.0;
15.129833333333334, 142714728025.0;
15.136500000000002, 143379986235.0;
15.143166666666668, 144095770385.0;
15.149833333333335, 144954711365.0;
15.156500000000001, 145859967790.0;
15.163166666666667, 146163123430.0;
15.169833333333335, 146314701250.0;
15.1765, 146070492540.0;
15.183166666666668, 146116807985.0;
15.189833333333334, 146163123430.0;
15.1965, 146125228975.0;
15.203166666666668, 146222070360.0;
15.209833333333334, 145822073335.0;
15.216500000000002, 145342076905.0;
15.223166666666668, 144617871765.0;
15.229833333333334, 144121033355.0;
15.236500000000001, 143784193755.0;
15.243166666666667, 143565248015.0;
15.249833333333335, 143931561080.0;
15.2565, 144546293350.0;
15.263166666666669, 145224183045.0;
15.269833333333334, 145813652345.0;
15.2765, 146521015505.0;
15.283166666666668, 147641007175.0;
15.289833333333334, 148601000035.0;
15.296500000000002, 149013628545.0;
15.303166666666668, 148845208745.0;
15.309833333333334, 148407317265.0;
15.316500000000001, 147611533710.0;
15.323166666666667, 146394700655.0;
15.329833333333335, 145190499085.0;
15.336500000000001, 144601029785.0;
15.343166666666669, 144714713150.0;
15.349833333333335, 144946290375.0;
15.3565, 145064184235.0;
15.363166666666668, 145064184235.0;
15.369833333333334, 145135762650.0;
15.376500000000002, 145329445420.0;
15.383166666666668, 145249446015.0;
15.389833333333334, 145401023835.0;
15.396500000000001, 145708389970.0;
15.403166666666667, 146230491350.0;
15.409833333333335, 146255754320.0;
15.416500000000001, 146158912935.0;
15.423166666666667, 146302069765.0;
15.429833333333335, 146243122835.0;
15.4365, 146099966005.0;
15.443166666666668, 145986282640.0;
15.449833333333334, 146533646990.0;
15.456500000000002, 147211536685.0;
15.463166666666668, 147472587375.0;
15.469833333333334, 147350483020.0;
15.476500000000001, 147211536685.0;
15.483166666666667, 147093642825.0;
15.489833333333335, 146735750750.0;
15.496500000000001, 145809441850.0;
15.503166666666667, 145118920670.0;
15.509833333333335, 145009447800.0;
15.5165, 145219972550.0;
15.523166666666668, 145426286805.0;
15.529833333333334, 145417865815.0;
15.536500000000002, 145590496110.0;
15.543166666666668, 145594706605.0;
15.549833333333334, 145552601655.0;
15.556500000000002, 145329445420.0;
15.563166666666667, 144912606415.0;
15.569833333333335, 144710502655.0;
15.576500000000001, 144693660675.0;
15.583166666666667, 144845238495.0;
15.589833333333335, 144942079880.0;
15.5965, 145081026215.0;
15.603166666666668, 145346287400.0;
15.609833333333334, 145430497300.0;
15.6165, 145438918290.0;
15.623166666666668, 145535759675.0;
15.629833333333334, 145792599870.0;
15.636500000000002, 146449437090.0;
15.643166666666668, 147215747180.0;
15.649833333333335, 148024162220.0;
15.656500000000001, 148491527165.0;
15.663166666666667, 148748367360.0;
15.669833333333335, 148710472905.0;
15.6765, 148201003010.0;
15.683166666666668, 147489429355.0;
15.689833333333334, 146815750155.0;
15.6965, 146605225405.0;
15.703166666666668, 146832592135.0;
15.709833333333334, 147266273120.0;
15.716500000000002, 147544165790.0;
15.723166666666668, 147358904010.0;
15.729833333333335, 147177852725.0;
15.736500000000001, 147017853915.0;
15.743166666666667, 146689435305.0;
15.749833333333335, 146201017885.0;
15.7565, 145944177690.0;
15.763166666666669, 146238912340.0;
15.769833333333334, 146546278475.0;
15.7765, 146575751940.0;
15.783166666666668, 146811539660.0;
15.789833333333334, 147321009555.0;
15.796500000000002, 147834689945.0;
15.803166666666668, 148007320240.0;
15.809833333333334, 147965215290.0;
15.816500000000001, 148116793110.0;
15.823166666666667, 147834689945.0;
15.829833333333335, 147472587375.0;
15.836500000000001, 147249431140.0;
15.843166666666669, 147434692920.0;
15.849833333333335, 147657849155.0;
15.8565, 147822058460.0;
15.863166666666668, 148537842610.0;
15.869833333333334, 149371520620.0;
15.876500000000002, 150057831305.0;
15.883166666666668, 150462038825.0;
15.889833333333334, 151274664360.0;
15.896500000000001, 152369393060.0;
15.903166666666667, 153207281565.0;
15.909833333333335, 153733593440.0;
15.916500000000001, 154171484920.0;
15.923166666666669, 154596744915.0;
15.929833333333335, 154651481350.0;
15.9365, 154377799175.0;
15.943166666666668, 154133590465.0;
15.949833333333334, 154171484920.0;
15.9565, 154213589870.0;
15.963166666666668, 153965170665.0;
15.969833333333336, 153565173640.0;
15.9765, 153198860575.0;
15.983166666666667, 152769390085.0;
15.989833333333335, 152015711480.0;
15.996500000000003, 150979929710.0;
16.003166666666665, 149944147940.0;
16.009833333333333, 149064154485.0;
16.0165, 148398896275.0;
16.023166666666665, 147754690540.0;
16.029833333333332, 147194694705.0;
16.0365, 146584172930.0;
16.043166666666664, 145881020265.0;
16.049833333333332, 144727344635.0;
16.0565, 143072620100.0;
16.063166666666667, 141152634380.0;
16.06983333333333, 139017913415.0;
16.0765, 136992665320.0;
16.083166666666667, 135274783360.0;
16.08983333333333, 133788478625.0;
16.0965, 132251647950.0;
16.103166666666667, 130121137480.0;
16.109833333333334, 127805365230.0;
16.1165, 125632749810.0;
16.123166666666666, 123350661520.0;
16.129833333333334, 121144362140.0;
16.136499999999998, 118639117615.0;
16.143166666666666, 116458081205.0;
16.149833333333333, 114378096675.0;
16.156499999999998, 112133902840.0;
16.163166666666665, 109881288015.0;
16.169833333333333, 107110782305.0;
16.1765, 104837115005.0;
16.183166666666665, 102672920575.0;
16.189833333333333, 100538199610.0;
16.1965, 98155059440.0;
16.203166666666664, 95620341450.0;
16.209833333333332, 93502462465.0;
16.2165, 91203532195.0;
16.223166666666668, 88635130245.0;
16.229833333333332, 86117254235.0;
16.2365, 84058322180.0;
16.243166666666667, 82639385365.0;
16.24983333333333, 81266763995.0;
16.2565, 79814143220.0;
16.263166666666667, 78500468780.0;
16.269833333333334, 76988901075.0;
16.2765, 75039441890.0;
16.283166666666666, 72483671425.0;
16.289833333333334, 70290003530.0;
16.296499999999998, 68530016620.0;
16.303166666666666, 66896344560.0;
16.309833333333334, 65346882400.0;
16.316499999999998, 63822683210.0;
16.323166666666665, 62551113720.0;
16.329833333333333, 60812179285.0;
16.3365, 58909035545.0;
16.343166666666665, 56955365865.0;
16.349833333333333, 55153274005.0;
16.3565, 53730126695.0;
16.363166666666665, 52555398590.0;
16.369833333333332, 51599616225.0;
16.3765, 50395414655.0;
16.383166666666668, 49309106945.0;
16.389833333333332, 48151220820.0;
16.3965, 47325963800.0;
16.403166666666667, 46332286980.0;
16.40983333333333, 45359662635.0;
16.4165, 44517563635.0;
16.423166666666667, 43692306615.0;
16.42983333333333, 43330204045.0;
16.4365, 42483894550.0;
16.443166666666666, 41380744860.0;
16.449833333333334, 40222858735.0;
16.4565, 39149182510.0;
16.463166666666666, 38479713805.0;
16.469833333333334, 37570246885.0;
16.476499999999998, 36888146695.0;
16.483166666666666, 36062889675.0;
16.489833333333333, 34879740580.0;
16.4965, 33852379800.0;
16.503166666666665, 32761861595.0;
16.509833333333333, 31839763190.0;
16.5165, 30833454885.0;
16.523166666666665, 30521878255.0;
16.529833333333332, 30900822805.0;
16.5365, 31473450125.0;
16.543166666666664, 31768184775.0;
16.549833333333332, 31932394080.0;
16.5565, 32366075065.0;
16.563166666666667, 32462916450.0;
16.56983333333333, 32311338630.0;
16.5765, 31886078635.0;
16.583166666666667, 31860815665.0;
16.58983333333333, 31873447150.0;
16.5965, 31667132895.0;
16.603166666666667, 31599764975.0;
16.609833333333334, 31839763190.0;
16.6165, 32113445365.0;
16.623166666666666, 31902920615.0;
16.629833333333334, 31473450125.0;
16.636499999999998, 31229241415.0;
16.643166666666666, 31069242605.0;
16.649833333333333, 30530299245.0;
16.6565, 29932408955.0;
16.663166666666665, 29898724995.0;
16.669833333333333, 30521878255.0;
16.6765, 30993453695.0;
16.683166666666665, 31098716070.0;
16.689833333333333, 31001874685.0;
16.6965, 30997664190.0;
16.703166666666664, 30610298650.0;
16.709833333333332, 29587148365.0;
16.7165, 28585050555.0;
16.723166666666668, 27974528780.0;
16.729833333333332, 28345052340.0;
16.7365, 29086099460.0;
16.743166666666667, 30083986775.0;
16.74983333333333, 31039769140.0;
16.7565, 31877657645.0;
16.763166666666667, 32681862190.0;
16.769833333333334, 32854492485.0;
16.7765, 32862913475.0;
16.783166666666666, 32555547340.0;
16.789833333333334, 32526073875.0;
16.796499999999998, 32551336845.0;
16.803166666666666, 32273444175.0;
16.809833333333334, 31860815665.0;
16.816499999999998, 31052400625.0;
16.823166666666665, 30256617070.0;
16.829833333333333, 29473465000.0;
16.8365, 28702944415.0;
16.843166666666665, 28366104815.0;
16.849833333333333, 28610313525.0;
16.8565, 29713463215.0;
16.863166666666665, 30955559240.0;
16.869833333333332, 31822921210.0;
16.8765, 32715546150.0;
16.883166666666668, 33498698220.0;
16.889833333333332, 33587118615.0;
16.8965, 32631336250.0;
16.903166666666667, 31751342795.0;
16.90983333333333, 31797658240.0;
16.9165, 32096603385.0;
16.923166666666667, 32454495460.0;
16.92983333333333, 32875544960.0;
16.9365, 33612381585.0;
16.943166666666666, 34062904550.0;
16.949833333333334, 33553434655.0;
16.9565, 32875544960.0;
16.963166666666666, 32222918235.0;
16.969833333333334, 32298707145.0;
16.976499999999998, 32488179420.0;
16.983166666666666, 32505021400.0;
16.989833333333333, 32648178230.0;
16.9965, 32812387535.0;
17.003166666666665, 33031333275.0;
17.009833333333333, 32850281990.0;
17.0165, 32883965950.0;
17.023166666666665, 33401856835.0;
17.029833333333332, 34025010095.0;
17.0365, 34366060190.0;
17.043166666666664, 34353428705.0;
17.049833333333332, 34142903955.0;
17.0565, 33831327325.0;
17.063166666666667, 33309225945.0;
17.06983333333333, 33031333275.0;
17.0765, 33073438225.0;
17.083166666666667, 33439751290.0;
17.08983333333333, 33987115640.0;
17.0965, 34138693460.0;
17.103166666666667, 34130272470.0;
17.109833333333334, 33667118020.0;
17.1165, 33149227135.0;
17.123166666666666, 32702914665.0;
17.129833333333334, 32467126945.0;
17.136499999999998, 32631336250.0;
17.143166666666666, 33086069710.0;
17.149833333333333, 33957642175.0;
17.1565, 34837635630.0;
17.163166666666665, 35435525920.0;
17.169833333333333, 35456578395.0;
17.1765, 34917635035.0;
17.183166666666665, 34163956430.0;
17.189833333333333, 33620802575.0;
17.1965, 33414488320.0;
17.203166666666664, 33166069115.0;
17.209833333333332, 33170279610.0;
17.2165, 33536592675.0;
17.223166666666668, 34227113855.0;
17.229833333333332, 34547111475.0;
17.2365, 34374481180.0;
17.243166666666667, 34345007715.0;
17.24983333333333, 34340797220.0;
17.2565, 34551321970.0;
17.263166666666667, 34580795435.0;
17.269833333333334, 34479743555.0;
17.2765, 34517638010.0;
17.283166666666666, 34412375635.0;
17.289833333333334, 34412375635.0;
17.296499999999998, 34231324350.0;
17.303166666666666, 34155535440.0;
17.309833333333334, 34265008310.0;
17.316499999999998, 34315534250.0;
17.323166666666665, 34256587320.0;
17.329833333333333, 34294481775.0;
17.3365, 34349218210.0;
17.343166666666665, 34273429300.0;
17.349833333333333, 34180798410.0;
17.3565, 34336586725.0;
17.363166666666665, 34905003550.0;
17.369833333333332, 34980792460.0;
17.3765, 34648163355.0;
17.383166666666668, 34252376825.0;
17.389833333333332, 34016589105.0;
17.3965, 33949221185.0;
17.403166666666667, 33776590890.0;
17.40983333333333, 33869221780.0;
17.4165, 34563953455.0;
17.423166666666667, 35397631465.0;
17.42983333333333, 36037626705.0;
17.4365, 35898680370.0;
17.443166666666666, 35519735820.0;
17.449833333333334, 35464999385.0;
17.4565, 35292369090.0;
17.463166666666666, 34926056025.0;
17.469833333333334, 34458691080.0;
17.476499999999998, 34374481180.0;
17.483166666666666, 34917635035.0;
17.489833333333333, 35439736415.0;
17.4965, 36332361355.0;
17.503166666666665, 37279722730.0;
17.509833333333333, 38214452620.0;
17.5165, 38904973800.0;
17.523166666666665, 38993394195.0;
17.529833333333332, 38867079345.0;
17.5365, 38496555785.0;
17.543166666666668, 38252347075.0;
17.549833333333332, 38256557570.0;
17.5565, 38416556380.0;
17.563166666666667, 38702870040.0;
17.56983333333333, 38871289840.0;
17.5765, 38766027465.0;
17.583166666666667, 38526029250.0;
17.58983333333333, 38424977370.0;
17.5965, 38677607070.0;
17.603166666666667, 38930236770.0;
17.609833333333334, 39094446075.0;
17.6165, 39250234390.0;
17.623166666666666, 39629178940.0;
17.629833333333334, 39389180725.0;
17.636499999999998, 38761816970.0;
17.643166666666666, 38370240935.0;
17.649833333333333, 38580765685.0;
17.6565, 39081814590.0;
17.663166666666665, 39355496765.0;
17.669833333333333, 39793388245.0;
17.6765, 40109175370.0;
17.683166666666665, 39991281510.0;
17.689833333333333, 39561811020.0;
17.6965, 39081814590.0;
17.703166666666664, 38757606475.0;
17.709833333333332, 38782869445.0;
17.7165, 39288128845.0;
17.723166666666668, 40210227250.0;
17.729833333333332, 40744960115.0;
17.7365, 40740749620.0;
17.743166666666667, 40542856355.0;
17.74983333333333, 40500751405.0;
17.7565, 40627066255.0;
17.763166666666667, 40446014970.0;
17.769833333333334, 40534435365.0;
17.7765, 40803907045.0;
17.783166666666666, 41380744860.0;
17.789833333333334, 41886004260.0;
17.796499999999998, 42079687030.0;
17.803166666666666, 42429158115.0;
17.809833333333334, 42837576130.0;
17.816499999999998, 43730201070.0;
17.823166666666665, 44307038885.0;
17.829833333333333, 44391248785.0;
17.8365, 44770193335.0;
17.843166666666665, 45342820655.0;
17.849833333333333, 46420707375.0;
17.8565, 47115439050.0;
17.863166666666665, 47974380030.0;
17.869833333333332, 48921741405.0;
17.8765, 49481737240.0;
17.883166666666668, 49784892880.0;
17.889833333333332, 49768050900.0;
17.8965, 49936470700.0;
17.903166666666667, 50281731290.0;
17.90983333333333, 50719622770.0;
17.9165, 51304881575.0;
17.923166666666667, 51944876815.0;
17.92983333333333, 52222769485.0;
17.9365, 51881719390.0;
17.943166666666666, 51048041380.0;
17.949833333333334, 50648044355.0;
17.9565, 50660675840.0;
17.963166666666666, 51031199400.0;
17.969833333333334, 51742773055.0;
17.976499999999998, 53271182740.0;
17.983166666666666, 55359588260.0;
17.989833333333333, 57005891805.0;
17.9965, 58029042090.0;
18.003166666666665, 58500617530.0;
18.009833333333333, 58786931190.0;
18.0165, 58925877525.0;
18.023166666666665, 58854299110.0;
18.029833333333332, 58862720100.0;
18.0365, 58976403465.0;
18.043166666666668, 59367979500.0;
18.049833333333332, 59970080285.0;
18.0565, 60610075525.0;
18.063166666666667, 61043756510.0;
18.06983333333333, 61207965815.0;
18.0765, 61250070765.0;
18.083166666666667, 61140597895.0;
18.08983333333333, 61216386805.0;
18.0965, 61435332545.0;
18.103166666666667, 62395325405.0;
18.109833333333334, 63818472715.0;
18.1165, 65102673690.0;
18.123166666666666, 65911088730.0;
18.129833333333334, 66062666550.0;
18.136499999999998, 66273191300.0;
18.143166666666666, 66134244965.0;
18.149833333333333, 66130034470.0;
18.1565, 66445821595.0;
18.163166666666665, 67300552080.0;
18.169833333333333, 68290018405.0;
18.1765, 68664752460.0;
18.183166666666665, 68656331470.0;
18.189833333333333, 68163703555.0;
18.1965, 67410024950.0;
18.203166666666664, 66403716645.0;
18.209833333333332, 65574249130.0;
18.2165, 65300566955.0;
18.223166666666668, 65393197845.0;
18.229833333333332, 65557407150.0;
18.2365, 65435302795.0;
18.243166666666667, 65296356460.0;
18.24983333333333, 64942674880.0;
18.2565, 64235311720.0;
18.263166666666667, 63170056485.0;
18.269833333333334, 62079538280.0;
18.2765, 61544805415.0;
18.283166666666666, 61098492945.0;
18.289833333333334, 60753232355.0;
18.296499999999998, 59961659295.0;
18.303166666666666, 59085876335.0;
18.309833333333334, 58134304465.0;
18.316499999999998, 56963786855.0;
18.323166666666665, 55658533405.0;
18.329833333333333, 54395384905.0;
18.3365, 53713284715.0;
18.343166666666665, 53245919770.0;
18.349833333333333, 52736449875.0;
18.3565, 52285926910.0;
18.363166666666665, 51957508300.0;
18.369833333333332, 51410143950.0;
18.3765, 50328046735.0;
18.383166666666668, 48997530315.0;
18.389833333333332, 47763855280.0;
18.3965, 46437549355.0;
18.403166666666667, 44896508185.0;
18.40983333333333, 43191257710.0;
18.4165, 41654427035.0;
18.423166666666667, 40273384675.0;
18.429833333333335, 38947078750.0;
18.4365, 37721824705.0;
18.443166666666666, 36791305310.0;
18.449833333333334, 36391308285.0;
18.4565, 36126047100.0;
18.463166666666666, 35544998790.0;
18.469833333333334, 34888161570.0;
18.476499999999998, 34361849695.0;
18.483166666666666, 33886063760.0;
18.489833333333333, 32846071495.0;
18.4965, 31751342795.0;
18.503166666666665, 31241872900.0;
18.509833333333333, 30951348745.0;
18.5165, 30370300435.0;
18.523166666666665, 29347150150.0;
18.529833333333332, 28627155505.0;
18.5365, 27928213335.0;
18.543166666666668, 27174534730.0;
18.549833333333332, 26302962265.0;
18.5565, 25540862670.0;
18.563166666666667, 24909288420.0;
18.56983333333333, 24088241895.0;
18.5765, 23174564480.0;
18.583166666666667, 22307202510.0;
18.58983333333333, 21726154200.0;
18.5965, 21414577570.0;
18.603166666666667, 21081948465.0;
18.609833333333334, 20719845895.0;
18.6165, 20606162530.0;
18.623166666666666, 20176692040.0;
18.629833333333334, 19199857200.0;
18.636499999999998, 17713552465.0;
18.643166666666666, 16492508915.0;
18.649833333333333, 15528305560.0;
18.6565, 14631470125.0;
18.663166666666665, 13848318055.0;
18.669833333333333, 13490425980.0;
18.6765, 13599898850.0;
18.683166666666665, 13873581025.0;
18.689833333333333, 14277788545.0;
18.6965, 14543049730.0;
18.703166666666664, 14639891115.0;
18.709833333333332, 14235683595.0;
18.7165, 13675687760.0;
18.723166666666668, 13035692520.0;
18.729833333333332, 12530433120.0;
18.7365, 12345171340.0;
18.743166666666667, 12425170745.0;
18.74983333333333, 12905167175.0;
18.7565, 13313585190.0;
18.763166666666667, 13637793305.0;
18.769833333333334, 13482004990.0;
18.7765, 12623064010.0;
18.783166666666666, 11625176695.0;
18.789833333333334, 11073601850.0;
18.796499999999998, 10795709180.0;
18.803166666666666, 10109398495.0;
18.809833333333334, 9284141475.0;
18.8165, 8976775340.0;
18.823166666666665, 9258878505.0;
18.829833333333333, 9498876720.0;
18.8365, 9562034145.0;
18.843166666666665, 9839926815.0;
18.849833333333333, 10218871365.0;
18.8565, 10210450375.0;
18.863166666666665, 9540981670.0;
18.869833333333332, 8370464060.0;
18.8765, 7103105065.0;
18.883166666666668, 6235743095.0;
18.889833333333332, 5684168250.0;
18.8965, 5743115180.0;
18.903166666666667, 5894693000.0;
18.90983333333333, 5852588050.0;
18.9165, 5599958350.0;
18.923166666666667, 5103119940.0;
18.929833333333335, 4892595190.0;
18.9365, 4635754995.0;
18.943166666666666, 4324178365.0;
18.949833333333334, 4349441335.0;
18.9565, 4690491430.0;
18.963166666666666, 5035752020.0;
18.969833333333334, 4715754400.0;
18.976499999999998, 4378914800.0;
18.983166666666666, 4488387670.0;
18.989833333333333, 4732596380.0;
18.9965, 4837858755.0;
19.003166666666665, 5094698950.0;
19.009833333333333, 5692589240.0;
19.0165, 5936797950.0;
19.023166666666665, 5587326865.0;
19.029833333333332, 5157856375.0;
19.0365, 4951542120.0;
19.043166666666668, 4362072820.0;
19.049833333333332, 3865234410.0;
19.0565, 3667341145.0;
19.063166666666667, 3810497975.0;
19.06983333333333, 3679972630.0;
19.0765, 3376816990.0;
19.083166666666667, 3393658970.0;
19.08983333333333, 3322080555.0;
19.0965, 2951556995.0;
19.103166666666667, 2652611850.0;
19.109833333333334, 2808400165.0;
19.1165, 2888399570.0;
19.123166666666666, 3035766895.0;
19.129833333333334, 3216818180.0;
19.136499999999998, 3827339955.0;
19.143166666666666, 4122074605.0;
19.149833333333333, 3890497380.0;
19.1565, 3696814610.0;
19.163166666666665, 3246291645.0;
19.169833333333333, 2917873035.0;
19.1765, 2602085910.0;
19.183166666666665, 2597875415.0;
19.189833333333333, 2774716205.0;
19.1965, 2593664920.0;
19.203166666666664, 2479981555.0;
19.209833333333332, 2122089480.0;
19.2165, 1709460970.0;
19.223166666666668, 1094728700.0;
19.229833333333332, 757889100.0;
19.2365, 778941575.0;
19.243166666666667, 1048413255.0;
19.24983333333333, 1385252855.0;
19.2565, 1633672060.0;
19.263166666666667, 2277877795.0;
19.269833333333334, 2926294025.0;
19.2765, 3688393620.0;
19.283166666666666, 3894707875.0;
19.289833333333334, 3793655995.0;
19.296499999999998, 3385237980.0;
19.303166666666666, 2829452640.0;
19.309833333333334, 2181036410.0;
19.3165, 1372621370.0;
19.323166666666665, 707363160.0;
19.329833333333333, 572627320.0;
19.3365, 1082097215.0;
19.343166666666665, 1671566515.0;
19.349833333333333, 2147352450.0;
19.3565, 2286298785.0;
19.363166666666665, 2484192050.0;
19.369833333333332, 2559980960.0;
19.3765, 2193667895.0;
19.383166666666668, 1486304735.0;
19.389833333333332, 294734650.0;
19.3965, -404207520.0;
19.403166666666667, -783152070.0;
19.40983333333333, -850519990.0;
19.4165, -656837220.0;
19.423166666666667, -181051285.0;
19.429833333333335, 576837815.0;
19.4365, 938940385.0;
19.443166666666666, 892624940.0;
19.449833333333334, 496838410.0;
19.4565, 96841385.0;
19.463166666666666, -332629105.0;
19.469833333333334, -475785935.0;
19.476499999999998, -239998215.0;
19.483166666666666, 341050095.0;
19.489833333333333, 829467515.0;
19.4965, 1073676225.0;
19.503166666666665, 1031571275.0;
19.509833333333333, 1216833055.0;
19.5165, 1465252260.0;
19.523166666666665, 1789460375.0;
19.529833333333332, 2176825915.0;
19.5365, 2458929080.0;
19.543166666666668, 2871557590.0;
19.549833333333332, 2703137790.0;
19.5565, 2147352450.0;
19.563166666666667, 1351568895.0;
19.56983333333333, 922098405.0;
19.5765, 837888505.0;
19.583166666666667, 446312470.0;
19.58983333333333, -134735840.0;
19.5965, -454733460.0;
19.603166666666667, -345260590.0;
19.609833333333334, -593679795.0;
19.6165, -1359989885.0;
19.623166666666666, -1983143145.0;
19.629833333333334, -2033669085.0;
19.636499999999998, -1810512850.0;
19.643166666666666, -1856828295.0;
19.649833333333333, -2058932055.0;
19.6565, -2193667895.0;
19.663166666666665, -2067353045.0;
19.669833333333333, -1776828890.0;
19.6765, -1528409685.0;
19.683166666666665, -1250517015.0;
19.689833333333333, -1010518800.0;
19.6965, -614732270.0;
19.703166666666668, -366313065.0;
19.709833333333332, -454733460.0;
19.7165, -905256425.0;
19.723166666666668, -1461041765.0;
19.729833333333332, -1814723345.0;
19.7365, -2063142550.0;
19.743166666666667, -2223141360.0;
19.74983333333333, -2025248095.0;
19.7565, -1519988695.0;
19.763166666666667, -1094728700.0;
19.769833333333334, -694731675.0;
19.7765, -370523560.0;
19.783166666666666, -126314850.0;
19.789833333333334, -298945145.0;
19.796499999999998, -484206925.0;
19.803166666666666, -311576630.0;
19.809833333333334, -290524155.0;
19.8165, -505259400.0;
19.823166666666665, -955782365.0;
19.829833333333333, -1094728700.0;
19.8365, -1023150285.0;
19.843166666666665, -1267358995.0;
19.849833333333333, -1258938005.0;
19.8565, -1271569490.0;
19.863166666666665, -976834840.0;
19.869833333333332, -947361375.0;
19.8765, -964203355.0;
19.883166666666668, -791573060.0;
19.889833333333332, -787362565.0;
19.8965, -728415635.0;
19.903166666666667, -825257020.0;
19.90983333333333, -690521180.0;
19.9165, -905256425.0;
19.923166666666667, -1330516420.0;
19.929833333333335, -1945248690.0;
19.9365, -2202088885.0;
19.943166666666666, -2046300570.0;
19.949833333333334, -1768407900.0;
19.9565, -1566304140.0;
##END=

$$ === CHEMSPECTRA INTEGRALS AND MULTIPLETS ===
##PAGE=254
##$OBSERVEDINTEGRALS= (X Y Z)
##$OBSERVEDMULTIPLETS=
##$OBSERVEDMULTIPLETSPEAKS=
##END=

$$ === CHEMSPECTRA PEAK TABLE EDIT ===
##TITLE=618becfe-a0ce-4983-ba36-5fdcbb7ed595
##JCAMP-DX=5.00
##DATA TYPE=LC/MSPEAKTABLE
##DATA CLASS=PEAKTABLE
##$CSCATEGORY=EDIT_PEAK
##$CSTHRESHOLD=0.05
##MAXX=19.9565
##MAXY=7198165410615.0
##MINX=-0.0435
##MINY=-162285108785.0
##PAGE=254
##NPOINTS=0
##PEAKTABLE= (XY..XY)
##END=

$$ === CHEMSPECTRA PEAK TABLE AUTO ===
##TITLE=618becfe-a0ce-4983-ba36-5fdcbb7ed595
##JCAMP-DX=5.00
##DATA TYPE=LC/MSPEAKTABLE
##DATA CLASS=PEAKTABLE
##$CSCATEGORY=AUTO_PEAK
##$CSTHRESHOLD=0.05
##MAXX=19.9565
##MAXY=7198165410615.0
##MINX=-0.0435
##MINY=-162285108785.0
##PAGE=254
##NPOINTS=1
##PEAKTABLE= (XY..XY)
2.2698333333333336, 7198165410615.0
##END=

$$ === CHEMSPECTRA UVVIS PEAK TABLE ===
##TITLE=618becfe-a0ce-4983-ba36-5fdcbb7ed595
##JCAMP-DX=5.00
##DATA TYPE=LC/MS
##DATA CLASS=PEAK TABLE
##ORIGIN=
##OWNER=
##XUNITS=RETENTION TIME
##YUNITS=DETECTOR SIGNAL
##$CSCATEGORY=UVVIS PEAK TABLE
##PAGE=280
##NPOINTS=3001
##DATA TABLE= (XY..XY), PEAKS
-0.0435, 92630890.0;
-0.03683333333333333, 63157425.0;
-0.03016666666666666, 181051285.0;
-0.023499999999999997, 522101380.0;
-0.01683333333333333, 484206925.0;
-0.010166666666666664, 189472275.0;
-0.003499999999999996, 42104950.0;
0.003166666666666672, 63157425.0;
0.00983333333333334, 197893265.0;
0.016500000000000008, -16841980.0;
0.02316666666666667, -84209900.0;
0.029833333333333337, 181051285.0;
0.036500000000000005, 673679200.0;
0.04316666666666667, 1145254640.0;
0.04983333333333334, 1292621965.0;
0.05650000000000001, 1094728700.0;
0.06316666666666668, 774731080.0;
0.06983333333333334, 517890885.0;
0.07650000000000001, 458943955.0;
0.08316666666666668, 412628510.0;
0.08983333333333333, 509469895.0;
0.09650000000000002, 997887315.0;
0.10316666666666667, 1574725130.0;
0.10983333333333335, 2037879580.0;
0.1165, 2084195025.0;
0.12316666666666669, 2172615420.0;
0.12983333333333336, 2138931460.0;
0.1365, 1882091265.0;
0.14316666666666666, 1423147310.0;
0.14983333333333337, 833678010.0;
0.15650000000000003, 547364350.0;
0.16316666666666668, 416839005.0;
0.16983333333333334, 576837815.0;
0.1765, 694731675.0;
0.1831666666666667, 1048413255.0;
0.18983333333333335, 1532620180.0;
0.1965, 1924196215.0;
0.20316666666666666, 1793670870.0;
0.20983333333333337, 1267358995.0;
0.21650000000000003, 938940385.0;
0.22316666666666668, 639995240.0;
0.2298333333333334, 488417420.0;
0.23650000000000004, 126314850.0;
0.2431666666666667, 29473465.0;
0.24983333333333335, 193682770.0;
0.25650000000000006, 534732865.0;
0.2631666666666667, 749468110.0;
0.26983333333333337, 572627320.0;
0.2765, 341050095.0;
0.2831666666666667, 138946335.0;
0.2898333333333334, -138946335.0;
0.29650000000000004, -383155045.0;
0.3031666666666667, -581048310.0;
0.30983333333333335, -458943955.0;
0.31650000000000006, -151577820.0;
0.3231666666666667, 159998810.0;
0.32983333333333337, 454733460.0;
0.3365, 269471680.0;
0.34316666666666673, 33683960.0;
0.3498333333333334, -391576035.0;
0.35650000000000004, -715784150.0;
0.3631666666666667, -1023150285.0;
0.3698333333333334, -1191570085.0;
0.37650000000000006, -896835435.0;
0.3831666666666667, -656837220.0;
0.38983333333333337, -362102570.0;
0.3965, -92630890.0;
0.40316666666666673, 383155045.0;
0.4098333333333334, 669468705.0;
0.41650000000000004, 442101975.0;
0.4231666666666667, 231577225.0;
0.4298333333333334, 239998215.0;
0.43650000000000005, 214735245.0;
0.4431666666666667, 16841980.0;
0.44983333333333336, -96841385.0;
0.4565, 42104950.0;
0.4631666666666667, 151577820.0;
0.46983333333333344, -33683960.0;
0.47650000000000003, -151577820.0;
0.48316666666666674, -505259400.0;
0.48983333333333334, -1069465730.0;
0.49650000000000005, -1431568300.0;
0.5031666666666668, -1330516420.0;
0.5098333333333334, -652626725.0;
0.5165000000000001, -159998810.0;
0.5231666666666667, 362102570.0;
0.5298333333333334, 871572465.0;
0.5365000000000001, 1221043550.0;
0.5431666666666667, 1199991075.0;
0.5498333333333334, 808415040.0;
0.5565000000000001, 614732270.0;
0.5631666666666667, 719994645.0;
0.5698333333333334, 1044202760.0;
0.5765, 1267358995.0;
0.5831666666666667, 1187359590.0;
0.5898333333333334, 955782365.0;
0.5965, 572627320.0;
0.6031666666666667, 273682175.0;
0.6098333333333333, -46315445.0;
0.6165, -458943955.0;
0.6231666666666668, -707363160.0;
0.6298333333333334, -707363160.0;
0.6365000000000001, -711573655.0;
0.6431666666666668, -930519395.0;
0.6498333333333334, -1191570085.0;
0.6565000000000001, -1069465730.0;
0.6631666666666667, -774731080.0;
0.6698333333333334, -749468110.0;
0.6765000000000001, -858940980.0;
0.6831666666666667, -1103149690.0;
0.6898333333333334, -1199991075.0;
0.6965000000000001, -1267358995.0;
0.7031666666666667, -1195780580.0;
0.7098333333333334, -1229464540.0;
0.7165, -1178938600.0;
0.7231666666666667, -926308900.0;
0.7298333333333334, -661047715.0;
0.7365, -484206925.0;
0.7431666666666668, -648416230.0;
0.7498333333333334, -597890290.0;
0.7565000000000001, -484206925.0;
0.7631666666666668, -282103165.0;
0.7698333333333334, -185261780.0;
0.7765000000000001, -311576630.0;
0.7831666666666668, -412628510.0;
0.7898333333333334, -509469895.0;
0.7965000000000001, -572627320.0;
0.8031666666666667, -783152070.0;
0.8098333333333334, -943150880.0;
0.8165000000000001, -871572465.0;
0.8231666666666667, -543153855.0;
0.8298333333333334, -315787125.0;
0.8365, 0.0;
0.8431666666666667, 362102570.0;
0.8498333333333334, 863151475.0;
0.8565, 1279990480.0;
0.8631666666666667, 1503146715.0;
0.8698333333333335, 1717881960.0;
0.8765000000000001, 1911564730.0;
0.8831666666666668, 1987353640.0;
0.8898333333333334, 1861038790.0;
0.8965000000000001, 1759986910.0;
0.9031666666666668, 2012616610.0;
0.9098333333333334, 2378929675.0;
0.9165000000000001, 2391561160.0;
0.9231666666666667, 2239983340.0;
0.9298333333333334, 2117878985.0;
0.9365000000000001, 1995774630.0;
0.9431666666666667, 1890512255.0;
0.9498333333333334, 1793670870.0;
0.9565, 1941038195.0;
0.9631666666666668, 2008406115.0;
0.9698333333333334, 1941038195.0;
0.9765, 1713671465.0;
0.9831666666666669, 1431568300.0;
0.9898333333333335, 1355779390.0;
0.9965, 1406305330.0;
1.0031666666666665, 1570514635.0;
1.0098333333333334, 1541041170.0;
1.0165, 1755776415.0;
1.0231666666666666, 1890512255.0;
1.0298333333333334, 1768407900.0;
1.0365, 1225254045.0;
1.0431666666666666, 421049500.0;
1.0498333333333334, -214735245.0;
1.0565, -1048413255.0;
1.0631666666666666, -1713671465.0;
1.0698333333333334, -1894722750.0;
1.0765, -943150880.0;
1.0831666666666666, 1212622560.0;
1.0898333333333332, 3995759755.0;
1.0965, 6682055565.0;
1.1031666666666666, 8585199305.0;
1.1098333333333332, 8745198115.0;
1.1165, 4176811040.0;
1.1231666666666666, -8888354945.0;
1.1298333333333332, -31709237845.0;
1.1365, -60155342065.0;
1.1431666666666667, -86955142740.0;
1.1498333333333333, -104117120360.0;
1.1565, -104340276595.0;
1.1631666666666667, -83422537435.0;
1.1698333333333333, -42850207615.0;
1.1764999999999999, 9852558300.0;
1.1831666666666667, 64458467955.0;
1.1898333333333333, 111788642250.0;
1.1965, 145438918290.0;
1.2031666666666667, 164445092720.0;
1.2098333333333333, 171708196595.0;
1.2165, 171337673035.0;
1.2231666666666667, 166668234080.0;
1.2298333333333333, 159371446245.0;
1.2365, 151396768715.0;
1.2431666666666668, 142904200300.0;
1.2498333333333334, 132626382005.0;
1.2565, 116062294675.0;
1.2631666666666665, 88167765300.0;
1.2698333333333334, 47490173105.0;
1.2765, -2378929675.0;
1.2831666666666666, -54062755800.0;
1.2898333333333334, -100087676645.0;
1.2965, -133497954470.0;
1.3031666666666666, -149068364980.0;
1.3098333333333334, -145910493730.0;
1.3165, -128866409970.0;
1.3231666666666666, -105982369645.0;
1.3298333333333334, -84066743170.0;
1.3365, -65810036850.0;
1.3431666666666666, -51582774245.0;
1.3498333333333332, -40867064470.0;
1.3565, -32820808525.0;
1.3631666666666666, -26530328995.0;
1.3698333333333332, -21452472025.0;
1.3765, -17321976430.0;
1.3831666666666667, -13831476075.0;
1.3898333333333333, -10795709180.0;
1.3965, -8711514155.0;
1.4031666666666667, -7376787240.0;
1.4098333333333333, -6387320915.0;
1.4165, -5389433600.0;
1.4231666666666667, -4564176580.0;
1.4298333333333333, -4151548070.0;
1.4365, -3557868275.0;
1.4431666666666667, -2698927295.0;
1.4498333333333333, -1646303545.0;
1.4565, -669468705.0;
1.4631666666666667, 58946930.0;
1.4698333333333333, 905256425.0;
1.4765, 1793670870.0;
1.4831666666666667, 2475771060.0;
1.4898333333333333, 3098924320.0;
1.4965, 3629446690.0;
1.5031666666666668, 4362072820.0;
1.5098333333333334, 4799964300.0;
1.5165, 4842069250.0;
1.5231666666666668, 4795753805.0;
1.5298333333333334, 4639965490.0;
1.5365, 4450493215.0;
1.5431666666666666, 4050496190.0;
1.5498333333333334, 3962075795.0;
1.5565, 4303125890.0;
1.5631666666666666, 4416809255.0;
1.5698333333333334, 4248389455.0;
1.5765, 4004180745.0;
1.5831666666666666, 3970496785.0;
1.5898333333333334, 3688393620.0;
1.5965, 3195765705.0;
1.6031666666666666, 3132608280.0;
1.6098333333333334, 3562078770.0;
1.6165, 3966286290.0;
1.6231666666666666, 4092601140.0;
1.6298333333333332, 4479966680.0;
1.6365, 4989436575.0;
1.6431666666666667, 5212592810.0;
1.6498333333333333, 5069435980.0;
1.6565, 5145224890.0;
1.6631666666666667, 5305223700.0;
1.6698333333333333, 4955752615.0;
1.6765, 4256810445.0;
1.6831666666666667, 3806287480.0;
1.6898333333333333, 3844181935.0;
1.6965000000000001, 3751551045.0;
1.7031666666666667, 3482079365.0;
1.7098333333333333, 3402079960.0;
1.7165, 3427342930.0;
1.7231666666666667, 3612604710.0;
1.7298333333333333, 3532605305.0;
1.7365, 3351554020.0;
1.7431666666666668, 3322080555.0;
1.7498333333333334, 3616815205.0;
1.7565, 4307336385.0;
1.7631666666666668, 4804174795.0;
1.7698333333333334, 5229434790.0;
1.7765, 6054691810.0;
1.7831666666666668, 6926264275.0;
1.7898333333333334, 7418892190.0;
1.7965, 7423102685.0;
1.8031666666666666, 7258893380.0;
1.8098333333333334, 7439944665.0;
1.8165, 7208367440.0;
1.8231666666666666, 6724160515.0;
1.8298333333333334, 6244164085.0;
1.8365, 6341005470.0;
1.8431666666666666, 6673634575.0;
1.8498333333333334, 6269427055.0;
1.8565, 5351539145.0;
1.8631666666666666, 4863121725.0;
1.8698333333333335, 5039962515.0;
1.8765, 5086277960.0;
1.8831666666666667, 4837858755.0;
1.8898333333333333, 4639965490.0;
1.8965, 4884174200.0;
1.9031666666666667, 4766280340.0;
1.9098333333333333, 4252599950.0;
1.9165, 3793655995.0;
1.9231666666666667, 3473658375.0;
1.9298333333333333, 3477868870.0;
1.9365, 3410500950.0;
1.9431666666666667, 3456816395.0;
1.9498333333333333, 3456816395.0;
1.9565, 3271554615.0;
1.9631666666666667, 3275765110.0;
1.9698333333333335, 3448395405.0;
1.9765, 3755761540.0;
1.9831666666666667, 3936812825.0;
1.9898333333333336, 3924181340.0;
1.9965, 3936812825.0;
2.003166666666667, 3734709065.0;
2.009833333333334, 3376816990.0;
2.0165, 3039977390.0;
2.023166666666667, 2947346500.0;
2.0298333333333334, 2968398975.0;
2.0365, 3035766895.0;
2.043166666666667, 3052608875.0;
2.0498333333333334, 2825242145.0;
2.0565, 2408403140.0;
2.063166666666667, 1945248690.0;
2.0698333333333334, 1730513445.0;
2.0765000000000002, 1490515230.0;
2.083166666666667, 1532620180.0;
2.0898333333333334, 1941038195.0;
2.0965000000000003, 2623138385.0;
2.103166666666667, 3082082340.0;
2.1098333333333334, 3372606495.0;
2.1165000000000003, 3705235600.0;
2.123166666666667, 3898918370.0;
2.1298333333333335, 3663130650.0;
2.1365000000000003, 3069450855.0;
2.143166666666667, 2644190860.0;
2.1498333333333335, 2602085910.0;
2.1565000000000003, 2846294620.0;
2.163166666666667, 3136818775.0;
2.1698333333333335, 3629446690.0;
2.1765000000000003, 4164179555.0;
2.183166666666667, 4408388265.0;
2.1898333333333335, 4341020345.0;
2.1965000000000003, 4029443715.0;
2.2031666666666667, 3814708470.0;
2.2098333333333335, 3650499165.0;
2.2165000000000004, 3519973820.0;
2.2231666666666667, 4206284505.0;
2.2298333333333336, 11528335310.0;
2.2365000000000004, 38248136580.0;
2.2431666666666668, 84129900595.0;
2.2498333333333336, 127721155330.0;
2.2565000000000004, 146748382235.0;
2.2631666666666668, 137956868675.0;
2.2698333333333336, 111363382255.0;
2.2765000000000004, 65523723190.0;
2.283166666666667, 3650499165.0;
2.2898333333333336, -52180664535.0;
2.2965000000000004, -80386770540.0;
2.303166666666667, -78854150360.0;
2.3098333333333336, -64542677855.0;
2.3165000000000004, -49136476650.0;
2.323166666666667, -35877627895.0;
2.3298333333333336, -25587178115.0;
2.3365000000000005, -17797762365.0;
2.343166666666667, -12100962630.0;
2.3498333333333337, -7877836145.0;
2.3565000000000005, -4576808065.0;
2.363166666666667, -1999985125.0;
2.3698333333333337, 715784150.0;
2.3765000000000005, 4054706685.0;
2.383166666666667, 8063097925.0;
2.3898333333333337, 12698852920.0;
2.3965, 17667237020.0;
2.403166666666667, 22985092205.0;
2.4098333333333337, 27945055315.0;
2.4165, 32096603385.0;
2.423166666666667, 35153422755.0;
2.4298333333333337, 37368143125.0;
2.4365, 38707080535.0;
2.443166666666667, 38976552215.0;
2.4498333333333338, 38100769255.0;
2.4565, 36319729870.0;
2.463166666666667, 34020799600.0;
2.4698333333333338, 31271346365.0;
2.4765, 28551366595.0;
2.483166666666667, 25806123855.0;
2.489833333333334, 23431404675.0;
2.4965, 21187210840.0;
2.503166666666667, 19233541160.0;
2.509833333333334, 17932498205.0;
2.5165, 17355660390.0;
2.523166666666667, 17970392660.0;
2.529833333333334, 19612485710.0;
2.5365, 22387201915.0;
2.543166666666667, 25755597915.0;
2.549833333333334, 29102941440.0;
2.5565, 32079761405.0;
2.563166666666667, 34488164545.0;
2.5698333333333334, 36307098385.0;
2.5765000000000002, 37498668470.0;
2.583166666666667, 38547081725.0;
2.5898333333333334, 39827072205.0;
2.5965000000000003, 41258640505.0;
2.603166666666667, 42589156925.0;
2.6098333333333334, 43667043645.0;
2.6165000000000003, 44770193335.0;
2.623166666666667, 45477556495.0;
2.6298333333333335, 45380715110.0;
2.6365000000000003, 44403880270.0;
2.643166666666667, 43052311375.0;
2.6498333333333335, 41717584460.0;
2.6565000000000003, 40180753785.0;
2.663166666666667, 38269189055.0;
2.6698333333333335, 36290256405.0;
2.6765000000000003, 34665005335.0;
2.683166666666667, 33372383370.0;
2.6898333333333335, 32239760215.0;
2.6965000000000003, 31043979635.0;
2.703166666666667, 30197670140.0;
2.7098333333333335, 29616621830.0;
2.7165000000000004, 29048205005.0;
2.723166666666667, 28361894320.0;
2.7298333333333336, 27801898485.0;
2.7365000000000004, 27734530565.0;
2.7431666666666668, 27827161455.0;
2.7498333333333336, 27970318285.0;
2.7565000000000004, 28231368975.0;
2.7631666666666668, 28766101840.0;
2.7698333333333336, 29128204410.0;
2.7765000000000004, 29465044010.0;
2.783166666666667, 30193459645.0;
2.7898333333333336, 31313451315.0;
2.7965000000000004, 32462916450.0;
2.803166666666667, 33296594460.0;
2.8098333333333336, 33995536630.0;
2.8165000000000004, 34517638010.0;
2.823166666666667, 34627110880.0;
2.8298333333333336, 34357639200.0;
2.8365000000000005, 33730275445.0;
2.843166666666667, 32749230110.0;
2.8498333333333337, 31578712500.0;
2.8565000000000005, 30193459645.0;
2.863166666666667, 28454525210.0;
2.8698333333333337, 26601907410.0;
2.8765000000000005, 24816657530.0;
2.883166666666667, 23578772000.0;
2.8898333333333337, 22618779140.0;
2.8965000000000005, 21578786875.0;
2.903166666666667, 20867213220.0;
2.9098333333333337, 20079850655.0;
2.9165000000000005, 19637748680.0;
2.923166666666667, 18980911460.0;
2.9298333333333337, 18357758200.0;
2.9365, 18075655035.0;
2.943166666666667, 17604079595.0;
2.9498333333333338, 17309344945.0;
2.9565, 17056715245.0;
2.963166666666667, 17275660985.0;
2.9698333333333338, 17557764150.0;
2.9765, 17751446920.0;
2.983166666666667, 18147233450.0;
2.989833333333334, 18543019980.0;
2.9965, 18686176810.0;
3.003166666666667, 18475652060.0;
3.009833333333334, 18319863745.0;
3.0165, 18189338400.0;
3.023166666666667, 17865130285.0;
3.029833333333334, 17764078405.0;
3.0365, 17776709890.0;
3.043166666666667, 17978813650.0;
3.049833333333334, 17966182165.0;
3.0565, 18084076025.0;
3.063166666666667, 18328284735.0;
3.069833333333334, 18484073050.0;
3.0765000000000002, 18332495230.0;
3.083166666666667, 17780920385.0;
3.089833333333334, 16745138615.0;
3.0965000000000003, 15166202990.0;
3.103166666666667, 13199901825.0;
3.1098333333333334, 11056759870.0;
3.1165000000000003, 9317825435.0;
3.123166666666667, 7957835550.0;
3.1298333333333335, 7204156945.0;
3.1365000000000003, 6572582695.0;
3.143166666666667, 6159954185.0;
3.1498333333333335, 5637852805.0;
3.1565000000000003, 5073646475.0;
3.163166666666667, 4492598165.0;
3.1698333333333335, 4058917180.0;
3.1765000000000003, 3932602330.0;
3.183166666666667, 3882076390.0;
3.1898333333333335, 3987338765.0;
3.1965000000000003, 4185232030.0;
3.203166666666667, 4303125890.0;
3.2098333333333335, 4290494405.0;
3.2165000000000004, 4202074010.0;
3.223166666666667, 4122074605.0;
3.2298333333333336, 3882076390.0;
3.2365000000000004, 3237870655.0;
3.243166666666667, 2425245120.0;
3.2498333333333336, 1494725725.0;
3.2565000000000004, 736836625.0;
3.263166666666667, 223156235.0;
3.2698333333333336, -202103760.0;
3.2765000000000004, -652626725.0;
3.283166666666667, -1162096620.0;
3.2898333333333336, -1612619585.0;
3.2965000000000004, -2315772250.0;
3.303166666666667, -3216818180.0;
3.3098333333333336, -3873655400.0;
3.3165000000000004, -4151548070.0;
3.323166666666667, -4189442525.0;
3.3298333333333336, -4277862920.0;
3.3365000000000005, -4286283910.0;
3.343166666666667, -4332599355.0;
3.3498333333333337, -4543124105.0;
3.3565000000000005, -4905226675.0;
3.363166666666667, -5427328055.0;
3.3698333333333337, -6029428840.0;
3.3765000000000005, -6631529625.0;
3.383166666666667, -7077842095.0;
3.3898333333333337, -7507312585.0;
3.3965000000000005, -7890467630.0;
3.403166666666667, -8117834360.0;
3.4098333333333337, -8130465845.0;
3.4165000000000005, -8033624460.0;
3.423166666666667, -7966256540.0;
3.4298333333333337, -7835731195.0;
3.4365000000000006, -7797836740.0;
3.443166666666667, -7789415750.0;
3.4498333333333338, -8138886835.0;
3.4565000000000006, -8837829005.0;
3.463166666666667, -9654665035.0;
3.4698333333333338, -10256765820.0;
3.4765, -10652552350.0;
3.483166666666667, -11195706205.0;
3.489833333333334, -11460967390.0;
3.4965, -11439914915.0;
3.503166666666667, -11334652540.0;
3.509833333333334, -11431493925.0;
3.5165, -11642018675.0;
3.523166666666667, -11570440260.0;
3.529833333333334, -11460967390.0;
3.5365, -11199916700.0;
3.543166666666667, -11056759870.0;
3.549833333333334, -11229390165.0;
3.5565, -11629387190.0;
3.563166666666667, -12185172530.0;
3.569833333333334, -12618853515.0;
3.5765000000000002, -13094639450.0;
3.583166666666667, -13204112320.0;
3.589833333333334, -13073586975.0;
3.5965000000000003, -12850430740.0;
3.603166666666667, -13052534500.0;
3.609833333333334, -13688319245.0;
3.6165000000000003, -14277788545.0;
3.623166666666667, -14618838640.0;
3.629833333333334, -14551470720.0;
3.6365000000000003, -14256736070.0;
3.643166666666667, -13747266175.0;
3.6498333333333335, -13191480835.0;
3.6565000000000003, -12922009155.0;
3.663166666666667, -12980956085.0;
3.6698333333333335, -13267269745.0;
3.6765000000000003, -13679898255.0;
3.683166666666667, -13991474885.0;
3.6898333333333335, -13869370530.0;
3.6965000000000003, -13540951920.0;
3.703166666666667, -13549372910.0;
3.7098333333333335, -13970422410.0;
3.7165000000000004, -14286209535.0;
3.723166666666667, -14315683000.0;
3.7298333333333336, -14614628145.0;
3.7365000000000004, -15119887545.0;
3.743166666666667, -15452516650.0;
3.7498333333333336, -15553568530.0;
3.7565000000000004, -15831461200.0;
3.763166666666667, -16374615055.0;
3.7698333333333336, -16521982380.0;
3.7765000000000004, -16441982975.0;
3.7831666666666672, -16117774860.0;
3.7898333333333336, -15898829120.0;
3.7965000000000004, -15650409915.0;
3.8031666666666673, -15503042590.0;
3.8098333333333336, -15814619220.0;
3.8165000000000004, -16084090900.0;
3.823166666666667, -16361983570.0;
3.8298333333333336, -16538824360.0;
3.8365000000000005, -16652507725.0;
3.843166666666667, -16437772480.0;
3.8498333333333337, -15823040210.0;
3.8565000000000005, -15566200015.0;
3.863166666666667, -15675672885.0;
3.8698333333333337, -15966197040.0;
3.8765000000000005, -16164090305.0;
3.883166666666667, -16732507130.0;
3.8898333333333337, -17477764745.0;
3.8965000000000005, -17890393255.0;
3.903166666666667, -18004076620.0;
3.9098333333333337, -17751446920.0;
3.9165000000000005, -17355660390.0;
3.923166666666667, -16505140400.0;
3.9298333333333337, -16084090900.0;
3.9365000000000006, -16155669315.0;
3.943166666666667, -16463035450.0;
3.9498333333333338, -16677770695.0;
3.9565, -16841980000.0;
3.963166666666667, -17208293065.0;
3.9698333333333338, -17229345540.0;
3.9765000000000006, -17014610295.0;
3.9831666666666674, -16761980595.0;
3.9898333333333333, -16917768910.0;
3.9965, -17494606725.0;
4.003166666666667, -18050392065.0;
4.009833333333334, -18408284140.0;
4.016500000000001, -18399863150.0;
4.0231666666666674, -18210390875.0;
4.029833333333333, -17688289495.0;
4.0365, -16892505940.0;
4.043166666666667, -16008301990.0;
4.049833333333334, -15313570315.0;
4.056500000000001, -15010414675.0;
4.0631666666666675, -15149361010.0;
4.069833333333333, -15469358630.0;
4.0765, -15936723575.0;
4.083166666666667, -16538824360.0;
4.089833333333334, -17343028905.0;
4.096500000000001, -18092497015.0;
4.103166666666667, -18340916220.0;
4.1098333333333334, -18547230475.0;
4.1165, -18812491660.0;
4.123166666666667, -19111436805.0;
4.129833333333334, -19220909675.0;
4.136500000000001, -18938806510.0;
4.143166666666667, -18639861365.0;
4.1498333333333335, -18357758200.0;
4.1565, -18088286520.0;
4.163166666666667, -17759867910.0;
4.169833333333334, -17313555440.0;
4.176500000000001, -17145135640.0;
4.183166666666667, -17204082570.0;
4.1898333333333335, -17410396825.0;
4.1965, -17591448110.0;
4.203166666666667, -17772499395.0;
4.209833333333334, -17983024145.0;
4.216500000000001, -18126180975.0;
4.223166666666667, -18117759985.0;
4.229833333333334, -17743025930.0;
4.2365, -17254608510.0;
4.243166666666667, -16972505345.0;
4.249833333333334, -16976715840.0;
4.256500000000001, -17157767125.0;
4.263166666666667, -17473554250.0;
4.269833333333334, -17945129690.0;
4.2765, -18391442160.0;
4.283166666666667, -18841965125.0;
4.289833333333334, -19073542350.0;
4.2965, -19199857200.0;
4.303166666666667, -19326172050.0;
4.309833333333334, -19490381355.0;
4.3165000000000004, -19637748680.0;
4.323166666666667, -19351435020.0;
4.329833333333334, -19355645515.0;
4.3365, -19637748680.0;
4.343166666666667, -20012482735.0;
4.349833333333334, -20159850060.0;
4.3565000000000005, -20214586495.0;
4.363166666666667, -20399848275.0;
4.369833333333334, -20231428475.0;
4.3765, -19776695015.0;
4.383166666666667, -19161962745.0;
4.389833333333334, -18921964530.0;
4.3965000000000005, -18892491065.0;
4.403166666666667, -19124068290.0;
4.409833333333334, -19418802940.0;
4.4165, -19439855415.0;
4.423166666666667, -19557749275.0;
4.429833333333334, -19940904320.0;
4.4365000000000006, -20614583520.0;
4.443166666666667, -20799845300.0;
4.449833333333333, -20660898965.0;
4.4565, -20808266290.0;
4.463166666666667, -20896686685.0;
4.469833333333334, -20749319360.0;
4.476500000000001, -20041956200.0;
4.483166666666667, -19650380165.0;
4.489833333333333, -19545117790.0;
4.4965, -19705116600.0;
4.503166666666667, -19987219765.0;
4.509833333333334, -20088271645.0;
4.516500000000001, -20420900750.0;
4.5231666666666674, -20846160745.0;
4.529833333333333, -21393525095.0;
4.5365, -21759838160.0;
4.543166666666667, -21684049250.0;
4.549833333333334, -21410367075.0;
4.556500000000001, -21044054010.0;
4.5631666666666675, -20896686685.0;
4.569833333333333, -20921949655.0;
4.5765, -20715635400.0;
4.583166666666667, -20804055795.0;
4.589833333333334, -20955633615.0;
4.596500000000001, -21178789850.0;
4.6031666666666675, -21149316385.0;
4.6098333333333334, -21018791040.0;
4.6165, -21048264505.0;
4.623166666666667, -20985107080.0;
4.629833333333334, -21170368860.0;
4.636500000000001, -21477734995.0;
4.643166666666667, -21726154200.0;
4.6498333333333335, -21978783900.0;
4.6565, -22273518550.0;
4.663166666666667, -22505095775.0;
4.669833333333334, -22345096965.0;
4.676500000000001, -22100888255.0;
4.683166666666667, -21860890040.0;
4.6898333333333335, -21561944895.0;
4.6965, -21284052225.0;
4.703166666666667, -20985107080.0;
4.709833333333334, -20732477380.0;
4.716500000000001, -20176692040.0;
4.723166666666667, -19873536400.0;
4.729833333333334, -19747221550.0;
4.7365, -19587222740.0;
4.743166666666667, -19431434425.0;
4.749833333333334, -19540907295.0;
4.756500000000001, -20176692040.0;
4.763166666666667, -20871423715.0;
4.769833333333334, -21422998560.0;
4.7765, -21717733210.0;
4.783166666666667, -21945099940.0;
4.789833333333334, -22193519145.0;
4.796500000000001, -22425096370.0;
4.803166666666667, -22345096965.0;
4.809833333333334, -21982994395.0;
4.8165000000000004, -21780890635.0;
4.823166666666667, -21995625880.0;
4.829833333333334, -22020888850.0;
4.8365, -21376683115.0;
4.843166666666667, -20374585305.0;
4.849833333333334, -19818799965.0;
4.8565000000000005, -19671432640.0;
4.863166666666667, -19469328880.0;
4.869833333333334, -19435644920.0;
4.8765, -19848273430.0;
4.883166666666667, -20808266290.0;
4.889833333333334, -21490366480.0;
4.8965000000000005, -21582997370.0;
4.903166666666667, -21578786875.0;
4.909833333333334, -21570365885.0;
4.9165, -21747206675.0;
4.923166666666667, -21734575190.0;
4.929833333333334, -21641944300.0;
4.9365000000000006, -21355630640.0;
4.943166666666667, -20660898965.0;
4.949833333333334, -19911430855.0;
4.9565, -19473539375.0;
4.963166666666667, -19279856605.0;
4.969833333333334, -19267225120.0;
4.976500000000001, -19566170265.0;
4.983166666666667, -19978798775.0;
4.989833333333333, -20391427285.0;
4.9965, -20429321740.0;
5.003166666666667, -20244059960.0;
5.009833333333334, -19860904915.0;
5.016500000000001, -19456697395.0;
5.0231666666666674, -19524065315.0;
5.029833333333333, -19974588280.0;
5.0365, -20383006295.0;
5.043166666666667, -20547215600.0;
5.049833333333334, -20513531640.0;
5.056500000000001, -20551426095.0;
5.0631666666666675, -20416690255.0;
5.069833333333333, -19953535805.0;
5.0765, -19343014030.0;
5.083166666666667, -19031437400.0;
5.089833333333334, -19119857795.0;
5.096500000000001, -19481960365.0;
5.1031666666666675, -19789326500.0;
5.1098333333333334, -19970377785.0;
5.1165, -20008272240.0;
5.123166666666667, -19999851250.0;
5.129833333333334, -20029324715.0;
5.136500000000001, -19978798775.0;
5.1431666666666676, -19907220360.0;
5.1498333333333335, -19557749275.0;
5.1565, -19157752250.0;
5.163166666666667, -18627229880.0;
5.169833333333334, -18134601965.0;
5.176500000000001, -17380923360.0;
5.183166666666667, -16753559605.0;
5.1898333333333335, -16850400990.0;
5.1965, -17204082570.0;
5.203166666666667, -17334607915.0;
5.209833333333334, -17237766530.0;
5.216500000000001, -17498817220.0;
5.223166666666667, -18008287115.0;
5.229833333333334, -17983024145.0;
5.2365, -18084076025.0;
5.243166666666667, -18450389090.0;
5.249833333333334, -18905122550.0;
5.256500000000001, -18997753440.0;
5.263166666666667, -18715650275.0;
5.269833333333334, -18631440375.0;
5.2765, -18606177405.0;
5.283166666666667, -18766176215.0;
5.289833333333334, -18972490470.0;
5.296500000000001, -18976700965.0;
5.303166666666667, -18905122550.0;
5.309833333333334, -18711439780.0;
5.3165000000000004, -18530388495.0;
5.323166666666667, -18244074835.0;
5.329833333333334, -17991445135.0;
5.336500000000001, -18050392065.0;
5.343166666666667, -17928287710.0;
5.349833333333334, -18058813055.0;
5.3565000000000005, -18134601965.0;
5.363166666666667, -18391442160.0;
5.369833333333334, -18218811865.0;
5.3765, -18113549490.0;
5.383166666666667, -18391442160.0;
5.389833333333334, -18623019385.0;
5.3965000000000005, -18673545325.0;
5.403166666666667, -18576703940.0;
5.409833333333334, -18770386710.0;
5.4165, -18724071265.0;
5.423166666666667, -18387231665.0;
5.429833333333334, -17801972860.0;
5.4365000000000006, -17254608510.0;
5.443166666666667, -16900926930.0;
5.449833333333334, -16900926930.0;
5.4565, -17119872670.0;
5.463166666666667, -17389344350.0;
5.469833333333334, -17970392660.0;
5.476500000000001, -18854596610.0;
5.483166666666667, -19675643135.0;
5.489833333333334, -20231428475.0;
5.4965, -20673530450.0;
5.503166666666667, -21309315195.0;
5.509833333333334, -21629312815.0;
5.516500000000001, -21667207270.0;
5.5231666666666674, -21359841135.0;
5.529833333333333, -20879844705.0;
5.5365, -20269322930.0;
5.543166666666667, -19684064125.0;
5.549833333333334, -19376697990.0;
5.556500000000001, -19174594230.0;
5.5631666666666675, -19052489875.0;
5.569833333333333, -19187225715.0;
5.5765, -19734590065.0;
5.583166666666667, -20387216790.0;
5.589833333333334, -20690372430.0;
5.596500000000001, -20576689065.0;
5.6031666666666675, -20454584710.0;
5.6098333333333334, -20256691445.0;
5.6165, -19919851845.0;
5.623166666666667, -19124068290.0;
5.629833333333334, -18383021170.0;
5.636500000000001, -17970392660.0;
5.6431666666666676, -17894603750.0;
5.6498333333333335, -17873551275.0;
5.6565, -17469343755.0;
5.663166666666667, -17376712865.0;
5.669833333333334, -17536711675.0;
5.676500000000001, -17823025335.0;
5.683166666666668, -17860919790.0;
5.6898333333333335, -17608290090.0;
5.6965, -17671447515.0;
5.703166666666667, -17578816625.0;
5.709833333333334, -17448291280.0;
5.716500000000001, -17119872670.0;
5.723166666666667, -16719875645.0;
5.729833333333334, -16374615055.0;
5.7365, -15650409915.0;
5.743166666666667, -14825152895.0;
5.749833333333334, -13730424195.0;
5.756500000000001, -12728326385.0;
5.763166666666667, -11797806990.0;
5.769833333333334, -10993602445.0;
5.7765, -10648341855.0;
5.783166666666667, -10917813535.0;
5.789833333333334, -11886227385.0;
5.796500000000001, -12875693710.0;
5.803166666666667, -13431479050.0;
5.809833333333334, -13667266770.0;
5.8165000000000004, -14020948350.0;
5.823166666666667, -14412524385.0;
5.829833333333334, -14463050325.0;
5.836500000000001, -14277788545.0;
5.843166666666667, -14488313295.0;
5.849833333333334, -15208307940.0;
5.8565000000000005, -15987249515.0;
5.863166666666667, -16315668125.0;
5.869833333333334, -16319878620.0;
5.876500000000001, -16180932285.0;
5.883166666666667, -15873566150.0;
5.889833333333334, -15414622195.0;
5.8965000000000005, -14778837450.0;
5.903166666666667, -14260946565.0;
5.909833333333334, -14004106370.0;
5.9165, -14092526765.0;
5.923166666666667, -14420945375.0;
5.929833333333334, -14745153490.0;
5.9365000000000006, -15056730120.0;
5.943166666666667, -15267254870.0;
5.949833333333334, -15372517245.0;
5.9565, -15469358630.0;
5.963166666666667, -15713567340.0;
5.969833333333334, -16008301990.0;
5.976500000000001, -16227247730.0;
5.983166666666667, -16298826145.0;
5.989833333333334, -16033564960.0;
5.9965, -15439885165.0;
6.003166666666667, -14551470720.0;
6.009833333333334, -13696740235.0;
6.016500000000001, -12913588165.0;
6.0231666666666674, -12374644805.0;
6.029833333333334, -11945174315.0;
6.0365, -11629387190.0;
6.043166666666667, -11309389570.0;
6.049833333333334, -11098864820.0;
6.056500000000001, -10972549970.0;
6.0631666666666675, -10930445020.0;
6.069833333333333, -11237811155.0;
6.0765, -11831490950.0;
6.083166666666667, -12623064010.0;
6.089833333333334, -13271480240.0;
6.096500000000001, -13574635880.0;
6.1031666666666675, -13663056275.0;
6.1098333333333334, -13536741425.0;
6.1165, -13566214890.0;
6.123166666666667, -13557793900.0;
6.129833333333334, -13317795685.0;
6.136500000000001, -13111481430.0;
6.1431666666666676, -13119902420.0;
6.1498333333333335, -13431479050.0;
6.1565, -13397795090.0;
6.163166666666667, -13065165985.0;
6.169833333333334, -12879904205.0;
6.176500000000001, -13103060440.0;
6.183166666666668, -13237796280.0;
6.1898333333333335, -13225164795.0;
6.1965, -13359900635.0;
6.203166666666667, -13793581620.0;
6.209833333333334, -14117789735.0;
6.216500000000001, -13962001420.0;
6.223166666666668, -13574635880.0;
6.229833333333334, -13039903015.0;
6.2365, -12639905990.0;
6.243166666666667, -12218856490.0;
6.249833333333334, -11957805800.0;
6.256500000000001, -11945174315.0;
6.263166666666667, -12248329955.0;
6.269833333333334, -12778852325.0;
6.2765, -12968324600.0;
6.283166666666667, -12943061630.0;
6.289833333333334, -12778852325.0;
6.296500000000001, -12825167770.0;
6.303166666666667, -12820957275.0;
6.309833333333334, -12500959655.0;
6.3165000000000004, -12105173125.0;
6.323166666666667, -11860964415.0;
6.329833333333334, -11995700255.0;
6.336500000000001, -12269382430.0;
6.343166666666667, -12484117675.0;
6.349833333333334, -12799904800.0;
6.3565000000000005, -13023061035.0;
6.363166666666667, -13435689545.0;
6.369833333333334, -13684108750.0;
6.376500000000001, -13802002610.0;
6.383166666666667, -13764108155.0;
6.389833333333334, -13738845185.0;
6.3965000000000005, -13953580430.0;
6.403166666666667, -13978843400.0;
6.409833333333334, -13717792710.0;
6.416500000000001, -13124112915.0;
6.423166666666667, -12484117675.0;
6.429833333333334, -11936753325.0;
6.4365000000000006, -11633597685.0;
6.443166666666667, -11654650160.0;
6.449833333333334, -12016752730.0;
6.4565, -12425170745.0;
6.463166666666667, -12858851730.0;
6.469833333333334, -13435689545.0;
6.476500000000001, -13865160035.0;
6.483166666666667, -14105158250.0;
6.489833333333334, -13911475480.0;
6.4965, -13780950135.0;
6.503166666666667, -13949369935.0;
6.509833333333334, -14105158250.0;
6.516500000000001, -13991474885.0;
6.5231666666666674, -13406216080.0;
6.529833333333334, -13031482025.0;
6.5365, -12804115295.0;
6.543166666666667, -12740957870.0;
6.549833333333334, -12690431930.0;
6.556500000000001, -13237796280.0;
6.5631666666666675, -14172526170.0;
6.569833333333334, -15014625170.0;
6.5765, -15490411105.0;
6.583166666666667, -15709356845.0;
6.589833333333334, -15734619815.0;
6.596500000000001, -15309359820.0;
6.6031666666666675, -14736732500.0;
6.6098333333333334, -14471471315.0;
6.6165, -14753574480.0;
6.623166666666667, -15174623980.0;
6.629833333333334, -15536726550.0;
6.636500000000001, -15545147540.0;
6.6431666666666676, -15511463580.0;
6.6498333333333335, -15532516055.0;
6.6565, -15229360415.0;
6.663166666666667, -14534628740.0;
6.669833333333334, -13789371125.0;
6.676500000000001, -13789371125.0;
6.683166666666668, -14277788545.0;
6.6898333333333335, -14660943590.0;
6.6965, -14863047350.0;
6.703166666666667, -15267254870.0;
6.709833333333334, -15936723575.0;
6.716500000000001, -16656718220.0;
6.723166666666668, -16787243565.0;
6.729833333333334, -16601981785.0;
6.7365, -16370404560.0;
6.743166666666667, -16151458820.0;
6.749833333333334, -15743040805.0;
6.756500000000001, -14884099825.0;
6.763166666666668, -14328314485.0;
6.769833333333334, -14012527360.0;
6.7765, -14042000825.0;
6.783166666666667, -13999895875.0;
6.789833333333334, -13983053895.0;
6.796500000000001, -13966211915.0;
6.803166666666667, -13974632905.0;
6.809833333333334, -13999895875.0;
6.8165000000000004, -13898843995.0;
6.823166666666667, -13919896470.0;
6.829833333333334, -13940948945.0;
6.836500000000001, -14273578050.0;
6.843166666666667, -14568312700.0;
6.849833333333334, -14719890520.0;
6.8565000000000005, -14530418245.0;
6.863166666666667, -14054632310.0;
6.869833333333334, -13696740235.0;
6.876500000000001, -13524109940.0;
6.883166666666667, -13494636475.0;
6.889833333333334, -13599898850.0;
6.8965000000000005, -14122000230.0;
6.903166666666667, -15178834475.0;
6.909833333333334, -16252510700.0;
6.916500000000001, -16888295445.0;
6.923166666666667, -16930400395.0;
6.929833333333334, -16677770695.0;
6.9365000000000006, -16008301990.0;
6.943166666666667, -15056730120.0;
6.949833333333334, -14012527360.0;
6.956500000000001, -13140954895.0;
6.963166666666667, -12766220840.0;
6.969833333333334, -12644116485.0;
6.976500000000001, -12858851730.0;
6.983166666666667, -13128323410.0;
6.989833333333334, -13528320435.0;
6.9965, -13730424195.0;
7.003166666666667, -13743055680.0;
7.009833333333334, -13730424195.0;
7.016500000000001, -13962001420.0;
7.0231666666666674, -14088316270.0;
7.029833333333334, -14050421815.0;
7.0365, -14012527360.0;
7.043166666666667, -14071474290.0;
7.049833333333334, -14206210130.0;
7.056500000000001, -13974632905.0;
7.0631666666666675, -13616740830.0;
7.069833333333334, -13212533310.0;
7.0765, -12997798065.0;
7.083166666666667, -12871483215.0;
7.089833333333334, -12728326385.0;
7.096500000000001, -12437802230.0;
7.1031666666666675, -12349381835.0;
7.109833333333334, -12311487380.0;
7.1165, -12239908965.0;
7.123166666666667, -12008331740.0;
7.129833333333334, -12033594710.0;
7.136500000000001, -12770431335.0;
7.1431666666666676, -13402005585.0;
7.1498333333333335, -13604109345.0;
7.1565, -13279901230.0;
7.163166666666667, -13469373505.0;
7.169833333333334, -13709371720.0;
7.176500000000001, -13616740830.0;
7.183166666666668, -13414637070.0;
7.1898333333333335, -13776739640.0;
7.1965, -14749363985.0;
7.203166666666667, -15174623980.0;
7.209833333333334, -14959888735.0;
7.216500000000001, -14500944780.0;
7.223166666666668, -14159894685.0;
7.229833333333334, -13692529740.0;
7.2365, -12930430145.0;
7.243166666666667, -12029384215.0;
7.249833333333334, -11444125410.0;
7.256500000000001, -11448335905.0;
7.263166666666668, -11848332930.0;
7.269833333333334, -12399907775.0;
7.2765, -12682010940.0;
7.283166666666667, -13069376480.0;
7.289833333333334, -13562004395.0;
7.296500000000001, -13764108155.0;
7.303166666666668, -13486215485.0;
7.309833333333334, -12783062820.0;
7.3165000000000004, -12416749755.0;
7.323166666666667, -12496749160.0;
7.329833333333334, -12614643020.0;
7.336500000000001, -12618853515.0;
7.343166666666667, -12559906585.0;
7.349833333333334, -12804115295.0;
7.3565000000000005, -13225164795.0;
7.363166666666667, -13448321030.0;
7.369833333333334, -13402005585.0;
7.376500000000001, -13157796875.0;
7.383166666666667, -13166217865.0;
7.389833333333334, -13343058655.0;
7.3965000000000005, -13490425980.0;
7.403166666666667, -13284111725.0;
7.409833333333334, -13006219055.0;
7.416500000000001, -12964114105.0;
7.423166666666667, -13090428955.0;
7.429833333333334, -13048324005.0;
7.4365000000000006, -12871483215.0;
7.443166666666667, -12892535690.0;
7.449833333333334, -13187270340.0;
7.456500000000001, -13220954300.0;
7.463166666666667, -12770431335.0;
7.469833333333334, -12180962035.0;
7.476500000000001, -11486230360.0;
7.483166666666667, -10833603635.0;
7.489833333333334, -10130450970.0;
7.496500000000001, -9936768200.0;
7.503166666666667, -10071504040.0;
7.509833333333334, -10475711560.0;
7.516500000000001, -11002023435.0;
7.5231666666666674, -11372546995.0;
7.529833333333334, -11658860655.0;
7.5365, -11675702635.0;
7.543166666666667, -11755702040.0;
7.549833333333334, -11823069960.0;
7.556500000000001, -12117804610.0;
7.5631666666666675, -12370434310.0;
7.569833333333334, -12538854110.0;
7.5765, -12332539855.0;
7.583166666666667, -12084120650.0;
7.589833333333334, -11616755705.0;
7.596500000000001, -11056759870.0;
7.6031666666666675, -10783077695.0;
7.609833333333334, -10783077695.0;
7.6165, -11098864820.0;
7.623166666666667, -11313600065.0;
7.629833333333334, -11709386595.0;
7.636500000000001, -11856753920.0;
7.6431666666666676, -11793596495.0;
7.649833333333334, -11448335905.0;
7.6565, -11170443235.0;
7.663166666666667, -10884129575.0;
7.669833333333334, -10585184430.0;
7.676500000000001, -10353607205.0;
7.683166666666668, -10147292950.0;
7.6898333333333335, -10016767605.0;
7.6965, -9856768795.0;
7.703166666666667, -9671507015.0;
7.709833333333334, -9355719890.0;
7.716500000000001, -9322035930.0;
7.723166666666668, -9439929790.0;
7.729833333333334, -9414666820.0;
7.7365, -8968354350.0;
7.743166666666667, -8307306635.0;
7.749833333333334, -7818889215.0;
7.756500000000001, -7187314965.0;
7.763166666666668, -6757844475.0;
7.769833333333334, -6648371605.0;
7.7765, -6745212990.0;
7.783166666666667, -6690476555.0;
7.789833333333334, -6442057350.0;
7.796500000000001, -6336794975.0;
7.803166666666668, -6151533195.0;
7.809833333333334, -5789430625.0;
7.8165000000000004, -5642063300.0;
7.823166666666667, -5970481910.0;
7.829833333333334, -6105217750.0;
7.836500000000001, -5595747855.0;
7.843166666666668, -4564176580.0;
7.849833333333334, -3873655400.0;
7.8565000000000005, -3541026295.0;
7.863166666666667, -3115766300.0;
7.869833333333334, -2863136600.0;
7.876500000000001, -2854715610.0;
7.883166666666667, -3191555210.0;
7.889833333333334, -3309449070.0;
7.8965000000000005, -3237870655.0;
7.903166666666667, -3351554020.0;
7.909833333333334, -3604183720.0;
7.916500000000001, -3856813420.0;
7.923166666666667, -4159969060.0;
7.929833333333334, -4564176580.0;
7.9365000000000006, -5056804495.0;
7.943166666666667, -5402065085.0;
7.949833333333334, -5549432410.0;
7.9565, -5747325675.0;
7.963166666666668, -5772588645.0;
7.969833333333334, -5898903495.0;
7.9765000000000015, -5701010230.0;
7.983166666666667, -5246276770.0;
7.989833333333333, -4762069845.0;
7.996500000000001, -4488387670.0;
8.003166666666667, -4804174795.0;
8.009833333333335, -4728385885.0;
8.0165, -4513650640.0;
8.023166666666667, -4391546285.0;
8.029833333333334, -4404177770.0;
8.0365, -4429440740.0;
8.043166666666668, -3764182530.0;
8.049833333333334, -3309449070.0;
8.0565, -3149450260.0;
8.063166666666667, -3338922535.0;
8.069833333333333, -3587341740.0;
8.076500000000001, -3747340550.0;
8.083166666666667, -4193653020.0;
8.089833333333335, -4589439550.0;
8.0965, -4833648260.0;
8.103166666666667, -4846279745.0;
8.109833333333334, -5035752020.0;
8.1165, -5208382315.0;
8.123166666666668, -5355749640.0;
8.129833333333334, -5831535575.0;
8.1365, -6635740120.0;
8.143166666666668, -7418892190.0;
8.149833333333333, -7856783670.0;
8.156500000000001, -8176781290.0;
8.163166666666667, -8509410395.0;
8.169833333333335, -8256780695.0;
8.1765, -7696784860.0;
8.183166666666667, -7140999520.0;
8.189833333333334, -6656792595.0;
8.1965, -6395741905.0;
8.203166666666668, -6488372795.0;
8.209833333333334, -7452576150.0;
8.2165, -8298885645.0;
8.223166666666668, -8580988810.0;
8.229833333333334, -8538883860.0;
8.236500000000001, -8530462870.0;
8.243166666666667, -8357832575.0;
8.249833333333333, -7490470605.0;
8.2565, -6568372200.0;
8.263166666666667, -6235743095.0;
8.269833333333334, -6235743095.0;
8.2765, -6294690025.0;
8.283166666666668, -6261006065.0;
8.289833333333334, -6484162300.0;
8.2965, -6901001305.0;
8.303166666666668, -7086263085.0;
8.309833333333334, -7111526055.0;
8.316500000000001, -6972579720.0;
8.323166666666667, -6799949425.0;
8.329833333333333, -6551530220.0;
8.336500000000001, -6109428245.0;
8.343166666666667, -5856798545.0;
8.349833333333335, -5679957755.0;
8.3565, -5536800925.0;
8.363166666666668, -5027331030.0;
8.369833333333334, -4332599355.0;
8.3765, -3886286885.0;
8.383166666666668, -3696814610.0;
8.389833333333334, -3722077580.0;
8.396500000000001, -3536815800.0;
8.403166666666667, -3448395405.0;
8.409833333333333, -3094713825.0;
8.416500000000001, -2437876605.0;
8.423166666666667, -1322095430.0;
8.429833333333335, -58946930.0;
8.4365, 1073676225.0;
8.443166666666666, 1957880175.0;
8.449833333333334, 2450508090.0;
8.4565, 2875768085.0;
8.463166666666668, 3368396000.0;
8.469833333333334, 3932602330.0;
8.476500000000001, 4484177175.0;
8.483166666666667, 5309434195.0;
8.489833333333333, 6357847450.0;
8.496500000000001, 7376787240.0;
8.503166666666667, 8223096735.0;
8.509833333333335, 9204142070.0;
8.5165, 10303081265.0;
8.523166666666667, 10833603635.0;
8.529833333333334, 10909392545.0;
8.5365, 10812551160.0;
8.543166666666668, 10934655515.0;
8.549833333333334, 11153601255.0;
8.556500000000002, 11162022245.0;
8.563166666666667, 11237811155.0;
8.569833333333333, 11229390165.0;
8.576500000000001, 11056759870.0;
8.583166666666667, 10374659680.0;
8.589833333333335, 9039932765.0;
8.5965, 7713626840.0;
8.603166666666667, 6753633980.0;
8.609833333333334, 6117849235.0;
8.6165, 5650484290.0;
8.623166666666668, 5406275580.0;
8.629833333333334, 5566274390.0;
8.6365, 5557853400.0;
8.643166666666668, 5166277365.0;
8.649833333333333, 4479966680.0;
8.656500000000001, 3751551045.0;
8.663166666666667, 2926294025.0;
8.669833333333335, 2113668490.0;
8.6765, 1604198595.0;
8.683166666666667, 1562093645.0;
8.689833333333334, 1591567110.0;
8.6965, 1229464540.0;
8.703166666666668, 661047715.0;
8.709833333333334, 126314850.0;
8.7165, -328418610.0;
8.723166666666668, -896835435.0;
8.729833333333334, -1254727510.0;
8.736500000000001, -1002097810.0;
8.743166666666667, -421049500.0;
8.749833333333335, -256840195.0;
8.7565, -581048310.0;
8.763166666666667, -1145254640.0;
8.769833333333334, -1503146715.0;
8.7765, -1907354235.0;
8.783166666666668, -2084195025.0;
8.789833333333334, -1907354235.0;
8.7965, -1263148500.0;
8.803166666666668, -639995240.0;
8.809833333333334, -412628510.0;
8.816500000000001, -353681580.0;
8.823166666666667, -757889100.0;
8.829833333333333, -1271569490.0;
8.836500000000001, -2058932055.0;
8.843166666666667, -2471560565.0;
8.849833333333335, -2665243335.0;
8.8565, -2635769870.0;
8.863166666666668, -2349456210.0;
8.869833333333334, -1886301760.0;
8.8765, -1326305925.0;
8.883166666666668, -703152665.0;
8.889833333333334, -37894455.0;
8.896500000000001, 564206330.0;
8.903166666666667, 892624940.0;
8.909833333333333, 698942170.0;
8.916500000000001, 261050690.0;
8.923166666666667, -218945740.0;
8.929833333333335, -248419205.0;
8.9365, -138946335.0;
8.943166666666666, -117893860.0;
8.949833333333334, 67367920.0;
8.9565, 551574845.0;
8.963166666666668, 892624940.0;
8.969833333333334, 703152665.0;
8.976500000000001, 176840790.0;
8.983166666666667, -54736435.0;
8.989833333333333, 46315445.0;
8.996500000000001, 227366730.0;
9.003166666666667, 164209305.0;
9.009833333333335, 71578415.0;
9.0165, -96841385.0;
9.023166666666667, -197893265.0;
9.029833333333334, -433680985.0;
9.0365, -564206330.0;
9.043166666666668, -425259995.0;
9.049833333333334, -370523560.0;
9.056500000000002, -324208115.0;
9.063166666666667, -197893265.0;
9.069833333333333, -46315445.0;
9.076500000000001, -159998810.0;
9.083166666666667, -581048310.0;
9.089833333333335, -799994050.0;
9.0965, -463154450.0;
9.103166666666667, -122104355.0;
9.109833333333334, 155788315.0;
9.1165, 311576630.0;
9.123166666666668, 736836625.0;
9.129833333333334, 934729890.0;
9.1365, 707363160.0;
9.143166666666668, 176840790.0;
9.149833333333333, 0.0;
9.156500000000001, 159998810.0;
9.163166666666667, 290524155.0;
9.169833333333335, 648416230.0;
9.1765, 1031571275.0;
9.183166666666667, 1301042955.0;
9.189833333333334, 1052623750.0;
9.1965, 442101975.0;
9.203166666666668, 143156830.0;
9.209833333333334, 4210495.0;
9.2165, -92630890.0;
9.223166666666668, -67367920.0;
9.229833333333334, 50525940.0;
9.236500000000001, 416839005.0;
9.243166666666667, 530522370.0;
9.249833333333335, 661047715.0;
9.2565, 905256425.0;
9.263166666666667, 1271569490.0;
9.269833333333334, 1747355425.0;
9.2765, 2303140765.0;
9.283166666666668, 3166292240.0;
9.289833333333334, 3970496785.0;
9.2965, 4770490835.0;
9.303166666666668, 5545221915.0;
9.309833333333334, 6336794975.0;
9.316500000000001, 6955737740.0;
9.323166666666667, 7191525460.0;
9.329833333333333, 7258893380.0;
9.336500000000001, 7208367440.0;
9.343166666666667, 7317840310.0;
9.349833333333335, 7709416345.0;
9.3565, 8505199900.0;
9.363166666666668, 9166247615.0;
9.369833333333334, 9343088405.0;
9.3765, 9140984645.0;
9.383166666666668, 8943091380.0;
9.389833333333334, 8757829600.0;
9.396500000000001, 8256780695.0;
9.403166666666667, 7890467630.0;
9.409833333333333, 8025203470.0;
9.416500000000001, 8686251185.0;
9.423166666666667, 9246247020.0;
9.429833333333335, 9271509990.0;
9.4365, 9018880290.0;
9.443166666666668, 8606251780.0;
9.449833333333334, 8340990595.0;
9.4565, 8168360300.0;
9.463166666666668, 8172570795.0;
9.469833333333334, 8555725840.0;
9.476500000000001, 9237826030.0;
9.483166666666667, 9894663250.0;
9.489833333333333, 9983083645.0;
9.496500000000001, 9494666225.0;
9.503166666666667, 8867302470.0;
9.509833333333335, 8231517725.0;
9.5165, 7355734765.0;
9.523166666666667, 6421004875.0;
9.529833333333334, 5869430030.0;
9.5365, 5865219535.0;
9.543166666666668, 5932587455.0;
9.549833333333334, 5995744880.0;
9.556500000000002, 6303111015.0;
9.563166666666667, 6825212395.0;
9.569833333333333, 7355734765.0;
9.576500000000001, 7679942880.0;
9.583166666666667, 7915730600.0;
9.589833333333335, 7789415750.0;
9.5965, 7646258920.0;
9.603166666666667, 7886257135.0;
9.609833333333334, 8319938120.0;
9.6165, 8715724650.0;
9.623166666666668, 8677830195.0;
9.629833333333334, 8913617915.0;
9.636500000000002, 9351509395.0;
9.643166666666668, 9620981075.0;
9.649833333333333, 9591507610.0;
9.656500000000001, 9427298305.0;
9.663166666666667, 9583086620.0;
9.669833333333335, 10042030575.0;
9.6765, 10454659085.0;
9.683166666666667, 10753604230.0;
9.689833333333334, 11086233335.0;
9.6965, 11435704420.0;
9.703166666666668, 11587282240.0;
9.709833333333334, 11237811155.0;
9.7165, 10686236310.0;
9.723166666666668, 10180976910.0;
9.729833333333334, 9654665035.0;
9.736500000000001, 9094669200.0;
9.743166666666667, 8530462870.0;
9.749833333333335, 8109413370.0;
9.7565, 7789415750.0;
9.763166666666667, 7755731790.0;
9.769833333333334, 7856783670.0;
9.7765, 7932572580.0;
9.783166666666668, 7995730005.0;
9.789833333333334, 8130465845.0;
9.7965, 8096781885.0;
9.803166666666668, 7473628625.0;
9.809833333333334, 6732581505.0;
9.816500000000001, 6467320320.0;
9.823166666666667, 6606266655.0;
9.829833333333335, 6652582100.0;
9.836500000000001, 6791528435.0;
9.843166666666667, 7107315560.0;
9.849833333333335, 7380997735.0;
9.8565, 7322050805.0;
9.863166666666668, 7292577340.0;
9.869833333333334, 7431523675.0;
9.8765, 7397839715.0;
9.883166666666668, 7237840905.0;
9.889833333333334, 7494681100.0;
9.896500000000001, 8054676935.0;
9.903166666666667, 8256780695.0;
9.909833333333333, 7928362085.0;
9.916500000000001, 7570470010.0;
9.923166666666667, 7515733575.0;
9.929833333333335, 7263103875.0;
9.9365, 6686266060.0;
9.943166666666668, 6311532005.0;
9.949833333333334, 6479951805.0;
9.9565, 6858896355.0;
9.963166666666668, 7115736550.0;
9.969833333333334, 7237840905.0;
9.976500000000001, 7220998925.0;
9.983166666666667, 7077842095.0;
9.989833333333333, 6934685265.0;
9.996500000000001, 7077842095.0;
10.003166666666667, 7347313775.0;
10.009833333333335, 7347313775.0;
10.0165, 7490470605.0;
10.023166666666667, 7692574365.0;
10.029833333333334, 7995730005.0;
10.0365, 8008361490.0;
10.043166666666668, 7932572580.0;
10.049833333333334, 8054676935.0;
10.056500000000002, 8155728815.0;
10.063166666666667, 8340990595.0;
10.069833333333333, 8458884455.0;
10.076500000000001, 8644146235.0;
10.083166666666667, 8656777720.0;
10.089833333333335, 8547304850.0;
10.0965, 8635725245.0;
10.103166666666667, 8799934550.0;
10.109833333333334, 8947301875.0;
10.1165, 8783092570.0;
10.123166666666668, 8458884455.0;
10.129833333333334, 8260991190.0;
10.136500000000002, 8159939310.0;
10.143166666666668, 8404148020.0;
10.149833333333333, 8602041285.0;
10.156500000000001, 8938880885.0;
10.163166666666667, 9313614940.0;
10.169833333333335, 9764137905.0;
10.1765, 9966241665.0;
10.183166666666667, 9802032360.0;
10.189833333333334, 9806242855.0;
10.1965, 10143082455.0;
10.203166666666668, 10724130765.0;
10.209833333333334, 11254653135.0;
10.2165, 11675702635.0;
10.223166666666668, 12029384215.0;
10.229833333333334, 12105173125.0;
10.236500000000001, 11848332930.0;
10.243166666666667, 11326231550.0;
10.249833333333335, 10846235120.0;
10.2565, 10597815915.0;
10.263166666666667, 10223081860.0;
10.269833333333334, 9713611965.0;
10.2765, 9204142070.0;
10.283166666666668, 9044143260.0;
10.289833333333334, 9195721080.0;
10.2965, 9237826030.0;
10.303166666666668, 9477824245.0;
10.309833333333334, 9827295330.0;
10.316500000000001, 10412554135.0;
10.323166666666667, 10964128980.0;
10.329833333333335, 11187285215.0;
10.336500000000001, 11427283430.0;
10.343166666666667, 11620966200.0;
10.349833333333335, 11949384810.0;
10.3565, 12075699660.0;
10.363166666666668, 12033594710.0;
10.369833333333334, 11789386000.0;
10.3765, 11865174910.0;
10.383166666666668, 12109383620.0;
10.389833333333334, 12336750350.0;
10.396500000000001, 12248329955.0;
10.403166666666667, 12029384215.0;
10.409833333333333, 12265171935.0;
10.416500000000001, 12315697875.0;
10.423166666666667, 12159909560.0;
10.429833333333335, 11865174910.0;
10.4365, 12151488570.0;
10.443166666666668, 12842009750.0;
10.449833333333334, 13402005585.0;
10.4565, 13974632905.0;
10.463166666666668, 14652522600.0;
10.469833333333334, 15263044375.0;
10.476500000000001, 15515674075.0;
10.483166666666667, 15423043185.0;
10.489833333333333, 15435674670.0;
10.496500000000001, 15393569720.0;
10.503166666666667, 15313570315.0;
10.509833333333335, 15317780810.0;
10.5165, 15625146945.0;
10.523166666666668, 16168300800.0;
10.529833333333334, 16543034855.0;
10.5365, 16677770695.0;
10.543166666666668, 16964084355.0;
10.549833333333334, 17587237615.0;
10.556500000000002, 18387231665.0;
10.563166666666667, 19317751060.0;
10.569833333333333, 20357743325.0;
10.576500000000001, 21658786280.0;
10.583166666666667, 22715620525.0;
10.589833333333335, 23519825070.0;
10.5965, 24079820905.0;
10.603166666666667, 24399818525.0;
10.609833333333334, 24597711790.0;
10.6165, 24652448225.0;
10.623166666666668, 24382976545.0;
10.629833333333334, 23835612195.0;
10.636500000000002, 23132459530.0;
10.643166666666668, 22635621120.0;
10.649833333333333, 22231413600.0;
10.656500000000001, 21839837565.0;
10.663166666666667, 21759838160.0;
10.669833333333335, 22109309245.0;
10.6765, 22715620525.0;
10.683166666666667, 23296668835.0;
10.689833333333334, 23641929425.0;
10.6965, 24016663480.0;
10.703166666666668, 24458765455.0;
10.709833333333334, 24618764265.0;
10.716500000000002, 24576659315.0;
10.723166666666668, 24391397535.0;
10.729833333333334, 24302977140.0;
10.736500000000001, 24307187635.0;
10.743166666666667, 24408239515.0;
10.749833333333335, 24740868620.0;
10.7565, 24976656340.0;
10.763166666666667, 24989287825.0;
10.769833333333334, 25018761290.0;
10.7765, 25081918715.0;
10.783166666666668, 24694553175.0;
10.789833333333334, 23970348035.0;
10.7965, 23372457745.0;
10.803166666666668, 23233511410.0;
10.809833333333334, 23136670025.0;
10.816500000000001, 22917724285.0;
10.823166666666667, 23406141705.0;
10.829833333333335, 24201925260.0;
10.836500000000001, 24711395155.0;
10.843166666666667, 24593501295.0;
10.849833333333335, 24639816740.0;
10.8565, 24934551390.0;
10.863166666666668, 24997708815.0;
10.869833333333334, 24782973570.0;
10.8765, 24804026045.0;
10.883166666666668, 25460863265.0;
10.889833333333334, 26075595535.0;
10.896500000000001, 26513487015.0;
10.903166666666667, 26791379685.0;
10.909833333333335, 27275586610.0;
10.916500000000001, 27911371355.0;
10.923166666666667, 28075580660.0;
10.929833333333335, 27966107790.0;
10.9365, 27797687990.0;
10.943166666666668, 27726109575.0;
10.949833333333334, 27671373140.0;
10.9565, 27397690965.0;
10.963166666666668, 27191376710.0;
10.969833333333334, 26989272950.0;
10.976500000000001, 26766116715.0;
10.983166666666667, 26450329590.0;
10.989833333333333, 26302962265.0;
10.996500000000001, 26307172760.0;
11.003166666666667, 26496645035.0;
11.009833333333335, 26787169190.0;
11.0165, 26985062455.0;
11.023166666666668, 27102956315.0;
11.029833333333334, 26757695725.0;
11.0365, 26349277710.0;
11.043166666666668, 25700861480.0;
11.049833333333334, 24997708815.0;
11.056500000000002, 24168241300.0;
11.063166666666667, 23305089825.0;
11.069833333333333, 22719831020.0;
11.076500000000001, 22109309245.0;
11.083166666666667, 21519839945.0;
11.089833333333335, 20976686090.0;
11.0965, 20972475595.0;
11.103166666666667, 21460893015.0;
11.109833333333334, 22193519145.0;
11.1165, 22934566265.0;
11.123166666666668, 23869296155.0;
11.129833333333334, 24841920500.0;
11.136500000000002, 25755597915.0;
11.143166666666668, 26711380280.0;
11.149833333333333, 27730320070.0;
11.156500000000001, 28947153125.0;
11.163166666666667, 30105039250.0;
11.169833333333335, 31414503195.0;
11.1765, 32711335655.0;
11.183166666666667, 33780801385.0;
11.189833333333334, 34568163950.0;
11.1965, 35439736415.0;
11.203166666666668, 36673411450.0;
11.209833333333334, 38134453215.0;
11.216500000000002, 39616547455.0;
11.223166666666668, 41216535555.0;
11.229833333333334, 42938628010.0;
11.236500000000001, 44471248190.0;
11.243166666666667, 45751238670.0;
11.249833333333335, 46845967370.0;
11.2565, 47784907755.0;
11.263166666666667, 48496481410.0;
11.269833333333334, 49128055660.0;
11.2765, 49835418820.0;
11.283166666666668, 50626991880.0;
11.289833333333334, 51557511275.0;
11.2965, 52488030670.0;
11.303166666666668, 53443813035.0;
11.309833333333334, 54349069460.0;
11.316500000000001, 55262746875.0;
11.323166666666667, 56138529835.0;
11.329833333333335, 56555368840.0;
11.336500000000001, 56597473790.0;
11.343166666666667, 55582744495.0;
11.349833333333335, 53519601945.0;
11.3565, 50504887525.0;
11.363166666666668, 46753336480.0;
11.369833333333334, 42530209995.0;
11.3765, 37890244505.0;
11.383166666666668, 33894484750.0;
11.389833333333334, 30627140630.0;
11.396500000000001, 28062949175.0;
11.403166666666667, 26058753555.0;
11.409833333333335, 24749289610.0;
11.416500000000001, 24029294965.0;
11.423166666666667, 23359826260.0;
11.429833333333335, 22820882900.0;
11.4365, 22374570430.0;
11.443166666666668, 22071414790.0;
11.449833333333334, 21662996775.0;
11.4565, 21519839945.0;
11.463166666666668, 21919836970.0;
11.469833333333334, 22778777950.0;
11.476500000000001, 24126136350.0;
11.483166666666667, 25915596725.0;
11.489833333333333, 28244000460.0;
11.496500000000001, 30913454290.0;
11.503166666666667, 33662907525.0;
11.509833333333335, 36547096600.0;
11.5165, 39275497360.0;
11.523166666666668, 42197580890.0;
11.529833333333334, 45427030555.0;
11.5365, 48732269130.0;
11.543166666666668, 51991192260.0;
11.549833333333334, 55031169650.0;
11.556500000000002, 58370092185.0;
11.563166666666667, 61814277095.0;
11.569833333333333, 65148989135.0;
11.576500000000001, 68302649890.0;
11.583166666666667, 71426837180.0;
11.589833333333335, 74656286845.0;
11.5965, 77603633345.0;
11.603166666666668, 79995194505.0;
11.609833333333334, 82218335865.0;
11.6165, 84458319205.0;
11.623166666666668, 86774091455.0;
11.629833333333334, 88837234005.0;
11.636500000000002, 90811956160.0;
11.643166666666668, 92883519700.0;
11.649833333333333, 94702453540.0;
11.656500000000001, 95944549565.0;
11.663166666666667, 95477184620.0;
11.669833333333335, 92938256135.0;
11.6765, 88083555400.0;
11.683166666666667, 81346763400.0;
11.689833333333334, 73047877755.0;
11.6965, 63856367170.0;
11.703166666666668, 55056432620.0;
11.709833333333334, 47485962610.0;
11.716500000000002, 41439691790.0;
11.723166666666668, 36681832440.0;
11.729833333333334, 33178700600.0;
11.736500000000001, 30627140630.0;
11.743166666666667, 28837680255.0;
11.749833333333335, 27566110765.0;
11.7565, 26753485230.0;
11.763166666666667, 25839807815.0;
11.769833333333334, 24753500105.0;
11.7765, 23608245465.0;
11.783166666666668, 22622989635.0;
11.789833333333334, 22033520335.0;
11.796500000000002, 21561944895.0;
11.803166666666668, 21460893015.0;
11.809833333333334, 21574576380.0;
11.816500000000001, 22004046870.0;
11.823166666666667, 22652463100.0;
11.829833333333335, 23098775570.0;
11.836500000000001, 23528246060.0;
11.843166666666667, 23936664075.0;
11.849833333333335, 24340871595.0;
11.8565, 24568238325.0;
11.863166666666668, 24585080305.0;
11.869833333333334, 24564027830.0;
11.8765, 24458765455.0;
11.883166666666668, 24286135160.0;
11.889833333333334, 24054557935.0;
11.896500000000001, 23654560910.0;
11.903166666666667, 23212458935.0;
11.909833333333335, 23237721905.0;
11.916500000000001, 23654560910.0;
11.923166666666667, 24231398725.0;
11.929833333333335, 24690342680.0;
11.9365, 25081918715.0;
11.943166666666668, 25372442870.0;
11.949833333333334, 25385074355.0;
11.9565, 25376653365.0;
11.963166666666668, 25326127425.0;
11.969833333333334, 25254549010.0;
11.976500000000001, 25469284255.0;
11.983166666666667, 25961912170.0;
11.989833333333335, 26378751175.0;
11.996500000000001, 26538749985.0;
12.003166666666667, 26795590180.0;
12.009833333333335, 27279797105.0;
12.0165, 27549268785.0;
12.023166666666668, 27208218690.0;
12.029833333333334, 26618749390.0;
12.0365, 25789281875.0;
12.043166666666668, 25145076140.0;
12.049833333333334, 24618764265.0;
12.056500000000002, 24521922880.0;
12.063166666666667, 24858762480.0;
12.069833333333333, 25604020095.0;
12.076500000000001, 26475592560.0;
12.083166666666667, 26913484040.0;
12.089833333333335, 26955588990.0;
12.0965, 26677696320.0;
12.103166666666668, 26391382660.0;
12.109833333333334, 26121910980.0;
12.1165, 26008227615.0;
12.123166666666668, 25936649200.0;
12.129833333333334, 25957701675.0;
12.136500000000002, 25780860885.0;
12.143166666666668, 25591388610.0;
12.149833333333333, 24947182875.0;
12.156500000000001, 24387187040.0;
12.163166666666667, 24004031995.0;
12.169833333333335, 24033505460.0;
12.1765, 24366134565.0;
12.183166666666667, 24711395155.0;
12.189833333333334, 24917709410.0;
12.1965, 24681921690.0;
12.203166666666668, 24378766050.0;
12.209833333333334, 24151399320.0;
12.216500000000002, 24256661695.0;
12.223166666666668, 24488238920.0;
12.229833333333334, 25060866240.0;
12.236500000000001, 25709282470.0;
12.243166666666667, 26273488800.0;
12.249833333333335, 26580854935.0;
12.2565, 26454540085.0;
12.263166666666667, 26227173355.0;
12.269833333333334, 26155594940.0;
12.2765, 26479803055.0;
12.283166666666668, 26732432755.0;
12.289833333333334, 26547170975.0;
12.296500000000002, 26290330780.0;
12.303166666666668, 26239804840.0;
12.309833333333334, 26222962860.0;
12.316500000000001, 25890333755.0;
12.323166666666667, 25435600295.0;
12.329833333333335, 25284022475.0;
12.336500000000001, 25359811385.0;
12.343166666666667, 25191391585.0;
12.349833333333335, 24833499510.0;
12.3565, 24488238920.0;
12.363166666666668, 24366134565.0;
12.369833333333334, 24404029020.0;
12.3765, 24433502485.0;
12.383166666666668, 24652448225.0;
12.389833333333334, 24879814955.0;
12.396500000000001, 25081918715.0;
12.403166666666667, 25081918715.0;
12.409833333333335, 24989287825.0;
12.416500000000001, 24825078520.0;
12.423166666666667, 24635606245.0;
12.429833333333335, 24542975355.0;
12.4365, 24702974165.0;
12.443166666666668, 24959814360.0;
12.449833333333334, 25250338515.0;
12.4565, 25410337325.0;
12.463166666666668, 25359811385.0;
12.469833333333334, 25006129805.0;
12.476500000000001, 24787184065.0;
12.483166666666667, 24989287825.0;
12.489833333333335, 25465073760.0;
12.496500000000001, 25978754150.0;
12.503166666666667, 26361909195.0;
12.509833333333335, 26766116715.0;
12.5165, 27031377900.0;
12.523166666666668, 26964009980.0;
12.529833333333334, 26597696915.0;
12.5365, 26290330780.0;
12.543166666666668, 26193489395.0;
12.549833333333334, 26378751175.0;
12.556500000000002, 26412435135.0;
12.563166666666667, 26496645035.0;
12.569833333333333, 26564012955.0;
12.576500000000001, 26795590180.0;
12.583166666666667, 27178745225.0;
12.589833333333335, 27650320665.0;
12.5965, 28172422045.0;
12.603166666666668, 28850311740.0;
12.609833333333334, 29233466785.0;
12.6165, 29199782825.0;
12.623166666666668, 28858732730.0;
12.629833333333334, 28462946200.0;
12.636500000000002, 27995581255.0;
12.643166666666668, 27056640870.0;
12.649833333333333, 26513487015.0;
12.656500000000001, 26555591965.0;
12.663166666666667, 27296639085.0;
12.669833333333335, 27999791750.0;
12.6765, 28749259860.0;
12.683166666666668, 29785041630.0;
12.689833333333334, 30963980230.0;
12.6965, 32062919425.0;
12.703166666666668, 32353443580.0;
12.709833333333334, 32513442390.0;
12.716500000000002, 32593441795.0;
12.723166666666668, 32867123970.0;
12.729833333333334, 32719756645.0;
12.736500000000001, 32298707145.0;
12.743166666666667, 31852394675.0;
12.749833333333335, 31288188345.0;
12.7565, 30833454885.0;
12.763166666666667, 30231354100.0;
12.769833333333334, 29873462025.0;
12.7765, 29309255695.0;
12.783166666666668, 29178730350.0;
12.789833333333334, 29385044605.0;
12.796500000000002, 29502938465.0;
12.803166666666668, 29397676090.0;
12.809833333333334, 29073467975.0;
12.816500000000001, 29010310550.0;
12.823166666666667, 28610313525.0;
12.829833333333335, 27911371355.0;
12.836500000000001, 27136640275.0;
12.843166666666667, 26627170380.0;
12.849833333333335, 26340856720.0;
12.8565, 26437698105.0;
12.863166666666668, 26686117310.0;
12.869833333333334, 27001904435.0;
12.876500000000002, 27334533540.0;
12.883166666666668, 27439795915.0;
12.889833333333334, 27372427995.0;
12.896500000000001, 26622959885.0;
12.903166666666667, 25915596725.0;
12.909833333333335, 25208233565.0;
12.916500000000001, 24782973570.0;
12.923166666666667, 24484028425.0;
12.929833333333335, 24332450605.0;
12.9365, 24404029020.0;
12.943166666666668, 24433502485.0;
12.949833333333334, 24399818525.0;
12.9565, 24265082685.0;
12.963166666666668, 24100873380.0;
12.969833333333334, 23957716550.0;
12.976500000000001, 23776665265.0;
12.983166666666667, 23793507245.0;
12.989833333333335, 24100873380.0;
12.996500000000001, 24412450010.0;
13.003166666666667, 24761921095.0;
13.009833333333335, 24888235945.0;
13.0165, 25166128615.0;
13.023166666666668, 25140865645.0;
13.029833333333334, 24677711195.0;
13.0365, 23810349225.0;
13.043166666666668, 22715620525.0;
13.049833333333334, 21881942515.0;
13.056500000000002, 21195631830.0;
13.063166666666667, 20959844110.0;
13.069833333333335, 21081948465.0;
13.076500000000001, 21439840540.0;
13.083166666666667, 21881942515.0;
13.089833333333335, 22168256175.0;
13.0965, 22311413005.0;
13.103166666666668, 22092467265.0;
13.109833333333334, 21637733805.0;
13.1165, 21124053415.0;
13.123166666666668, 20475637185.0;
13.129833333333334, 19818799965.0;
13.136500000000002, 19187225715.0;
13.143166666666668, 18724071265.0;
13.149833333333333, 18412494635.0;
13.156500000000001, 18185127905.0;
13.163166666666667, 18387231665.0;
13.169833333333335, 18509336020.0;
13.1765, 18437757605.0;
13.183166666666668, 18176706915.0;
13.189833333333334, 18046181570.0;
13.1965, 17936708700.0;
13.203166666666668, 17831446325.0;
13.209833333333334, 18008287115.0;
13.216500000000002, 18564072455.0;
13.223166666666668, 18997753440.0;
13.229833333333334, 19338803535.0;
13.236500000000001, 19890378380.0;
13.243166666666667, 20340901345.0;
13.249833333333335, 20416690255.0;
13.2565, 19860904915.0;
13.263166666666667, 19250383140.0;
13.269833333333334, 18479862555.0;
13.2765, 17469343755.0;
13.283166666666668, 16812506535.0;
13.289833333333334, 16884084950.0;
13.296500000000002, 17688289495.0;
13.303166666666668, 18429336615.0;
13.309833333333334, 18863017600.0;
13.316500000000001, 19271435615.0;
13.323166666666667, 19347224525.0;
13.329833333333335, 18905122550.0;
13.336500000000001, 17953550680.0;
13.343166666666667, 17570395635.0;
13.349833333333335, 17705131475.0;
13.3565, 17831446325.0;
13.363166666666668, 17734604940.0;
13.369833333333334, 17532501180.0;
13.376500000000002, 17519869695.0;
13.383166666666668, 17187240590.0;
13.389833333333334, 16808296040.0;
13.396500000000001, 16223037235.0;
13.403166666666667, 15743040805.0;
13.409833333333335, 15587252490.0;
13.416500000000001, 15578831500.0;
13.423166666666667, 15692514865.0;
13.429833333333335, 15595673480.0;
13.4365, 15797777240.0;
13.443166666666668, 16172511295.0;
13.449833333333334, 16509350895.0;
13.4565, 16551455845.0;
13.463166666666668, 16530403370.0;
13.469833333333334, 16812506535.0;
13.476500000000001, 17271450490.0;
13.483166666666667, 17540922170.0;
13.489833333333335, 17439870290.0;
13.496500000000001, 17418817815.0;
13.503166666666667, 17351449895.0;
13.509833333333335, 17254608510.0;
13.5165, 17060925740.0;
13.523166666666668, 16938821385.0;
13.529833333333334, 16976715840.0;
13.5365, 17014610295.0;
13.543166666666668, 17220924550.0;
13.549833333333334, 17414607320.0;
13.556500000000002, 17511448705.0;
13.563166666666667, 17427238805.0;
13.569833333333335, 17267239995.0;
13.576500000000001, 17275660985.0;
13.583166666666667, 17406186330.0;
13.589833333333335, 17608290090.0;
13.5965, 17814604345.0;
13.603166666666668, 18387231665.0;
13.609833333333334, 19014595420.0;
13.6165, 19473539375.0;
13.623166666666668, 19494591850.0;
13.629833333333334, 19220909675.0;
13.636500000000002, 18888280570.0;
13.643166666666668, 18610387900.0;
13.649833333333333, 18446178595.0;
13.656500000000001, 18172496420.0;
13.663166666666667, 17835656820.0;
13.669833333333335, 17776709890.0;
13.6765, 17881972265.0;
13.683166666666668, 17620921575.0;
13.689833333333334, 17406186330.0;
13.6965, 17465133260.0;
13.703166666666668, 17869340780.0;
13.709833333333334, 17945129690.0;
13.716500000000002, 17839867315.0;
13.723166666666668, 17764078405.0;
13.729833333333334, 17549343160.0;
13.736500000000001, 17279871480.0;
13.743166666666667, 16989347325.0;
13.749833333333335, 16930400395.0;
13.7565, 16917768910.0;
13.763166666666669, 17170398610.0;
13.769833333333334, 17427238805.0;
13.7765, 17389344350.0;
13.783166666666668, 17052504750.0;
13.789833333333334, 16564087330.0;
13.796500000000002, 16168300800.0;
13.803166666666668, 15633567935.0;
13.809833333333334, 15330412295.0;
13.816500000000001, 15292517840.0;
13.823166666666667, 15709356845.0;
13.829833333333335, 16399878025.0;
13.836500000000001, 17065136235.0;
13.843166666666667, 17389344350.0;
13.849833333333335, 17368291875.0;
13.8565, 17326186925.0;
13.863166666666668, 17208293065.0;
13.869833333333334, 16938821385.0;
13.876500000000002, 16656718220.0;
13.883166666666668, 16761980595.0;
13.889833333333334, 16959873860.0;
13.896500000000001, 17132504155.0;
13.903166666666667, 17149346135.0;
13.909833333333335, 17233556035.0;
13.916500000000001, 17098820195.0;
13.923166666666667, 16644086735.0;
13.929833333333335, 16412509510.0;
13.9365, 16543034855.0;
13.943166666666668, 17073557225.0;
13.949833333333334, 17553553655.0;
13.956500000000002, 18037760580.0;
13.963166666666668, 18589335425.0;
13.969833333333334, 18896701560.0;
13.976500000000001, 18783018195.0;
13.983166666666667, 18357758200.0;
13.989833333333335, 17806183355.0;
13.996500000000001, 17250398015.0;
14.003166666666667, 16829348515.0;
14.009833333333335, 16766191090.0;
14.0165, 16791454060.0;
14.023166666666668, 16589350300.0;
14.029833333333334, 16201984760.0;
14.0365, 16290405155.0;
14.043166666666668, 16353562580.0;
14.049833333333334, 16126195850.0;
14.056500000000002, 15776724765.0;
14.063166666666667, 15907250110.0;
14.069833333333335, 16303036640.0;
14.076500000000001, 16176721790.0;
14.083166666666667, 15890408130.0;
14.089833333333335, 15776724765.0;
14.0965, 15873566150.0;
14.103166666666668, 15780935260.0;
14.109833333333334, 15444095660.0;
14.1165, 15250412890.0;
14.123166666666668, 15246202395.0;
14.129833333333334, 15507253085.0;
14.136500000000002, 15823040210.0;
14.143166666666668, 16239879215.0;
14.149833333333333, 16795664555.0;
14.156500000000001, 17393554845.0;
14.163166666666667, 17873551275.0;
14.169833333333335, 17743025930.0;
14.1765, 17317765935.0;
14.183166666666668, 16825138020.0;
14.189833333333334, 16597771290.0;
14.1965, 16530403370.0;
14.203166666666668, 16370404560.0;
14.209833333333334, 16475666935.0;
14.216500000000002, 16749349110.0;
14.223166666666668, 16926189900.0;
14.229833333333334, 17010399800.0;
14.236500000000001, 16681981190.0;
14.243166666666667, 16458824955.0;
14.249833333333335, 16067248920.0;
14.2565, 15730409320.0;
14.263166666666669, 15755672290.0;
14.269833333333334, 15856724170.0;
14.2765, 16319878620.0;
14.283166666666668, 16345141590.0;
14.289833333333334, 16180932285.0;
14.296500000000002, 16046196445.0;
14.303166666666668, 15814619220.0;
14.309833333333334, 15696725360.0;
14.316500000000001, 15494621600.0;
14.323166666666667, 15966197040.0;
14.329833333333335, 16656718220.0;
14.336500000000001, 17237766530.0;
14.343166666666667, 17570395635.0;
14.349833333333335, 17633553060.0;
14.3565, 17696710485.0;
14.363166666666668, 17452501775.0;
14.369833333333334, 17380923360.0;
14.376500000000002, 17191451085.0;
14.383166666666668, 17056715245.0;
14.389833333333334, 16825138020.0;
14.396500000000001, 16484087925.0;
14.403166666666667, 16256721195.0;
14.409833333333335, 15987249515.0;
14.416500000000001, 15915671100.0;
14.423166666666667, 15650409915.0;
14.429833333333335, 15334622790.0;
14.4365, 15208307940.0;
14.443166666666668, 15275675860.0;
14.449833333333334, 15490411105.0;
14.456500000000002, 15549358035.0;
14.463166666666668, 15734619815.0;
14.469833333333334, 16201984760.0;
14.476500000000001, 16623034260.0;
14.483166666666667, 16820927525.0;
14.489833333333335, 16589350300.0;
14.496500000000001, 16475666935.0;
14.503166666666667, 16383036045.0;
14.509833333333335, 16336720600.0;
14.5165, 16130406345.0;
14.523166666666668, 15903039615.0;
14.529833333333334, 16079880405.0;
14.5365, 16303036640.0;
14.543166666666668, 16509350895.0;
14.549833333333334, 16324089115.0;
14.556500000000002, 16517771885.0;
14.563166666666667, 16863032475.0;
14.569833333333335, 17241977025.0;
14.576500000000001, 17216714055.0;
14.583166666666667, 17073557225.0;
14.589833333333335, 16938821385.0;
14.5965, 16690402180.0;
14.603166666666668, 16593560795.0;
14.609833333333334, 16109353870.0;
14.6165, 15755672290.0;
14.623166666666668, 15726198825.0;
14.629833333333334, 16399878025.0;
14.636500000000002, 17056715245.0;
14.643166666666668, 17326186925.0;
14.649833333333335, 17696710485.0;
14.656500000000001, 18130391470.0;
14.663166666666667, 17974603155.0;
14.669833333333335, 17292502965.0;
14.6765, 16538824360.0;
14.683166666666668, 16252510700.0;
14.689833333333334, 16058827930.0;
14.6965, 15919881595.0;
14.703166666666668, 16281984165.0;
14.709833333333334, 16593560795.0;
14.716500000000002, 16778822575.0;
14.723166666666668, 16425140995.0;
14.729833333333334, 16248300205.0;
14.736500000000001, 16437772480.0;
14.743166666666667, 16463035450.0;
14.749833333333335, 16623034260.0;
14.7565, 16787243565.0;
14.763166666666669, 17166188115.0;
14.769833333333334, 17208293065.0;
14.7765, 16825138020.0;
14.783166666666668, 16530403370.0;
14.789833333333334, 16084090900.0;
14.796500000000002, 15797777240.0;
14.803166666666668, 15734619815.0;
14.809833333333334, 16311457630.0;
14.816500000000001, 16837769505.0;
14.823166666666667, 17195661580.0;
14.829833333333335, 17368291875.0;
14.836500000000001, 17764078405.0;
14.843166666666669, 18223022360.0;
14.849833333333335, 18458810080.0;
14.8565, 18774597205.0;
14.863166666666668, 18905122550.0;
14.869833333333334, 19153541755.0;
14.876500000000002, 18989332450.0;
14.883166666666668, 18345126715.0;
14.889833333333334, 17532501180.0;
14.896500000000001, 16985136830.0;
14.903166666666667, 16959873860.0;
14.909833333333335, 17132504155.0;
14.916500000000001, 17220924550.0;
14.923166666666667, 17385133855.0;
14.929833333333335, 17225135045.0;
14.9365, 17006189305.0;
14.943166666666668, 16934610890.0;
14.949833333333334, 17039873265.0;
14.956500000000002, 17103030690.0;
14.963166666666668, 16921979405.0;
14.969833333333334, 16993557820.0;
14.976500000000001, 17098820195.0;
14.983166666666667, 17006189305.0;
14.989833333333335, 16681981190.0;
14.996500000000001, 16488298420.0;
15.003166666666667, 16677770695.0;
15.009833333333335, 16875663960.0;
15.0165, 16799875050.0;
15.023166666666668, 16383036045.0;
15.029833333333334, 16033564960.0;
15.036500000000002, 16016722980.0;
15.043166666666668, 16100932880.0;
15.049833333333334, 16105143375.0;
15.056500000000002, 16079880405.0;
15.063166666666667, 16105143375.0;
15.069833333333335, 16155669315.0;
15.076500000000001, 16353562580.0;
15.083166666666667, 16812506535.0;
15.089833333333335, 17313555440.0;
15.0965, 17368291875.0;
15.103166666666668, 17241977025.0;
15.109833333333334, 17023031285.0;
15.1165, 16711454655.0;
15.123166666666668, 16269352680.0;
15.129833333333334, 15966197040.0;
15.136500000000002, 16197774265.0;
15.143166666666668, 16463035450.0;
15.149833333333335, 16509350895.0;
15.156500000000001, 16210405750.0;
15.163166666666667, 15730409320.0;
15.169833333333335, 15511463580.0;
15.1765, 15347254275.0;
15.183166666666668, 15679883380.0;
15.189833333333334, 16092511890.0;
15.1965, 16627244755.0;
15.203166666666668, 16993557820.0;
15.209833333333334, 16850400990.0;
15.216500000000002, 16526192875.0;
15.223166666666668, 15755672290.0;
15.229833333333334, 15073572100.0;
15.236500000000001, 14547260225.0;
15.243166666666667, 14404103395.0;
15.249833333333335, 14639891115.0;
15.2565, 14955678240.0;
15.263166666666669, 15355675265.0;
15.269833333333334, 15831461200.0;
15.2765, 16185142780.0;
15.283166666666668, 16315668125.0;
15.289833333333334, 16260931690.0;
15.296500000000002, 16361983570.0;
15.303166666666668, 16648297230.0;
15.309833333333334, 16909347920.0;
15.316500000000001, 16938821385.0;
15.323166666666667, 16968294850.0;
15.329833333333335, 16900926930.0;
15.336500000000001, 16639876240.0;
15.343166666666669, 16357773075.0;
15.349833333333335, 16269352680.0;
15.3565, 16437772480.0;
15.363166666666668, 16538824360.0;
15.369833333333334, 16804085545.0;
15.376500000000002, 17161977620.0;
15.383166666666668, 17216714055.0;
15.389833333333334, 17052504750.0;
15.396500000000001, 16888295445.0;
15.403166666666667, 16930400395.0;
15.409833333333335, 16547245350.0;
15.416500000000001, 15983039020.0;
15.423166666666667, 15877776645.0;
15.429833333333335, 15961986545.0;
15.4365, 16180932285.0;
15.443166666666668, 16256721195.0;
15.449833333333334, 16728296635.0;
15.456500000000002, 17423028310.0;
15.463166666666668, 17738815435.0;
15.469833333333334, 17604079595.0;
15.476500000000001, 17044083760.0;
15.483166666666667, 16475666935.0;
15.489833333333335, 15995670505.0;
15.496500000000001, 15528305560.0;
15.503166666666667, 15220939425.0;
15.509833333333335, 15275675860.0;
15.5165, 15528305560.0;
15.523166666666668, 16063038425.0;
15.529833333333334, 16492508915.0;
15.536500000000002, 16913558415.0;
15.543166666666668, 17098820195.0;
15.549833333333334, 17098820195.0;
15.556500000000002, 17124083165.0;
15.563166666666667, 17031452275.0;
15.569833333333335, 16917768910.0;
15.576500000000001, 16610402775.0;
15.583166666666667, 16235668720.0;
15.589833333333335, 16050406940.0;
15.5965, 15978828525.0;
15.603166666666668, 15869355655.0;
15.609833333333334, 15654620410.0;
15.6165, 15498832095.0;
15.623166666666668, 15595673480.0;
15.629833333333334, 15658830905.0;
15.636500000000002, 15974618030.0;
15.643166666666668, 16134616840.0;
15.649833333333335, 16248300205.0;
15.656500000000001, 16260931690.0;
15.663166666666667, 16505140400.0;
15.669833333333335, 16837769505.0;
15.6765, 16770401585.0;
15.683166666666668, 16846190495.0;
15.689833333333334, 17006189305.0;
15.6965, 17161977620.0;
15.703166666666668, 17048294255.0;
15.709833333333334, 16846190495.0;
15.716500000000002, 16745138615.0;
15.723166666666668, 16328299610.0;
15.729833333333335, 15890408130.0;
15.736500000000001, 15599883975.0;
15.743166666666667, 15364096255.0;
15.749833333333335, 14959888735.0;
15.7565, 14475681810.0;
15.763166666666669, 14395682405.0;
15.769833333333334, 14509365770.0;
15.7765, 14593575670.0;
15.783166666666668, 14783047945.0;
15.789833333333334, 15309359820.0;
15.796500000000002, 16041985950.0;
15.803166666666668, 16366194065.0;
15.809833333333334, 16260931690.0;
15.816500000000001, 16058827930.0;
15.823166666666667, 15776724765.0;
15.829833333333335, 15431464175.0;
15.836500000000001, 14968309725.0;
15.843166666666669, 14719890520.0;
15.849833333333335, 14711469530.0;
15.8565, 14812521410.0;
15.863166666666668, 14884099825.0;
15.869833333333334, 14564102205.0;
15.876500000000002, 13995685380.0;
15.883166666666668, 13380953110.0;
15.889833333333334, 12888325195.0;
15.896500000000001, 12816746780.0;
15.903166666666667, 12888325195.0;
15.909833333333335, 13077797470.0;
15.916500000000001, 13166217865.0;
15.923166666666669, 13140954895.0;
15.929833333333335, 13124112915.0;
15.9365, 12964114105.0;
15.943166666666668, 12913588165.0;
15.949833333333334, 12896746185.0;
15.9565, 12555696090.0;
15.963166666666668, 11978858275.0;
15.969833333333336, 11380967985.0;
15.9765, 10703078290.0;
15.983166666666667, 10029399090.0;
15.989833333333335, 9385193355.0;
15.996500000000003, 9254668010.0;
16.003166666666665, 9166247615.0;
16.009833333333333, 8707303660.0;
16.0165, 7936783075.0;
16.023166666666665, 6947316750.0;
16.029833333333332, 6067323295.0;
16.0365, 5136803900.0;
16.043166666666664, 4509440145.0;
16.049833333333332, 4071548665.0;
16.0565, 3941023320.0;
16.063166666666667, 3541026295.0;
16.06983333333333, 2745242740.0;
16.0765, 1751565920.0;
16.083166666666667, 749468110.0;
16.08983333333333, -210524750.0;
16.0965, -1385252855.0;
16.103166666666667, -2463139575.0;
16.109833333333334, -3376816990.0;
16.1165, -4117864110.0;
16.123166666666666, -5305223700.0;
16.129833333333334, -6791528435.0;
16.136499999999998, -8446252970.0;
16.143166666666666, -9818874340.0;
16.149833333333333, -10846235120.0;
16.156499999999998, -11962016295.0;
16.163166666666665, -12820957275.0;
16.169833333333333, -13919896470.0;
16.1765, -14968309725.0;
16.183166666666665, -16420930500.0;
16.189833333333333, -18197759390.0;
16.1965, -19827220955.0;
16.203166666666664, -20930370645.0;
16.209833333333332, -21115632425.0;
16.2165, -20989317575.0;
16.223166666666668, -20968265100.0;
16.229833333333332, -21124053415.0;
16.2365, -21267210245.0;
16.243166666666667, -21515629450.0;
16.24983333333333, -22159835185.0;
16.2565, -23157722500.0;
16.263166666666667, -23785086255.0;
16.269833333333334, -24113504865.0;
16.2765, -24500870405.0;
16.283166666666666, -25225075545.0;
16.289833333333334, -25924017715.0;
16.296499999999998, -26526118500.0;
16.303166666666666, -27351375520.0;
16.309833333333334, -28134527590.0;
16.316499999999998, -28968205600.0;
16.323166666666665, -29671358265.0;
16.329833333333333, -30366089940.0;
16.3365, -30576614690.0;
16.343166666666665, -30665035085.0;
16.349833333333333, -30892401815.0;
16.3565, -31145031515.0;
16.363166666666665, -31262925375.0;
16.369833333333332, -31507134085.0;
16.3765, -32378706550.0;
16.383166666666668, -33326067925.0;
16.389833333333332, -34298692270.0;
16.3965, -34921845530.0;
16.403166666666667, -35662892650.0;
16.40983333333333, -36210257000.0;
16.4165, -36454465710.0;
16.423166666666667, -36302887890.0;
16.42983333333333, -35633419185.0;
16.4365, -34892372065.0;
16.443166666666666, -34079746530.0;
16.449833333333334, -33389225350.0;
16.4565, -32926070900.0;
16.463166666666666, -32488179420.0;
16.469833333333334, -32231339225.0;
16.476499999999998, -31945025565.0;
16.483166666666666, -31730290320.0;
16.489833333333333, -31591343985.0;
16.4965, -31275556860.0;
16.503166666666665, -31031348150.0;
16.509833333333333, -30631351125.0;
16.5165, -30281880040.0;
16.523166666666665, -29700831730.0;
16.529833333333332, -28955574115.0;
16.5365, -28088212145.0;
16.543166666666664, -27241902650.0;
16.549833333333332, -26576644440.0;
16.5565, -25907175735.0;
16.563166666666667, -25456652770.0;
16.56983333333333, -24917709410.0;
16.5765, -24622974760.0;
16.583166666666667, -24753500105.0;
16.58983333333333, -25048234755.0;
16.5965, -25174549605.0;
16.603166666666667, -24879814955.0;
16.609833333333334, -24517712385.0;
16.6165, -24079820905.0;
16.623166666666666, -23284037350.0;
16.629833333333334, -22340886470.0;
16.636499999999998, -21582997370.0;
16.643166666666666, -21027212030.0;
16.649833333333333, -20681951440.0;
16.6565, -20336690850.0;
16.663166666666665, -19890378380.0;
16.669833333333333, -19246172645.0;
16.6765, -18631440375.0;
16.683166666666665, -18383021170.0;
16.689833333333333, -18311442755.0;
16.6965, -18100918005.0;
16.703166666666664, -17650395040.0;
16.709833333333332, -17136714650.0;
16.7165, -16543034855.0;
16.723166666666668, -15936723575.0;
16.729833333333332, -15145150515.0;
16.7365, -14492523790.0;
16.743166666666667, -13877791520.0;
16.74983333333333, -13477794495.0;
16.7565, -13145165390.0;
16.763166666666667, -12484117675.0;
16.769833333333334, -11700965605.0;
16.7765, -10606236905.0;
16.783166666666666, -10020978100.0;
16.789833333333334, -9684138500.0;
16.796499999999998, -9418877315.0;
16.803166666666666, -9233615535.0;
16.809833333333334, -9056774745.0;
16.816499999999998, -9212563060.0;
16.823166666666665, -9056774745.0;
16.829833333333333, -8749408610.0;
16.8365, -8484147425.0;
16.843166666666665, -8016782480.0;
16.849833333333333, -7279945855.0;
16.8565, -6067323295.0;
16.863166666666665, -5204171820.0;
16.869833333333332, -4690491430.0;
16.8765, -4273652425.0;
16.883166666666668, -4071548665.0;
16.889833333333332, -4349441335.0;
16.8965, -5111540930.0;
16.903166666666667, -5439959540.0;
16.90983333333333, -4905226675.0;
16.9165, -4075759160.0;
16.923166666666667, -3216818180.0;
16.92983333333333, -2324193240.0;
16.9365, -1423147310.0;
16.943166666666666, -808415040.0;
16.949833333333334, -972624345.0;
16.9565, -1317884935.0;
16.963166666666666, -1629461565.0;
16.969833333333334, -1591567110.0;
16.976499999999998, -1519988695.0;
16.983166666666666, -1536830675.0;
16.989833333333333, -1431568300.0;
16.9965, -1258938005.0;
17.003166666666665, -1065255235.0;
17.009833333333333, -943150880.0;
17.0165, -479996430.0;
17.023166666666665, 239998215.0;
17.029833333333332, 943150880.0;
17.0365, 1486304735.0;
17.043166666666664, 2159983935.0;
17.049833333333332, 2858926105.0;
17.0565, 3410500950.0;
17.063166666666667, 3751551045.0;
17.06983333333333, 4050496190.0;
17.0765, 4391546285.0;
17.083166666666667, 4593650045.0;
17.08983333333333, 4821016775.0;
17.0965, 4816806280.0;
17.103166666666667, 4951542120.0;
17.109833333333334, 5082067465.0;
17.1165, 5258908255.0;
17.123166666666666, 5414696570.0;
17.129833333333334, 5410486075.0;
17.136499999999998, 5646273795.0;
17.143166666666666, 5865219535.0;
17.149833333333333, 6269427055.0;
17.1565, 6454688835.0;
17.163166666666665, 6543109230.0;
17.169833333333333, 6858896355.0;
17.1765, 7267314370.0;
17.183166666666665, 7962046045.0;
17.189833333333333, 8602041285.0;
17.1965, 9402035335.0;
17.203166666666664, 10223081860.0;
17.209833333333332, 10896761060.0;
17.2165, 11380967985.0;
17.223166666666668, 11688334120.0;
17.229833333333332, 11886227385.0;
17.2365, 12079910155.0;
17.243166666666667, 12214645995.0;
17.24983333333333, 12269382430.0;
17.2565, 12467275695.0;
17.263166666666667, 12644116485.0;
17.269833333333334, 12795694305.0;
17.2765, 13090428955.0;
17.283166666666666, 13633582810.0;
17.289833333333334, 14387261415.0;
17.296499999999998, 14888310320.0;
17.303166666666666, 15086203585.0;
17.309833333333334, 15410411700.0;
17.316499999999998, 15641988925.0;
17.323166666666665, 15595673480.0;
17.329833333333333, 15389359225.0;
17.3365, 15090414080.0;
17.343166666666665, 14964099230.0;
17.349833333333333, 14841994875.0;
17.3565, 14926204775.0;
17.363166666666665, 15372517245.0;
17.369833333333332, 15793566745.0;
17.3765, 16475666935.0;
17.383166666666668, 17246187520.0;
17.389833333333332, 17873551275.0;
17.3965, 18353547705.0;
17.403166666666667, 18441968100.0;
17.40983333333333, 18366179190.0;
17.4165, 18189338400.0;
17.423166666666667, 18054602560.0;
17.42983333333333, 18227232855.0;
17.4365, 18311442755.0;
17.443166666666666, 18623019385.0;
17.449833333333334, 19263014625.0;
17.4565, 19907220360.0;
17.463166666666666, 20446163720.0;
17.469833333333334, 20837739755.0;
17.476499999999998, 21275631235.0;
17.483166666666666, 21844048060.0;
17.489833333333333, 22172466670.0;
17.4965, 22677726070.0;
17.503166666666665, 23044039135.0;
17.509833333333333, 23393510220.0;
17.5165, 23574561505.0;
17.523166666666665, 23599824475.0;
17.529833333333332, 23658771405.0;
17.5365, 23469299130.0;
17.543166666666668, 23338773785.0;
17.549833333333332, 23435615170.0;
17.5565, 23675613385.0;
17.563166666666667, 23713507840.0;
17.56983333333333, 23633508435.0;
17.5765, 23679823880.0;
17.583166666666667, 23991400510.0;
17.58983333333333, 24252451200.0;
17.5965, 24559817335.0;
17.603166666666667, 24947182875.0;
17.609833333333334, 25368232375.0;
17.6165, 25928228210.0;
17.623166666666666, 26564012955.0;
17.629833333333334, 26745064240.0;
17.636499999999998, 26795590180.0;
17.643166666666666, 27145061265.0;
17.649833333333333, 27822950960.0;
17.6565, 28319789370.0;
17.663166666666665, 28551366595.0;
17.669833333333333, 28976626590.0;
17.6765, 29250308765.0;
17.683166666666665, 29199782825.0;
17.689833333333333, 29406097080.0;
17.6965, 29945040440.0;
17.703166666666664, 30441878850.0;
17.709833333333332, 30681877065.0;
17.7165, 30879770330.0;
17.723166666666668, 31241872900.0;
17.729833333333332, 31296609335.0;
17.7365, 31456608145.0;
17.743166666666667, 32105024375.0;
17.74983333333333, 33267120995.0;
17.7565, 34395533655.0;
17.763166666666667, 34846056620.0;
17.769833333333334, 35212369685.0;
17.7765, 35178685725.0;
17.783166666666666, 35098686320.0;
17.789833333333334, 35006055430.0;
17.796499999999998, 35136580775.0;
17.803166666666666, 35709208095.0;
17.809833333333334, 35957627300.0;
17.816499999999998, 36429202740.0;
17.823166666666665, 36799726300.0;
17.829833333333333, 37006040555.0;
17.8365, 37456563520.0;
17.843166666666665, 37911296980.0;
17.849833333333333, 38846026870.0;
17.8565, 39561811020.0;
17.863166666666665, 40353384080.0;
17.869833333333332, 41250219515.0;
17.8765, 41776531390.0;
17.883166666666668, 42349158710.0;
17.889833333333332, 42845997120.0;
17.8965, 43464939885.0;
17.903166666666667, 43873357900.0;
17.90983333333333, 44037567205.0;
17.9165, 44382827795.0;
17.923166666666667, 44938613135.0;
17.92983333333333, 45359662635.0;
17.9365, 45565976890.0;
17.943166666666666, 45827027580.0;
17.949833333333334, 46664916085.0;
17.9565, 47671224390.0;
17.963166666666666, 48412271510.0;
17.969833333333334, 48947004375.0;
17.976499999999998, 49507000210.0;
17.983166666666666, 50012259610.0;
17.989833333333333, 50155416440.0;
17.9965, 50454361585.0;
18.003166666666665, 51081725340.0;
18.009833333333333, 51869087905.0;
18.0165, 52715397400.0;
18.023166666666665, 53544864915.0;
18.029833333333332, 54479594805.0;
18.0365, 55220641925.0;
18.043166666666668, 55995373005.0;
18.049833333333332, 56803788045.0;
18.0565, 57565887640.0;
18.063166666666667, 58125883475.0;
18.06983333333333, 58315355750.0;
18.0765, 58340618720.0;
18.083166666666667, 58100620505.0;
18.08983333333333, 58003779120.0;
18.0965, 57991147635.0;
18.103166666666667, 58399565650.0;
18.109833333333334, 59224822670.0;
18.1165, 60109026620.0;
18.123166666666666, 60930073145.0;
18.129833333333334, 61645857295.0;
18.136499999999998, 62563745205.0;
18.143166666666666, 63203740445.0;
18.149833333333333, 63645842420.0;
18.1565, 63881630140.0;
18.163166666666665, 64180575285.0;
18.169833333333333, 64386889540.0;
18.1765, 64290048155.0;
18.183166666666665, 64155312315.0;
18.189833333333333, 63927945585.0;
18.1965, 63738473310.0;
18.203166666666664, 63414265195.0;
18.209833333333332, 62997426190.0;
18.2165, 62618481640.0;
18.223166666666668, 62205853130.0;
18.229833333333332, 61869013530.0;
18.2365, 61616383830.0;
18.243166666666667, 61696383235.0;
18.24983333333333, 61927960460.0;
18.2565, 61839540065.0;
18.263166666666667, 61334280665.0;
18.269833333333334, 60500602655.0;
18.2765, 59683766625.0;
18.283166666666666, 58601669410.0;
18.289833333333334, 57490098730.0;
18.296499999999998, 56559579335.0;
18.303166666666666, 56134319340.0;
18.309833333333334, 55902742115.0;
18.316499999999998, 55384851230.0;
18.323166666666665, 54635383120.0;
18.329833333333333, 53932230455.0;
18.3365, 53359603135.0;
18.343166666666665, 52488030670.0;
18.349833333333333, 51271197615.0;
18.3565, 50184889905.0;
18.363166666666665, 49275422985.0;
18.369833333333332, 48134378840.0;
18.3765, 46652284600.0;
18.383166666666668, 45351241645.0;
18.389833333333332, 44408090765.0;
18.3965, 43414413945.0;
18.403166666666667, 42071266040.0;
18.40983333333333, 40547066850.0;
18.4165, 39397601715.0;
18.423166666666667, 38639712615.0;
18.429833333333335, 37894455000.0;
18.4365, 36980777585.0;
18.443166666666666, 36189204525.0;
18.449833333333334, 35978679775.0;
18.4565, 35873417400.0;
18.463166666666666, 35208159190.0;
18.469833333333334, 34319744745.0;
18.476499999999998, 33587118615.0;
18.483166666666666, 33069227730.0;
18.489833333333333, 32151339820.0;
18.4965, 31065032110.0;
18.503166666666665, 30206091130.0;
18.509833333333333, 29456623020.0;
18.5165, 28542945605.0;
18.523166666666665, 27469269380.0;
18.529833333333332, 26433487610.0;
18.5365, 25208233565.0;
18.543166666666668, 24046136945.0;
18.549833333333332, 23178774975.0;
18.5565, 22829303890.0;
18.563166666666667, 22757725475.0;
18.56983333333333, 22639831615.0;
18.5765, 22425096370.0;
18.583166666666667, 22138782710.0;
18.58983333333333, 21827206080.0;
18.5965, 21431419550.0;
18.603166666666667, 20850371240.0;
18.609833333333334, 20265112435.0;
18.6165, 20180902535.0;
18.623166666666666, 20185113030.0;
18.629833333333334, 20004061745.0;
18.636499999999998, 19456697395.0;
18.643166666666666, 19065121360.0;
18.649833333333333, 18749334235.0;
18.6565, 18231443350.0;
18.663166666666665, 17557764150.0;
18.669833333333333, 17086188710.0;
18.6765, 16913558415.0;
18.683166666666665, 16644086735.0;
18.689833333333333, 16357773075.0;
18.6965, 16138827335.0;
18.703166666666664, 16029354465.0;
18.709833333333332, 15616725955.0;
18.7165, 15178834475.0;
18.723166666666668, 15010414675.0;
18.729833333333332, 15035677645.0;
18.7365, 14993572695.0;
18.743166666666667, 14745153490.0;
18.74983333333333, 14530418245.0;
18.7565, 14256736070.0;
18.763166666666667, 13924106965.0;
18.769833333333334, 13469373505.0;
18.7765, 12740957870.0;
18.783166666666666, 11970437285.0;
18.789833333333334, 11490440855.0;
18.796499999999998, 11014654920.0;
18.803166666666666, 10202029385.0;
18.809833333333334, 9157826625.0;
18.8165, 8530462870.0;
18.823166666666665, 8479936930.0;
18.829833333333333, 8484147425.0;
18.8365, 8420990000.0;
18.843166666666665, 8416779505.0;
18.849833333333333, 8652567225.0;
18.8565, 8732566630.0;
18.863166666666665, 8602041285.0;
18.869833333333332, 8374674555.0;
18.8765, 8138886835.0;
18.883166666666668, 7953625055.0;
18.889833333333332, 7700995355.0;
18.8965, 7734679315.0;
18.903166666666667, 7679942880.0;
18.90983333333333, 7435734170.0;
18.9165, 7279945855.0;
18.923166666666667, 7284156350.0;
18.929833333333335, 7587311990.0;
18.9365, 7566259515.0;
18.943166666666666, 7258893380.0;
18.949833333333334, 7170472985.0;
18.9565, 7456786645.0;
18.963166666666666, 7743100305.0;
18.969833333333334, 7309419320.0;
18.976499999999998, 6795738930.0;
18.983166666666666, 6698897545.0;
18.989833333333333, 6808370415.0;
18.9965, 6534688240.0;
19.003166666666665, 6214690620.0;
19.009833333333333, 6467320320.0;
19.0165, 6745212990.0;
19.023166666666665, 6606266655.0;
19.029833333333332, 6079954780.0;
19.0365, 5839956565.0;
19.043166666666668, 5650484290.0;
19.049833333333332, 5368381125.0;
19.0565, 5128382910.0;
19.063166666666667, 5035752020.0;
19.06983333333333, 4993647070.0;
19.0765, 4791543310.0;
19.083166666666667, 4732596380.0;
19.08983333333333, 4736806875.0;
19.0965, 4787332815.0;
19.103166666666667, 5128382910.0;
19.109833333333334, 5734694190.0;
19.1165, 6122059730.0;
19.123166666666666, 5924166465.0;
19.129833333333334, 5166277365.0;
19.136499999999998, 4383125295.0;
19.143166666666666, 3368396000.0;
19.149833333333333, 2244193835.0;
19.1565, 1511567705.0;
19.163166666666665, 1414726320.0;
19.169833333333333, 2113668490.0;
19.1765, 2774716205.0;
19.183166666666665, 3233660160.0;
19.189833333333333, 3482079365.0;
19.1965, 3545236790.0;
19.203166666666664, 3675762135.0;
19.209833333333332, 3671551640.0;
19.2165, 3962075795.0;
19.223166666666668, 4387335790.0;
19.229833333333332, 4732596380.0;
19.2365, 4715754400.0;
19.243166666666667, 4551545095.0;
19.24983333333333, 4244178960.0;
19.2565, 3793655995.0;
19.263166666666667, 3461026890.0;
19.269833333333334, 3208397190.0;
19.2765, 3166292240.0;
19.283166666666666, 2732611255.0;
19.289833333333334, 2185246905.0;
19.296499999999998, 1583146120.0;
19.303166666666666, 1317884935.0;
19.309833333333334, 1469462755.0;
19.3165, 1793670870.0;
19.323166666666665, 2117878985.0;
19.329833333333333, 2475771060.0;
19.3365, 3199976200.0;
19.343166666666665, 3696814610.0;
19.349833333333333, 3865234410.0;
19.3565, 3654709660.0;
19.363166666666665, 3465237385.0;
19.369833333333332, 3482079365.0;
19.3765, 3027345905.0;
19.383166666666668, 2564191455.0;
19.389833333333332, 1945248690.0;
19.3965, 1675777010.0;
19.403166666666667, 1642093050.0;
19.40983333333333, 1423147310.0;
19.4165, 1498936220.0;
19.423166666666667, 1785249880.0;
19.429833333333335, 2471560565.0;
19.4365, 2947346500.0;
19.443166666666666, 3301028080.0;
19.449833333333334, 3814708470.0;
19.4565, 4319967870.0;
19.463166666666666, 4467335195.0;
19.469833333333334, 4079969655.0;
19.476499999999998, 3456816395.0;
19.483166666666666, 2686295810.0;
19.489833333333333, 1738934435.0;
19.4965, 867361970.0;
19.503166666666665, 126314850.0;
19.509833333333333, -159998810.0;
19.5165, 4210495.0;
19.523166666666665, 538943360.0;
19.529833333333332, 1090518205.0;
19.5365, 1288411470.0;
19.543166666666668, 1275779985.0;
19.549833333333332, 985255830.0;
19.5565, 505259400.0;
19.563166666666667, 37894455.0;
19.56983333333333, -67367920.0;
19.5765, 96841385.0;
19.583166666666667, 252629700.0;
19.58983333333333, 526311875.0;
19.5965, 1086307710.0;
19.603166666666667, 1646303545.0;
19.609833333333334, 1785249880.0;
19.6165, 1667356020.0;
19.623166666666666, 1785249880.0;
19.629833333333334, 2046300570.0;
19.636499999999998, 2227351855.0;
19.643166666666666, 2214720370.0;
19.649833333333333, 2113668490.0;
19.6565, 1991564135.0;
19.663166666666665, 1924196215.0;
19.669833333333333, 1844196810.0;
19.6765, 1915775225.0;
19.683166666666665, 2042090075.0;
19.689833333333333, 2362087695.0;
19.6965, 2732611255.0;
19.703166666666668, 2795768680.0;
19.709833333333332, 2589454425.0;
19.7165, 2088405520.0;
19.723166666666668, 1776828890.0;
19.729833333333332, 1524199190.0;
19.7365, 1347358400.0;
19.743166666666667, 1322095430.0;
19.74983333333333, 1494725725.0;
19.7565, 1536830675.0;
19.763166666666667, 1229464540.0;
19.769833333333334, 1090518205.0;
19.7765, 1174728105.0;
19.783166666666666, 1242096025.0;
19.789833333333334, 896835435.0;
19.796499999999998, 581048310.0;
19.803166666666666, 421049500.0;
19.809833333333334, 58946930.0;
19.8165, -391576035.0;
19.823166666666665, -724205140.0;
19.829833333333333, -555785340.0;
19.8365, -134735840.0;
19.843166666666665, 227366730.0;
19.849833333333333, 551574845.0;
19.8565, 479996430.0;
19.863166666666665, 315787125.0;
19.869833333333332, 33683960.0;
19.8765, -21052475.0;
19.883166666666668, 206314255.0;
19.889833333333332, 492627915.0;
19.8965, 854730485.0;
19.903166666666667, 1010518800.0;
19.90983333333333, 1098939195.0;
19.9165, 715784150.0;
19.923166666666667, 21052475.0;
19.929833333333335, -867361970.0;
19.9365, -1498936220.0;
19.943166666666666, -1705250475.0;
19.949833333333334, -1545251665.0;
19.9565, -1263148500.0;
##END=

$$ === CHEMSPECTRA INTEGRALS AND MULTIPLETS ===
##PAGE=280
##$OBSERVEDINTEGRALS= (X Y Z)
##$OBSERVEDMULTIPLETS=
##$OBSERVEDMULTIPLETSPEAKS=
##END=

$$ === CHEMSPECTRA PEAK TABLE EDIT ===
##TITLE=618becfe-a0ce-4983-ba36-5fdcbb7ed595
##JCAMP-DX=5.00
##DATA TYPE=LC/MSPEAKTABLE
##DATA CLASS=PEAKTABLE
##$CSCATEGORY=EDIT_PEAK
##$CSTHRESHOLD=0.05
##MAXX=19.9565
##MAXY=171708196595.0
##MINX=-0.0435
##MINY=-149068364980.0
##PAGE=280
##NPOINTS=0
##PEAKTABLE= (XY..XY)
1.2098333333333333, 171708196595.0
2.2565000000000004, 146748382235.0
11.656500000000001, 95944549565.0
18.169833333333333, 64386889540.0
18.24983333333333, 61927960460.0
18.0765, 58340618720.0
11.336500000000001, 56597473790.0
2.623166666666667, 45477556495.0
2.443166666666667, 38976552215.0
17.769833333333334, 35212369685.0
2.823166666666667, 34627110880.0
12.723166666666668, 32867123970.0
12.796500000000002, 29502938465.0
##END=

$$ === CHEMSPECTRA PEAK TABLE AUTO ===
##TITLE=618becfe-a0ce-4983-ba36-5fdcbb7ed595
##JCAMP-DX=5.00
##DATA TYPE=LC/MSPEAKTABLE
##DATA CLASS=PEAKTABLE
##$CSCATEGORY=AUTO_PEAK
##$CSTHRESHOLD=0.05
##MAXX=19.9565
##MAXY=171708196595.0
##MINX=-0.0435
##MINY=-149068364980.0
##PAGE=280
##NPOINTS=100
##PEAKTABLE= (XY..XY)
##END=

$$ === CHEMSPECTRA UVVIS PEAK TABLE ===
##TITLE=618becfe-a0ce-4983-ba36-5fdcbb7ed595
##JCAMP-DX=5.00
##DATA TYPE=LC/MS
##DATA CLASS=PEAK TABLE
##ORIGIN=
##OWNER=
##XUNITS=RETENTION TIME
##YUNITS=DETECTOR SIGNAL
##$CSCATEGORY=UVVIS PEAK TABLE
##PAGE=300
##NPOINTS=3001
##DATA TABLE= (XY..XY), PEAKS
-0.0435, -75788910.0;
-0.03683333333333333, -117893860.0;
-0.03016666666666666, -172630295.0;
-0.023499999999999997, -33683960.0;
-0.01683333333333333, 185261780.0;
-0.010166666666666664, 391576035.0;
-0.003499999999999996, 227366730.0;
0.003166666666666672, -155788315.0;
0.00983333333333334, -581048310.0;
0.016500000000000008, -1090518205.0;
0.02316666666666667, -1528409685.0;
0.029833333333333337, -1663145525.0;
0.036500000000000005, -1402094835.0;
0.04316666666666667, -770520585.0;
0.04983333333333334, 12631485.0;
0.05650000000000001, 265261185.0;
0.06316666666666668, 54736435.0;
0.06983333333333334, -463154450.0;
0.07650000000000001, -749468110.0;
0.08316666666666668, -1166307115.0;
0.08983333333333333, -1587356615.0;
0.09650000000000002, -1709460970.0;
0.10316666666666667, -1494725725.0;
0.10983333333333335, -1162096620.0;
0.1165, -1254727510.0;
0.12316666666666669, -1221043550.0;
0.12983333333333336, -1027360780.0;
0.1365, -387365540.0;
0.14316666666666666, 151577820.0;
0.14983333333333337, 366313065.0;
0.15650000000000003, 703152665.0;
0.16316666666666668, 1086307710.0;
0.16983333333333334, 1397884340.0;
0.1765, 1103149690.0;
0.1831666666666667, 837888505.0;
0.18983333333333335, 951571870.0;
0.1965, 1204201570.0;
0.20316666666666666, 993676820.0;
0.20983333333333337, 290524155.0;
0.21650000000000003, -357892075.0;
0.22316666666666668, -854730485.0;
0.2298333333333334, -1077886720.0;
0.23650000000000004, -1444199785.0;
0.2431666666666667, -1629461565.0;
0.24983333333333335, -1519988695.0;
0.25650000000000006, -1039992265.0;
0.2631666666666667, -732626130.0;
0.26983333333333337, -766310090.0;
0.2765, -808415040.0;
0.2831666666666667, -821046525.0;
0.2898333333333334, -905256425.0;
0.29650000000000004, -922098405.0;
0.3031666666666667, -833678010.0;
0.30983333333333335, -896835435.0;
0.31650000000000006, -1166307115.0;
0.3231666666666667, -1439989290.0;
0.32983333333333337, -1435778795.0;
0.3365, -1667356020.0;
0.34316666666666673, -1747355425.0;
0.3498333333333334, -1465252260.0;
0.35650000000000004, -1023150285.0;
0.3631666666666667, -888414445.0;
0.3698333333333334, -1098939195.0;
0.37650000000000006, -959992860.0;
0.3831666666666667, -837888505.0;
0.38983333333333337, -1128412660.0;
0.3965, -1431568300.0;
0.40316666666666673, -968413850.0;
0.4098333333333334, -4210495.0;
0.41650000000000004, 467364945.0;
0.4231666666666667, 425259995.0;
0.4298333333333334, 298945145.0;
0.43650000000000005, 8420990.0;
0.4431666666666667, -488417420.0;
0.44983333333333336, -766310090.0;
0.4565, -614732270.0;
0.4631666666666667, -522101380.0;
0.46983333333333344, -627363755.0;
0.47650000000000003, -475785935.0;
0.48316666666666674, -463154450.0;
0.48983333333333334, -892624940.0;
0.49650000000000005, -1263148500.0;
0.5031666666666668, -854730485.0;
0.5098333333333334, 197893265.0;
0.5165000000000001, 901045930.0;
0.5231666666666667, 1258938005.0;
0.5298333333333334, 1376831865.0;
0.5365000000000001, 1166307115.0;
0.5431666666666667, 538943360.0;
0.5498333333333334, -202103760.0;
0.5565000000000001, -479996430.0;
0.5631666666666667, -210524750.0;
0.5698333333333334, 227366730.0;
0.5765, 572627320.0;
0.5831666666666667, 509469895.0;
0.5898333333333334, 336839600.0;
0.5965, 21052475.0;
0.6031666666666667, -273682175.0;
0.6098333333333333, -585258805.0;
0.6165, -825257020.0;
0.6231666666666668, -825257020.0;
0.6298333333333334, -661047715.0;
0.6365000000000001, -618942765.0;
0.6431666666666668, -631574250.0;
0.6498333333333334, -450522965.0;
0.6565000000000001, -168419800.0;
0.6631666666666667, 164209305.0;
0.6698333333333334, 126314850.0;
0.6765000000000001, 189472275.0;
0.6831666666666667, 202103760.0;
0.6898333333333334, 197893265.0;
0.6965000000000001, 269471680.0;
0.7031666666666667, 593679795.0;
0.7098333333333334, 795783555.0;
0.7165, 648416230.0;
0.7231666666666667, 202103760.0;
0.7298333333333334, -298945145.0;
0.7365, -661047715.0;
0.7431666666666668, -1191570085.0;
0.7498333333333334, -1170517610.0;
0.7565000000000001, -736836625.0;
0.7631666666666668, -88420395.0;
0.7698333333333334, 446312470.0;
0.7765000000000001, 741047120.0;
0.7831666666666668, 1296832460.0;
0.7898333333333334, 1911564730.0;
0.7965000000000001, 2273667300.0;
0.8031666666666667, 2336824725.0;
0.8098333333333334, 2197878390.0;
0.8165000000000001, 2197878390.0;
0.8231666666666667, 2155773440.0;
0.8298333333333334, 1793670870.0;
0.8365, 1633672060.0;
0.8431666666666667, 1764197405.0;
0.8498333333333334, 2008406115.0;
0.8565, 1679987505.0;
0.8631666666666667, 837888505.0;
0.8698333333333335, 58946930.0;
0.8765000000000001, -463154450.0;
0.8831666666666668, -858940980.0;
0.8898333333333334, -1258938005.0;
0.8965000000000001, -1355779390.0;
0.9031666666666668, -1061044740.0;
0.9098333333333334, -597890290.0;
0.9165000000000001, -374734055.0;
0.9231666666666667, -117893860.0;
0.9298333333333334, 341050095.0;
0.9365000000000001, 917887910.0;
0.9431666666666667, 1604198595.0;
0.9498333333333334, 2029458590.0;
0.9565, 2366298190.0;
0.9631666666666668, 2336824725.0;
0.9698333333333334, 2147352450.0;
0.9765, 1705250475.0;
0.9831666666666669, 947361375.0;
0.9898333333333335, 513680390.0;
0.9965, 538943360.0;
1.0031666666666665, 926308900.0;
1.0098333333333334, 1317884935.0;
1.0165, 2025248095.0;
1.0231666666666666, 2858926105.0;
1.0298333333333334, 3452605900.0;
1.0365, 3246291645.0;
1.0431666666666666, 2109457995.0;
1.0498333333333334, 475785935.0;
1.0565, -1351568895.0;
1.0631666666666666, -2572612445.0;
1.0698333333333334, -3065240360.0;
1.0765, -2244193835.0;
1.0831666666666666, -58946930.0;
1.0898333333333332, 3094713825.0;
1.0965, 6075744285.0;
1.1031666666666666, 7957835550.0;
1.1098333333333332, 7692574365.0;
1.1165, 2446297595.0;
1.1231666666666666, -10698867795.0;
1.1298333333333332, -32471337440.0;
1.1365, -58445881095.0;
1.1431666666666667, -81995179630.0;
1.1498333333333333, -95805603230.0;
1.1565, -93515093950.0;
1.1631666666666667, -72142621330.0;
1.1698333333333333, -33856590295.0;
1.1764999999999999, 14214631120.0;
1.1831666666666667, 63056373120.0;
1.1898333333333333, 104744484115.0;
1.1965, 134020055850.0;
1.2031666666666667, 150542038230.0;
1.2098333333333333, 157165146865.0;
1.2165, 157114620925.0;
1.2231666666666667, 152929388895.0;
1.2298333333333333, 145927335710.0;
1.2365, 137923184715.0;
1.2431666666666668, 129144302640.0;
1.2498333333333334, 118365435440.0;
1.2565, 101809769100.0;
1.2631666666666665, 75068915355.0;
1.2698333333333334, 37624983320.0;
1.2765, -6905211800.0;
1.2831666666666666, -51814351470.0;
1.2898333333333334, -90955112990.0;
1.2965, -118963325730.0;
1.3031666666666666, -130988499450.0;
1.3098333333333334, -126820109400.0;
1.3165, -111085489585.0;
1.3231666666666666, -91296163085.0;
1.3298333333333334, -72791037560.0;
1.3365, -56925892400.0;
1.3431666666666666, -44138619085.0;
1.3498333333333332, -34222903360.0;
1.3565, -26884010575.0;
1.3631666666666666, -21166158365.0;
1.3698333333333332, -16774612080.0;
1.3765, -13444110535.0;
1.3831666666666667, -10829393140.0;
1.3898333333333333, -8412569010.0;
1.3965, -6564161705.0;
1.4031666666666667, -5199961325.0;
1.4098333333333333, -3835760945.0;
1.4165, -2648401355.0;
1.4231666666666667, -1919985720.0;
1.4298333333333333, -2185246905.0;
1.4365, -2362087695.0;
1.4431666666666667, -2155773440.0;
1.4498333333333333, -1574725130.0;
1.4565, -762099595.0;
1.4631666666666667, 50525940.0;
1.4698333333333333, 1246306520.0;
1.4765, 2126299975.0;
1.4831666666666667, 2336824725.0;
1.4898333333333333, 2021037600.0;
1.4965, 1541041170.0;
1.5031666666666668, 1402094835.0;
1.5098333333333334, 1166307115.0;
1.5165, 968413850.0;
1.5231666666666668, 1141044145.0;
1.5298333333333334, 1494725725.0;
1.5365, 1907354235.0;
1.5431666666666666, 1919985720.0;
1.5498333333333334, 1831565325.0;
1.5565, 1873670275.0;
1.5631666666666666, 1772618395.0;
1.5698333333333334, 1738934435.0;
1.5765, 1696829485.0;
1.5831666666666666, 1835775820.0;
1.5898333333333334, 2088405520.0;
1.5965, 2273667300.0;
1.6031666666666666, 2597875415.0;
1.6098333333333334, 2976819965.0;
1.6165, 3157871250.0;
1.6231666666666666, 3254712635.0;
1.6298333333333332, 3305238575.0;
1.6365, 3503131840.0;
1.6431666666666667, 3612604710.0;
1.6498333333333333, 3562078770.0;
1.6565, 3692604115.0;
1.6631666666666667, 3717867085.0;
1.6698333333333333, 3591552235.0;
1.6765, 3292607090.0;
1.6831666666666667, 3052608875.0;
1.6898333333333333, 2947346500.0;
1.6965000000000001, 2724190265.0;
1.7031666666666667, 2534717990.0;
1.7098333333333333, 2614717395.0;
1.7165, 2690506305.0;
1.7231666666666667, 2993661945.0;
1.7298333333333333, 3141029270.0;
1.7365, 3174713230.0;
1.7431666666666668, 3456816395.0;
1.7498333333333334, 3785235005.0;
1.7565, 4235757970.0;
1.7631666666666668, 4319967870.0;
1.7698333333333334, 4597860540.0;
1.7765, 5389433600.0;
1.7831666666666668, 5949429435.0;
1.7898333333333334, 6336794975.0;
1.7965, 6602056160.0;
1.8031666666666666, 6892580315.0;
1.8098333333333334, 7258893380.0;
1.8165, 7284156350.0;
1.8231666666666666, 7233630410.0;
1.8298333333333334, 6964158730.0;
1.8365, 6791528435.0;
1.8431666666666666, 6753633980.0;
1.8498333333333334, 6176796165.0;
1.8565, 5279960730.0;
1.8631666666666666, 4922068655.0;
1.8698333333333335, 5326276175.0;
1.8765, 5987323890.0;
1.8831666666666667, 6227322105.0;
1.8898333333333333, 6383110420.0;
1.8965, 6627319130.0;
1.9031666666666667, 6408373390.0;
1.9098333333333333, 5772588645.0;
1.9165, 4959963110.0;
1.9231666666666667, 4383125295.0;
1.9298333333333333, 3999970250.0;
1.9365, 3343133030.0;
1.9431666666666667, 2795768680.0;
1.9498333333333333, 2353666705.0;
1.9565, 2046300570.0;
1.9631666666666667, 1882091265.0;
1.9698333333333335, 1835775820.0;
1.9765, 2286298785.0;
1.9831666666666667, 2808400165.0;
1.9898333333333336, 2976819965.0;
1.9965, 2922083530.0;
2.003166666666667, 2749453235.0;
2.009833333333334, 2787347690.0;
2.0165, 2762084720.0;
2.023166666666667, 2522086505.0;
2.0298333333333334, 2046300570.0;
2.0365, 1473673250.0;
2.043166666666667, 1073676225.0;
2.0498333333333334, 846309495.0;
2.0565, 774731080.0;
2.063166666666667, 770520585.0;
2.0698333333333334, 1069465730.0;
2.0765000000000002, 1279990480.0;
2.083166666666667, 1511567705.0;
2.0898333333333334, 1402094835.0;
2.0965000000000003, 1056834245.0;
2.103166666666667, 732626130.0;
2.1098333333333334, 783152070.0;
2.1165000000000003, 1292621965.0;
2.123166666666667, 1898933245.0;
2.1298333333333335, 2404192645.0;
2.1365000000000003, 2778926700.0;
2.143166666666667, 3069450855.0;
2.1498333333333335, 3385237980.0;
2.1565000000000003, 3705235600.0;
2.163166666666667, 3713656590.0;
2.1698333333333335, 3696814610.0;
2.1765000000000003, 3810497975.0;
2.183166666666667, 4037864705.0;
2.1898333333333335, 4075759160.0;
2.1965000000000003, 3570499760.0;
2.2031666666666667, 2989451450.0;
2.2098333333333335, 2522086505.0;
2.2165000000000004, 2109457995.0;
2.2231666666666667, 2972609470.0;
2.2298333333333336, 18113549490.0;
2.2365000000000004, 78344680465.0;
2.2431666666666668, 188482808675.0;
2.2498333333333336, 307917709845.0;
2.2565000000000004, 386729755255.0;
2.2631666666666668, 411133784275.0;
2.2698333333333336, 394093911010.0;
2.2765000000000004, 325513368450.0;
2.283166666666667, 207156354000.0;
2.2898333333333336, 81270974490.0;
2.2965000000000004, -2349456210.0;
2.303166666666667, -30930296270.0;
2.3098333333333336, -30841875875.0;
2.3165000000000004, -22862987850.0;
2.323166666666667, -13932527955.0;
2.3298333333333336, -6117849235.0;
2.3365000000000005, 698942170.0;
2.343166666666667, 6029428840.0;
2.3498333333333337, 9823084835.0;
2.3565000000000005, 12799904800.0;
2.363166666666667, 15717777835.0;
2.3698333333333337, 19688274620.0;
2.3765000000000005, 24993498320.0;
2.383166666666667, 32109234870.0;
2.3898333333333337, 41574427630.0;
2.3965, 52942764130.0;
2.403166666666667, 65300566955.0;
2.4098333333333337, 76883638700.0;
2.4165, 86698302545.0;
2.423166666666667, 93809828600.0;
2.4298333333333337, 97889798255.0;
2.4365, 98710844780.0;
2.443166666666667, 96820332525.0;
2.4498333333333338, 92980361085.0;
2.4565, 87847767680.0;
2.463166666666667, 81860443790.0;
2.4698333333333338, 75271019115.0;
2.4765, 68837382755.0;
2.483166666666667, 62610060650.0;
2.489833333333334, 57144838140.0;
2.4965, 52243821960.0;
2.503166666666667, 48184904780.0;
2.509833333333334, 45069138480.0;
2.5165, 43010206425.0;
2.523166666666667, 42547051975.0;
2.529833333333334, 43587044240.0;
2.5365, 46125972725.0;
2.543166666666667, 49523842190.0;
2.549833333333334, 53186972840.0;
2.5565, 56647999730.0;
2.563166666666667, 59422715935.0;
2.5698333333333334, 60972178095.0;
2.5765000000000002, 61401648585.0;
2.583166666666667, 61300596705.0;
2.5898333333333334, 61359543635.0;
2.5965000000000003, 61481647990.0;
2.603166666666667, 61035335520.0;
2.6098333333333334, 60176394540.0;
2.6165000000000003, 58955350990.0;
2.623166666666667, 57136417150.0;
2.6298333333333335, 54252228075.0;
2.6365000000000003, 50673307325.0;
2.643166666666667, 47679645380.0;
2.6498333333333335, 45368083625.0;
2.6565000000000003, 43073363850.0;
2.663166666666667, 40475488435.0;
2.6698333333333335, 38180768660.0;
2.6765000000000003, 36328150860.0;
2.683166666666667, 34328165735.0;
2.6898333333333335, 31961867545.0;
2.6965000000000003, 30088197270.0;
2.703166666666667, 29288203220.0;
2.7098333333333335, 29279782230.0;
2.7165000000000004, 29410307575.0;
2.723166666666667, 29309255695.0;
2.7298333333333336, 29174519855.0;
2.7365000000000004, 29098730945.0;
2.7431666666666668, 29077678470.0;
2.7498333333333336, 28972416095.0;
2.7565000000000004, 29010310550.0;
2.7631666666666668, 29115572925.0;
2.7698333333333336, 29098730945.0;
2.7765000000000004, 28871364215.0;
2.783166666666667, 28917679660.0;
2.7898333333333336, 29275571735.0;
2.7965000000000004, 29726094700.0;
2.803166666666667, 30332405980.0;
2.8098333333333336, 31157663000.0;
2.8165000000000004, 31987130515.0;
2.823166666666667, 32294496650.0;
2.8298333333333336, 32134497840.0;
2.8365000000000005, 31633448935.0;
2.843166666666667, 30837665380.0;
2.8498333333333337, 29873462025.0;
2.8565000000000005, 28702944415.0;
2.863166666666667, 27208218690.0;
2.8698333333333337, 25473494750.0;
2.8765000000000005, 23721928830.0;
2.883166666666667, 22353517955.0;
2.8898333333333337, 21372472620.0;
2.8965000000000005, 20601952035.0;
2.903166666666667, 20084061150.0;
2.9098333333333337, 19284067100.0;
2.9165000000000005, 18492494040.0;
2.923166666666667, 17423028310.0;
2.9298333333333337, 16378825550.0;
2.9365, 15865145160.0;
2.943166666666667, 15629357440.0;
2.9498333333333338, 15734619815.0;
2.9565, 15818829715.0;
2.963166666666667, 16126195850.0;
2.9698333333333338, 16412509510.0;
2.9765, 16319878620.0;
2.983166666666667, 16071459415.0;
2.989833333333334, 16041985950.0;
2.9965, 16151458820.0;
3.003166666666667, 16143037830.0;
3.009833333333334, 16180932285.0;
3.0165, 16277773670.0;
3.023166666666667, 16463035450.0;
3.029833333333334, 16715665150.0;
3.0365, 16879874455.0;
3.043166666666667, 17435659795.0;
3.049833333333334, 17490396230.0;
3.0565, 17267239995.0;
3.063166666666667, 16530403370.0;
3.069833333333334, 15801987735.0;
3.0765000000000002, 15170413485.0;
3.083166666666667, 14100947755.0;
3.089833333333334, 12951482620.0;
3.0965000000000003, 11726228575.0;
3.103166666666667, 10698867795.0;
3.1098333333333334, 9427298305.0;
3.1165000000000003, 8084150400.0;
3.123166666666667, 6762054970.0;
3.1298333333333335, 5852588050.0;
3.1365000000000003, 5170487860.0;
3.143166666666667, 4985226080.0;
3.1498333333333335, 4922068655.0;
3.1565000000000003, 4795753805.0;
3.163166666666667, 4496808660.0;
3.1698333333333335, 4025233220.0;
3.1765000000000003, 3461026890.0;
3.183166666666667, 2534717990.0;
3.1898333333333335, 1692618990.0;
3.1965000000000003, 1204201570.0;
3.203166666666667, 816836030.0;
3.2098333333333335, 501048905.0;
3.2165000000000004, 193682770.0;
3.223166666666667, 126314850.0;
3.2298333333333336, 256840195.0;
3.2365000000000004, 298945145.0;
3.243166666666667, 248419205.0;
3.2498333333333336, -218945740.0;
3.2565000000000004, -479996430.0;
3.263166666666667, -530522370.0;
3.2698333333333336, -728415635.0;
3.2765000000000004, -1082097215.0;
3.283166666666667, -1170517610.0;
3.2898333333333336, -677889695.0;
3.2965000000000004, -665258210.0;
3.303166666666667, -1330516420.0;
3.3098333333333336, -2113668490.0;
3.3165000000000004, -2661032840.0;
3.323166666666667, -3056819370.0;
3.3298333333333336, -3566289265.0;
3.3365000000000005, -3709446095.0;
3.343166666666667, -3709446095.0;
3.3498333333333337, -3776814015.0;
3.3565000000000005, -4033654210.0;
3.363166666666667, -4193653020.0;
3.3698333333333337, -4404177770.0;
3.3765000000000005, -4858911230.0;
3.383166666666667, -5271539740.0;
3.3898333333333337, -5781009635.0;
3.3965000000000005, -6063112800.0;
3.403166666666667, -6610477150.0;
3.4098333333333337, -6896790810.0;
3.4165000000000005, -6968369225.0;
3.423166666666667, -7039947640.0;
3.4298333333333337, -7128368035.0;
3.4365000000000006, -7755731790.0;
3.443166666666667, -8315727625.0;
3.4498333333333338, -9166247615.0;
3.4565000000000006, -10084135525.0;
3.463166666666667, -10993602445.0;
3.4698333333333338, -11460967390.0;
3.4765, -11427283430.0;
3.483166666666667, -11503072340.0;
3.489833333333334, -11511493330.0;
3.4965, -11242021650.0;
3.503166666666667, -10433606610.0;
3.509833333333334, -9776769390.0;
3.5165, -9406245830.0;
3.523166666666667, -9153616130.0;
3.529833333333334, -8867302470.0;
3.5365, -8740987620.0;
3.543166666666667, -9178879100.0;
3.549833333333334, -9928347210.0;
3.5565, -10479922055.0;
3.563166666666667, -10711499280.0;
3.569833333333334, -10745183240.0;
3.5765000000000002, -10757814725.0;
3.583166666666667, -10374659680.0;
3.589833333333334, -9789400875.0;
3.5965000000000003, -9524139690.0;
3.603166666666667, -9945189190.0;
3.609833333333334, -10951497495.0;
3.6165000000000003, -11768333525.0;
3.623166666666667, -12294645400.0;
3.629833333333334, -12530433120.0;
3.6365000000000003, -12580959060.0;
3.643166666666667, -12450433715.0;
3.6498333333333335, -12143067580.0;
3.6565000000000003, -11999910750.0;
3.663166666666667, -12366223815.0;
3.6698333333333335, -12917798660.0;
3.6765000000000003, -13296743210.0;
3.683166666666667, -13103060440.0;
3.6898333333333335, -12757799850.0;
3.6965000000000003, -12694642425.0;
3.703166666666667, -12922009155.0;
3.7098333333333335, -13330427170.0;
3.7165000000000004, -13839897065.0;
3.723166666666667, -14479892305.0;
3.7298333333333336, -14934625765.0;
3.7365000000000004, -15145150515.0;
3.743166666666667, -15132519030.0;
3.7498333333333336, -15073572100.0;
3.7565000000000004, -15077782595.0;
3.763166666666667, -15065151110.0;
3.7698333333333336, -14799889925.0;
3.7765000000000004, -14412524385.0;
3.7831666666666672, -13907264985.0;
3.7898333333333336, -13591477860.0;
3.7965000000000004, -13372532120.0;
3.8031666666666673, -13279901230.0;
3.8098333333333336, -13692529740.0;
3.8165000000000004, -14172526170.0;
3.823166666666667, -14846205370.0;
3.8298333333333336, -15326201800.0;
3.8365000000000005, -15519884570.0;
3.843166666666667, -15498832095.0;
3.8498333333333337, -15490411105.0;
3.8565000000000005, -15961986545.0;
3.863166666666667, -16197774265.0;
3.8698333333333337, -16151458820.0;
3.8765000000000005, -15987249515.0;
3.883166666666667, -16256721195.0;
3.8898333333333337, -16374615055.0;
3.8965000000000005, -15940934070.0;
3.903166666666667, -15519884570.0;
3.9098333333333337, -15317780810.0;
3.9165000000000005, -15549358035.0;
3.923166666666667, -15587252490.0;
3.9298333333333337, -15557779025.0;
3.9365000000000006, -15743040805.0;
3.943166666666667, -16374615055.0;
3.9498333333333338, -17170398610.0;
3.9565, -17583027120.0;
3.963166666666667, -17570395635.0;
3.9698333333333338, -17658816030.0;
3.9765000000000006, -17747236425.0;
3.9831666666666674, -17486185735.0;
3.9898333333333333, -16985136830.0;
3.9965, -16686191685.0;
4.003166666666667, -16665139210.0;
4.009833333333334, -16551455845.0;
4.016500000000001, -16214616245.0;
4.0231666666666674, -15924092090.0;
4.029833333333333, -15730409320.0;
4.0365, -15507253085.0;
4.043166666666667, -15439885165.0;
4.049833333333334, -15427253680.0;
4.056500000000001, -15545147540.0;
4.0631666666666675, -15743040805.0;
4.069833333333333, -15570410510.0;
4.0765, -15376727740.0;
4.083166666666667, -15060940615.0;
4.089833333333334, -15166202990.0;
4.096500000000001, -15574621005.0;
4.103166666666667, -15658830905.0;
4.1098333333333334, -15898829120.0;
4.1165, -16252510700.0;
4.123166666666667, -16808296040.0;
4.129833333333334, -16934610890.0;
4.136500000000001, -16467245945.0;
4.143166666666667, -16248300205.0;
4.1498333333333335, -16349352085.0;
4.1565, -16319878620.0;
4.163166666666667, -15961986545.0;
4.169833333333334, -15679883380.0;
4.176500000000001, -15768303775.0;
4.183166666666667, -15608304965.0;
4.1898333333333335, -15128308535.0;
4.1965, -14766205965.0;
4.203166666666667, -14871468340.0;
4.209833333333334, -15031467150.0;
4.216500000000001, -15006204180.0;
4.223166666666667, -14976730715.0;
4.229833333333334, -15212518435.0;
4.2365, -15844092685.0;
4.243166666666667, -16429351490.0;
4.249833333333334, -16804085545.0;
4.256500000000001, -17018820790.0;
4.263166666666667, -17566185140.0;
4.269833333333334, -18206180380.0;
4.2765, -18223022360.0;
4.283166666666667, -17957761175.0;
4.289833333333334, -17629342565.0;
4.2965, -17814604345.0;
4.303166666666667, -17957761175.0;
4.309833333333334, -17751446920.0;
4.3165000000000004, -17532501180.0;
4.323166666666667, -17187240590.0;
4.329833333333334, -17376712865.0;
4.3365, -17511448705.0;
4.343166666666667, -17785130880.0;
4.349833333333334, -18079865530.0;
4.3565000000000005, -18328284735.0;
4.363166666666667, -18336705725.0;
4.369833333333334, -17869340780.0;
4.3765, -17431449300.0;
4.383166666666667, -17056715245.0;
4.389833333333334, -17174609105.0;
4.3965000000000005, -17439870290.0;
4.403166666666667, -17991445135.0;
4.409833333333334, -18648282355.0;
4.4165, -18917754035.0;
4.423166666666667, -18858807105.0;
4.429833333333334, -18521967505.0;
4.4365000000000006, -18551440970.0;
4.443166666666667, -18635650870.0;
4.449833333333333, -18521967505.0;
4.4565, -18458810080.0;
4.463166666666667, -18391442160.0;
4.469833333333334, -18568282950.0;
4.476500000000001, -18412494635.0;
4.483166666666667, -18336705725.0;
4.489833333333333, -18294600775.0;
4.4965, -18576703940.0;
4.503166666666667, -19229330665.0;
4.509833333333334, -19545117790.0;
4.516500000000001, -19620906700.0;
4.5231666666666674, -19267225120.0;
4.529833333333333, -19086173835.0;
4.5365, -18989332450.0;
4.543166666666667, -18652492850.0;
4.549833333333334, -18446178595.0;
4.556500000000001, -18711439780.0;
4.5631666666666675, -19709327095.0;
4.569833333333333, -20639846490.0;
4.5765, -20728266885.0;
4.583166666666667, -20656688470.0;
4.589833333333334, -20551426095.0;
4.596500000000001, -20463005700.0;
4.6031666666666675, -19915641350.0;
4.6098333333333334, -19174594230.0;
4.6165, -18913543540.0;
4.623166666666667, -18547230475.0;
4.629833333333334, -18269337805.0;
4.636500000000001, -17974603155.0;
4.643166666666667, -17945129690.0;
4.6498333333333335, -18420915625.0;
4.6565, -19128278785.0;
4.663166666666667, -20096692635.0;
4.669833333333334, -20707214410.0;
4.676500000000001, -20631425500.0;
4.683166666666667, -20025114220.0;
4.6898333333333335, -19018805915.0;
4.6965, -18084076025.0;
4.703166666666667, -17246187520.0;
4.709833333333334, -16644086735.0;
4.716500000000001, -16391457035.0;
4.723166666666667, -16399878025.0;
4.729833333333334, -16509350895.0;
4.7365, -16387246540.0;
4.743166666666667, -16197774265.0;
4.749833333333334, -16273563175.0;
4.756500000000001, -16660928715.0;
4.763166666666667, -17208293065.0;
4.769833333333334, -17789341375.0;
4.7765, -18189338400.0;
4.783166666666667, -18248285330.0;
4.789833333333334, -17865130285.0;
4.796500000000001, -17591448110.0;
4.803166666666667, -17481975240.0;
4.809833333333334, -17444080785.0;
4.8165000000000004, -17503027715.0;
4.823166666666667, -18025129095.0;
4.829833333333334, -18707229285.0;
4.8365, -19014595420.0;
4.843166666666667, -18858807105.0;
4.849833333333334, -18884070075.0;
4.8565000000000005, -19250383140.0;
4.863166666666667, -19540907295.0;
4.869833333333334, -19793536995.0;
4.8765, -19827220955.0;
4.883166666666667, -20037745705.0;
4.889833333333334, -19831431450.0;
4.8965000000000005, -19128278785.0;
4.903166666666667, -18155654440.0;
4.909833333333334, -17052504750.0;
4.9165, -16593560795.0;
4.923166666666667, -16484087925.0;
4.929833333333334, -16871453465.0;
4.9365000000000006, -17174609105.0;
4.943166666666667, -17153556630.0;
4.949833333333334, -17001978810.0;
4.9565, -16858821980.0;
4.963166666666667, -16846190495.0;
4.969833333333334, -16614613270.0;
4.976500000000001, -16572508320.0;
4.983166666666667, -16543034855.0;
4.989833333333333, -16644086735.0;
4.9965, -16492508915.0;
5.003166666666667, -16214616245.0;
5.009833333333334, -15961986545.0;
5.016500000000001, -15553568530.0;
5.0231666666666674, -15658830905.0;
5.029833333333333, -16420930500.0;
5.0365, -17359870885.0;
5.043166666666667, -17827235830.0;
5.049833333333334, -17772499395.0;
5.056500000000001, -18016708105.0;
5.0631666666666675, -18130391470.0;
5.069833333333333, -17595658605.0;
5.0765, -16614613270.0;
5.083166666666667, -15919881595.0;
5.089833333333334, -15738830310.0;
5.096500000000001, -15835671695.0;
5.1031666666666675, -15793566745.0;
5.1098333333333334, -15772514270.0;
5.1165, -15793566745.0;
5.123166666666667, -16210405750.0;
5.129833333333334, -16644086735.0;
5.136500000000001, -16829348515.0;
5.1431666666666676, -17098820195.0;
5.1498333333333335, -17241977025.0;
5.1565, -17347239400.0;
5.163166666666667, -16791454060.0;
5.169833333333334, -16311457630.0;
5.176500000000001, -15688304370.0;
5.183166666666667, -15023046160.0;
5.1898333333333335, -14799889925.0;
5.1965, -14850415865.0;
5.203166666666667, -15199886950.0;
5.209833333333334, -15511463580.0;
5.216500000000001, -16134616840.0;
5.223166666666667, -17166188115.0;
5.229833333333334, -17721973455.0;
5.2365, -18117759985.0;
5.243166666666667, -18298811270.0;
5.249833333333334, -18391442160.0;
5.256500000000001, -18134601965.0;
5.263166666666667, -17515659200.0;
5.269833333333334, -16993557820.0;
5.2765, -16589350300.0;
5.283166666666667, -16239879215.0;
5.289833333333334, -15991460010.0;
5.296500000000001, -15743040805.0;
5.303166666666667, -15620936450.0;
5.309833333333334, -15587252490.0;
5.3165000000000004, -15705146350.0;
5.323166666666667, -15961986545.0;
5.329833333333334, -15987249515.0;
5.336500000000001, -15903039615.0;
5.343166666666667, -15288307345.0;
5.349833333333334, -14719890520.0;
5.3565000000000005, -14105158250.0;
5.363166666666667, -13877791520.0;
5.369833333333334, -13713582215.0;
5.3765, -13898843995.0;
5.383166666666667, -14492523790.0;
5.389833333333334, -15086203585.0;
5.3965000000000005, -15389359225.0;
5.403166666666667, -15263044375.0;
5.409833333333334, -15124098040.0;
5.4165, -14753574480.0;
5.423166666666667, -14446208345.0;
5.429833333333334, -14235683595.0;
5.4365000000000006, -14189368150.0;
5.443166666666667, -14176736665.0;
5.449833333333334, -14357787950.0;
5.4565, -14795679430.0;
5.463166666666667, -14972520220.0;
5.469833333333334, -14761995470.0;
5.476500000000001, -14534628740.0;
5.483166666666667, -14227262605.0;
5.489833333333334, -13671477265.0;
5.4965, -12652537475.0;
5.503166666666667, -12075699660.0;
5.509833333333334, -12020963225.0;
5.516500000000001, -12336750350.0;
5.5231666666666674, -12947272125.0;
5.529833333333333, -13789371125.0;
5.5365, -14707259035.0;
5.543166666666667, -15195676455.0;
5.549833333333334, -15490411105.0;
5.556500000000001, -15557779025.0;
5.5631666666666675, -15216728930.0;
5.569833333333333, -14639891115.0;
5.5765, -14235683595.0;
5.583166666666667, -14252525575.0;
5.589833333333334, -14235683595.0;
5.596500000000001, -14075684785.0;
5.6031666666666675, -14088316270.0;
5.6098333333333334, -14361998445.0;
5.6165, -14749363985.0;
5.623166666666667, -14728311510.0;
5.629833333333334, -14374629930.0;
5.636500000000001, -13839897065.0;
5.6431666666666676, -13444110535.0;
5.6498333333333335, -13014640045.0;
5.6565, -12311487380.0;
5.663166666666667, -11860964415.0;
5.669833333333334, -11717807585.0;
5.676500000000001, -11949384810.0;
5.683166666666668, -12138857085.0;
5.6898333333333335, -12332539855.0;
5.6965, -13002008560.0;
5.703166666666667, -13427268555.0;
5.709833333333334, -13629372315.0;
5.716500000000001, -13393584595.0;
5.723166666666667, -13174638855.0;
5.729833333333334, -12660958465.0;
5.7365, -11212548185.0;
5.743166666666667, -9355719890.0;
5.749833333333334, -7608364465.0;
5.756500000000001, -6538898735.0;
5.763166666666667, -5776799140.0;
5.769833333333334, -5347328650.0;
5.7765, -5511537955.0;
5.783166666666667, -6475741310.0;
5.789833333333334, -7642048425.0;
5.796500000000001, -8294675150.0;
5.803166666666667, -8265201685.0;
5.809833333333334, -8324148615.0;
5.8165000000000004, -8858881480.0;
5.823166666666667, -9465192760.0;
5.829833333333334, -9810453350.0;
5.836500000000001, -9962031170.0;
5.843166666666667, -10214660870.0;
5.849833333333334, -10404133145.0;
5.8565000000000005, -10597815915.0;
5.863166666666667, -10665183835.0;
5.869833333333334, -10799919675.0;
5.876500000000001, -10943076505.0;
5.883166666666667, -11153601255.0;
5.889833333333334, -11343073530.0;
5.8965000000000005, -11136759275.0;
5.903166666666667, -10610447400.0;
5.909833333333334, -10130450970.0;
5.9165, -10054662060.0;
5.923166666666667, -10399922650.0;
5.929833333333334, -10652552350.0;
5.9365000000000006, -10808340665.0;
5.943166666666667, -11157811750.0;
5.949833333333334, -11482019865.0;
5.9565, -11515703825.0;
5.963166666666667, -11309389570.0;
5.969833333333334, -11086233335.0;
5.976500000000001, -10829393140.0;
5.983166666666667, -10467290570.0;
5.989833333333334, -10235713345.0;
5.9965, -10159924435.0;
6.003166666666667, -9700980480.0;
6.009833333333334, -8618883265.0;
6.016500000000001, -6909422295.0;
6.0231666666666674, -5044173010.0;
6.029833333333334, -3061029865.0;
6.0365, -1322095430.0;
6.043166666666667, -21052475.0;
6.049833333333334, 458943955.0;
6.056500000000001, -63157425.0;
6.0631666666666675, -1136833650.0;
6.069833333333333, -2656822345.0;
6.0765, -4155758565.0;
6.083166666666667, -5696799735.0;
6.089833333333334, -7170472985.0;
6.096500000000001, -8286254160.0;
6.1031666666666675, -9098879695.0;
6.1098333333333334, -9359930385.0;
6.1165, -9448350780.0;
6.123166666666667, -8997827815.0;
6.129833333333334, -7860994165.0;
6.136500000000001, -6475741310.0;
6.1431666666666676, -5233645285.0;
6.1498333333333335, -4345230840.0;
6.1565, -3225239170.0;
6.163166666666667, -2319982745.0;
6.169833333333334, -2054721560.0;
6.176500000000001, -2488402545.0;
6.183166666666668, -2884189075.0;
6.1898333333333335, -3406290455.0;
6.1965, -4298915395.0;
6.203166666666667, -5658905280.0;
6.209833333333334, -6644161110.0;
6.216500000000001, -7187314965.0;
6.223166666666668, -7663100900.0;
6.229833333333334, -7999940500.0;
6.2365, -8353622080.0;
6.243166666666667, -8340990595.0;
6.249833333333334, -8719935145.0;
6.256500000000001, -9212563060.0;
6.263166666666667, -9545192165.0;
6.269833333333334, -9258878505.0;
6.2765, -8391516535.0;
6.283166666666667, -7865204660.0;
6.289833333333334, -7734679315.0;
6.296500000000001, -7932572580.0;
6.303166666666667, -8054676935.0;
6.309833333333334, -8273622675.0;
6.3165000000000004, -8783092570.0;
6.323166666666667, -9296772960.0;
6.329833333333334, -9557823650.0;
6.336500000000001, -9519929195.0;
6.343166666666667, -9494666225.0;
6.349833333333334, -9844137310.0;
6.3565000000000005, -10079925030.0;
6.363166666666667, -10147292950.0;
6.369833333333334, -10084135525.0;
6.376500000000001, -10168345425.0;
6.383166666666667, -10357817700.0;
6.389833333333334, -10509395520.0;
6.3965000000000005, -10820972150.0;
6.403166666666667, -10930445020.0;
6.409833333333334, -10602026410.0;
6.416500000000001, -10362028195.0;
6.423166666666667, -10694657300.0;
6.429833333333334, -11351494520.0;
6.4365000000000006, -11667281645.0;
6.443166666666667, -11583071745.0;
6.449833333333334, -11633597685.0;
6.4565, -11507282835.0;
6.463166666666667, -10985181455.0;
6.469833333333334, -10332554730.0;
6.476500000000001, -10117819485.0;
6.483166666666667, -10665183835.0;
6.489833333333334, -11271495115.0;
6.4965, -11629387190.0;
6.503166666666667, -11869385405.0;
6.509833333333334, -12096752135.0;
6.516500000000001, -12387276290.0;
6.5231666666666674, -12362013320.0;
6.529833333333334, -12378855300.0;
6.5365, -12412539260.0;
6.543166666666667, -12467275695.0;
6.549833333333334, -12395697280.0;
6.556500000000001, -12362013320.0;
6.5631666666666675, -12197804015.0;
6.569833333333334, -11949384810.0;
6.5765, -11688334120.0;
6.583166666666667, -11785175505.0;
6.589833333333334, -12273592925.0;
6.596500000000001, -12711484405.0;
6.6031666666666675, -13216743805.0;
6.6098333333333334, -13528320435.0;
6.6165, -13789371125.0;
6.623166666666667, -13873581025.0;
6.629833333333334, -13932527955.0;
6.636500000000001, -14075684785.0;
6.6431666666666676, -14286209535.0;
6.6498333333333335, -14850415865.0;
6.6565, -15536726550.0;
6.663166666666667, -15751461795.0;
6.669833333333334, -15376727740.0;
6.676500000000001, -14993572695.0;
6.683166666666668, -14879889330.0;
6.6898333333333335, -14707259035.0;
6.6965, -14189368150.0;
6.703166666666667, -13797792115.0;
6.709833333333334, -13599898850.0;
6.716500000000001, -13486215485.0;
6.723166666666668, -13136744400.0;
6.729833333333334, -12842009750.0;
6.7365, -12686221435.0;
6.743166666666667, -12551485595.0;
6.749833333333334, -12399907775.0;
6.756500000000001, -11873595900.0;
6.763166666666668, -11368336500.0;
6.769833333333334, -10825182645.0;
6.7765, -10804130170.0;
6.783166666666667, -11069391355.0;
6.789833333333334, -11599913725.0;
6.796500000000001, -12214645995.0;
6.803166666666667, -12976745590.0;
6.809833333333334, -13637793305.0;
6.8165000000000004, -13957790925.0;
6.823166666666667, -14260946565.0;
6.829833333333334, -14197789140.0;
6.836500000000001, -14134631715.0;
6.843166666666667, -13768318650.0;
6.849833333333334, -13330427170.0;
6.8565000000000005, -12686221435.0;
6.863166666666667, -11844122435.0;
6.869833333333334, -11418862440.0;
6.876500000000001, -11389388975.0;
6.883166666666667, -11696755110.0;
6.889833333333334, -12235698470.0;
6.8965000000000005, -13166217865.0;
6.903166666666667, -14269367555.0;
6.909833333333334, -14938836260.0;
6.916500000000001, -14804100420.0;
6.923166666666667, -14096737260.0;
6.929833333333334, -13482004990.0;
6.9365000000000006, -13006219055.0;
6.943166666666667, -12728326385.0;
6.949833333333334, -12842009750.0;
6.956500000000001, -13562004395.0;
6.963166666666667, -14513576265.0;
6.969833333333334, -15111466555.0;
6.976500000000001, -15326201800.0;
6.983166666666667, -15199886950.0;
6.989833333333334, -14879889330.0;
6.9965, -14307262010.0;
7.003166666666667, -14016737855.0;
7.009833333333334, -13890423005.0;
7.016500000000001, -14004106370.0;
7.0231666666666674, -14113579240.0;
7.029833333333334, -14046211320.0;
7.0365, -13860949540.0;
7.043166666666667, -13477794495.0;
7.049833333333334, -13309374695.0;
7.056500000000001, -12934640640.0;
7.0631666666666675, -12762010345.0;
7.069833333333334, -12774641830.0;
7.0765, -13002008560.0;
7.083166666666667, -12846220245.0;
7.089833333333334, -12159909560.0;
7.096500000000001, -11334652540.0;
7.1031666666666675, -10795709180.0;
7.109833333333334, -10353607205.0;
7.1165, -9898873745.0;
7.123166666666667, -9658875530.0;
7.129833333333334, -9932557705.0;
7.136500000000001, -10648341855.0;
7.1431666666666676, -10719920270.0;
7.1498333333333335, -10079925030.0;
7.1565, -9031511775.0;
7.163166666666667, -8614672770.0;
7.169833333333334, -8517831385.0;
7.176500000000001, -8391516535.0;
7.183166666666668, -8319938120.0;
7.1898333333333335, -8825197520.0;
7.1965, -9709401470.0;
7.203166666666667, -10105188000.0;
7.209833333333334, -10020978100.0;
7.216500000000001, -9780979885.0;
7.223166666666668, -9679928005.0;
7.229833333333334, -9671507015.0;
7.2365, -9747295925.0;
7.243166666666667, -9823084835.0;
7.249833333333334, -9743085430.0;
7.256500000000001, -9570455135.0;
7.263166666666668, -9473613750.0;
7.269833333333334, -9372561870.0;
7.2765, -9183089595.0;
7.283166666666667, -9044143260.0;
7.289833333333334, -9157826625.0;
7.296500000000001, -9263089000.0;
7.303166666666668, -9246247020.0;
7.309833333333334, -9115721675.0;
7.3165000000000004, -8985196330.0;
7.323166666666667, -8964143855.0;
7.329833333333334, -8829408015.0;
7.336500000000001, -8888354945.0;
7.343166666666667, -9039932765.0;
7.349833333333334, -9229405040.0;
7.3565000000000005, -9402035335.0;
7.363166666666667, -9608349590.0;
7.369833333333334, -9844137310.0;
7.376500000000001, -9936768200.0;
7.383166666666667, -9911505230.0;
7.389833333333334, -9743085430.0;
7.3965000000000005, -9448350780.0;
7.403166666666667, -8980985835.0;
7.409833333333334, -8900986430.0;
7.416500000000001, -9187300090.0;
7.423166666666667, -9587297115.0;
7.429833333333334, -9709401470.0;
7.4365000000000006, -9730453945.0;
7.443166666666667, -9700980480.0;
7.449833333333334, -9423087810.0;
7.456500000000001, -8724145640.0;
7.463166666666667, -7886257135.0;
7.469833333333334, -7511523080.0;
7.476500000000001, -7486260110.0;
7.483166666666667, -7814678720.0;
7.489833333333334, -7894678125.0;
7.496500000000001, -8075729410.0;
7.503166666666667, -8467305445.0;
7.509833333333334, -9082037715.0;
7.516500000000001, -9654665035.0;
7.5231666666666674, -9827295330.0;
7.529833333333334, -10071504040.0;
7.5365, -10450448590.0;
7.543166666666667, -10997812940.0;
7.549833333333334, -11376757490.0;
7.556500000000001, -11810438475.0;
7.5631666666666675, -12088331145.0;
7.569833333333334, -12218856490.0;
7.5765, -11911490355.0;
7.583166666666667, -11435704420.0;
7.589833333333334, -10568342450.0;
7.596500000000001, -9667296520.0;
7.6031666666666675, -9136774150.0;
7.609833333333334, -9225194545.0;
7.6165, -9789400875.0;
7.623166666666667, -10168345425.0;
7.629833333333334, -10534658490.0;
7.636500000000001, -10589394925.0;
7.6431666666666676, -10686236310.0;
7.649833333333334, -10425185620.0;
7.6565, -10088346020.0;
7.663166666666667, -9898873745.0;
7.669833333333334, -10092556515.0;
7.676500000000001, -10450448590.0;
7.683166666666668, -10500974530.0;
7.6898333333333335, -10412554135.0;
7.6965, -10404133145.0;
7.703166666666667, -10345186215.0;
7.709833333333334, -10020978100.0;
7.716500000000001, -9844137310.0;
7.723166666666668, -9835716320.0;
7.729833333333334, -9730453945.0;
7.7365, -9258878505.0;
7.743166666666667, -8905196925.0;
7.749833333333334, -8858881480.0;
7.756500000000001, -8488357920.0;
7.763166666666668, -8020992975.0;
7.769833333333334, -7646258920.0;
7.7765, -7414681695.0;
7.783166666666667, -6854685860.0;
7.789833333333334, -6210480125.0;
7.796500000000001, -5907324485.0;
7.803166666666668, -5738904685.0;
7.809833333333334, -5524169440.0;
7.8165000000000004, -5263118750.0;
7.823166666666667, -5250487265.0;
7.829833333333334, -5035752020.0;
7.836500000000001, -4665228460.0;
7.843166666666668, -4282073415.0;
7.849833333333334, -4399967275.0;
7.8565000000000005, -5006278555.0;
7.863166666666667, -5397854590.0;
7.869833333333334, -5461012015.0;
7.876500000000001, -5212592810.0;
7.883166666666667, -5132593405.0;
7.889833333333334, -4846279745.0;
7.8965000000000005, -4408388265.0;
7.903166666666667, -4210495000.0;
7.909833333333334, -4437861730.0;
7.916500000000001, -4576808065.0;
7.923166666666667, -4143127080.0;
7.929833333333334, -3326291050.0;
7.9365000000000006, -2437876605.0;
7.943166666666667, -1688408495.0;
7.949833333333334, -1077886720.0;
7.9565, -1027360780.0;
7.963166666666668, -1237885530.0;
7.969833333333334, -1806302355.0;
7.9765000000000015, -2130510470.0;
7.983166666666667, -2067353045.0;
7.989833333333333, -1705250475.0;
7.996500000000001, -1010518800.0;
8.003166666666667, -875782960.0;
8.009833333333335, -736836625.0;
8.0165, -863151475.0;
8.023166666666667, -1048413255.0;
8.029833333333334, -1435778795.0;
8.0365, -2303140765.0;
8.043166666666668, -2564191455.0;
8.049833333333334, -2479981555.0;
8.0565, -1941038195.0;
8.063166666666667, -1629461565.0;
8.069833333333333, -1444199785.0;
8.076500000000001, -808415040.0;
8.083166666666667, -235787720.0;
8.089833333333335, 71578415.0;
8.0965, -303155640.0;
8.103166666666667, -669468705.0;
8.109833333333334, -981045335.0;
8.1165, -1494725725.0;
8.123166666666668, -2319982745.0;
8.129833333333334, -3359975010.0;
8.1365, -4084180150.0;
8.143166666666668, -4669438955.0;
8.149833333333333, -5178908850.0;
8.156500000000001, -5562063895.0;
8.163166666666667, -5692589240.0;
8.169833333333335, -5494695975.0;
8.1765, -5393644095.0;
8.183166666666667, -5486274985.0;
8.189833333333334, -5397854590.0;
8.1965, -5292592215.0;
8.203166666666668, -5364170630.0;
8.209833333333334, -5873640525.0;
8.2165, -6109428245.0;
8.223166666666668, -5966271415.0;
8.229833333333334, -5856798545.0;
8.236500000000001, -6021007850.0;
8.243166666666667, -6164164680.0;
8.249833333333333, -5873640525.0;
8.2565, -5604168845.0;
8.263166666666667, -5519958945.0;
8.269833333333334, -5414696570.0;
8.2765, -5305223700.0;
8.283166666666668, -5258908255.0;
8.289833333333334, -5528379935.0;
8.2965, -5894693000.0;
8.303166666666668, -6088375770.0;
8.309833333333334, -6332584480.0;
8.316500000000001, -6501004280.0;
8.323166666666667, -6526267250.0;
8.329833333333333, -6168375175.0;
8.336500000000001, -5595747855.0;
8.343166666666667, -5233645285.0;
8.349833333333335, -4888384695.0;
8.3565, -4686280935.0;
8.363166666666668, -4484177175.0;
8.369833333333334, -4522071630.0;
8.3765, -4665228460.0;
8.383166666666668, -4690491430.0;
8.389833333333334, -4661017965.0;
8.396500000000001, -4029443715.0;
8.403166666666667, -3254712635.0;
8.409833333333333, -2294719775.0;
8.416500000000001, -1532620180.0;
8.423166666666667, -1115781175.0;
8.429833333333335, -968413850.0;
8.4365, -1124202165.0;
8.443166666666666, -1254727510.0;
8.449833333333334, -1355779390.0;
8.4565, -1242096025.0;
8.463166666666668, -559995835.0;
8.469833333333334, 189472275.0;
8.476500000000001, 576837815.0;
8.483166666666667, 783152070.0;
8.489833333333333, 1077886720.0;
8.496500000000001, 1494725725.0;
8.503166666666667, 1734723940.0;
8.509833333333335, 2214720370.0;
8.5165, 3086292835.0;
8.523166666666667, 3684183125.0;
8.529833333333334, 3848392430.0;
8.5365, 3726288075.0;
8.543166666666668, 3734709065.0;
8.549833333333334, 3890497380.0;
8.556500000000002, 3852602925.0;
8.563166666666667, 3734709065.0;
8.569833333333333, 3549447285.0;
8.576500000000001, 3061029865.0;
8.583166666666667, 1949459185.0;
8.589833333333335, 277892670.0;
8.5965, -1141044145.0;
8.603166666666667, -1873670275.0;
8.609833333333334, -2227351855.0;
8.6165, -2311561755.0;
8.623166666666668, -2214720370.0;
8.629833333333334, -1999985125.0;
8.6365, -1995774630.0;
8.643166666666668, -2231562350.0;
8.649833333333333, -2559980960.0;
8.656500000000001, -2799979175.0;
8.663166666666667, -3090503330.0;
8.669833333333335, -3250502140.0;
8.6765, -3397869465.0;
8.683166666666667, -3494710850.0;
8.689833333333334, -3541026295.0;
8.6965, -3524184315.0;
8.703166666666668, -3292607090.0;
8.709833333333334, -3157871250.0;
8.7165, -3107345310.0;
8.723166666666668, -3069450855.0;
8.729833333333334, -2968398975.0;
8.736500000000001, -2795768680.0;
8.743166666666667, -2602085910.0;
8.749833333333335, -2492613040.0;
8.7565, -2336824725.0;
8.763166666666667, -2467350070.0;
8.769833333333334, -2724190265.0;
8.7765, -3330501545.0;
8.783166666666668, -3545236790.0;
8.789833333333334, -3191555210.0;
8.7965, -2458929080.0;
8.803166666666668, -1903143740.0;
8.809833333333334, -1713671465.0;
8.816500000000001, -1343147905.0;
8.823166666666667, -1406305330.0;
8.829833333333333, -1705250475.0;
8.836500000000001, -2639980365.0;
8.843166666666667, -3469447880.0;
8.849833333333335, -4079969655.0;
8.8565, -4425230245.0;
8.863166666666668, -4543124105.0;
8.869833333333334, -4762069845.0;
8.8765, -4711543905.0;
8.883166666666668, -4151548070.0;
8.889833333333334, -3322080555.0;
8.896500000000001, -2741032245.0;
8.903166666666667, -2698927295.0;
8.909833333333333, -2892610065.0;
8.916500000000001, -2858926105.0;
8.923166666666667, -2795768680.0;
8.929833333333335, -2496823535.0;
8.9365, -2357877200.0;
8.943166666666666, -2261035815.0;
8.949833333333334, -2155773440.0;
8.9565, -1966301165.0;
8.963166666666668, -1970511660.0;
8.969833333333334, -2256825320.0;
8.976500000000001, -2332614230.0;
8.983166666666667, -1751565920.0;
8.989833333333333, -837888505.0;
8.996500000000001, -176840790.0;
9.003166666666667, 58946930.0;
9.009833333333335, -4210495.0;
9.0165, -555785340.0;
9.023166666666667, -1431568300.0;
9.029833333333334, -2353666705.0;
9.0365, -2648401355.0;
9.043166666666668, -2387350665.0;
9.049833333333334, -1915775225.0;
9.056500000000002, -1334726915.0;
9.063166666666667, -728415635.0;
9.069833333333333, -290524155.0;
9.076500000000001, -522101380.0;
9.083166666666667, -1031571275.0;
9.089833333333335, -1444199785.0;
9.0965, -1507357210.0;
9.103166666666667, -1536830675.0;
9.109833333333334, -1679987505.0;
9.1165, -1869459780.0;
9.123166666666668, -2122089480.0;
9.129833333333334, -2370508685.0;
9.1365, -2555770465.0;
9.143166666666668, -2711558780.0;
9.149833333333333, -2454718585.0;
9.156500000000001, -1932617205.0;
9.163166666666667, -1267358995.0;
9.169833333333335, -812625535.0;
9.1765, -538943360.0;
9.183166666666667, -517890885.0;
9.189833333333334, -778941575.0;
9.1965, -1216833055.0;
9.203166666666668, -1364200380.0;
9.209833333333334, -1006308305.0;
9.2165, -522101380.0;
9.223166666666668, 105262375.0;
9.229833333333334, 618942765.0;
9.236500000000001, 1208412065.0;
9.243166666666667, 1519988695.0;
9.249833333333335, 1633672060.0;
9.2565, 1679987505.0;
9.263166666666667, 1658935030.0;
9.269833333333334, 1663145525.0;
9.2765, 1482094240.0;
9.283166666666668, 1503146715.0;
9.289833333333334, 1553672655.0;
9.2965, 1722092455.0;
9.303166666666668, 2092616015.0;
9.309833333333334, 2656822345.0;
9.316500000000001, 3389448475.0;
9.323166666666667, 3983128270.0;
9.329833333333333, 4635754995.0;
9.336500000000001, 5347328650.0;
9.343166666666667, 5823114585.0;
9.349833333333335, 5936797950.0;
9.3565, 5932587455.0;
9.363166666666668, 5831535575.0;
9.369833333333334, 5494695975.0;
9.3765, 5077856970.0;
9.383166666666668, 4724175390.0;
9.389833333333334, 4387335790.0;
9.396500000000001, 3882076390.0;
9.403166666666667, 3393658970.0;
9.409833333333333, 3145239765.0;
9.416500000000001, 2833663135.0;
9.423166666666667, 2534717990.0;
9.429833333333335, 2501034030.0;
9.4365, 2593664920.0;
9.443166666666668, 2606296405.0;
9.449833333333334, 2298930270.0;
9.4565, 2294719775.0;
9.463166666666668, 2606296405.0;
9.469833333333334, 2938925510.0;
9.476500000000001, 3061029865.0;
9.483166666666667, 3065240360.0;
9.489833333333333, 3477868870.0;
9.496500000000001, 3835760945.0;
9.503166666666667, 4050496190.0;
9.509833333333335, 3966286290.0;
9.5165, 3818918965.0;
9.523166666666667, 3806287480.0;
9.529833333333334, 3722077580.0;
9.5365, 3646288670.0;
9.543166666666668, 3444184910.0;
9.549833333333334, 3469447880.0;
9.556500000000002, 3911549855.0;
9.563166666666667, 4370493810.0;
9.569833333333333, 4522071630.0;
9.576500000000001, 4303125890.0;
9.583166666666667, 4151548070.0;
9.589833333333335, 3776814015.0;
9.5965, 3402079960.0;
9.603166666666667, 3389448475.0;
9.609833333333334, 3671551640.0;
9.6165, 4261020940.0;
9.623166666666668, 4576808065.0;
9.629833333333334, 5225224295.0;
9.636500000000002, 6021007850.0;
9.643166666666668, 6762054970.0;
9.649833333333333, 7162051995.0;
9.656500000000001, 7103105065.0;
9.663166666666667, 6858896355.0;
9.669833333333335, 6458899330.0;
9.6765, 5768378150.0;
9.683166666666667, 5073646475.0;
9.689833333333334, 4842069250.0;
9.6965, 4964173605.0;
9.703166666666668, 5343118155.0;
9.709833333333334, 5709431220.0;
9.7165, 6159954185.0;
9.723166666666668, 6298900520.0;
9.729833333333334, 5919955970.0;
9.736500000000001, 5170487860.0;
9.743166666666667, 4395756780.0;
9.749833333333335, 3797866490.0;
9.7565, 3461026890.0;
9.763166666666667, 3444184910.0;
9.769833333333334, 3524184315.0;
9.7765, 3844181935.0;
9.783166666666668, 4391546285.0;
9.789833333333334, 4917858160.0;
9.7965, 4955752615.0;
9.803166666666668, 4690491430.0;
9.809833333333334, 4471545690.0;
9.816500000000001, 4450493215.0;
9.823166666666667, 4218915990.0;
9.829833333333335, 3945233815.0;
9.836500000000001, 4046285695.0;
9.843166666666667, 4286283910.0;
9.849833333333335, 4728385885.0;
9.8565, 5225224295.0;
9.863166666666668, 6084165275.0;
9.869833333333334, 6829422890.0;
9.8765, 7208367440.0;
9.883166666666668, 7469418130.0;
9.889833333333334, 7654679910.0;
9.896500000000001, 7751521295.0;
9.903166666666667, 7570470010.0;
9.909833333333333, 7427313180.0;
9.916500000000001, 7250472390.0;
9.923166666666667, 6821001900.0;
9.929833333333335, 6214690620.0;
9.9365, 5372591620.0;
9.943166666666668, 4572597570.0;
9.949833333333334, 3915760350.0;
9.9565, 3751551045.0;
9.963166666666668, 4037864705.0;
9.969833333333334, 4362072820.0;
9.976500000000001, 4644175985.0;
9.983166666666667, 4959963110.0;
9.989833333333333, 5166277365.0;
9.996500000000001, 5178908850.0;
10.003166666666667, 5284171225.0;
10.009833333333335, 5490485480.0;
10.0165, 5852588050.0;
10.023166666666667, 5827325080.0;
10.029833333333334, 5806272605.0;
10.0365, 5987323890.0;
10.043166666666668, 6248374580.0;
10.049833333333334, 6362057945.0;
10.056500000000002, 6282058540.0;
10.063166666666667, 6412583885.0;
10.069833333333333, 6589424675.0;
10.076500000000001, 6530477745.0;
10.083166666666667, 5915745475.0;
10.089833333333335, 5221013800.0;
10.0965, 4837858755.0;
10.103166666666667, 4926279150.0;
10.109833333333334, 5250487265.0;
10.1165, 5397854590.0;
10.123166666666668, 5402065085.0;
10.129833333333334, 5322065680.0;
10.136500000000002, 5039962515.0;
10.143166666666668, 4884174200.0;
10.149833333333333, 4606281530.0;
10.156500000000001, 4547334600.0;
10.163166666666667, 4618913015.0;
10.169833333333335, 5119961920.0;
10.1765, 5755746665.0;
10.183166666666667, 6088375770.0;
10.189833333333334, 6357847450.0;
10.1965, 6501004280.0;
10.203166666666668, 6842054375.0;
10.209833333333334, 6959948235.0;
10.2165, 7048368630.0;
10.223166666666668, 6947316750.0;
10.229833333333334, 6791528435.0;
10.236500000000001, 6774686455.0;
10.243166666666667, 6808370415.0;
10.249833333333335, 6972579720.0;
10.2565, 7132578530.0;
10.263166666666667, 7195735955.0;
10.269833333333334, 7086263085.0;
10.2765, 6981000710.0;
10.283166666666668, 7208367440.0;
10.289833333333334, 7810468225.0;
10.2965, 8256780695.0;
10.303166666666668, 8740987620.0;
10.309833333333334, 9212563060.0;
10.316500000000001, 9789400875.0;
10.323166666666667, 9856768795.0;
10.329833333333335, 9250457515.0;
10.336500000000001, 8635725245.0;
10.343166666666667, 8282043665.0;
10.349833333333335, 8265201685.0;
10.3565, 8029413965.0;
10.363166666666668, 7734679315.0;
10.369833333333334, 7427313180.0;
10.3765, 7469418130.0;
10.383166666666668, 7536786050.0;
10.389833333333334, 7511523080.0;
10.396500000000001, 7343103280.0;
10.403166666666667, 7490470605.0;
10.409833333333333, 8176781290.0;
10.416500000000001, 8732566630.0;
10.423166666666667, 9060985240.0;
10.429833333333335, 9162037120.0;
10.4365, 9494666225.0;
10.443166666666668, 9869400280.0;
10.449833333333334, 10079925030.0;
10.4565, 10185187405.0;
10.463166666666668, 10256765820.0;
10.469833333333334, 10437817105.0;
10.476500000000001, 10778867200.0;
10.483166666666667, 11065180860.0;
10.489833333333333, 11317810560.0;
10.496500000000001, 11410441450.0;
10.503166666666667, 11557808775.0;
10.509833333333335, 11688334120.0;
10.5165, 11802017485.0;
10.523166666666668, 12113594115.0;
10.529833333333334, 12488328170.0;
10.5365, 13052534500.0;
10.543166666666668, 13738845185.0;
10.549833333333334, 14391471910.0;
10.556500000000002, 14749363985.0;
10.563166666666667, 14774626955.0;
10.569833333333333, 14947257250.0;
10.576500000000001, 15578831500.0;
10.583166666666667, 16223037235.0;
10.589833333333335, 16783033070.0;
10.5965, 17254608510.0;
10.603166666666667, 17654605535.0;
10.609833333333334, 18105128500.0;
10.6165, 18206180380.0;
10.623166666666668, 17848288305.0;
10.629833333333334, 17271450490.0;
10.636500000000002, 16896716435.0;
10.643166666666668, 17010399800.0;
10.649833333333333, 16934610890.0;
10.656500000000001, 16580929310.0;
10.663166666666667, 16349352085.0;
10.669833333333335, 16475666935.0;
10.6765, 16707244160.0;
10.683166666666667, 16736717625.0;
10.689833333333334, 16543034855.0;
10.6965, 16484087925.0;
10.703166666666668, 16761980595.0;
10.709833333333334, 16875663960.0;
10.716500000000002, 16833559010.0;
10.723166666666668, 16669349705.0;
10.729833333333334, 16656718220.0;
10.736500000000001, 16879874455.0;
10.743166666666667, 17225135045.0;
10.749833333333335, 17806183355.0;
10.7565, 18079865530.0;
10.763166666666667, 18180917410.0;
10.769833333333334, 18412494635.0;
10.7765, 18930385520.0;
10.783166666666668, 18863017600.0;
10.789833333333334, 18345126715.0;
10.7965, 18105128500.0;
10.803166666666668, 18235653845.0;
10.809833333333334, 18121970480.0;
10.816500000000001, 17317765935.0;
10.823166666666667, 17119872670.0;
10.829833333333335, 17755657415.0;
10.836500000000001, 18681966315.0;
10.843166666666667, 19170383735.0;
10.849833333333335, 19612485710.0;
10.8565, 20109324120.0;
10.863166666666668, 20277743920.0;
10.869833333333334, 19903009865.0;
10.8765, 19448276405.0;
10.883166666666668, 19675643135.0;
10.889833333333334, 20227217980.0;
10.896500000000001, 21023001535.0;
10.903166666666667, 21768259150.0;
10.909833333333335, 22387201915.0;
10.916500000000001, 22947197750.0;
10.923166666666667, 22997723690.0;
10.929833333333335, 22719831020.0;
10.9365, 22307202510.0;
10.943166666666668, 22193519145.0;
10.949833333333334, 22606147655.0;
10.9565, 22879829830.0;
10.963166666666668, 22833514385.0;
10.969833333333334, 22639831615.0;
10.976500000000001, 22509306270.0;
10.983166666666667, 22117730235.0;
10.989833333333333, 21431419550.0;
10.996500000000001, 20711424905.0;
11.003166666666667, 20500900155.0;
11.009833333333335, 20711424905.0;
11.0165, 20791424310.0;
11.023166666666668, 20753529855.0;
11.029833333333334, 20088271645.0;
11.0365, 19330382545.0;
11.043166666666668, 18155654440.0;
11.049833333333334, 16774612080.0;
11.056500000000002, 15439885165.0;
11.063166666666667, 14328314485.0;
11.069833333333333, 14029369340.0;
11.076500000000001, 13983053895.0;
11.083166666666667, 14336735475.0;
11.089833333333335, 14783047945.0;
11.0965, 15456727145.0;
11.103166666666667, 16088301395.0;
11.109833333333334, 16437772480.0;
11.1165, 16429351490.0;
11.123166666666668, 16235668720.0;
11.129833333333334, 15991460010.0;
11.136500000000002, 15831461200.0;
11.143166666666668, 15987249515.0;
11.149833333333333, 16336720600.0;
11.156500000000001, 17031452275.0;
11.163166666666667, 17616711080.0;
11.169833333333335, 18235653845.0;
11.1765, 18825123145.0;
11.183166666666667, 19372487495.0;
11.189833333333334, 19663011650.0;
11.1965, 19814589470.0;
11.203166666666668, 20138797585.0;
11.209833333333334, 20370374810.0;
11.216500000000002, 20231428475.0;
11.223166666666668, 19945114815.0;
11.229833333333334, 20054587685.0;
11.236500000000001, 20201955010.0;
11.243166666666667, 20277743920.0;
11.249833333333335, 20665109460.0;
11.2565, 21561944895.0;
11.263166666666667, 22391412410.0;
11.269833333333334, 22955618740.0;
11.2765, 23822980710.0;
11.283166666666668, 24816657530.0;
11.289833333333334, 25418758315.0;
11.2965, 25469284255.0;
11.303166666666668, 25444021285.0;
11.309833333333334, 25355600890.0;
11.316500000000001, 24829289015.0;
11.323166666666667, 24126136350.0;
11.329833333333335, 23536667050.0;
11.336500000000001, 23275616360.0;
11.343166666666667, 22934566265.0;
11.349833333333335, 22492464290.0;
11.3565, 21932468455.0;
11.363166666666668, 21279841730.0;
11.369833333333334, 20513531640.0;
11.3765, 19469328880.0;
11.383166666666668, 18681966315.0;
11.389833333333334, 18159864935.0;
11.396500000000001, 18058813055.0;
11.403166666666667, 18016708105.0;
11.409833333333335, 18004076620.0;
11.416500000000001, 18151443945.0;
11.423166666666667, 18277758795.0;
11.429833333333335, 18260916815.0;
11.4365, 18100918005.0;
11.443166666666668, 18218811865.0;
11.449833333333334, 18559861960.0;
11.4565, 19258804130.0;
11.463166666666668, 20159850060.0;
11.469833333333334, 21393525095.0;
11.476500000000001, 23288247845.0;
11.483166666666667, 25675598510.0;
11.489833333333333, 28559787585.0;
11.496500000000001, 31477660620.0;
11.503166666666667, 34614479395.0;
11.509833333333335, 38024980345.0;
11.5165, 41199693575.0;
11.523166666666668, 44256512945.0;
11.529833333333334, 47418594690.0;
11.5365, 50875411085.0;
11.543166666666668, 54509068270.0;
11.549833333333334, 58210093375.0;
11.556500000000002, 62193221645.0;
11.563166666666667, 66306875260.0;
11.569833333333333, 70260530065.0;
11.576500000000001, 74306815760.0;
11.583166666666667, 78555205215.0;
11.589833333333335, 82849910115.0;
11.5965, 86496198785.0;
11.603166666666668, 89308809445.0;
11.609833333333334, 91590897735.0;
11.6165, 93607724840.0;
11.623166666666668, 95611920460.0;
11.629833333333334, 97628747565.0;
11.636500000000002, 100083466150.0;
11.643166666666668, 103026602155.0;
11.649833333333333, 106125526475.0;
11.656500000000001, 108470772190.0;
11.663166666666667, 108500245655.0;
11.669833333333335, 105531846680.0;
11.6765, 99161367745.0;
11.683166666666667, 89851963300.0;
11.689833333333334, 78264681060.0;
11.6965, 65650038040.0;
11.703166666666668, 53460655015.0;
11.709833333333334, 42803892170.0;
11.716500000000002, 34454480585.0;
11.723166666666668, 28210316500.0;
11.729833333333334, 23898769620.0;
11.736500000000001, 20863002725.0;
11.743166666666667, 19056700370.0;
11.749833333333335, 17999866125.0;
11.7565, 17625132070.0;
11.763166666666667, 17860919790.0;
11.769833333333334, 18248285330.0;
11.7765, 18585124930.0;
11.783166666666668, 18736702750.0;
11.789833333333334, 18989332450.0;
11.796500000000002, 19208278190.0;
11.803166666666668, 19090384330.0;
11.809833333333334, 18715650275.0;
11.816500000000001, 18298811270.0;
11.823166666666667, 17987234640.0;
11.829833333333335, 17646184545.0;
11.836500000000001, 17300923955.0;
11.843166666666667, 17065136235.0;
11.849833333333335, 17077767720.0;
11.8565, 17385133855.0;
11.863166666666668, 17764078405.0;
11.869833333333334, 18164075430.0;
11.8765, 18593545920.0;
11.883166666666668, 19216699180.0;
11.889833333333334, 19759853035.0;
11.896500000000001, 19924062340.0;
11.903166666666667, 19839852440.0;
11.909833333333335, 20168271050.0;
11.916500000000001, 20593531045.0;
11.923166666666667, 20892476190.0;
11.929833333333335, 20938791635.0;
11.9365, 20858792230.0;
11.943166666666668, 20547215600.0;
11.949833333333334, 19865115410.0;
11.9565, 19574591255.0;
11.963166666666668, 19738800560.0;
11.969833333333334, 20029324715.0;
11.976500000000001, 20281954415.0;
11.983166666666667, 20799845300.0;
11.989833333333335, 21305104700.0;
11.996500000000001, 21216684305.0;
12.003166666666667, 20837739755.0;
12.009833333333335, 20631425500.0;
12.0165, 20972475595.0;
12.023166666666668, 21355630640.0;
12.029833333333334, 21789311625.0;
12.0365, 21818785090.0;
12.043166666666668, 21599839350.0;
12.049833333333334, 21149316385.0;
12.056500000000002, 20555636590.0;
12.063166666666667, 19583012245.0;
12.069833333333333, 18315653250.0;
12.076500000000001, 17456712270.0;
12.083166666666667, 17069346730.0;
12.089833333333335, 17326186925.0;
12.0965, 17789341375.0;
12.103166666666668, 18732492255.0;
12.109833333333334, 19903009865.0;
12.1165, 21124053415.0;
12.123166666666668, 21810364100.0;
12.129833333333334, 21974573405.0;
12.136500000000002, 21835627070.0;
12.143166666666668, 21759838160.0;
12.149833333333333, 21486155985.0;
12.156500000000001, 21170368860.0;
12.163166666666667, 20863002725.0;
12.169833333333335, 20618794015.0;
12.1765, 20538794610.0;
12.183166666666667, 20260901940.0;
12.189833333333334, 19873536400.0;
12.1965, 19439855415.0;
12.203166666666668, 19359856010.0;
12.209833333333334, 19528275810.0;
12.216500000000002, 19574591255.0;
12.223166666666668, 19650380165.0;
12.229833333333334, 20138797585.0;
12.236500000000001, 20745108865.0;
12.243166666666667, 21161947870.0;
12.249833333333335, 21288262720.0;
12.2565, 21086158960.0;
12.263166666666667, 20841950250.0;
12.269833333333334, 20319848870.0;
12.2765, 19903009865.0;
12.283166666666668, 19620906700.0;
12.289833333333334, 19667222145.0;
12.296500000000002, 20134587090.0;
12.303166666666668, 20610373025.0;
12.309833333333334, 21031422525.0;
12.316500000000001, 21284052225.0;
12.323166666666667, 21275631235.0;
12.329833333333335, 20997738565.0;
12.336500000000001, 20858792230.0;
12.343166666666667, 20791424310.0;
12.349833333333335, 20711424905.0;
12.3565, 20374585305.0;
12.363166666666668, 20311427880.0;
12.369833333333334, 20686161935.0;
12.3765, 20867213220.0;
12.383166666666668, 20909318170.0;
12.389833333333334, 20951423120.0;
12.396500000000001, 21300894205.0;
12.403166666666667, 21561944895.0;
12.409833333333335, 21368262125.0;
12.416500000000001, 21035633020.0;
12.423166666666667, 21094579950.0;
12.429833333333335, 21393525095.0;
12.4365, 21755627665.0;
12.443166666666668, 21599839350.0;
12.449833333333334, 21233526285.0;
12.4565, 20905107675.0;
12.463166666666668, 20319848870.0;
12.469833333333334, 19532486305.0;
12.476500000000001, 18787228690.0;
12.483166666666667, 18905122550.0;
12.489833333333335, 19561959770.0;
12.496500000000001, 20079850655.0;
12.503166666666667, 20176692040.0;
12.509833333333335, 20294585900.0;
12.5165, 20429321740.0;
12.523166666666668, 20496689660.0;
12.529833333333334, 20496689660.0;
12.5365, 20934581140.0;
12.543166666666668, 22041941325.0;
12.549833333333334, 23098775570.0;
12.556500000000002, 23890348630.0;
12.563166666666667, 24041926450.0;
12.569833333333333, 23721928830.0;
12.576500000000001, 23111407055.0;
12.583166666666667, 22319833995.0;
12.589833333333335, 21911415980.0;
12.5965, 21465103510.0;
12.603166666666668, 21507208460.0;
12.609833333333334, 21726154200.0;
12.6165, 21995625880.0;
12.623166666666668, 22117730235.0;
12.629833333333334, 22117730235.0;
12.636500000000002, 22319833995.0;
12.643166666666668, 22105098750.0;
12.649833333333333, 21890363505.0;
12.656500000000001, 21801943110.0;
12.663166666666667, 22155624690.0;
12.669833333333335, 22387201915.0;
12.6765, 22694568050.0;
12.683166666666668, 23355615765.0;
12.689833333333334, 24151399320.0;
12.6965, 24774552580.0;
12.703166666666668, 24681921690.0;
12.709833333333334, 24618764265.0;
12.716500000000002, 24130346845.0;
12.723166666666668, 23797717740.0;
12.729833333333334, 23422983685.0;
12.736500000000001, 23220879925.0;
12.743166666666667, 22993513195.0;
12.749833333333335, 22576674190.0;
12.7565, 22568253200.0;
12.763166666666667, 22395622905.0;
12.769833333333334, 22210361125.0;
12.7765, 21452472025.0;
12.783166666666668, 20993528070.0;
12.789833333333334, 20698793420.0;
12.796500000000002, 20378795800.0;
12.803166666666668, 20025114220.0;
12.809833333333334, 19768274025.0;
12.816500000000001, 20273533425.0;
12.823166666666667, 20614583520.0;
12.829833333333335, 20576689065.0;
12.836500000000001, 20214586495.0;
12.843166666666667, 19957746300.0;
12.849833333333335, 19709327095.0;
12.8565, 19410381950.0;
12.863166666666668, 19330382545.0;
12.869833333333334, 19519854820.0;
12.876500000000002, 19700906105.0;
12.883166666666668, 19692485115.0;
12.889833333333334, 19709327095.0;
12.896500000000001, 19477749870.0;
12.903166666666667, 19330382545.0;
12.909833333333335, 19204067695.0;
12.916500000000001, 19086173835.0;
12.923166666666667, 18509336020.0;
12.929833333333335, 17650395040.0;
12.9365, 16837769505.0;
12.943166666666668, 16071459415.0;
12.949833333333334, 15216728930.0;
12.9565, 14500944780.0;
12.963166666666668, 14378840425.0;
12.969833333333334, 14673575075.0;
12.976500000000001, 14968309725.0;
12.983166666666667, 15069361605.0;
12.989833333333335, 15372517245.0;
12.996500000000001, 15671462390.0;
13.003166666666667, 15957776050.0;
13.009833333333335, 15961986545.0;
13.0165, 16201984760.0;
13.023166666666668, 16707244160.0;
13.029833333333334, 17174609105.0;
13.0365, 17625132070.0;
13.043166666666668, 17528290685.0;
13.049833333333334, 17098820195.0;
13.056500000000002, 16281984165.0;
13.063166666666667, 15321991305.0;
13.069833333333335, 14614628145.0;
13.076500000000001, 14227262605.0;
13.083166666666667, 14328314485.0;
13.089833333333335, 14559891710.0;
13.0965, 14749363985.0;
13.103166666666668, 14871468340.0;
13.109833333333334, 14943046755.0;
13.1165, 14875678835.0;
13.123166666666668, 14614628145.0;
13.129833333333334, 14383050920.0;
13.136500000000002, 14193578645.0;
13.143166666666668, 13924106965.0;
13.149833333333333, 13465163010.0;
13.156500000000001, 12905167175.0;
13.163166666666667, 12724115890.0;
13.169833333333335, 12656747970.0;
13.1765, 12804115295.0;
13.183166666666668, 13077797470.0;
13.189833333333334, 13317795685.0;
13.1965, 13279901230.0;
13.203166666666668, 13212533310.0;
13.209833333333334, 13524109940.0;
13.216500000000002, 13869370530.0;
13.223166666666668, 13705161225.0;
13.229833333333334, 13540951920.0;
13.236500000000001, 13764108155.0;
13.243166666666667, 13806213105.0;
13.249833333333335, 13326216675.0;
13.2565, 12627274505.0;
13.263166666666667, 12256750945.0;
13.269833333333334, 11785175505.0;
13.2765, 11284126600.0;
13.283166666666668, 11246232145.0;
13.289833333333334, 11738860060.0;
13.296500000000002, 12420960250.0;
13.303166666666668, 12863062225.0;
13.309833333333334, 13271480240.0;
13.316500000000001, 13797792115.0;
13.323166666666667, 14058842805.0;
13.329833333333335, 13978843400.0;
13.336500000000001, 13574635880.0;
13.343166666666667, 13427268555.0;
13.349833333333335, 13267269745.0;
13.3565, 12884114700.0;
13.363166666666668, 12387276290.0;
13.369833333333334, 11936753325.0;
13.376500000000002, 11730439070.0;
13.383166666666668, 11477809370.0;
13.389833333333334, 11515703825.0;
13.396500000000001, 11654650160.0;
13.403166666666667, 11667281645.0;
13.409833333333335, 11486230360.0;
13.416500000000001, 11220969175.0;
13.423166666666667, 11355705015.0;
13.429833333333335, 11477809370.0;
13.4365, 11637808180.0;
13.443166666666668, 11999910750.0;
13.449833333333334, 12534643615.0;
13.4565, 12846220245.0;
13.463166666666668, 12719905395.0;
13.469833333333334, 12820957275.0;
13.476500000000001, 13414637070.0;
13.483166666666667, 13949369935.0;
13.489833333333335, 14223052110.0;
13.496500000000001, 14593575670.0;
13.503166666666667, 15090414080.0;
13.509833333333335, 15284096850.0;
13.5165, 14804100420.0;
13.523166666666668, 14176736665.0;
13.529833333333334, 13810423600.0;
13.5365, 13730424195.0;
13.543166666666668, 13696740235.0;
13.549833333333334, 13486215485.0;
13.556500000000002, 13157796875.0;
13.563166666666667, 12888325195.0;
13.569833333333335, 12833588760.0;
13.576500000000001, 13044113510.0;
13.583166666666667, 13439900040.0;
13.589833333333335, 13797792115.0;
13.5965, 13919896470.0;
13.603166666666668, 13962001420.0;
13.609833333333334, 13620951325.0;
13.6165, 13035692520.0;
13.623166666666668, 12340960845.0;
13.629833333333334, 12050436690.0;
13.636500000000002, 12353592330.0;
13.643166666666668, 12905167175.0;
13.649833333333333, 13620951325.0;
13.656500000000001, 14071474290.0;
13.663166666666667, 14113579240.0;
13.669833333333335, 13991474885.0;
13.6765, 13688319245.0;
13.683166666666668, 13044113510.0;
13.689833333333334, 12218856490.0;
13.6965, 11734649565.0;
13.703166666666668, 11764123030.0;
13.709833333333334, 11663071150.0;
13.716500000000002, 11536756300.0;
13.723166666666668, 11633597685.0;
13.729833333333334, 11852543425.0;
13.736500000000001, 11768333525.0;
13.743166666666667, 11271495115.0;
13.749833333333335, 10669394330.0;
13.7565, 10138871960.0;
13.763166666666669, 10100977505.0;
13.769833333333334, 10332554730.0;
13.7765, 10648341855.0;
13.783166666666668, 10926234525.0;
13.789833333333334, 11267284620.0;
13.796500000000002, 11764123030.0;
13.803166666666668, 11924121840.0;
13.809833333333334, 12100962630.0;
13.816500000000001, 12214645995.0;
13.823166666666667, 12547275100.0;
13.829833333333335, 13060955490.0;
13.836500000000001, 13233585785.0;
13.843166666666667, 12724115890.0;
13.849833333333335, 11545177290.0;
13.8565, 10627289380.0;
13.863166666666668, 9869400280.0;
13.869833333333334, 9220984050.0;
13.876500000000002, 8665198710.0;
13.883166666666668, 8808355540.0;
13.889833333333334, 9519929195.0;
13.896500000000001, 10231502850.0;
13.903166666666667, 10724130765.0;
13.909833333333335, 10976760465.0;
13.916500000000001, 11330442045.0;
13.923166666666667, 11503072340.0;
13.929833333333335, 11772544020.0;
13.9365, 11886227385.0;
13.943166666666668, 12109383620.0;
13.949833333333334, 12176751540.0;
13.956500000000002, 12063068175.0;
13.963166666666668, 12037805205.0;
13.969833333333334, 11966226790.0;
13.976500000000001, 11945174315.0;
13.983166666666667, 11852543425.0;
13.989833333333335, 11730439070.0;
13.996500000000001, 11557808775.0;
14.003166666666667, 11254653135.0;
14.009833333333335, 11002023435.0;
14.0165, 10774656705.0;
14.023166666666668, 10745183240.0;
14.029833333333334, 11010444425.0;
14.0365, 11802017485.0;
14.043166666666668, 12458854705.0;
14.049833333333334, 12639905990.0;
14.056500000000002, 12580959060.0;
14.063166666666667, 12530433120.0;
14.069833333333335, 12517801635.0;
14.076500000000001, 11886227385.0;
14.083166666666667, 11246232145.0;
14.089833333333335, 11077812345.0;
14.0965, 11322021055.0;
14.103166666666668, 11557808775.0;
14.109833333333334, 11313600065.0;
14.1165, 11275705610.0;
14.123166666666668, 11309389570.0;
14.129833333333334, 11309389570.0;
14.136500000000002, 10858866605.0;
14.143166666666668, 10311502255.0;
14.149833333333333, 10197818890.0;
14.156500000000001, 10433606610.0;
14.163166666666667, 10930445020.0;
14.169833333333335, 11056759870.0;
14.1765, 10959918485.0;
14.183166666666668, 10534658490.0;
14.189833333333334, 10159924435.0;
14.1965, 9738874935.0;
14.203166666666668, 9275720485.0;
14.209833333333334, 9044143260.0;
14.216500000000002, 9195721080.0;
14.223166666666668, 9633612560.0;
14.229833333333334, 10328344235.0;
14.236500000000001, 11060970365.0;
14.243166666666667, 11894648375.0;
14.249833333333335, 12513591140.0;
14.2565, 12934640640.0;
14.263166666666669, 13338848160.0;
14.269833333333334, 13402005585.0;
14.2765, 13284111725.0;
14.283166666666668, 12694642425.0;
14.289833333333334, 12126225600.0;
14.296500000000002, 12025173720.0;
14.303166666666668, 12227277480.0;
14.309833333333334, 12669379455.0;
14.316500000000001, 12926219650.0;
14.323166666666667, 13494636475.0;
14.329833333333335, 14033579835.0;
14.336500000000001, 14100947755.0;
14.343166666666667, 13528320435.0;
14.349833333333335, 12711484405.0;
14.3565, 12109383620.0;
14.363166666666668, 11343073530.0;
14.369833333333334, 10783077695.0;
14.376500000000002, 10610447400.0;
14.383166666666668, 11385178480.0;
14.389833333333334, 12260961440.0;
14.396500000000001, 12879904205.0;
14.403166666666667, 13431479050.0;
14.409833333333335, 13844107560.0;
14.416500000000001, 14172526170.0;
14.423166666666667, 13869370530.0;
14.429833333333335, 13414637070.0;
14.4365, 13216743805.0;
14.443166666666668, 13212533310.0;
14.449833333333334, 13267269745.0;
14.456500000000002, 12943061630.0;
14.463166666666668, 12665168960.0;
14.469833333333334, 12513591140.0;
14.476500000000001, 12315697875.0;
14.483166666666667, 12042015700.0;
14.489833333333335, 11692544615.0;
14.496500000000001, 11557808775.0;
14.503166666666667, 11090443830.0;
14.509833333333335, 10808340665.0;
14.5165, 10694657300.0;
14.523166666666668, 11023075910.0;
14.529833333333334, 11557808775.0;
14.5365, 12050436690.0;
14.543166666666668, 12597801040.0;
14.549833333333334, 12534643615.0;
14.556500000000002, 12517801635.0;
14.563166666666667, 12273592925.0;
14.569833333333335, 11966226790.0;
14.576500000000001, 11629387190.0;
14.583166666666667, 11616755705.0;
14.589833333333335, 11999910750.0;
14.5965, 12054647185.0;
14.603166666666668, 11764123030.0;
14.609833333333334, 11153601255.0;
14.6165, 10846235120.0;
14.623166666666668, 10964128980.0;
14.629833333333334, 11364126005.0;
14.636500000000002, 11557808775.0;
14.643166666666668, 11793596495.0;
14.649833333333335, 12349381835.0;
14.656500000000001, 12888325195.0;
14.663166666666667, 12900956680.0;
14.669833333333335, 12420960250.0;
14.6765, 12063068175.0;
14.683166666666668, 11856753920.0;
14.689833333333334, 11671492140.0;
14.6965, 11498861845.0;
14.703166666666668, 11747281050.0;
14.709833333333334, 12159909560.0;
14.716500000000002, 12715694900.0;
14.723166666666668, 13006219055.0;
14.729833333333334, 13439900040.0;
14.736500000000001, 13844107560.0;
14.743166666666667, 13747266175.0;
14.749833333333335, 13629372315.0;
14.7565, 13439900040.0;
14.763166666666669, 13460952515.0;
14.769833333333334, 13027271530.0;
14.7765, 12206225005.0;
14.783166666666668, 11427283430.0;
14.789833333333334, 10602026410.0;
14.796500000000002, 10084135525.0;
14.803166666666668, 9928347210.0;
14.809833333333334, 10218871365.0;
14.816500000000001, 10479922055.0;
14.823166666666667, 10673604825.0;
14.829833333333335, 10896761060.0;
14.836500000000001, 11364126005.0;
14.843166666666669, 11755702040.0;
14.849833333333335, 12223066985.0;
14.8565, 13039903015.0;
14.863166666666668, 14100947755.0;
14.869833333333334, 15216728930.0;
14.876500000000002, 15557779025.0;
14.883166666666668, 15225149920.0;
14.889833333333334, 14441997850.0;
14.896500000000001, 13780950135.0;
14.903166666666667, 13111481430.0;
14.909833333333335, 12576748565.0;
14.916500000000001, 12378855300.0;
14.923166666666667, 12555696090.0;
14.929833333333335, 12635695495.0;
14.9365, 12425170745.0;
14.943166666666668, 12290434905.0;
14.949833333333334, 12063068175.0;
14.956500000000002, 11620966200.0;
14.963166666666668, 11103075315.0;
14.969833333333334, 10778867200.0;
14.976500000000001, 10795709180.0;
14.983166666666667, 10602026410.0;
14.989833333333335, 10332554730.0;
14.996500000000001, 10050451565.0;
15.003166666666667, 9928347210.0;
15.009833333333335, 9991504635.0;
15.0165, 9886242260.0;
15.023166666666668, 9789400875.0;
15.029833333333334, 9738874935.0;
15.036500000000002, 10079925030.0;
15.043166666666668, 10753604230.0;
15.049833333333334, 11599913725.0;
15.056500000000002, 12395697280.0;
15.063166666666667, 12879904205.0;
15.069833333333335, 13136744400.0;
15.076500000000001, 13195691330.0;
15.083166666666667, 13170428360.0;
15.089833333333335, 12875693710.0;
15.0965, 12454644210.0;
15.103166666666668, 12345171340.0;
15.109833333333334, 12391486785.0;
15.1165, 12336750350.0;
15.123166666666668, 11995700255.0;
15.129833333333334, 11486230360.0;
15.136500000000002, 11124127790.0;
15.143166666666668, 10749393735.0;
15.149833333333335, 10391501660.0;
15.156500000000001, 10063083050.0;
15.163166666666667, 9368351375.0;
15.169833333333335, 8934670390.0;
15.1765, 8631514750.0;
15.183166666666668, 8926249400.0;
15.189833333333334, 9187300090.0;
15.1965, 9536771175.0;
15.203166666666668, 10252555325.0;
15.209833333333334, 10854656110.0;
15.216500000000002, 11166232740.0;
15.223166666666668, 10774656705.0;
15.229833333333334, 10366238690.0;
15.236500000000001, 9957820675.0;
15.243166666666667, 9486245235.0;
15.249833333333335, 9300983455.0;
15.2565, 9507297710.0;
15.263166666666669, 9882031765.0;
15.269833333333334, 10210450375.0;
15.2765, 10572552945.0;
15.283166666666668, 11199916700.0;
15.289833333333334, 11793596495.0;
15.296500000000002, 12008331740.0;
15.303166666666668, 12100962630.0;
15.309833333333334, 12185172530.0;
15.316500000000001, 12256750945.0;
15.323166666666667, 12340960845.0;
15.329833333333335, 12197804015.0;
15.336500000000001, 12016752730.0;
15.343166666666669, 11818859465.0;
15.349833333333335, 11700965605.0;
15.3565, 11713597090.0;
15.363166666666668, 11473598875.0;
15.369833333333334, 11187285215.0;
15.376500000000002, 10993602445.0;
15.383166666666668, 10951497495.0;
15.389833333333334, 11309389570.0;
15.396500000000001, 11642018675.0;
15.403166666666667, 11983068770.0;
15.409833333333335, 11856753920.0;
15.416500000000001, 11747281050.0;
15.423166666666667, 11785175505.0;
15.429833333333335, 11574650755.0;
15.4365, 11246232145.0;
15.443166666666668, 10854656110.0;
15.449833333333334, 10905182050.0;
15.456500000000002, 11031496900.0;
15.463166666666668, 11023075910.0;
15.469833333333334, 10812551160.0;
15.476500000000001, 10715709775.0;
15.483166666666667, 10930445020.0;
15.489833333333335, 11536756300.0;
15.496500000000001, 11911490355.0;
15.503166666666667, 11974647780.0;
15.509833333333335, 12075699660.0;
15.5165, 12029384215.0;
15.523166666666668, 11945174315.0;
15.529833333333334, 11486230360.0;
15.536500000000002, 11271495115.0;
15.543166666666668, 11204127195.0;
15.549833333333334, 11267284620.0;
15.556500000000002, 11439914915.0;
15.563166666666667, 11355705015.0;
15.569833333333335, 11406230955.0;
15.576500000000001, 11465177885.0;
15.583166666666667, 11810438475.0;
15.589833333333335, 12164120055.0;
15.5965, 12265171935.0;
15.603166666666668, 12235698470.0;
15.609833333333334, 11966226790.0;
15.6165, 11654650160.0;
15.623166666666668, 11326231550.0;
15.629833333333334, 11027286405.0;
15.636500000000002, 11119917295.0;
15.643166666666668, 11199916700.0;
15.649833333333335, 11187285215.0;
15.656500000000001, 11014654920.0;
15.663166666666667, 10905182050.0;
15.669833333333335, 10770446210.0;
15.6765, 10260976315.0;
15.683166666666668, 10147292950.0;
15.689833333333334, 10383080670.0;
15.6965, 10707288785.0;
15.703166666666668, 10690446805.0;
15.709833333333334, 10703078290.0;
15.716500000000002, 10976760465.0;
15.723166666666668, 10858866605.0;
15.729833333333335, 10698867795.0;
15.736500000000001, 10795709180.0;
15.743166666666667, 11149390760.0;
15.749833333333335, 11338863035.0;
15.7565, 11456756895.0;
15.763166666666669, 12033594710.0;
15.769833333333334, 12471486190.0;
15.7765, 12239908965.0;
15.783166666666668, 11633597685.0;
15.789833333333334, 11136759275.0;
15.796500000000002, 10656762845.0;
15.803166666666668, 10122029980.0;
15.809833333333334, 9764137905.0;
15.816500000000001, 9915715725.0;
15.823166666666667, 10164134930.0;
15.829833333333335, 10307291760.0;
15.836500000000001, 10433606610.0;
15.843166666666669, 10538868985.0;
15.849833333333335, 10656762845.0;
15.8565, 10711499280.0;
15.863166666666668, 10930445020.0;
15.869833333333334, 11002023435.0;
15.876500000000002, 10867287595.0;
15.883166666666668, 10378870175.0;
15.889833333333334, 9974662655.0;
15.896500000000001, 9974662655.0;
15.903166666666667, 10223081860.0;
15.909833333333335, 10576763440.0;
15.916500000000001, 10871498090.0;
15.923166666666669, 11077812345.0;
15.929833333333335, 10938866010.0;
15.9365, 10340975720.0;
15.943166666666668, 9519929195.0;
15.949833333333334, 8652567225.0;
15.9565, 7738889810.0;
15.963166666666668, 6976790215.0;
15.969833333333336, 6458899330.0;
15.9765, 5903113990.0;
15.983166666666667, 5397854590.0;
15.989833333333335, 5132593405.0;
15.996500000000003, 5098909445.0;
16.003166666666665, 4804174795.0;
16.009833333333333, 4042075200.0;
16.0165, 3237870655.0;
16.023166666666665, 2231562350.0;
16.029833333333332, 1178938600.0;
16.0365, 235787720.0;
16.043166666666664, -159998810.0;
16.049833333333332, -214735245.0;
16.0565, -117893860.0;
16.063166666666667, -143156830.0;
16.06983333333333, -602100785.0;
16.0765, -1751565920.0;
16.083166666666667, -3477868870.0;
16.08983333333333, -5275750235.0;
16.0965, -7094684075.0;
16.103166666666667, -8749408610.0;
16.109833333333334, -10210450375.0;
16.1165, -11162022245.0;
16.123166666666666, -11907279860.0;
16.129833333333334, -12850430740.0;
16.136499999999998, -14172526170.0;
16.143166666666666, -15604094470.0;
16.149833333333333, -16690402180.0;
16.156499999999998, -17730394445.0;
16.163166666666665, -18715650275.0;
16.169833333333333, -20075640160.0;
16.1765, -21212473810.0;
16.183166666666665, -22155624690.0;
16.189833333333333, -23300879330.0;
16.1965, -24517712385.0;
16.203166666666664, -25599809600.0;
16.209833333333332, -25776650390.0;
16.2165, -25726124450.0;
16.223166666666668, -26109279495.0;
16.229833333333332, -26698748795.0;
16.2365, -27115587800.0;
16.243166666666667, -27326112550.0;
16.24983333333333, -27928213335.0;
16.2565, -28867153720.0;
16.263166666666667, -29317676685.0;
16.269833333333334, -29347150150.0;
16.2765, -29671358265.0;
16.283166666666666, -30412405385.0;
16.289833333333334, -31043979635.0;
16.296499999999998, -31460818640.0;
16.303166666666666, -32147129325.0;
16.309833333333334, -33018701790.0;
16.316499999999998, -33730275445.0;
16.323166666666665, -34206061380.0;
16.329833333333333, -34589216425.0;
16.3365, -34622900385.0;
16.343166666666665, -34391323160.0;
16.349833333333333, -34269218805.0;
16.3565, -34471322565.0;
16.363166666666665, -34871319590.0;
16.369833333333332, -35494472850.0;
16.3765, -36526044125.0;
16.383166666666668, -37515510450.0;
16.389833333333332, -38618660140.0;
16.3965, -39216550430.0;
16.403166666666667, -39717599335.0;
16.40983333333333, -39886019135.0;
16.4165, -39532337555.0;
16.423166666666667, -38816553405.0;
16.42983333333333, -37494457975.0;
16.4365, -36496570660.0;
16.443166666666666, -35688155620.0;
16.449833333333334, -35237632655.0;
16.4565, -35523946315.0;
16.463166666666666, -36184994030.0;
16.469833333333334, -36879725705.0;
16.476499999999998, -36820778775.0;
16.483166666666666, -36231309475.0;
16.489833333333333, -35641840175.0;
16.4965, -34753425730.0;
16.503166666666665, -33928168710.0;
16.509833333333333, -33178700600.0;
16.5165, -32993438820.0;
16.523166666666665, -32816598030.0;
16.529833333333332, -32382917045.0;
16.5365, -31713448340.0;
16.543166666666664, -30968190725.0;
16.549833333333332, -30260827565.0;
16.5565, -29187151340.0;
16.563166666666667, -28286105410.0;
16.56983333333333, -27254534135.0;
16.5765, -26576644440.0;
16.583166666666667, -26058753555.0;
16.58983333333333, -25780860885.0;
16.5965, -25810334350.0;
16.603166666666667, -25844018310.0;
16.609833333333334, -25814544845.0;
16.6165, -25279811980.0;
16.623166666666666, -24559817335.0;
16.629833333333334, -23924032590.0;
16.636499999999998, -23246142895.0;
16.643166666666666, -22290360530.0;
16.649833333333333, -21364051630.0;
16.6565, -20749319360.0;
16.663166666666665, -20008272240.0;
16.669833333333333, -18997753440.0;
16.6765, -18092497015.0;
16.683166666666665, -17540922170.0;
16.689833333333333, -17001978810.0;
16.6965, -16248300205.0;
16.703166666666664, -15755672290.0;
16.709833333333332, -15625146945.0;
16.7165, -15486200610.0;
16.723166666666668, -15229360415.0;
16.729833333333332, -14938836260.0;
16.7365, -14968309725.0;
16.743166666666667, -14863047350.0;
16.74983333333333, -14770416460.0;
16.7565, -14496734285.0;
16.763166666666667, -13978843400.0;
16.769833333333334, -13389374100.0;
16.7765, -12429381240.0;
16.783166666666666, -11751491545.0;
16.789833333333334, -10778867200.0;
16.796499999999998, -9802032360.0;
16.803166666666666, -9191510585.0;
16.809833333333334, -8892565440.0;
16.816499999999998, -8926249400.0;
16.823166666666665, -8568357325.0;
16.829833333333333, -8071518915.0;
16.8365, -7869415155.0;
16.843166666666665, -7696784860.0;
16.849833333333333, -7486260110.0;
16.8565, -6821001900.0;
16.863166666666665, -6218901115.0;
16.869833333333332, -5869430030.0;
16.8765, -5427328055.0;
16.883166666666668, -4981015585.0;
16.889833333333332, -4804174795.0;
16.8965, -5149435385.0;
16.903166666666667, -5477853995.0;
16.90983333333333, -5469433005.0;
16.9165, -5494695975.0;
16.923166666666667, -5364170630.0;
16.92983333333333, -4791543310.0;
16.9365, -3924181340.0;
16.943166666666666, -3381027485.0;
16.949833333333334, -3528394810.0;
16.9565, -3452605900.0;
16.963166666666666, -3237870655.0;
16.969833333333334, -2703137790.0;
16.976499999999998, -2189457400.0;
16.983166666666666, -1503146715.0;
16.989833333333333, -353681580.0;
16.9965, 669468705.0;
17.003166666666665, 1242096025.0;
17.009833333333333, 1039992265.0;
17.0165, 581048310.0;
17.023166666666665, 416839005.0;
17.029833333333332, 362102570.0;
17.0365, 168419800.0;
17.043166666666664, 71578415.0;
17.049833333333332, 404207520.0;
17.0565, 1296832460.0;
17.063166666666667, 1861038790.0;
17.06983333333333, 2016827105.0;
17.0765, 2176825915.0;
17.083166666666667, 2585243930.0;
17.08983333333333, 3111555805.0;
17.0965, 3010503925.0;
17.103166666666667, 2795768680.0;
17.109833333333334, 2501034030.0;
17.1165, 2412613635.0;
17.123166666666666, 2618927890.0;
17.129833333333334, 3229449665.0;
17.136499999999998, 4538913610.0;
17.143166666666666, 5890482505.0;
17.149833333333333, 7376787240.0;
17.1565, 8408358515.0;
17.163166666666665, 8791513560.0;
17.169833333333333, 8442042475.0;
17.1765, 7431523675.0;
17.183166666666665, 6694687050.0;
17.189833333333333, 6416794380.0;
17.1965, 6981000710.0;
17.203166666666664, 7797836740.0;
17.209833333333332, 8682040690.0;
17.2165, 9608349590.0;
17.223166666666668, 10437817105.0;
17.229833333333332, 10783077695.0;
17.2365, 10383080670.0;
17.243166666666667, 9924136715.0;
17.24983333333333, 9793611370.0;
17.2565, 10294660275.0;
17.263166666666667, 10753604230.0;
17.269833333333334, 11195706205.0;
17.2765, 11882016890.0;
17.283166666666666, 12728326385.0;
17.289833333333334, 13284111725.0;
17.296499999999998, 13119902420.0;
17.303166666666666, 12745168365.0;
17.309833333333334, 12639905990.0;
17.316499999999998, 12753589355.0;
17.323166666666665, 12665168960.0;
17.329833333333333, 12677800445.0;
17.3365, 12888325195.0;
17.343166666666665, 13431479050.0;
17.349833333333333, 13911475480.0;
17.3565, 14197789140.0;
17.363166666666665, 14660943590.0;
17.369833333333332, 14959888735.0;
17.3765, 15347254275.0;
17.383166666666668, 15532516055.0;
17.389833333333332, 15764093280.0;
17.3965, 16210405750.0;
17.403166666666667, 16585139805.0;
17.40983333333333, 16947242375.0;
17.4165, 17435659795.0;
17.423166666666667, 18172496420.0;
17.42983333333333, 18867228095.0;
17.4365, 18947227500.0;
17.443166666666666, 18753544730.0;
17.449833333333334, 18614598395.0;
17.4565, 18218811865.0;
17.463166666666666, 17507238210.0;
17.469833333333334, 16900926930.0;
17.476499999999998, 16736717625.0;
17.483166666666666, 16964084355.0;
17.489833333333333, 16989347325.0;
17.4965, 17031452275.0;
17.503166666666665, 17195661580.0;
17.509833333333333, 17591448110.0;
17.5165, 18147233450.0;
17.523166666666665, 18728281760.0;
17.529833333333332, 19629327690.0;
17.5365, 20639846490.0;
17.543166666666668, 21629312815.0;
17.549833333333332, 22345096965.0;
17.5565, 22728252010.0;
17.563166666666667, 22804040920.0;
17.56983333333333, 22669305080.0;
17.5765, 22597726665.0;
17.583166666666667, 22450359340.0;
17.58983333333333, 22446148845.0;
17.5965, 22812461910.0;
17.603166666666667, 23427194180.0;
17.609833333333334, 23987190015.0;
17.6165, 24404029020.0;
17.623166666666666, 25039813765.0;
17.629833333333334, 25178760100.0;
17.636499999999998, 25073497725.0;
17.643166666666666, 25094550200.0;
17.649833333333333, 25625072570.0;
17.6565, 26260857315.0;
17.663166666666665, 26496645035.0;
17.669833333333333, 26858747605.0;
17.6765, 26884010575.0;
17.683166666666665, 26433487610.0;
17.689833333333333, 25717703460.0;
17.6965, 25073497725.0;
17.703166666666664, 25060866240.0;
17.709833333333332, 25524020690.0;
17.7165, 26302962265.0;
17.723166666666668, 27065061860.0;
17.729833333333332, 27473479875.0;
17.7365, 27869266405.0;
17.743166666666667, 28328210360.0;
17.74983333333333, 28862943225.0;
17.7565, 29460833515.0;
17.763166666666667, 29763989155.0;
17.769833333333334, 30117670735.0;
17.7765, 30037671330.0;
17.783166666666666, 29759778660.0;
17.789833333333334, 29393465595.0;
17.796499999999998, 29098730945.0;
17.803166666666666, 29486096485.0;
17.809833333333334, 30201880635.0;
17.816499999999998, 31519765570.0;
17.823166666666665, 32517652885.0;
17.829833333333333, 32976596840.0;
17.8365, 33797643365.0;
17.843166666666665, 34631321375.0;
17.849833333333333, 35384999980.0;
17.8565, 35494472850.0;
17.863166666666665, 35738681560.0;
17.869833333333332, 36551307095.0;
17.8765, 37027093030.0;
17.883166666666668, 37170249860.0;
17.889833333333332, 37178670850.0;
17.8965, 37448142530.0;
17.903166666666667, 38142874205.0;
17.90983333333333, 38862868850.0;
17.9165, 39923913590.0;
17.923166666666667, 41435481295.0;
17.92983333333333, 42947049000.0;
17.9365, 44033356710.0;
17.943166666666666, 44307038885.0;
17.949833333333334, 44399669775.0;
17.9565, 44222828985.0;
17.963166666666666, 43835463445.0;
17.969833333333334, 43561781270.0;
17.976499999999998, 43932304830.0;
17.983166666666666, 44938613135.0;
17.989833333333333, 45961763420.0;
17.9965, 46744915490.0;
18.003166666666665, 47081755090.0;
18.009833333333333, 47174385980.0;
18.0165, 47250174890.0;
18.023166666666665, 47233332910.0;
18.029833333333332, 47102807565.0;
18.0365, 47271227365.0;
18.043166666666668, 48336482600.0;
18.049833333333332, 50109100995.0;
18.0565, 51784878005.0;
18.063166666666667, 52799607300.0;
18.06983333333333, 53351182145.0;
18.0765, 53717495210.0;
18.083166666666667, 53688021745.0;
18.08983333333333, 53241709275.0;
18.0965, 52492241165.0;
18.103166666666667, 52361715820.0;
18.109833333333334, 52984869080.0;
18.1165, 53662758775.0;
18.123166666666666, 54197491640.0;
18.129833333333334, 54559594210.0;
18.136499999999998, 55161694995.0;
18.143166666666666, 55435377170.0;
18.149833333333333, 55574323505.0;
18.1565, 55906952610.0;
18.163166666666665, 56525895375.0;
18.169833333333333, 57245890020.0;
18.1765, 57755359915.0;
18.183166666666665, 58252198325.0;
18.189833333333333, 58420618125.0;
18.1965, 58222724860.0;
18.203166666666664, 57616413580.0;
18.209833333333332, 56896418935.0;
18.2165, 56555368840.0;
18.223166666666668, 56538526860.0;
18.229833333333332, 56483790425.0;
18.2365, 55978531025.0;
18.243166666666667, 55372219745.0;
18.24983333333333, 54774329455.0;
18.2565, 53784863130.0;
18.263166666666667, 52399610275.0;
18.269833333333334, 51144882765.0;
18.2765, 50530150495.0;
18.283166666666666, 50050154065.0;
18.289833333333334, 49553315655.0;
18.296499999999998, 48900688930.0;
18.303166666666666, 48336482600.0;
18.309833333333334, 47747013300.0;
18.316499999999998, 47123860040.0;
18.323166666666665, 46580706185.0;
18.329833333333333, 46285971535.0;
18.3365, 46521759255.0;
18.343166666666665, 46913335290.0;
18.349833333333333, 46984913705.0;
18.3565, 46711231530.0;
18.363166666666665, 46197551140.0;
18.369833333333332, 45405978080.0;
18.3765, 43978620275.0;
18.383166666666668, 42496526035.0;
18.389833333333332, 41321797930.0;
18.3965, 40332331605.0;
18.403166666666667, 39191287460.0;
18.40983333333333, 37978664900.0;
18.4165, 37271301740.0;
18.423166666666667, 36673411450.0;
18.429833333333335, 36029205715.0;
18.4365, 34959739985.0;
18.443166666666666, 33928168710.0;
18.449833333333334, 33157648125.0;
18.4565, 32412390510.0;
18.463166666666666, 31397661215.0;
18.469833333333334, 30260827565.0;
18.476499999999998, 29385044605.0;
18.483166666666666, 28669260455.0;
18.489833333333333, 27806108980.0;
18.4965, 27031377900.0;
18.503166666666665, 26652433350.0;
18.509833333333333, 26319804245.0;
18.5165, 25928228210.0;
18.523166666666665, 25557704650.0;
18.529833333333332, 25136655150.0;
18.5365, 23856664670.0;
18.543166666666668, 22142993205.0;
18.549833333333332, 20601952035.0;
18.5565, 19524065315.0;
18.563166666666667, 18467231070.0;
18.56983333333333, 17460922765.0;
18.5765, 17233556035.0;
18.583166666666667, 17481975240.0;
18.58983333333333, 17919866720.0;
18.5965, 18130391470.0;
18.603166666666667, 18256706320.0;
18.609833333333334, 18307232260.0;
18.6165, 18383021170.0;
18.623166666666666, 18058813055.0;
18.629833333333334, 17490396230.0;
18.636499999999998, 16846190495.0;
18.643166666666666, 16656718220.0;
18.649833333333333, 16492508915.0;
18.6565, 15991460010.0;
18.663166666666665, 15330412295.0;
18.669833333333333, 14606207155.0;
18.6765, 13978843400.0;
18.683166666666665, 13056744995.0;
18.689833333333333, 12458854705.0;
18.6965, 12399907775.0;
18.703166666666664, 12740957870.0;
18.709833333333332, 12896746185.0;
18.7165, 12745168365.0;
18.723166666666668, 12442012725.0;
18.729833333333332, 11818859465.0;
18.7365, 10787288190.0;
18.743166666666667, 9608349590.0;
18.74983333333333, 8833618510.0;
18.7565, 8475726435.0;
18.763166666666667, 8534673365.0;
18.769833333333334, 8808355540.0;
18.7765, 8917828410.0;
18.783166666666666, 8892565440.0;
18.789833333333334, 9086248210.0;
18.796499999999998, 9364140880.0;
18.803166666666666, 9406245830.0;
18.809833333333334, 9098879695.0;
18.8165, 8943091380.0;
18.823166666666665, 8964143855.0;
18.829833333333333, 8711514155.0;
18.8365, 8454673960.0;
18.843166666666665, 8252570200.0;
18.849833333333333, 8340990595.0;
18.8565, 8315727625.0;
18.863166666666665, 8290464655.0;
18.869833333333332, 8244149210.0;
18.8765, 7974677530.0;
18.883166666666668, 7793626245.0;
18.889833333333332, 7726258325.0;
18.8965, 8029413965.0;
18.903166666666667, 8214675745.0;
18.90983333333333, 8206254755.0;
18.9165, 8033624460.0;
18.923166666666667, 7755731790.0;
18.929833333333335, 7515733575.0;
18.9365, 6968369225.0;
18.943166666666666, 6197848640.0;
18.949833333333334, 5498906470.0;
18.9565, 5258908255.0;
18.963166666666666, 5183119345.0;
18.969833333333334, 4715754400.0;
18.976499999999998, 4408388265.0;
18.983166666666666, 4555755590.0;
18.989833333333333, 5014699545.0;
18.9965, 5044173010.0;
19.003166666666665, 4905226675.0;
19.009833333333333, 5061014990.0;
19.0165, 5183119345.0;
19.023166666666665, 5023120535.0;
19.029833333333332, 4585229055.0;
19.0365, 4303125890.0;
19.043166666666668, 3915760350.0;
19.049833333333332, 3532605305.0;
19.0565, 3343133030.0;
19.063166666666667, 3292607090.0;
19.06983333333333, 3427342930.0;
19.0765, 3671551640.0;
19.083166666666667, 4063127675.0;
19.08983333333333, 4286283910.0;
19.0965, 4223126485.0;
19.103166666666667, 4282073415.0;
19.109833333333334, 4446282720.0;
19.1165, 4463124700.0;
19.123166666666666, 4307336385.0;
19.129833333333334, 3915760350.0;
19.136499999999998, 3663130650.0;
19.143166666666666, 3254712635.0;
19.149833333333333, 2707348285.0;
19.1565, 2328403735.0;
19.163166666666665, 2058932055.0;
19.169833333333333, 2227351855.0;
19.1765, 2261035815.0;
19.183166666666665, 2197878390.0;
19.189833333333333, 1970511660.0;
19.1965, 1713671465.0;
19.203166666666664, 1734723940.0;
19.209833333333332, 1591567110.0;
19.2165, 1667356020.0;
19.223166666666668, 1848407305.0;
19.229833333333332, 2244193835.0;
19.2365, 2378929675.0;
19.243166666666667, 2450508090.0;
19.24983333333333, 2496823535.0;
19.2565, 2442087100.0;
19.263166666666667, 2488402545.0;
19.269833333333334, 2471560565.0;
19.2765, 2635769870.0;
19.283166666666666, 2454718585.0;
19.289833333333334, 2391561160.0;
19.296499999999998, 2248404330.0;
19.303166666666666, 2185246905.0;
19.309833333333334, 2172615420.0;
19.3165, 2298930270.0;
19.323166666666665, 2501034030.0;
19.329833333333333, 2917873035.0;
19.3365, 3583131245.0;
19.343166666666665, 4046285695.0;
19.349833333333333, 4164179555.0;
19.3565, 4004180745.0;
19.363166666666665, 4063127675.0;
19.369833333333332, 4063127675.0;
19.3765, 3541026295.0;
19.383166666666668, 2905241550.0;
19.389833333333332, 2248404330.0;
19.3965, 1945248690.0;
19.403166666666667, 1524199190.0;
19.40983333333333, 770520585.0;
19.4165, 315787125.0;
19.423166666666667, 134735840.0;
19.429833333333335, 479996430.0;
19.4365, 425259995.0;
19.443166666666666, 181051285.0;
19.449833333333334, 92630890.0;
19.4565, 484206925.0;
19.463166666666666, 1103149690.0;
19.469833333333334, 1301042955.0;
19.476499999999998, 1465252260.0;
19.483166666666666, 1785249880.0;
19.489833333333333, 2357877200.0;
19.4965, 2791558185.0;
19.503166666666665, 2774716205.0;
19.509833333333333, 2955767490.0;
19.5165, 3145239765.0;
19.523166666666665, 3313659565.0;
19.529833333333332, 3141029270.0;
19.5365, 2627348880.0;
19.543166666666668, 2370508685.0;
19.549833333333332, 1898933245.0;
19.5565, 1654724535.0;
19.563166666666667, 1608409090.0;
19.56983333333333, 1886301760.0;
19.5765, 2172615420.0;
19.583166666666667, 1898933245.0;
19.58983333333333, 1650514040.0;
19.5965, 1406305330.0;
19.603166666666667, 1170517610.0;
19.609833333333334, 690521180.0;
19.6165, 197893265.0;
19.623166666666666, 214735245.0;
19.629833333333334, 627363755.0;
19.636499999999998, 1204201570.0;
19.643166666666666, 1482094240.0;
19.649833333333333, 1456831270.0;
19.6565, 1263148500.0;
19.663166666666665, 1330516420.0;
19.669833333333333, 1225254045.0;
19.6765, 1069465730.0;
19.683166666666665, 917887910.0;
19.689833333333333, 938940385.0;
19.6965, 1086307710.0;
19.703166666666668, 635784745.0;
19.709833333333332, 58946930.0;
19.7165, -707363160.0;
19.723166666666668, -1107360185.0;
19.729833333333332, -1170517610.0;
19.7365, -1103149690.0;
19.743166666666667, -703152665.0;
19.74983333333333, -25262970.0;
19.7565, 631574250.0;
19.763166666666667, 614732270.0;
19.769833333333334, 210524750.0;
19.7765, 8420990.0;
19.783166666666666, 16841980.0;
19.789833333333334, -231577225.0;
19.796499999999998, -572627320.0;
19.803166666666666, -530522370.0;
19.809833333333334, -193682770.0;
19.8165, 231577225.0;
19.823166666666665, 661047715.0;
19.829833333333333, 1296832460.0;
19.8365, 2079984530.0;
19.843166666666665, 2614717395.0;
19.849833333333333, 2719979770.0;
19.8565, 1983143145.0;
19.863166666666665, 884203950.0;
19.869833333333332, -223156235.0;
19.8765, -976834840.0;
19.883166666666668, -1566304140.0;
19.889833333333332, -2004195620.0;
19.8965, -1999985125.0;
19.903166666666667, -1637882555.0;
19.90983333333333, -1212622560.0;
19.9165, -1035781770.0;
19.923166666666667, -741047120.0;
19.929833333333335, -421049500.0;
19.9365, -63157425.0;
19.943166666666666, 143156830.0;
19.949833333333334, 602100785.0;
19.9565, 1115781175.0;
##END=

$$ === CHEMSPECTRA INTEGRALS AND MULTIPLETS ===
##PAGE=300
##$OBSERVEDINTEGRALS= (X Y Z)
##$OBSERVEDMULTIPLETS=
##$OBSERVEDMULTIPLETSPEAKS=
##END=

$$ === CHEMSPECTRA PEAK TABLE EDIT ===
##TITLE=618becfe-a0ce-4983-ba36-5fdcbb7ed595
##JCAMP-DX=5.00
##DATA TYPE=LC/MSPEAKTABLE
##DATA CLASS=PEAKTABLE
##$CSCATEGORY=EDIT_PEAK
##$CSTHRESHOLD=0.05
##MAXX=19.9565
##MAXY=411133784275.0
##MINX=-0.0435
##MINY=-130988499450.0
##PAGE=300
##NPOINTS=0
##PEAKTABLE= (XY..XY)
##END=

$$ === CHEMSPECTRA PEAK TABLE AUTO ===
##TITLE=618becfe-a0ce-4983-ba36-5fdcbb7ed595
##JCAMP-DX=5.00
##DATA TYPE=LC/MSPEAKTABLE
##DATA CLASS=PEAKTABLE
##$CSCATEGORY=AUTO_PEAK
##$CSTHRESHOLD=0.05
##MAXX=19.9565
##MAXY=411133784275.0
##MINX=-0.0435
##MINY=-130988499450.0
##PAGE=300
##NPOINTS=34
##PEAKTABLE= (XY..XY)
2.2631666666666668, 411133784275.0
1.2098333333333333, 157165146865.0
11.663166666666667, 108500245655.0
2.4365, 98710844780.0
2.5965000000000003, 61481647990.0
2.5765000000000002, 61401648585.0
18.189833333333333, 58420618125.0
18.0765, 53717495210.0
18.0165, 47250174890.0
18.349833333333333, 46984913705.0
17.949833333333334, 44399669775.0
2.823166666666667, 32294496650.0
17.769833333333334, 30117670735.0
2.7165000000000004, 29410307575.0
2.7631666666666668, 29115572925.0
17.6765, 26884010575.0
11.2965, 25469284255.0
17.629833333333334, 25178760100.0
12.6965, 24774552580.0
12.563166666666667, 24041926450.0
10.923166666666667, 22997723690.0
10.9565, 22879829830.0
17.563166666666667, 22804040920.0
12.636500000000002, 22319833995.0
12.129833333333334, 21974573405.0
12.0365, 21818785090.0
12.4365, 21755627665.0
12.403166666666667, 21561944895.0
11.989833333333335, 21305104700.0
12.249833333333335, 21288262720.0
12.316500000000001, 21284052225.0
11.929833333333335, 20938791635.0
11.0165, 20791424310.0
12.823166666666667, 20614583520.0
##END=

$$ === CHEMSPECTRA UVVIS PEAK TABLE ===
##TITLE=618becfe-a0ce-4983-ba36-5fdcbb7ed595
##JCAMP-DX=5.00
##DATA TYPE=LC/MS
##DATA CLASS=PEAK TABLE
##ORIGIN=
##OWNER=
##XUNITS=RETENTION TIME
##YUNITS=DETECTOR SIGNAL
##$CSCATEGORY=UVVIS PEAK TABLE
##PAGE=400
##NPOINTS=3001
##DATA TABLE= (XY..XY), PEAKS
-0.0435, 54736435.0;
-0.03683333333333333, 319997620.0;
-0.03016666666666666, 635784745.0;
-0.023499999999999997, 1115781175.0;
-0.01683333333333333, 1469462755.0;
-0.010166666666666664, 1545251665.0;
-0.003499999999999996, 1355779390.0;
0.003166666666666672, 1212622560.0;
0.00983333333333334, 972624345.0;
0.016500000000000008, 585258805.0;
0.02316666666666667, 248419205.0;
0.029833333333333337, 164209305.0;
0.036500000000000005, 290524155.0;
0.04316666666666667, 391576035.0;
0.04983333333333334, 610521775.0;
0.05650000000000001, 711573655.0;
0.06316666666666668, 863151475.0;
0.06983333333333334, 1065255235.0;
0.07650000000000001, 1309463945.0;
0.08316666666666668, 1519988695.0;
0.08983333333333333, 1629461565.0;
0.09650000000000002, 1835775820.0;
0.10316666666666667, 1941038195.0;
0.10983333333333335, 1772618395.0;
0.1165, 1372621370.0;
0.12316666666666669, 1195780580.0;
0.12983333333333336, 1115781175.0;
0.1365, 1098939195.0;
0.14316666666666666, 1002097810.0;
0.14983333333333337, 972624345.0;
0.15650000000000003, 1065255235.0;
0.16316666666666668, 1039992265.0;
0.16983333333333334, 1023150285.0;
0.1765, 972624345.0;
0.1831666666666667, 1077886720.0;
0.18983333333333335, 1330516420.0;
0.1965, 1633672060.0;
0.20316666666666666, 1642093050.0;
0.20983333333333337, 1199991075.0;
0.21650000000000003, 602100785.0;
0.22316666666666668, 159998810.0;
0.2298333333333334, -8420990.0;
0.23650000000000004, -92630890.0;
0.2431666666666667, 189472275.0;
0.24983333333333335, 749468110.0;
0.25650000000000006, 1326305925.0;
0.2631666666666667, 1414726320.0;
0.26983333333333337, 1086307710.0;
0.2765, 673679200.0;
0.2831666666666667, 185261780.0;
0.2898333333333334, -101051880.0;
0.29650000000000004, -101051880.0;
0.3031666666666667, 172630295.0;
0.30983333333333335, 467364945.0;
0.31650000000000006, 467364945.0;
0.3231666666666667, 248419205.0;
0.32983333333333337, -109472870.0;
0.3365, -543153855.0;
0.34316666666666673, -639995240.0;
0.3498333333333334, -471575440.0;
0.35650000000000004, -42104950.0;
0.3631666666666667, 412628510.0;
0.3698333333333334, 597890290.0;
0.37650000000000006, 686310685.0;
0.3831666666666667, 290524155.0;
0.38983333333333337, -218945740.0;
0.3965, -501048905.0;
0.40316666666666673, -298945145.0;
0.4098333333333334, 227366730.0;
0.41650000000000004, 450522965.0;
0.4231666666666667, 665258210.0;
0.4298333333333334, 719994645.0;
0.43650000000000005, 618942765.0;
0.4431666666666667, 492627915.0;
0.44983333333333336, 509469895.0;
0.4565, 799994050.0;
0.4631666666666667, 875782960.0;
0.46983333333333344, 905256425.0;
0.47650000000000003, 985255830.0;
0.48316666666666674, 1018939790.0;
0.48983333333333334, 955782365.0;
0.49650000000000005, 943150880.0;
0.5031666666666668, 1141044145.0;
0.5098333333333334, 1507357210.0;
0.5165000000000001, 1671566515.0;
0.5231666666666667, 1482094240.0;
0.5298333333333334, 993676820.0;
0.5365000000000001, 463154450.0;
0.5431666666666667, 172630295.0;
0.5498333333333334, -46315445.0;
0.5565000000000001, 37894455.0;
0.5631666666666667, 391576035.0;
0.5698333333333334, 968413850.0;
0.5765, 1381042360.0;
0.5831666666666667, 1439989290.0;
0.5898333333333334, 1439989290.0;
0.5965, 1338937410.0;
0.6031666666666667, 1229464540.0;
0.6098333333333333, 1044202760.0;
0.6165, 905256425.0;
0.6231666666666668, 955782365.0;
0.6298333333333334, 1119991670.0;
0.6365000000000001, 1031571275.0;
0.6431666666666668, 673679200.0;
0.6498333333333334, 252629700.0;
0.6565000000000001, 155788315.0;
0.6631666666666667, 319997620.0;
0.6698333333333334, 341050095.0;
0.6765000000000001, 458943955.0;
0.6831666666666667, 719994645.0;
0.6898333333333334, 1145254640.0;
0.6965000000000001, 1385252855.0;
0.7031666666666667, 1334726915.0;
0.7098333333333334, 1010518800.0;
0.7165, 694731675.0;
0.7231666666666667, 404207520.0;
0.7298333333333334, 185261780.0;
0.7365, 88420395.0;
0.7431666666666668, 21052475.0;
0.7498333333333334, 307366135.0;
0.7565000000000001, 538943360.0;
0.7631666666666668, 741047120.0;
0.7698333333333334, 846309495.0;
0.7765000000000001, 846309495.0;
0.7831666666666668, 901045930.0;
0.7898333333333334, 757889100.0;
0.7965000000000001, 677889695.0;
0.8031666666666667, 652626725.0;
0.8098333333333334, 450522965.0;
0.8165000000000001, 147367325.0;
0.8231666666666667, -147367325.0;
0.8298333333333334, -319997620.0;
0.8365, -324208115.0;
0.8431666666666667, -206314255.0;
0.8498333333333334, 349471085.0;
0.8565, 858940980.0;
0.8631666666666667, 1002097810.0;
0.8698333333333335, 842099000.0;
0.8765000000000001, 745257615.0;
0.8831666666666668, 665258210.0;
0.8898333333333334, 412628510.0;
0.8965000000000001, 378944550.0;
0.9031666666666668, 787362565.0;
0.9098333333333334, 1435778795.0;
0.9165000000000001, 1675777010.0;
0.9231666666666667, 1642093050.0;
0.9298333333333334, 1578935625.0;
0.9365000000000001, 1574725130.0;
0.9431666666666667, 1667356020.0;
0.9498333333333334, 1818933840.0;
0.9565, 2168404925.0;
0.9631666666666668, 2286298785.0;
0.9698333333333334, 2155773440.0;
0.9765, 1827354830.0;
0.9831666666666669, 1448410280.0;
0.9898333333333335, 955782365.0;
0.9965, 311576630.0;
1.0031666666666665, -63157425.0;
1.0098333333333334, -197893265.0;
1.0165, 58946930.0;
1.0231666666666666, 362102570.0;
1.0298333333333334, 854730485.0;
1.0365, 1250517015.0;
1.0431666666666666, 1178938600.0;
1.0498333333333334, 774731080.0;
1.0565, 4210495.0;
1.0631666666666666, -606311280.0;
1.0698333333333334, -858940980.0;
1.0765, -252629700.0;
1.0831666666666666, 1473673250.0;
1.0898333333333332, 3785235005.0;
1.0965, 5713641715.0;
1.1031666666666666, 6513635765.0;
1.1098333333333332, 5541011420.0;
1.1165, 901045930.0;
1.1231666666666666, -9372561870.0;
1.1298333333333332, -25069287230.0;
1.1365, -42513368015.0;
1.1431666666666667, -57330099920.0;
1.1498333333333333, -65102673690.0;
1.1565, -60879547205.0;
1.1631666666666667, -41991266635.0;
1.1698333333333333, -10425185620.0;
1.1764999999999999, 27574531755.0;
1.1831666666666667, 65300566955.0;
1.1898333333333333, 97418222815.0;
1.1965, 119603320970.0;
1.2031666666666667, 130912710540.0;
1.2098333333333333, 133481112490.0;
1.2165, 130773764205.0;
1.2231666666666667, 125519066445.0;
1.2298333333333333, 118921220780.0;
1.2365, 112201270760.0;
1.2431666666666668, 105043429260.0;
1.2498333333333334, 96032969960.0;
1.2565, 81755181415.0;
1.2631666666666665, 59641661675.0;
1.2698333333333334, 30559772710.0;
1.2765, -1949459185.0;
1.2831666666666666, -33511329705.0;
1.2898333333333334, -60614286020.0;
1.2965, -79624670945.0;
1.3031666666666666, -87696189860.0;
1.3098333333333334, -85611994835.0;
1.3165, -76980480085.0;
1.3231666666666666, -66083719025.0;
1.3298333333333334, -55359588260.0;
1.3365, -45380715110.0;
1.3431666666666666, -36614464520.0;
1.3498333333333332, -29220835300.0;
1.3565, -23511404080.0;
1.3631666666666666, -19090384330.0;
1.3698333333333332, -15671462390.0;
1.3765, -12787273315.0;
1.3831666666666667, -10164134930.0;
1.3898333333333333, -7700995355.0;
1.3965, -5667326270.0;
1.4031666666666667, -3978917775.0;
1.4098333333333333, -2463139575.0;
1.4165, -1187359590.0;
1.4231666666666667, -311576630.0;
1.4298333333333333, 0.0;
1.4365, 248419205.0;
1.4431666666666667, 362102570.0;
1.4498333333333333, 383155045.0;
1.4565, 252629700.0;
1.4631666666666667, 109472870.0;
1.4698333333333333, 164209305.0;
1.4765, 227366730.0;
1.4831666666666667, 248419205.0;
1.4898333333333333, 408418015.0;
1.4965, 656837220.0;
1.5031666666666668, 930519395.0;
1.5098333333333334, 1035781770.0;
1.5165, 947361375.0;
1.5231666666666668, 1023150285.0;
1.5298333333333334, 1077886720.0;
1.5365, 1191570085.0;
1.5431666666666666, 1111570680.0;
1.5498333333333334, 1035781770.0;
1.5565, 1309463945.0;
1.5631666666666666, 1587356615.0;
1.5698333333333334, 1911564730.0;
1.5765, 2147352450.0;
1.5831666666666666, 2357877200.0;
1.5898333333333334, 2475771060.0;
1.5965, 2475771060.0;
1.6031666666666666, 2736821750.0;
1.6098333333333334, 3018924915.0;
1.6165, 3115766300.0;
1.6231666666666666, 3065240360.0;
1.6298333333333332, 3107345310.0;
1.6365, 3229449665.0;
1.6431666666666667, 3090503330.0;
1.6498333333333333, 3002082935.0;
1.6565, 3141029270.0;
1.6631666666666667, 3368396000.0;
1.6698333333333333, 3461026890.0;
1.6765, 3503131840.0;
1.6831666666666667, 3738919560.0;
1.6898333333333333, 3755761540.0;
1.6965000000000001, 3381027485.0;
1.7031666666666667, 2926294025.0;
1.7098333333333333, 2770505710.0;
1.7165, 2639980365.0;
1.7231666666666667, 2505244525.0;
1.7298333333333333, 2319982745.0;
1.7365, 2282088290.0;
1.7431666666666668, 2564191455.0;
1.7498333333333334, 3010503925.0;
1.7565, 3705235600.0;
1.7631666666666668, 3957865300.0;
1.7698333333333334, 3768393025.0;
1.7765, 3599973225.0;
1.7831666666666668, 3237870655.0;
1.7898333333333334, 2799979175.0;
1.7965, 2155773440.0;
1.8031666666666666, 1759986910.0;
1.8098333333333334, 2067353045.0;
1.8165, 2269456805.0;
1.8231666666666666, 2282088290.0;
1.8298333333333334, 1966301165.0;
1.8365, 1764197405.0;
1.8431666666666666, 1738934435.0;
1.8498333333333334, 1376831865.0;
1.8565, 1061044740.0;
1.8631666666666666, 1082097215.0;
1.8698333333333335, 1292621965.0;
1.8765, 1431568300.0;
1.8831666666666667, 1557883150.0;
1.8898333333333333, 1823144335.0;
1.8965, 2096826510.0;
1.9031666666666667, 1983143145.0;
1.9098333333333333, 1856828295.0;
1.9165, 1890512255.0;
1.9231666666666667, 1785249880.0;
1.9298333333333333, 1709460970.0;
1.9365, 1570514635.0;
1.9431666666666667, 1701039980.0;
1.9498333333333333, 1713671465.0;
1.9565, 1498936220.0;
1.9631666666666667, 1351568895.0;
1.9698333333333335, 1258938005.0;
1.9765, 1355779390.0;
1.9831666666666667, 1578935625.0;
1.9898333333333336, 1844196810.0;
1.9965, 2159983935.0;
2.003166666666667, 2185246905.0;
2.009833333333334, 2210509875.0;
2.0165, 2256825320.0;
2.023166666666667, 2252614825.0;
2.0298333333333334, 2037879580.0;
2.0365, 1747355425.0;
2.043166666666667, 1747355425.0;
2.0498333333333334, 1726302950.0;
2.0565, 1713671465.0;
2.063166666666667, 1625251070.0;
2.0698333333333334, 1852617800.0;
2.0765000000000002, 1962090670.0;
2.083166666666667, 1873670275.0;
2.0898333333333334, 1646303545.0;
2.0965000000000003, 1250517015.0;
2.103166666666667, 821046525.0;
2.1098333333333334, 362102570.0;
2.1165000000000003, 101051880.0;
2.123166666666667, 25262970.0;
2.1298333333333335, 218945740.0;
2.1365000000000003, 669468705.0;
2.143166666666667, 1124202165.0;
2.1498333333333335, 1688408495.0;
2.1565000000000003, 2408403140.0;
2.163166666666667, 3073661350.0;
2.1698333333333335, 3309449070.0;
2.1765000000000003, 3208397190.0;
2.183166666666667, 2947346500.0;
2.1898333333333335, 2690506305.0;
2.1965000000000003, 2286298785.0;
2.2031666666666667, 1924196215.0;
2.2098333333333335, 1789460375.0;
2.2165000000000004, 1793670870.0;
2.2231666666666667, 1844196810.0;
2.2298333333333336, 151577820.0;
2.2365000000000004, -6021007850.0;
2.2431666666666668, -16972505345.0;
2.2498333333333336, -31612396460.0;
2.2565000000000004, -46909124795.0;
2.2631666666666668, -61995328380.0;
2.2698333333333336, -74673128825.0;
2.2765000000000004, -81216238055.0;
2.283166666666667, -81064660235.0;
2.2898333333333336, -75026810405.0;
2.2965000000000004, -66660556840.0;
2.303166666666667, -56993260320.0;
2.3098333333333336, -47149123010.0;
2.3165000000000004, -38210242125.0;
2.323166666666667, -30555562215.0;
2.3298333333333336, -24627185255.0;
2.3365000000000005, -20117745110.0;
2.343166666666667, -16719875645.0;
2.3498333333333337, -14201999635.0;
2.3565000000000005, -12227277480.0;
2.363166666666667, -10816761655.0;
2.3698333333333337, -9814663845.0;
2.3765000000000005, -9098879695.0;
2.383166666666667, -8686251185.0;
2.3898333333333337, -8294675150.0;
2.3965, -7987309015.0;
2.403166666666667, -7637837930.0;
2.4098333333333337, -7237840905.0;
2.4165, -6631529625.0;
2.423166666666667, -5789430625.0;
2.4298333333333337, -4618913015.0;
2.4365, -3351554020.0;
2.443166666666667, -2105247500.0;
2.4498333333333338, -951571870.0;
2.4565, 189472275.0;
2.463166666666667, 1288411470.0;
2.4698333333333338, 2021037600.0;
2.4765, 2593664920.0;
2.483166666666667, 2993661945.0;
2.489833333333334, 3465237385.0;
2.4965, 3583131245.0;
2.503166666666667, 3254712635.0;
2.509833333333334, 2682085315.0;
2.5165, 2084195025.0;
2.523166666666667, 2058932055.0;
2.529833333333334, 2501034030.0;
2.5365, 3650499165.0;
2.543166666666667, 5187329840.0;
2.549833333333334, 6989421700.0;
2.5565, 8934670390.0;
2.563166666666667, 10749393735.0;
2.5698333333333334, 12492538665.0;
2.5765000000000002, 14092526765.0;
2.583166666666667, 16008301990.0;
2.5898333333333334, 18353547705.0;
2.5965000000000003, 20947212625.0;
2.603166666666667, 23393510220.0;
2.6098333333333334, 25473494750.0;
2.6165000000000003, 27212429185.0;
2.623166666666667, 28168211550.0;
2.6298333333333335, 28172422045.0;
2.6365000000000003, 27460848390.0;
2.643166666666667, 26719801270.0;
2.6498333333333335, 26185068405.0;
2.6565000000000003, 25540862670.0;
2.663166666666667, 24871393965.0;
2.6698333333333335, 24172451795.0;
2.6765000000000003, 23553509030.0;
2.683166666666667, 22740883495.0;
2.6898333333333335, 21578786875.0;
2.6965000000000003, 20324059365.0;
2.703166666666667, 19364066505.0;
2.7098333333333335, 18993542945.0;
2.7165000000000004, 19014595420.0;
2.723166666666667, 19052489875.0;
2.7298333333333336, 19204067695.0;
2.7365000000000004, 19503012840.0;
2.7431666666666668, 19810378975.0;
2.7498333333333336, 20075640160.0;
2.7565000000000004, 20315638375.0;
2.7631666666666668, 20686161935.0;
2.7698333333333336, 20879844705.0;
2.7765000000000004, 21157737375.0;
2.783166666666667, 21688259745.0;
2.7898333333333336, 22201940135.0;
2.7965000000000004, 22538779735.0;
2.803166666666667, 22799830425.0;
2.8098333333333336, 23262984875.0;
2.8165000000000004, 23604034970.0;
2.823166666666667, 23684034375.0;
2.8298333333333336, 23751402295.0;
2.8365000000000005, 23742981305.0;
2.843166666666667, 23342984280.0;
2.8498333333333337, 22467201320.0;
2.8565000000000005, 21481945490.0;
2.863166666666667, 20378795800.0;
2.8698333333333337, 19132489280.0;
2.8765000000000005, 17549343160.0;
2.883166666666667, 16185142780.0;
2.8898333333333337, 15191465960.0;
2.8965000000000005, 14281999040.0;
2.903166666666667, 13452531525.0;
2.9098333333333337, 12534643615.0;
2.9165000000000005, 12307276885.0;
2.923166666666667, 12404118270.0;
2.9298333333333337, 12559906585.0;
2.9365, 12783062820.0;
2.943166666666667, 12964114105.0;
2.9498333333333338, 13145165390.0;
2.9565, 12989377075.0;
2.963166666666667, 12644116485.0;
2.9698333333333338, 12399907775.0;
2.9765, 12311487380.0;
2.983166666666667, 12505170150.0;
2.989833333333334, 12724115890.0;
2.9965, 12724115890.0;
3.003166666666667, 12673589950.0;
3.009833333333334, 12829378265.0;
3.0165, 13094639450.0;
3.023166666666667, 13065165985.0;
3.029833333333334, 13069376480.0;
3.0365, 13107270935.0;
3.043166666666667, 13372532120.0;
3.049833333333334, 13271480240.0;
3.0565, 13086218460.0;
3.063166666666667, 12926219650.0;
3.069833333333334, 12745168365.0;
3.0765000000000002, 12399907775.0;
3.083166666666667, 11540966795.0;
3.089833333333334, 10500974530.0;
3.0965000000000003, 9162037120.0;
3.103166666666667, 7671521890.0;
3.1098333333333334, 6113638740.0;
3.1165000000000003, 4871542715.0;
3.123166666666667, 4050496190.0;
3.1298333333333335, 3549447285.0;
3.1365000000000003, 3136818775.0;
3.143166666666667, 2917873035.0;
3.1498333333333335, 2728400760.0;
3.1565000000000003, 2648401355.0;
3.163166666666667, 2509455020.0;
3.1698333333333335, 2256825320.0;
3.1765000000000003, 1839986315.0;
3.183166666666667, 1381042360.0;
3.1898333333333335, 1199991075.0;
3.1965000000000003, 1334726915.0;
3.203166666666667, 1456831270.0;
3.2098333333333335, 1519988695.0;
3.2165000000000004, 1528409685.0;
3.223166666666667, 1456831270.0;
3.2298333333333336, 1221043550.0;
3.2365000000000004, 665258210.0;
3.243166666666667, 143156830.0;
3.2498333333333336, -496838410.0;
3.2565000000000004, -905256425.0;
3.263166666666667, -1199991075.0;
3.2698333333333336, -1524199190.0;
3.2765000000000004, -1861038790.0;
3.283166666666667, -2096826510.0;
3.2898333333333336, -2037879580.0;
3.2965000000000004, -2138931460.0;
3.303166666666667, -2345245715.0;
3.3098333333333336, -2661032840.0;
3.3165000000000004, -3090503330.0;
3.323166666666667, -3755761540.0;
3.3298333333333336, -4471545690.0;
3.3365000000000005, -4863121725.0;
3.343166666666667, -5128382910.0;
3.3498333333333337, -5279960730.0;
3.3565000000000005, -5347328650.0;
3.363166666666667, -5469433005.0;
3.3698333333333337, -5755746665.0;
3.3765000000000005, -6319952995.0;
3.383166666666667, -6631529625.0;
3.3898333333333337, -6690476555.0;
3.3965000000000005, -6673634575.0;
3.403166666666667, -6770475960.0;
3.4098333333333337, -6905211800.0;
3.4165000000000005, -6968369225.0;
3.423166666666667, -7183104470.0;
3.4298333333333337, -7620995950.0;
3.4365000000000006, -8016782480.0;
3.443166666666667, -7734679315.0;
3.4498333333333338, -7204156945.0;
3.4565000000000006, -6879948830.0;
3.463166666666667, -7073631600.0;
3.4698333333333338, -7271524865.0;
3.4765, -7427313180.0;
3.483166666666667, -7953625055.0;
3.489833333333334, -8719935145.0;
3.4965, -9305193950.0;
3.503166666666667, -9473613750.0;
3.509833333333334, -9536771175.0;
3.5165, -9810453350.0;
3.523166666666667, -10050451565.0;
3.529833333333334, -10004136120.0;
3.5365, -9583086620.0;
3.543166666666667, -9162037120.0;
3.549833333333334, -9039932765.0;
3.5565, -8968354350.0;
3.563166666666667, -8892565440.0;
3.569833333333334, -8896775935.0;
3.5765000000000002, -9372561870.0;
3.583166666666667, -9633612560.0;
3.589833333333334, -9599928600.0;
3.5965000000000003, -9486245235.0;
3.603166666666667, -9722032955.0;
3.609833333333334, -10290449780.0;
3.6165000000000003, -10673604825.0;
3.623166666666667, -11149390760.0;
3.629833333333334, -11414651945.0;
3.6365000000000003, -11376757490.0;
3.643166666666667, -11145180265.0;
3.6498333333333335, -10951497495.0;
3.6565000000000003, -10980970960.0;
3.663166666666667, -10959918485.0;
3.6698333333333335, -11027286405.0;
3.6765000000000003, -11284126600.0;
3.683166666666667, -11397809965.0;
3.6898333333333335, -11060970365.0;
3.6965000000000003, -10509395520.0;
3.703166666666667, -10282028790.0;
3.7098333333333335, -10437817105.0;
3.7165000000000004, -10724130765.0;
3.723166666666667, -11006233930.0;
3.7298333333333336, -11292547590.0;
3.7365000000000004, -11406230955.0;
3.743166666666667, -11220969175.0;
3.7498333333333336, -10900971555.0;
3.7565000000000004, -10631499875.0;
3.763166666666667, -10467290570.0;
3.7698333333333336, -10265186810.0;
3.7765000000000004, -10248344830.0;
3.7831666666666672, -10143082455.0;
3.7898333333333336, -10033609585.0;
3.7965000000000004, -9827295330.0;
3.8031666666666673, -9591507610.0;
3.8098333333333336, -9612560085.0;
3.8165000000000004, -9591507610.0;
3.823166666666667, -9932557705.0;
3.8298333333333336, -10269397305.0;
3.8365000000000005, -10492553540.0;
3.843166666666667, -10677815320.0;
3.8498333333333337, -10812551160.0;
3.8565000000000005, -11288337095.0;
3.863166666666667, -11608334715.0;
3.8698333333333337, -11999910750.0;
3.8765000000000005, -12416749755.0;
3.883166666666667, -12875693710.0;
3.8898333333333337, -13216743805.0;
3.8965000000000005, -13204112320.0;
3.903166666666667, -13128323410.0;
3.9098333333333337, -12858851730.0;
3.9165000000000005, -12500959655.0;
3.923166666666667, -12033594710.0;
3.9298333333333337, -11730439070.0;
3.9365000000000006, -11498861845.0;
3.943166666666667, -11326231550.0;
3.9498333333333338, -11018865415.0;
3.9565, -10825182645.0;
3.963166666666667, -10808340665.0;
3.9698333333333338, -10879919080.0;
3.9765000000000006, -11153601255.0;
3.9831666666666674, -11435704420.0;
3.9898333333333333, -11898858870.0;
3.9965, -12155699065.0;
4.003166666666667, -12303066390.0;
4.009833333333334, -12294645400.0;
4.016500000000001, -12252540450.0;
4.0231666666666674, -12206225005.0;
4.029833333333333, -12092541640.0;
4.0365, -12092541640.0;
4.043166666666667, -12067278670.0;
4.049833333333334, -12058857680.0;
4.056500000000001, -11957805800.0;
4.0631666666666675, -11928332335.0;
4.069833333333333, -11692544615.0;
4.0765, -11444125410.0;
4.083166666666667, -11103075315.0;
4.089833333333334, -10993602445.0;
4.096500000000001, -11006233930.0;
4.103166666666667, -10947287000.0;
4.1098333333333334, -11237811155.0;
4.1165, -11772544020.0;
4.123166666666667, -12463065200.0;
4.129833333333334, -12837799255.0;
4.136500000000001, -12867272720.0;
4.143166666666667, -13018850540.0;
4.1498333333333335, -13275690735.0;
4.1565, -13364111130.0;
4.163166666666667, -13039903015.0;
4.169833333333334, -12593590545.0;
4.176500000000001, -12357802825.0;
4.183166666666667, -12197804015.0;
4.1898333333333335, -12004121245.0;
4.1965, -11776754515.0;
4.203166666666667, -11818859465.0;
4.209833333333334, -11945174315.0;
4.216500000000001, -12218856490.0;
4.223166666666667, -12551485595.0;
4.229833333333334, -12677800445.0;
4.2365, -12656747970.0;
4.243166666666667, -12757799850.0;
4.249833333333334, -13103060440.0;
4.256500000000001, -13364111130.0;
4.263166666666667, -13233585785.0;
4.269833333333334, -13098849945.0;
4.2765, -13267269745.0;
4.283166666666667, -13730424195.0;
4.289833333333334, -13957790925.0;
4.2965, -14029369340.0;
4.303166666666667, -14147263200.0;
4.309833333333334, -14378840425.0;
4.3165000000000004, -14463050325.0;
4.323166666666667, -14210420625.0;
4.329833333333334, -14193578645.0;
4.3365, -14180947160.0;
4.343166666666667, -14100947755.0;
4.349833333333334, -13679898255.0;
4.3565000000000005, -13174638855.0;
4.363166666666667, -12669379455.0;
4.369833333333334, -12117804610.0;
4.3765, -11667281645.0;
4.383166666666667, -11452546400.0;
4.389833333333334, -11730439070.0;
4.3965000000000005, -12378855300.0;
4.403166666666667, -13267269745.0;
4.409833333333334, -14016737855.0;
4.4165, -14404103395.0;
4.423166666666667, -14543049730.0;
4.429833333333334, -14580944185.0;
4.4365000000000006, -14724101015.0;
4.443166666666667, -14736732500.0;
4.449833333333333, -14724101015.0;
4.4565, -14833573885.0;
4.463166666666667, -14930415270.0;
4.469833333333334, -15077782595.0;
4.476500000000001, -15018835665.0;
4.483166666666667, -15157782000.0;
4.489833333333333, -15309359820.0;
4.4965, -15456727145.0;
4.503166666666667, -15591462985.0;
4.509833333333334, -15372517245.0;
4.516500000000001, -14913573290.0;
4.5231666666666674, -14033579835.0;
4.529833333333333, -13263059250.0;
4.5365, -12976745590.0;
4.543166666666667, -12993587570.0;
4.549833333333334, -13208322815.0;
4.556500000000001, -13524109940.0;
4.5631666666666675, -14336735475.0;
4.569833333333333, -15258833880.0;
4.5765, -15599883975.0;
4.583166666666667, -15797777240.0;
4.589833333333334, -15949355060.0;
4.596500000000001, -16033564960.0;
4.6031666666666675, -15486200610.0;
4.6098333333333334, -14665154085.0;
4.6165, -14185157655.0;
4.623166666666667, -13780950135.0;
4.629833333333334, -13646214295.0;
4.636500000000001, -13835686570.0;
4.643166666666667, -14509365770.0;
4.6498333333333335, -15507253085.0;
4.6565, -16500929905.0;
4.663166666666667, -17368291875.0;
4.669833333333334, -17734604940.0;
4.676500000000001, -17583027120.0;
4.683166666666667, -17119872670.0;
4.6898333333333335, -16500929905.0;
4.6965, -16100932880.0;
4.703166666666667, -15797777240.0;
4.709833333333334, -15612515460.0;
4.716500000000001, -15313570315.0;
4.723166666666667, -15115677050.0;
4.729833333333334, -14972520220.0;
4.7365, -14728311510.0;
4.743166666666667, -14467260820.0;
4.749833333333334, -14450418840.0;
4.756500000000001, -14854626360.0;
4.763166666666667, -15254623385.0;
4.769833333333334, -15456727145.0;
4.7765, -15246202395.0;
4.783166666666667, -14964099230.0;
4.789833333333334, -14694627550.0;
4.796500000000001, -14686206560.0;
4.803166666666667, -14677785570.0;
4.809833333333334, -14551470720.0;
4.8165000000000004, -14576733690.0;
4.823166666666667, -14837784380.0;
4.829833333333334, -15132519030.0;
4.8365, -15098835070.0;
4.843166666666667, -15027256655.0;
4.849833333333334, -15052519625.0;
4.8565000000000005, -14968309725.0;
4.863166666666667, -14576733690.0;
4.869833333333334, -14134631715.0;
4.8765, -13827265580.0;
4.883166666666667, -13789371125.0;
4.889833333333334, -13818844590.0;
4.8965000000000005, -13865160035.0;
4.903166666666667, -14147263200.0;
4.909833333333334, -14383050920.0;
4.9165, -14745153490.0;
4.923166666666667, -14905152300.0;
4.929833333333334, -15115677050.0;
4.9365000000000006, -15401990710.0;
4.943166666666667, -15427253680.0;
4.949833333333334, -15364096255.0;
4.9565, -15069361605.0;
4.963166666666667, -14837784380.0;
4.969833333333334, -14656733095.0;
4.976500000000001, -14610417650.0;
4.983166666666667, -14580944185.0;
4.989833333333333, -14589365175.0;
4.9965, -14976730715.0;
5.003166666666667, -15591462985.0;
5.009833333333334, -16041985950.0;
5.016500000000001, -15894618625.0;
5.0231666666666674, -15591462985.0;
5.029833333333333, -15465148135.0;
5.0365, -15107256060.0;
5.043166666666667, -14526207750.0;
5.049833333333334, -13919896470.0;
5.056500000000001, -13945159440.0;
5.0631666666666675, -14281999040.0;
5.069833333333333, -14517786760.0;
5.0765, -14648312105.0;
5.083166666666667, -14820942400.0;
5.089833333333334, -15199886950.0;
5.096500000000001, -15633567935.0;
5.1031666666666675, -15894618625.0;
5.1098333333333334, -15928302585.0;
5.1165, -15667251895.0;
5.123166666666667, -15334622790.0;
5.129833333333334, -14829363390.0;
5.136500000000001, -14336735475.0;
5.1431666666666676, -14324103990.0;
5.1498333333333335, -14311472505.0;
5.1565, -14185157655.0;
5.163166666666667, -13519899445.0;
5.169833333333334, -13124112915.0;
5.176500000000001, -12711484405.0;
5.183166666666667, -12231487975.0;
5.1898333333333335, -12235698470.0;
5.1965, -12635695495.0;
5.203166666666667, -13317795685.0;
5.209833333333334, -13709371720.0;
5.216500000000001, -13928317460.0;
5.223166666666667, -14054632310.0;
5.229833333333334, -13789371125.0;
5.2365, -13726213700.0;
5.243166666666667, -13827265580.0;
5.249833333333334, -14054632310.0;
5.256500000000001, -14252525575.0;
5.263166666666667, -14277788545.0;
5.269833333333334, -14340945970.0;
5.2765, -14286209535.0;
5.283166666666667, -14412524385.0;
5.289833333333334, -14711469530.0;
5.296500000000001, -14934625765.0;
5.303166666666667, -15086203585.0;
5.309833333333334, -15195676455.0;
5.3165000000000004, -15263044375.0;
5.323166666666667, -15027256655.0;
5.329833333333334, -14475681810.0;
5.336500000000001, -14151473695.0;
5.343166666666667, -13738845185.0;
5.349833333333334, -13359900635.0;
5.3565000000000005, -12766220840.0;
5.363166666666667, -12572538070.0;
5.369833333333334, -12572538070.0;
5.3765, -12753589355.0;
5.383166666666667, -13082007965.0;
5.389833333333334, -13486215485.0;
5.3965000000000005, -13949369935.0;
5.403166666666667, -14252525575.0;
5.409833333333334, -14500944780.0;
5.4165, -14370419435.0;
5.423166666666667, -14147263200.0;
5.429833333333334, -13776739640.0;
5.4365000000000006, -13427268555.0;
5.443166666666667, -13178849350.0;
5.449833333333334, -13145165390.0;
5.4565, -13376742615.0;
5.463166666666667, -13376742615.0;
5.469833333333334, -13338848160.0;
5.476500000000001, -13460952515.0;
5.483166666666667, -13642003800.0;
5.489833333333334, -13785160630.0;
5.4965, -13751476670.0;
5.503166666666667, -14029369340.0;
5.509833333333334, -14265157060.0;
5.516500000000001, -14488313295.0;
5.5231666666666674, -14521997255.0;
5.529833333333333, -14475681810.0;
5.5365, -14269367555.0;
5.543166666666667, -13734634690.0;
5.549833333333334, -13220954300.0;
5.556500000000001, -12715694900.0;
5.5631666666666675, -12446223220.0;
5.569833333333333, -12353592330.0;
5.5765, -12618853515.0;
5.583166666666667, -13250427765.0;
5.589833333333334, -14029369340.0;
5.596500000000001, -14648312105.0;
5.6031666666666675, -14888310320.0;
5.6098333333333334, -14837784380.0;
5.6165, -14597786165.0;
5.623166666666667, -14176736665.0;
5.629833333333334, -13667266770.0;
5.636500000000001, -13385163605.0;
5.6431666666666676, -13498846970.0;
5.6498333333333335, -13726213700.0;
5.6565, -13810423600.0;
5.663166666666667, -14122000230.0;
5.669833333333334, -14673575075.0;
5.676500000000001, -14888310320.0;
5.683166666666668, -14378840425.0;
5.6898333333333335, -13490425980.0;
5.6965, -12951482620.0;
5.703166666666667, -12589380050.0;
5.709833333333334, -12269382430.0;
5.716500000000001, -12113594115.0;
5.723166666666667, -12315697875.0;
5.729833333333334, -12867272720.0;
5.7365, -13115691925.0;
5.743166666666667, -12896746185.0;
5.749833333333334, -12404118270.0;
5.756500000000001, -12231487975.0;
5.763166666666667, -12357802825.0;
5.769833333333334, -12349381835.0;
5.7765, -12210435500.0;
5.783166666666667, -12248329955.0;
5.789833333333334, -12572538070.0;
5.796500000000001, -12749378860.0;
5.803166666666667, -12454644210.0;
5.809833333333334, -12113594115.0;
5.8165000000000004, -12143067580.0;
5.823166666666667, -12378855300.0;
5.829833333333334, -12505170150.0;
5.836500000000001, -12303066390.0;
5.843166666666667, -12290434905.0;
5.849833333333334, -12345171340.0;
5.8565000000000005, -12547275100.0;
5.863166666666667, -12648326980.0;
5.869833333333334, -12623064010.0;
5.876500000000001, -12618853515.0;
5.883166666666667, -12639905990.0;
5.889833333333334, -12863062225.0;
5.8965000000000005, -12791483810.0;
5.903166666666667, -12433591735.0;
5.909833333333334, -12012542235.0;
5.9165, -11890437880.0;
5.923166666666667, -12008331740.0;
5.929833333333334, -12042015700.0;
5.9365000000000006, -12067278670.0;
5.943166666666667, -12168330550.0;
5.949833333333334, -12282013915.0;
5.9565, -12176751540.0;
5.963166666666667, -11915700850.0;
5.969833333333334, -11726228575.0;
5.976500000000001, -11738860060.0;
5.983166666666667, -12138857085.0;
5.989833333333334, -12564117080.0;
5.9965, -12909377670.0;
6.003166666666667, -13027271530.0;
6.009833333333334, -13183059845.0;
6.016500000000001, -13258848755.0;
6.0231666666666674, -13157796875.0;
6.029833333333334, -13060955490.0;
6.0365, -13149375885.0;
6.043166666666667, -13334637665.0;
6.049833333333334, -13267269745.0;
6.056500000000001, -12993587570.0;
6.0631666666666675, -12711484405.0;
6.069833333333333, -12580959060.0;
6.0765, -12387276290.0;
6.083166666666667, -12151488570.0;
6.089833333333334, -12113594115.0;
6.096500000000001, -12277803420.0;
6.1031666666666675, -12391486785.0;
6.1098333333333334, -12218856490.0;
6.1165, -12202014510.0;
6.123166666666667, -12269382430.0;
6.129833333333334, -12239908965.0;
6.136500000000001, -11983068770.0;
6.1431666666666676, -11860964415.0;
6.1498333333333335, -12063068175.0;
6.1565, -12176751540.0;
6.163166666666667, -12210435500.0;
6.169833333333334, -12155699065.0;
6.176500000000001, -12265171935.0;
6.183166666666668, -12008331740.0;
6.1898333333333335, -11692544615.0;
6.1965, -11397809965.0;
6.203166666666667, -11359915510.0;
6.209833333333334, -11313600065.0;
6.216500000000001, -11208337690.0;
6.223166666666668, -11410441450.0;
6.229833333333334, -11650439665.0;
6.2365, -11974647780.0;
6.243166666666667, -11940963820.0;
6.249833333333334, -11919911345.0;
6.256500000000001, -11983068770.0;
6.263166666666667, -12075699660.0;
6.269833333333334, -12075699660.0;
6.2765, -11650439665.0;
6.283166666666667, -11376757490.0;
6.289833333333334, -11187285215.0;
6.296500000000001, -11258863630.0;
6.303166666666667, -11385178480.0;
6.309833333333334, -11465177885.0;
6.3165000000000004, -11776754515.0;
6.323166666666667, -12092541640.0;
6.329833333333334, -12391486785.0;
6.336500000000001, -12408328765.0;
6.343166666666667, -12159909560.0;
6.349833333333334, -11898858870.0;
6.3565000000000005, -11562019270.0;
6.363166666666667, -11359915510.0;
6.369833333333334, -11183074720.0;
6.376500000000001, -10951497495.0;
6.383166666666667, -10564131955.0;
6.389833333333334, -10138871960.0;
6.3965000000000005, -9903084240.0;
6.403166666666667, -9776769390.0;
6.409833333333334, -9780979885.0;
6.416500000000001, -10122029980.0;
6.423166666666667, -10930445020.0;
6.429833333333334, -11865174910.0;
6.4365000000000006, -12522012130.0;
6.443166666666667, -12804115295.0;
6.449833333333334, -12820957275.0;
6.4565, -12564117080.0;
6.463166666666667, -12176751540.0;
6.469833333333334, -11793596495.0;
6.476500000000001, -11519914320.0;
6.483166666666667, -11646229170.0;
6.489833333333334, -11844122435.0;
6.4965, -11987279265.0;
6.503166666666667, -12012542235.0;
6.509833333333334, -12218856490.0;
6.516500000000001, -12576748565.0;
6.5231666666666674, -12572538070.0;
6.529833333333334, -12538854110.0;
6.5365, -12736747375.0;
6.543166666666667, -13145165390.0;
6.549833333333334, -13258848755.0;
6.556500000000001, -13153586380.0;
6.5631666666666675, -12850430740.0;
6.569833333333334, -12391486785.0;
6.5765, -11671492140.0;
6.583166666666667, -10913603040.0;
6.589833333333334, -10362028195.0;
6.596500000000001, -10130450970.0;
6.6031666666666675, -10336765225.0;
6.6098333333333334, -10778867200.0;
6.6165, -11220969175.0;
6.623166666666667, -11473598875.0;
6.629833333333334, -11540966795.0;
6.636500000000001, -11385178480.0;
6.6431666666666676, -11178864225.0;
6.6498333333333335, -11225179670.0;
6.6565, -11393599470.0;
6.663166666666667, -11423072935.0;
6.669833333333334, -11195706205.0;
6.676500000000001, -11128338285.0;
6.683166666666668, -11271495115.0;
6.6898333333333335, -11418862440.0;
6.6965, -11477809370.0;
6.703166666666667, -11608334715.0;
6.709833333333334, -11894648375.0;
6.716500000000001, -12311487380.0;
6.723166666666668, -12522012130.0;
6.729833333333334, -12576748565.0;
6.7365, -12408328765.0;
6.743166666666667, -12282013915.0;
6.749833333333334, -12307276885.0;
6.756500000000001, -12100962630.0;
6.763166666666668, -11873595900.0;
6.769833333333334, -11183074720.0;
6.7765, -10669394330.0;
6.783166666666667, -10235713345.0;
6.789833333333334, -10159924435.0;
6.796500000000001, -10286239285.0;
6.803166666666667, -10420975125.0;
6.809833333333334, -10757814725.0;
6.8165000000000004, -11132548780.0;
6.823166666666667, -11802017485.0;
6.829833333333334, -12147278075.0;
6.836500000000001, -12340960845.0;
6.843166666666667, -12307276885.0;
6.849833333333334, -12092541640.0;
6.8565000000000005, -11663071150.0;
6.863166666666667, -10846235120.0;
6.869833333333334, -10172555920.0;
6.876500000000001, -9747295925.0;
6.883166666666667, -9654665035.0;
6.889833333333334, -9844137310.0;
6.8965000000000005, -10298870770.0;
6.903166666666667, -10934655515.0;
6.909833333333334, -11427283430.0;
6.916500000000001, -11473598875.0;
6.923166666666667, -11191495710.0;
6.929833333333334, -10997812940.0;
6.9365000000000006, -10778867200.0;
6.943166666666667, -10551500470.0;
6.949833333333334, -10269397305.0;
6.956500000000001, -10307291760.0;
6.963166666666667, -10639920865.0;
6.969833333333334, -10858866605.0;
6.976500000000001, -11035707395.0;
6.983166666666667, -11111496305.0;
6.989833333333334, -11317810560.0;
6.9965, -11271495115.0;
7.003166666666667, -10968339475.0;
7.009833333333334, -10665183835.0;
7.016500000000001, -10656762845.0;
7.0231666666666674, -10715709775.0;
7.029833333333334, -10593605420.0;
7.0365, -10387291165.0;
7.043166666666667, -10383080670.0;
7.049833333333334, -10698867795.0;
7.056500000000001, -10905182050.0;
7.0631666666666675, -11119917295.0;
7.069833333333334, -11275705610.0;
7.0765, -11599913725.0;
7.083166666666667, -11848332930.0;
7.089833333333334, -11978858275.0;
7.096500000000001, -11818859465.0;
7.1031666666666675, -11705176100.0;
7.109833333333334, -11612545210.0;
7.1165, -11402020460.0;
7.123166666666667, -10934655515.0;
7.129833333333334, -10442027600.0;
7.136500000000001, -10467290570.0;
7.1431666666666676, -10425185620.0;
7.1498333333333335, -10256765820.0;
7.1565, -10037820080.0;
7.163166666666667, -10496764035.0;
7.169833333333334, -10955707990.0;
7.176500000000001, -11035707395.0;
7.183166666666668, -10791498685.0;
7.1898333333333335, -10715709775.0;
7.1965, -10816761655.0;
7.203166666666667, -10568342450.0;
7.209833333333334, -10164134930.0;
7.216500000000001, -9835716320.0;
7.223166666666668, -9734664440.0;
7.229833333333334, -9789400875.0;
7.2365, -9860979290.0;
7.243166666666667, -9983083645.0;
7.249833333333334, -10218871365.0;
7.256500000000001, -10530447995.0;
7.263166666666668, -10850445615.0;
7.269833333333334, -10968339475.0;
7.2765, -10833603635.0;
7.283166666666667, -10677815320.0;
7.289833333333334, -10543079480.0;
7.296500000000001, -10349396710.0;
7.303166666666668, -10231502850.0;
7.309833333333334, -10168345425.0;
7.3165000000000004, -10307291760.0;
7.323166666666667, -10244134335.0;
7.329833333333334, -9983083645.0;
7.336500000000001, -9814663845.0;
7.343166666666667, -9629402065.0;
7.349833333333334, -9587297115.0;
7.3565000000000005, -9658875530.0;
7.363166666666667, -10008346615.0;
7.369833333333334, -10332554730.0;
7.376500000000001, -10374659680.0;
7.383166666666667, -10416764630.0;
7.389833333333334, -10618868390.0;
7.3965000000000005, -10804130170.0;
7.403166666666667, -10787288190.0;
7.409833333333334, -10820972150.0;
7.416500000000001, -11048338880.0;
7.423166666666667, -11448335905.0;
7.429833333333334, -11477809370.0;
7.4365000000000006, -11359915510.0;
7.443166666666667, -11098864820.0;
7.449833333333334, -10913603040.0;
7.456500000000001, -10522027005.0;
7.463166666666667, -9827295330.0;
7.469833333333334, -9275720485.0;
7.476500000000001, -8816776530.0;
7.483166666666667, -8682040690.0;
7.489833333333334, -8458884455.0;
7.496500000000001, -8635725245.0;
7.503166666666667, -8993617320.0;
7.509833333333334, -9364140880.0;
7.516500000000001, -9528350185.0;
7.5231666666666674, -9444140285.0;
7.529833333333334, -9511508205.0;
7.5365, -9494666225.0;
7.543166666666667, -9679928005.0;
7.549833333333334, -9890452755.0;
7.556500000000001, -10454659085.0;
7.5631666666666675, -10896761060.0;
7.569833333333334, -11065180860.0;
7.5765, -10745183240.0;
7.583166666666667, -10290449780.0;
7.589833333333334, -9755716915.0;
7.596500000000001, -9090458705.0;
7.6031666666666675, -8816776530.0;
7.609833333333334, -8947301875.0;
7.6165, -9355719890.0;
7.623166666666667, -9532560680.0;
7.629833333333334, -9709401470.0;
7.636500000000001, -9898873745.0;
7.6431666666666676, -9966241665.0;
7.649833333333334, -9810453350.0;
7.6565, -9806242855.0;
7.663166666666667, -9949399685.0;
7.669833333333334, -10256765820.0;
7.676500000000001, -10395712155.0;
7.683166666666668, -10256765820.0;
7.6898333333333335, -9974662655.0;
7.6965, -9654665035.0;
7.703166666666667, -9338877910.0;
7.709833333333334, -8770461085.0;
7.716500000000001, -8387306040.0;
7.723166666666668, -8231517725.0;
7.729833333333334, -8105202875.0;
7.7365, -7865204660.0;
7.743166666666667, -7759942285.0;
7.749833333333334, -8054676935.0;
7.756500000000001, -8210465250.0;
7.763166666666668, -8446252970.0;
7.769833333333334, -8934670390.0;
7.7765, -9578876125.0;
7.783166666666667, -9882031765.0;
7.789833333333334, -9700980480.0;
7.796500000000001, -9553613155.0;
7.803166666666668, -9279930980.0;
7.809833333333334, -8728356135.0;
7.8165000000000004, -8239938715.0;
7.823166666666667, -8235728220.0;
7.829833333333334, -8530462870.0;
7.836500000000001, -8711514155.0;
7.843166666666668, -8829408015.0;
7.849833333333334, -9271509990.0;
7.8565000000000005, -9797821865.0;
7.863166666666667, -9907294735.0;
7.869833333333334, -9751506420.0;
7.876500000000001, -9562034145.0;
7.883166666666667, -9574665630.0;
7.889833333333334, -9334667415.0;
7.8965000000000005, -8858881480.0;
7.903166666666667, -8500989405.0;
7.909833333333334, -8362043070.0;
7.916500000000001, -8231517725.0;
7.923166666666667, -7936783075.0;
7.929833333333334, -7667311395.0;
7.9365000000000006, -7629416940.0;
7.943166666666667, -7886257135.0;
7.949833333333334, -8269412180.0;
7.9565, -8749408610.0;
7.963166666666668, -9002038310.0;
7.969833333333334, -9229405040.0;
7.9765000000000015, -9174668605.0;
7.983166666666667, -8829408015.0;
7.989833333333333, -8399937525.0;
7.996500000000001, -8126255350.0;
8.003166666666667, -8362043070.0;
8.009833333333335, -8509410395.0;
8.0165, -8433621485.0;
8.023166666666667, -8185202280.0;
8.029833333333334, -7852573175.0;
8.0365, -7688363870.0;
8.043166666666668, -7132578530.0;
8.049833333333334, -6648371605.0;
8.0565, -6513635765.0;
8.063166666666667, -6770475960.0;
8.069833333333333, -6951527245.0;
8.076500000000001, -6753633980.0;
8.083166666666667, -6821001900.0;
8.089833333333335, -7044158135.0;
8.0965, -7195735955.0;
8.103166666666667, -6938895760.0;
8.109833333333334, -6635740120.0;
8.1165, -6277848045.0;
8.123166666666668, -5743115180.0;
8.129833333333334, -5208382315.0;
8.1365, -4816806280.0;
8.143166666666668, -4602071035.0;
8.149833333333333, -4698912420.0;
8.156500000000001, -5082067465.0;
8.163166666666667, -5818904090.0;
8.169833333333335, -6534688240.0;
8.1765, -7288366845.0;
8.183166666666667, -7945204065.0;
8.189833333333334, -8138886835.0;
8.1965, -8063097925.0;
8.203166666666668, -7772573770.0;
8.209833333333334, -7650469415.0;
8.2165, -7322050805.0;
8.223166666666668, -6955737740.0;
8.229833333333334, -6753633980.0;
8.236500000000001, -6623108635.0;
8.243166666666667, -6593635170.0;
8.249833333333333, -6303111015.0;
8.2565, -5928376960.0;
8.263166666666667, -5595747855.0;
8.269833333333334, -5322065680.0;
8.2765, -5562063895.0;
8.283166666666668, -6021007850.0;
8.289833333333334, -6698897545.0;
8.2965, -7389418725.0;
8.303166666666668, -7978888025.0;
8.309833333333334, -8740987620.0;
8.316500000000001, -9275720485.0;
8.323166666666667, -9406245830.0;
8.329833333333333, -9199931575.0;
8.336500000000001, -8972564845.0;
8.343166666666667, -9107300685.0;
8.349833333333335, -9178879100.0;
8.3565, -9094669200.0;
8.363166666666668, -8846249995.0;
8.369833333333334, -8522041880.0;
8.3765, -8239938715.0;
8.383166666666668, -7810468225.0;
8.389833333333334, -7267314370.0;
8.396500000000001, -6576793190.0;
8.403166666666667, -6197848640.0;
8.409833333333333, -6105217750.0;
8.416500000000001, -5936797950.0;
8.423166666666667, -5595747855.0;
8.429833333333335, -5376802115.0;
8.4365, -5406275580.0;
8.443166666666666, -5355749640.0;
8.449833333333334, -5191540335.0;
8.4565, -5191540335.0;
8.463166666666668, -5284171225.0;
8.469833333333334, -5376802115.0;
8.476500000000001, -5423117560.0;
8.483166666666667, -5469433005.0;
8.489833333333333, -5621010825.0;
8.496500000000001, -5886272010.0;
8.503166666666667, -6345215965.0;
8.509833333333335, -6804159920.0;
8.5165, -7056789620.0;
8.523166666666667, -7220998925.0;
8.529833333333334, -7128368035.0;
8.5365, -6930474770.0;
8.543166666666668, -6378899925.0;
8.549833333333334, -5633642310.0;
8.556500000000002, -5221013800.0;
8.563166666666667, -5132593405.0;
8.569833333333333, -5338907660.0;
8.576500000000001, -5334697165.0;
8.583166666666667, -5612589835.0;
8.589833333333335, -6046270820.0;
8.5965, -6084165275.0;
8.603166666666667, -5612589835.0;
8.609833333333334, -5065225485.0;
8.6165, -4947331625.0;
8.623166666666668, -4825227270.0;
8.629833333333334, -4505229650.0;
8.6365, -4223126485.0;
8.643166666666668, -4126285100.0;
8.649833333333333, -4214705495.0;
8.656500000000001, -4273652425.0;
8.663166666666667, -4442072225.0;
8.669833333333335, -4707333410.0;
8.6765, -4976805090.0;
8.683166666666667, -5048383505.0;
8.689833333333334, -4858911230.0;
8.6965, -4492598165.0;
8.703166666666668, -4046285695.0;
8.709833333333334, -3839971440.0;
8.7165, -3932602330.0;
8.723166666666668, -4362072820.0;
8.729833333333334, -4682070440.0;
8.736500000000001, -4821016775.0;
8.743166666666667, -4736806875.0;
8.749833333333335, -4585229055.0;
8.7565, -4404177770.0;
8.763166666666667, -4517861135.0;
8.769833333333334, -4854700735.0;
8.7765, -5604168845.0;
8.783166666666668, -6197848640.0;
8.789833333333334, -6387320915.0;
8.7965, -6088375770.0;
8.803166666666668, -5637852805.0;
8.809833333333334, -5452591025.0;
8.816500000000001, -5077856970.0;
8.823166666666667, -4901016180.0;
8.829833333333333, -4909437170.0;
8.836500000000001, -5490485480.0;
8.843166666666667, -5991534385.0;
8.849833333333335, -6227322105.0;
8.8565, -6357847450.0;
8.863166666666668, -6488372795.0;
8.869833333333334, -6707318535.0;
8.8765, -6673634575.0;
8.883166666666668, -6319952995.0;
8.889833333333334, -5793641120.0;
8.896500000000001, -5301013205.0;
8.903166666666667, -4943121130.0;
8.909833333333333, -4757859350.0;
8.916500000000001, -4597860540.0;
8.923166666666667, -4484177175.0;
8.929833333333335, -4294704900.0;
8.9365, -4075759160.0;
8.943166666666666, -4037864705.0;
8.949833333333334, -4096811635.0;
8.9565, -4223126485.0;
8.963166666666668, -4404177770.0;
8.969833333333334, -4530492620.0;
8.976500000000001, -4753648855.0;
8.983166666666667, -4656807470.0;
8.989833333333333, -4223126485.0;
8.996500000000001, -3722077580.0;
9.003166666666667, -3473658375.0;
9.009833333333335, -3557868275.0;
9.0165, -3591552235.0;
9.023166666666667, -3557868275.0;
9.029833333333334, -3528394810.0;
9.0365, -3296817585.0;
9.043166666666668, -3031556400.0;
9.049833333333334, -2732611255.0;
9.056500000000002, -2576822940.0;
9.063166666666667, -2471560565.0;
9.069833333333333, -2724190265.0;
9.076500000000001, -3414711445.0;
9.083166666666667, -4239968465.0;
9.089833333333335, -4905226675.0;
9.0965, -5254697760.0;
9.103166666666667, -5536800925.0;
9.109833333333334, -5583116370.0;
9.1165, -5414696570.0;
9.123166666666668, -4959963110.0;
9.129833333333334, -4606281530.0;
9.1365, -4370493810.0;
9.143166666666668, -4252599950.0;
9.149833333333333, -3856813420.0;
9.156500000000001, -3385237980.0;
9.163166666666667, -2879978580.0;
9.169833333333335, -2484192050.0;
9.1765, -2252614825.0;
9.183166666666667, -2075774035.0;
9.189833333333334, -2075774035.0;
9.1965, -2265246310.0;
9.203166666666668, -2644190860.0;
9.209833333333334, -2715769275.0;
9.2165, -2677874820.0;
9.223166666666668, -2690506305.0;
9.229833333333334, -2985240955.0;
9.236500000000001, -3292607090.0;
9.243166666666667, -3452605900.0;
9.249833333333335, -3633657185.0;
9.2565, -3435763920.0;
9.263166666666667, -3111555805.0;
9.269833333333334, -2618927890.0;
9.2765, -2189457400.0;
9.283166666666668, -1907354235.0;
9.289833333333334, -2092616015.0;
9.2965, -2618927890.0;
9.303166666666668, -2858926105.0;
9.309833333333334, -2922083530.0;
9.316500000000001, -2997872440.0;
9.323166666666667, -3098924320.0;
9.329833333333333, -2728400760.0;
9.336500000000001, -2159983935.0;
9.343166666666667, -1873670275.0;
9.349833333333335, -1578935625.0;
9.3565, -1128412660.0;
9.363166666666668, -816836030.0;
9.369833333333334, -917887910.0;
9.3765, -1271569490.0;
9.383166666666668, -1482094240.0;
9.389833333333334, -1844196810.0;
9.396500000000001, -2307351260.0;
9.403166666666667, -2623138385.0;
9.409833333333333, -2635769870.0;
9.416500000000001, -2555770465.0;
9.423166666666667, -2522086505.0;
9.429833333333335, -2534717990.0;
9.4365, -2585243930.0;
9.443166666666668, -2812610660.0;
9.449833333333334, -3187344715.0;
9.4565, -3515763325.0;
9.463166666666668, -3911549855.0;
9.469833333333334, -4109443120.0;
9.476500000000001, -4054706685.0;
9.483166666666667, -3498921345.0;
9.489833333333333, -2728400760.0;
9.496500000000001, -2159983935.0;
9.503166666666667, -1688408495.0;
9.509833333333335, -1456831270.0;
9.5165, -1439989290.0;
9.523166666666667, -1701039980.0;
9.529833333333334, -2033669085.0;
9.5365, -2214720370.0;
9.543166666666668, -2378929675.0;
9.549833333333334, -2387350665.0;
9.556500000000002, -2197878390.0;
9.563166666666667, -1953669680.0;
9.569833333333333, -1654724535.0;
9.576500000000001, -1334726915.0;
9.583166666666667, -1031571275.0;
9.589833333333335, -1128412660.0;
9.5965, -1330516420.0;
9.603166666666667, -1338937410.0;
9.609833333333334, -1402094835.0;
9.6165, -1595777605.0;
9.623166666666668, -1861038790.0;
9.629833333333334, -1713671465.0;
9.636500000000002, -1423147310.0;
9.643166666666668, -1250517015.0;
9.649833333333333, -1103149690.0;
9.656500000000001, -985255830.0;
9.663166666666667, -901045930.0;
9.669833333333335, -774731080.0;
9.6765, -669468705.0;
9.683166666666667, -669468705.0;
9.689833333333334, -875782960.0;
9.6965, -985255830.0;
9.703166666666668, -812625535.0;
9.709833333333334, -534732865.0;
9.7165, -433680985.0;
9.723166666666668, -492627915.0;
9.729833333333334, -593679795.0;
9.736500000000001, -778941575.0;
9.743166666666667, -1048413255.0;
9.749833333333335, -1410515825.0;
9.7565, -1482094240.0;
9.763166666666667, -1145254640.0;
9.769833333333334, -661047715.0;
9.7765, -332629105.0;
9.783166666666668, -147367325.0;
9.789833333333334, 239998215.0;
9.7965, 530522370.0;
9.803166666666668, 492627915.0;
9.809833333333334, 75788910.0;
9.816500000000001, -151577820.0;
9.823166666666667, -155788315.0;
9.829833333333335, -164209305.0;
9.836500000000001, -159998810.0;
9.843166666666667, -164209305.0;
9.849833333333335, 126314850.0;
9.8565, 425259995.0;
9.863166666666668, 757889100.0;
9.869833333333334, 905256425.0;
9.8765, 711573655.0;
9.883166666666668, 261050690.0;
9.889833333333334, -29473465.0;
9.896500000000001, -58946930.0;
9.903166666666667, 4210495.0;
9.909833333333333, 71578415.0;
9.916500000000001, 349471085.0;
9.923166666666667, 888414445.0;
9.929833333333335, 1258938005.0;
9.9365, 1317884935.0;
9.943166666666668, 1048413255.0;
9.949833333333334, 661047715.0;
9.9565, 181051285.0;
9.963166666666668, -134735840.0;
9.969833333333334, -273682175.0;
9.976500000000001, -252629700.0;
9.983166666666667, -96841385.0;
9.989833333333333, 147367325.0;
9.996500000000001, 526311875.0;
10.003166666666667, 850519990.0;
10.009833333333335, 989466325.0;
10.0165, 1048413255.0;
10.023166666666667, 1014729295.0;
10.029833333333334, 1098939195.0;
10.0365, 1174728105.0;
10.043166666666668, 1246306520.0;
10.049833333333334, 1343147905.0;
10.056500000000002, 1393673845.0;
10.063166666666667, 1376831865.0;
10.069833333333333, 1157886125.0;
10.076500000000001, 854730485.0;
10.083166666666667, 694731675.0;
10.089833333333335, 749468110.0;
10.0965, 968413850.0;
10.103166666666667, 1174728105.0;
10.109833333333334, 1166307115.0;
10.1165, 1073676225.0;
10.123166666666668, 762099595.0;
10.129833333333334, 568416825.0;
10.136500000000002, 349471085.0;
10.143166666666668, 475785935.0;
10.149833333333333, 879993455.0;
10.156500000000001, 1511567705.0;
10.163166666666667, 2105247500.0;
10.169833333333335, 2429455615.0;
10.1765, 2639980365.0;
10.183166666666667, 2778926700.0;
10.189833333333334, 2972609470.0;
10.1965, 2951556995.0;
10.203166666666668, 2879978580.0;
10.209833333333334, 2724190265.0;
10.2165, 2610506900.0;
10.223166666666668, 2442087100.0;
10.229833333333334, 2294719775.0;
10.236500000000001, 2143141955.0;
10.243166666666667, 1751565920.0;
10.249833333333335, 1322095430.0;
10.2565, 955782365.0;
10.263166666666667, 551574845.0;
10.269833333333334, 75788910.0;
10.2765, -294734650.0;
10.283166666666668, -185261780.0;
10.289833333333334, 349471085.0;
10.2965, 926308900.0;
10.303166666666668, 1688408495.0;
10.309833333333334, 2332614230.0;
10.316500000000001, 3103134815.0;
10.323166666666667, 3835760945.0;
10.329833333333335, 4387335790.0;
10.336500000000001, 4656807470.0;
10.343166666666667, 4383125295.0;
10.349833333333335, 4134706090.0;
10.3565, 3877865895.0;
10.363166666666668, 3781024510.0;
10.369833333333334, 3536815800.0;
10.3765, 3414711445.0;
10.383166666666668, 3608394215.0;
10.389833333333334, 3844181935.0;
10.396500000000001, 3865234410.0;
10.403166666666667, 3604183720.0;
10.409833333333333, 3507342335.0;
10.416500000000001, 3452605900.0;
10.423166666666667, 3246291645.0;
10.429833333333335, 2888399570.0;
10.4365, 2799979175.0;
10.443166666666668, 2867347095.0;
10.449833333333334, 2875768085.0;
10.4565, 2846294620.0;
10.463166666666668, 2934715015.0;
10.469833333333334, 3107345310.0;
10.476500000000001, 3090503330.0;
10.483166666666667, 2922083530.0;
10.489833333333333, 2846294620.0;
10.496500000000001, 2762084720.0;
10.503166666666667, 2799979175.0;
10.509833333333335, 3031556400.0;
10.5165, 3359975010.0;
10.523166666666668, 3722077580.0;
10.529833333333334, 3839971440.0;
10.5365, 3894707875.0;
10.543166666666668, 4042075200.0;
10.549833333333334, 4130495595.0;
10.556500000000002, 4071548665.0;
10.563166666666667, 3839971440.0;
10.569833333333333, 3604183720.0;
10.576500000000001, 3473658375.0;
10.583166666666667, 3246291645.0;
10.589833333333335, 3023135410.0;
10.5965, 3035766895.0;
10.603166666666667, 3153660755.0;
10.609833333333334, 3301028080.0;
10.6165, 3347343525.0;
10.623166666666668, 3204186695.0;
10.629833333333334, 3301028080.0;
10.636500000000002, 3629446690.0;
10.643166666666668, 4294704900.0;
10.649833333333333, 4955752615.0;
10.656500000000001, 5444170035.0;
10.663166666666667, 5747325675.0;
10.669833333333335, 5755746665.0;
10.6765, 5381012610.0;
10.683166666666667, 4825227270.0;
10.689833333333334, 4155758565.0;
10.6965, 3667341145.0;
10.703166666666668, 3701025105.0;
10.709833333333334, 3806287480.0;
10.716500000000002, 4151548070.0;
10.723166666666668, 4387335790.0;
10.729833333333334, 4778911825.0;
10.736500000000001, 5178908850.0;
10.743166666666667, 5199961325.0;
10.749833333333335, 5023120535.0;
10.7565, 4475756185.0;
10.763166666666667, 4164179555.0;
10.769833333333334, 4176811040.0;
10.7765, 4378914800.0;
10.783166666666668, 4454703710.0;
10.789833333333334, 4547334600.0;
10.7965, 4896805685.0;
10.803166666666668, 5275750235.0;
10.809833333333334, 5229434790.0;
10.816500000000001, 4863121725.0;
10.823166666666667, 5069435980.0;
10.829833333333335, 5823114585.0;
10.836500000000001, 6606266655.0;
10.843166666666667, 6816791405.0;
10.849833333333335, 7018895165.0;
10.8565, 7347313775.0;
10.863166666666668, 7423102685.0;
10.869833333333334, 6976790215.0;
10.8765, 6387320915.0;
10.883166666666668, 6294690025.0;
10.889833333333334, 6332584480.0;
10.896500000000001, 6421004875.0;
10.903166666666667, 6391531410.0;
10.909833333333335, 6526267250.0;
10.916500000000001, 6938895760.0;
10.923166666666667, 7174683480.0;
10.929833333333335, 7288366845.0;
10.9365, 7191525460.0;
10.943166666666668, 7027316155.0;
10.949833333333334, 6661003090.0;
10.9565, 5995744880.0;
10.963166666666668, 5397854590.0;
10.969833333333334, 4922068655.0;
10.976500000000001, 4741017370.0;
10.983166666666667, 4829437765.0;
10.989833333333333, 5322065680.0;
10.996500000000001, 5911534980.0;
11.003166666666667, 6458899330.0;
11.009833333333335, 6976790215.0;
11.0165, 7343103280.0;
11.023166666666668, 7578891000.0;
11.029833333333334, 7431523675.0;
11.0365, 7364155755.0;
11.043166666666668, 7258893380.0;
11.049833333333334, 7157841500.0;
11.056500000000002, 6833633385.0;
11.063166666666667, 6341005470.0;
11.069833333333333, 6105217750.0;
11.076500000000001, 6046270820.0;
11.083166666666667, 6269427055.0;
11.089833333333335, 6433636360.0;
11.0965, 6791528435.0;
11.103166666666667, 7208367440.0;
11.109833333333334, 7528365060.0;
11.1165, 7423102685.0;
11.123166666666668, 7010474175.0;
11.129833333333334, 6711529030.0;
11.136500000000002, 6778896950.0;
11.143166666666668, 7149420510.0;
11.149833333333333, 7359945260.0;
11.156500000000001, 7397839715.0;
11.163166666666667, 7368366250.0;
11.169833333333335, 7566259515.0;
11.1765, 7671521890.0;
11.183166666666667, 7519944070.0;
11.189833333333334, 7212577935.0;
11.1965, 7313629815.0;
11.203166666666668, 7772573770.0;
11.209833333333334, 8054676935.0;
11.216500000000002, 8004150995.0;
11.223166666666668, 7940993570.0;
11.229833333333334, 8185202280.0;
11.236500000000001, 8269412180.0;
11.243166666666667, 8122044855.0;
11.249833333333335, 7999940500.0;
11.2565, 8046255945.0;
11.263166666666667, 8084150400.0;
11.269833333333334, 8159939310.0;
11.2765, 8378885050.0;
11.283166666666668, 8429410990.0;
11.289833333333334, 8147307825.0;
11.2965, 7747310800.0;
11.303166666666668, 7490470605.0;
11.309833333333334, 7115736550.0;
11.316500000000001, 6547319725.0;
11.323166666666667, 6202059135.0;
11.329833333333335, 6223111610.0;
11.336500000000001, 6585214180.0;
11.343166666666667, 6879948830.0;
11.349833333333335, 7195735955.0;
11.3565, 7507312585.0;
11.363166666666668, 7688363870.0;
11.369833333333334, 7688363870.0;
11.3765, 7477839120.0;
11.383166666666668, 7423102685.0;
11.389833333333334, 7490470605.0;
11.396500000000001, 7684153375.0;
11.403166666666667, 7894678125.0;
11.409833333333335, 8122044855.0;
11.416500000000001, 8374674555.0;
11.423166666666667, 8450463465.0;
11.429833333333335, 8564146830.0;
11.4365, 8736777125.0;
11.443166666666668, 9216773555.0;
11.449833333333334, 9633612560.0;
11.4565, 9970452160.0;
11.463166666666668, 10244134335.0;
11.469833333333334, 10105188000.0;
11.476500000000001, 9797821865.0;
11.483166666666667, 9242036525.0;
11.489833333333333, 9010459300.0;
11.496500000000001, 8900986430.0;
11.503166666666667, 8842039500.0;
11.509833333333335, 9098879695.0;
11.5165, 9317825435.0;
11.523166666666668, 9511508205.0;
11.529833333333334, 9562034145.0;
11.5365, 9654665035.0;
11.543166666666668, 9797821865.0;
11.549833333333334, 9540981670.0;
11.556500000000002, 9271509990.0;
11.563166666666667, 9140984645.0;
11.569833333333333, 9124142665.0;
11.576500000000001, 9204142070.0;
11.583166666666667, 9486245235.0;
11.589833333333335, 10235713345.0;
11.5965, 10926234525.0;
11.603166666666668, 11313600065.0;
11.609833333333334, 11355705015.0;
11.6165, 11018865415.0;
11.623166666666668, 10399922650.0;
11.629833333333334, 9570455135.0;
11.636500000000002, 9052564250.0;
11.643166666666668, 8745198115.0;
11.649833333333333, 8766250590.0;
11.656500000000001, 9056774745.0;
11.663166666666667, 9242036525.0;
11.669833333333335, 9351509395.0;
11.6765, 9170458110.0;
11.683166666666667, 9305193950.0;
11.689833333333334, 9620981075.0;
11.6965, 10058872555.0;
11.703166666666668, 10425185620.0;
11.709833333333334, 10513606015.0;
11.716500000000002, 10753604230.0;
11.723166666666668, 10804130170.0;
11.729833333333334, 10719920270.0;
11.736500000000001, 10500974530.0;
11.743166666666667, 10707288785.0;
11.749833333333335, 11452546400.0;
11.7565, 12092541640.0;
11.763166666666667, 12286224410.0;
11.769833333333334, 12063068175.0;
11.7765, 11709386595.0;
11.783166666666668, 11166232740.0;
11.789833333333334, 10677815320.0;
11.796500000000002, 10311502255.0;
11.803166666666668, 10185187405.0;
11.809833333333334, 10126240475.0;
11.816500000000001, 10155713940.0;
11.823166666666667, 10265186810.0;
11.829833333333335, 10012557110.0;
11.836500000000001, 9789400875.0;
11.843166666666667, 9717822460.0;
11.849833333333335, 10029399090.0;
11.8565, 10336765225.0;
11.863166666666668, 10479922055.0;
11.869833333333334, 10656762845.0;
11.8765, 10808340665.0;
11.883166666666668, 11128338285.0;
11.889833333333334, 11258863630.0;
11.896500000000001, 11246232145.0;
11.903166666666667, 11094654325.0;
11.909833333333335, 11435704420.0;
11.916500000000001, 11953595305.0;
11.923166666666667, 12197804015.0;
11.929833333333335, 12138857085.0;
11.9365, 12033594710.0;
11.943166666666668, 12223066985.0;
11.949833333333334, 12248329955.0;
11.9565, 12336750350.0;
11.963166666666668, 12408328765.0;
11.969833333333334, 12458854705.0;
11.976500000000001, 12614643020.0;
11.983166666666667, 12783062820.0;
11.989833333333335, 12833588760.0;
11.996500000000001, 12766220840.0;
12.003166666666667, 12896746185.0;
12.009833333333335, 13233585785.0;
12.0165, 13406216080.0;
12.023166666666668, 13229375290.0;
12.029833333333334, 13006219055.0;
12.0365, 12492538665.0;
12.043166666666668, 11894648375.0;
12.049833333333334, 11393599470.0;
12.056500000000002, 11334652540.0;
12.063166666666667, 11557808775.0;
12.069833333333333, 11768333525.0;
12.076500000000001, 12075699660.0;
12.083166666666667, 12332539855.0;
12.089833333333335, 12593590545.0;
12.0965, 12736747375.0;
12.103166666666668, 12955693115.0;
12.109833333333334, 13275690735.0;
12.1165, 13642003800.0;
12.123166666666668, 13793581620.0;
12.129833333333334, 13772529145.0;
12.136500000000002, 13553583405.0;
12.143166666666668, 13254638260.0;
12.149833333333333, 12736747375.0;
12.156500000000001, 12332539855.0;
12.163166666666667, 12252540450.0;
12.169833333333335, 12408328765.0;
12.1765, 12682010940.0;
12.183166666666667, 12863062225.0;
12.189833333333334, 12829378265.0;
12.1965, 12635695495.0;
12.203166666666668, 12513591140.0;
12.209833333333334, 12505170150.0;
12.216500000000002, 12543064605.0;
12.223166666666668, 12715694900.0;
12.229833333333334, 13452531525.0;
12.236500000000001, 14185157655.0;
12.243166666666667, 14610417650.0;
12.249833333333335, 14690417055.0;
12.2565, 14580944185.0;
12.263166666666667, 14340945970.0;
12.269833333333334, 13919896470.0;
12.2765, 13759897660.0;
12.283166666666668, 13835686570.0;
12.289833333333334, 13911475480.0;
12.296500000000002, 13882002015.0;
12.303166666666668, 13844107560.0;
12.309833333333334, 13835686570.0;
12.316500000000001, 14050421815.0;
12.323166666666667, 14130421220.0;
12.329833333333335, 14172526170.0;
12.336500000000001, 14185157655.0;
12.343166666666667, 14054632310.0;
12.349833333333335, 13776739640.0;
12.3565, 13039903015.0;
12.363166666666668, 12467275695.0;
12.369833333333334, 12164120055.0;
12.3765, 12143067580.0;
12.383166666666668, 12315697875.0;
12.389833333333334, 12387276290.0;
12.396500000000001, 12576748565.0;
12.403166666666667, 12618853515.0;
12.409833333333335, 12673589950.0;
12.416500000000001, 12686221435.0;
12.423166666666667, 12762010345.0;
12.429833333333335, 13039903015.0;
12.4365, 13372532120.0;
12.443166666666668, 13679898255.0;
12.449833333333334, 14016737855.0;
12.4565, 14345156465.0;
12.463166666666668, 14572523195.0;
12.469833333333334, 14441997850.0;
12.476500000000001, 14155684190.0;
12.483166666666667, 14050421815.0;
12.489833333333335, 13991474885.0;
12.496500000000001, 13936738450.0;
12.503166666666667, 13814634095.0;
12.509833333333335, 13789371125.0;
12.5165, 13924106965.0;
12.523166666666668, 13983053895.0;
12.529833333333334, 13999895875.0;
12.5365, 14016737855.0;
12.543166666666668, 14075684785.0;
12.549833333333334, 14269367555.0;
12.556500000000002, 14378840425.0;
12.563166666666667, 14425155870.0;
12.569833333333333, 14138842210.0;
12.576500000000001, 13654635285.0;
12.583166666666667, 13098849945.0;
12.589833333333335, 12602011535.0;
12.5965, 12138857085.0;
12.603166666666668, 11860964415.0;
12.609833333333334, 11557808775.0;
12.6165, 11334652540.0;
12.623166666666668, 11402020460.0;
12.629833333333334, 11856753920.0;
12.636500000000002, 12517801635.0;
12.643166666666668, 12770431335.0;
12.649833333333333, 13174638855.0;
12.656500000000001, 13827265580.0;
12.663166666666667, 14509365770.0;
12.669833333333335, 14677785570.0;
12.6765, 14336735475.0;
12.683166666666668, 14084105775.0;
12.689833333333334, 13957790925.0;
12.6965, 13957790925.0;
12.703166666666668, 13882002015.0;
12.709833333333334, 14008316865.0;
12.716500000000002, 14168315675.0;
12.723166666666668, 14324103990.0;
12.729833333333334, 14248315080.0;
12.736500000000001, 14037790330.0;
12.743166666666667, 13608319840.0;
12.749833333333335, 12976745590.0;
12.7565, 12703063415.0;
12.763166666666667, 12669379455.0;
12.769833333333334, 12884114700.0;
12.7765, 12623064010.0;
12.783166666666668, 12450433715.0;
12.789833333333334, 12395697280.0;
12.796500000000002, 12113594115.0;
12.803166666666668, 11667281645.0;
12.809833333333334, 11225179670.0;
12.816500000000001, 11469388380.0;
12.823166666666667, 11734649565.0;
12.829833333333335, 11810438475.0;
12.836500000000001, 11844122435.0;
12.843166666666667, 12016752730.0;
12.849833333333335, 12134646590.0;
12.8565, 12012542235.0;
12.863166666666668, 11755702040.0;
12.869833333333334, 11604124220.0;
12.876500000000002, 11465177885.0;
12.883166666666668, 11174653730.0;
12.889833333333334, 10736762250.0;
12.896500000000001, 10151503445.0;
12.903166666666667, 9789400875.0;
12.909833333333335, 9553613155.0;
12.916500000000001, 9456771770.0;
12.923166666666667, 9355719890.0;
12.929833333333335, 9347298900.0;
12.9365, 9431508800.0;
12.943166666666668, 9562034145.0;
12.949833333333334, 9595718105.0;
12.9565, 9583086620.0;
12.963166666666668, 9684138500.0;
12.969833333333334, 10054662060.0;
12.976500000000001, 10399922650.0;
12.983166666666667, 10324133740.0;
12.989833333333335, 10037820080.0;
12.996500000000001, 9713611965.0;
13.003166666666667, 9679928005.0;
13.009833333333335, 9482034740.0;
13.0165, 9292562465.0;
13.023166666666668, 9414666820.0;
13.029833333333334, 9932557705.0;
13.0365, 10530447995.0;
13.043166666666668, 10652552350.0;
13.049833333333334, 10446238095.0;
13.056500000000002, 10130450970.0;
13.063166666666667, 9793611370.0;
13.069833333333335, 9330456920.0;
13.076500000000001, 8778882075.0;
13.083166666666667, 8269412180.0;
13.089833333333335, 7987309015.0;
13.0965, 7911520105.0;
13.103166666666668, 7898888620.0;
13.109833333333334, 7911520105.0;
13.1165, 7831520700.0;
13.123166666666668, 7743100305.0;
13.129833333333334, 7633627435.0;
13.136500000000002, 7486260110.0;
13.143166666666668, 7220998925.0;
13.149833333333333, 6825212395.0;
13.156500000000001, 6522056755.0;
13.163166666666667, 6585214180.0;
13.169833333333335, 6698897545.0;
13.1765, 6757844475.0;
13.183166666666668, 6631529625.0;
13.189833333333334, 6631529625.0;
13.1965, 6715739525.0;
13.203166666666668, 6934685265.0;
13.209833333333334, 7183104470.0;
13.216500000000002, 7254682885.0;
13.223166666666668, 7166262490.0;
13.229833333333334, 7056789620.0;
13.236500000000001, 7035737145.0;
13.243166666666667, 6581003685.0;
13.249833333333335, 6042060325.0;
13.2565, 5852588050.0;
13.263166666666667, 6248374580.0;
13.269833333333334, 6707318535.0;
13.2765, 6850475365.0;
13.283166666666668, 7086263085.0;
13.289833333333334, 7347313775.0;
13.296500000000002, 7364155755.0;
13.303166666666668, 6757844475.0;
13.309833333333334, 6004165870.0;
13.316500000000001, 5688378745.0;
13.323166666666667, 5743115180.0;
13.329833333333335, 5941008445.0;
13.336500000000001, 6054691810.0;
13.343166666666667, 6446267845.0;
13.349833333333335, 6745212990.0;
13.3565, 6968369225.0;
13.363166666666668, 7077842095.0;
13.369833333333334, 6964158730.0;
13.376500000000002, 6719950020.0;
13.383166666666668, 6319952995.0;
13.389833333333334, 6210480125.0;
13.396500000000001, 5974692405.0;
13.403166666666667, 5461012015.0;
13.409833333333335, 5111540930.0;
13.416500000000001, 5204171820.0;
13.423166666666667, 5734694190.0;
13.429833333333335, 6197848640.0;
13.4365, 6509425270.0;
13.443166666666668, 6631529625.0;
13.449833333333334, 6517846260.0;
13.4565, 6227322105.0;
13.463166666666668, 5877851020.0;
13.469833333333334, 5528379935.0;
13.476500000000001, 5296802710.0;
13.483166666666667, 5178908850.0;
13.489833333333335, 5166277365.0;
13.496500000000001, 5242066275.0;
13.503166666666667, 5301013205.0;
13.509833333333335, 5465222510.0;
13.5165, 5823114585.0;
13.523166666666668, 6395741905.0;
13.529833333333334, 7107315560.0;
13.5365, 7549417535.0;
13.543166666666668, 7831520700.0;
13.549833333333334, 8016782480.0;
13.556500000000002, 8084150400.0;
13.563166666666667, 7983098520.0;
13.569833333333335, 7486260110.0;
13.576500000000001, 7027316155.0;
13.583166666666667, 6606266655.0;
13.589833333333335, 6227322105.0;
13.5965, 5793641120.0;
13.603166666666668, 5444170035.0;
13.609833333333334, 5292592215.0;
13.6165, 5271539740.0;
13.623166666666668, 5216803305.0;
13.629833333333334, 5174698355.0;
13.636500000000002, 5313644690.0;
13.643166666666668, 5658905280.0;
13.649833333333333, 6185217155.0;
13.656500000000001, 6606266655.0;
13.663166666666667, 6816791405.0;
13.669833333333335, 6875738335.0;
13.6765, 6850475365.0;
13.683166666666668, 6547319725.0;
13.689833333333334, 6088375770.0;
13.6965, 5898903495.0;
13.703166666666668, 6214690620.0;
13.709833333333334, 6656792595.0;
13.716500000000002, 6934685265.0;
13.723166666666668, 7191525460.0;
13.729833333333334, 7557838525.0;
13.736500000000001, 7776784265.0;
13.743166666666667, 7591522485.0;
13.749833333333335, 7225209420.0;
13.7565, 6892580315.0;
13.763166666666669, 6833633385.0;
13.769833333333334, 6799949425.0;
13.7765, 6783107445.0;
13.783166666666668, 6837843880.0;
13.789833333333334, 6888369820.0;
13.796500000000002, 6867317345.0;
13.803166666666668, 6610477150.0;
13.809833333333334, 6378899925.0;
13.816500000000001, 6079954780.0;
13.823166666666667, 5848377555.0;
13.829833333333335, 5793641120.0;
13.836500000000001, 6050481315.0;
13.843166666666667, 6298900520.0;
13.849833333333335, 6252585075.0;
13.8565, 6218901115.0;
13.863166666666668, 6290479530.0;
13.869833333333334, 6484162300.0;
13.876500000000002, 6479951805.0;
13.883166666666668, 6610477150.0;
13.889833333333334, 6926264275.0;
13.896500000000001, 7309419320.0;
13.903166666666667, 7414681695.0;
13.909833333333335, 7338892785.0;
13.916500000000001, 7246261895.0;
13.923166666666667, 6993632195.0;
13.929833333333335, 6879948830.0;
13.9365, 6686266060.0;
13.943166666666668, 6829422890.0;
13.949833333333334, 7018895165.0;
13.956500000000002, 7322050805.0;
13.963166666666668, 7654679910.0;
13.969833333333334, 7852573175.0;
13.976500000000001, 8185202280.0;
13.983166666666667, 8526252375.0;
13.989833333333335, 8669409205.0;
13.996500000000001, 8332569605.0;
14.003166666666667, 7932572580.0;
14.009833333333335, 7688363870.0;
14.0165, 7414681695.0;
14.023166666666668, 6964158730.0;
14.029833333333334, 6501004280.0;
14.0365, 6661003090.0;
14.043166666666668, 6837843880.0;
14.049833333333334, 6901001305.0;
14.056500000000002, 6909422295.0;
14.063166666666667, 7098894570.0;
14.069833333333335, 7477839120.0;
14.076500000000001, 7296787835.0;
14.083166666666667, 6875738335.0;
14.089833333333335, 6395741905.0;
14.0965, 6088375770.0;
14.103166666666668, 5941008445.0;
14.109833333333334, 5625221320.0;
14.1165, 5503116965.0;
14.123166666666668, 5583116370.0;
14.129833333333334, 5886272010.0;
14.136500000000002, 6046270820.0;
14.143166666666668, 5907324485.0;
14.149833333333333, 5797851615.0;
14.156500000000001, 5701010230.0;
14.163166666666667, 5671536765.0;
14.169833333333335, 5423117560.0;
14.1765, 5178908850.0;
14.183166666666668, 5107330435.0;
14.189833333333334, 5162066870.0;
14.1965, 5199961325.0;
14.203166666666668, 5103119940.0;
14.209833333333334, 5128382910.0;
14.216500000000002, 5465222510.0;
14.223166666666668, 5642063300.0;
14.229833333333334, 5919955970.0;
14.236500000000001, 6223111610.0;
14.243166666666667, 6905211800.0;
14.249833333333335, 7355734765.0;
14.2565, 7220998925.0;
14.263166666666669, 6972579720.0;
14.269833333333334, 6745212990.0;
14.2765, 6854685860.0;
14.283166666666668, 6753633980.0;
14.289833333333334, 6799949425.0;
14.296500000000002, 7393629220.0;
14.303166666666668, 8265201685.0;
14.309833333333334, 8892565440.0;
14.316500000000001, 8753619105.0;
14.323166666666667, 8488357920.0;
14.329833333333335, 8159939310.0;
14.336500000000001, 7663100900.0;
14.343166666666667, 6997842690.0;
14.349833333333335, 6538898735.0;
14.3565, 6665213585.0;
14.363166666666668, 6943106255.0;
14.369833333333334, 7330471795.0;
14.376500000000002, 7338892785.0;
14.383166666666668, 7263103875.0;
14.389833333333334, 6976790215.0;
14.396500000000001, 6682055565.0;
14.403166666666667, 6488372795.0;
14.409833333333335, 6349426460.0;
14.416500000000001, 6517846260.0;
14.423166666666667, 6795738930.0;
14.429833333333335, 7018895165.0;
14.4365, 6993632195.0;
14.443166666666668, 6749423485.0;
14.449833333333334, 6656792595.0;
14.456500000000002, 6770475960.0;
14.463166666666668, 6943106255.0;
14.469833333333334, 7225209420.0;
14.476500000000001, 7469418130.0;
14.483166666666667, 7705205850.0;
14.489833333333335, 7608364465.0;
14.496500000000001, 7284156350.0;
14.503166666666667, 6821001900.0;
14.509833333333335, 6458899330.0;
14.5165, 6324163490.0;
14.523166666666668, 6261006065.0;
14.529833333333334, 6256795570.0;
14.5365, 6164164680.0;
14.543166666666668, 6075744285.0;
14.549833333333334, 5717852210.0;
14.556500000000002, 5650484290.0;
14.563166666666667, 5713641715.0;
14.569833333333335, 5953639930.0;
14.576500000000001, 6117849235.0;
14.583166666666667, 6479951805.0;
14.589833333333335, 7162051995.0;
14.5965, 7515733575.0;
14.603166666666668, 7620995950.0;
14.609833333333334, 7423102685.0;
14.6165, 7313629815.0;
14.623166666666668, 7338892785.0;
14.629833333333334, 7519944070.0;
14.636500000000002, 7831520700.0;
14.643166666666668, 8269412180.0;
14.649833333333335, 8787303065.0;
14.656500000000001, 9254668010.0;
14.663166666666667, 9229405040.0;
14.669833333333335, 8812566035.0;
14.6765, 8180991785.0;
14.683166666666668, 7671521890.0;
14.689833333333334, 7359945260.0;
14.6965, 7258893380.0;
14.703166666666668, 7507312585.0;
14.709833333333334, 7591522485.0;
14.716500000000002, 7519944070.0;
14.723166666666668, 7111526055.0;
14.729833333333334, 6854685860.0;
14.736500000000001, 6753633980.0;
14.743166666666667, 6458899330.0;
14.749833333333335, 6399952400.0;
14.7565, 6505214775.0;
14.763166666666669, 6888369820.0;
14.769833333333334, 7098894570.0;
14.7765, 6968369225.0;
14.783166666666668, 6888369820.0;
14.789833333333334, 6715739525.0;
14.796500000000002, 6686266060.0;
14.803166666666668, 6639950615.0;
14.809833333333334, 6581003685.0;
14.816500000000001, 6218901115.0;
14.823166666666667, 5755746665.0;
14.829833333333335, 5292592215.0;
14.836500000000001, 5039962515.0;
14.843166666666669, 4922068655.0;
14.849833333333335, 4981015585.0;
14.8565, 5469433005.0;
14.863166666666668, 5970481910.0;
14.869833333333334, 6446267845.0;
14.876500000000002, 6593635170.0;
14.883166666666668, 6644161110.0;
14.889833333333334, 6538898735.0;
14.896500000000001, 6492583290.0;
14.903166666666667, 6534688240.0;
14.909833333333335, 6585214180.0;
14.916500000000001, 6378899925.0;
14.923166666666667, 6096796760.0;
14.929833333333335, 5877851020.0;
14.9365, 5823114585.0;
14.943166666666668, 5911534980.0;
14.949833333333334, 6029428840.0;
14.956500000000002, 6244164085.0;
14.963166666666668, 6151533195.0;
14.969833333333334, 5814693595.0;
14.976500000000001, 5435749045.0;
14.983166666666667, 5246276770.0;
14.989833333333335, 5532590430.0;
14.996500000000001, 5987323890.0;
15.003166666666667, 6656792595.0;
15.009833333333335, 7178893975.0;
15.0165, 7288366845.0;
15.023166666666668, 7035737145.0;
15.029833333333334, 6564161705.0;
15.036500000000002, 6315742500.0;
15.043166666666668, 6151533195.0;
15.049833333333334, 6143112205.0;
15.056500000000002, 6235743095.0;
15.063166666666667, 6282058540.0;
15.069833333333335, 6130480720.0;
15.076500000000001, 5827325080.0;
15.083166666666667, 5599958350.0;
15.089833333333335, 5389433600.0;
15.0965, 5065225485.0;
15.103166666666668, 4901016180.0;
15.109833333333334, 4867332220.0;
15.1165, 4854700735.0;
15.123166666666668, 4901016180.0;
15.129833333333334, 5225224295.0;
15.136500000000002, 6046270820.0;
15.143166666666668, 6682055565.0;
15.149833333333335, 7073631600.0;
15.156500000000001, 7292577340.0;
15.163166666666667, 7351524270.0;
15.169833333333335, 7515733575.0;
15.1765, 7431523675.0;
15.183166666666668, 7658890405.0;
15.189833333333334, 7755731790.0;
15.1965, 7882046640.0;
15.203166666666668, 8004150995.0;
15.209833333333334, 7688363870.0;
15.216500000000002, 7107315560.0;
15.223166666666668, 6277848045.0;
15.229833333333334, 5785220130.0;
15.236500000000001, 5587326865.0;
15.243166666666667, 5444170035.0;
15.249833333333335, 5637852805.0;
15.2565, 6218901115.0;
15.263166666666669, 7018895165.0;
15.269833333333334, 7705205850.0;
15.2765, 7882046640.0;
15.283166666666668, 7835731195.0;
15.289833333333334, 7595732980.0;
15.296500000000002, 7271524865.0;
15.303166666666668, 6926264275.0;
15.309833333333334, 6572582695.0;
15.316500000000001, 6370478935.0;
15.323166666666667, 6429425865.0;
15.329833333333335, 6576793190.0;
15.336500000000001, 6623108635.0;
15.343166666666669, 6551530220.0;
15.349833333333335, 6572582695.0;
15.3565, 6879948830.0;
15.363166666666668, 7094684075.0;
15.369833333333334, 7187314965.0;
15.376500000000002, 7250472390.0;
15.383166666666668, 7103105065.0;
15.389833333333334, 7031526650.0;
15.396500000000001, 6879948830.0;
15.403166666666667, 6917843285.0;
15.409833333333335, 6698897545.0;
15.416500000000001, 6475741310.0;
15.423166666666667, 6652582100.0;
15.429833333333335, 6715739525.0;
15.4365, 6682055565.0;
15.443166666666668, 6492583290.0;
15.449833333333334, 6627319130.0;
15.456500000000002, 6812580910.0;
15.463166666666668, 6559951210.0;
15.469833333333334, 6252585075.0;
15.476500000000001, 6071533790.0;
15.483166666666667, 6075744285.0;
15.489833333333335, 6244164085.0;
15.496500000000001, 6378899925.0;
15.503166666666667, 6522056755.0;
15.509833333333335, 6665213585.0;
15.5165, 6821001900.0;
15.523166666666668, 7208367440.0;
15.529833333333334, 7288366845.0;
15.536500000000002, 7208367440.0;
15.543166666666668, 7225209420.0;
15.549833333333334, 7439944665.0;
15.556500000000002, 7435734170.0;
15.563166666666667, 7010474175.0;
15.569833333333335, 6719950020.0;
15.576500000000001, 6728371010.0;
15.583166666666667, 6791528435.0;
15.589833333333335, 6715739525.0;
15.5965, 6703108040.0;
15.603166666666668, 6770475960.0;
15.609833333333334, 7014684670.0;
15.6165, 7326261300.0;
15.623166666666668, 7658890405.0;
15.629833333333334, 7705205850.0;
15.636500000000002, 7688363870.0;
15.643166666666668, 7692574365.0;
15.649833333333335, 7633627435.0;
15.656500000000001, 7393629220.0;
15.663166666666667, 7191525460.0;
15.669833333333335, 7279945855.0;
15.6765, 7528365060.0;
15.683166666666668, 7633627435.0;
15.689833333333334, 7317840310.0;
15.6965, 6665213585.0;
15.703166666666668, 5974692405.0;
15.709833333333334, 5435749045.0;
15.716500000000002, 5107330435.0;
15.723166666666668, 4909437170.0;
15.729833333333335, 5103119940.0;
15.736500000000001, 5658905280.0;
15.743166666666667, 6218901115.0;
15.749833333333335, 6513635765.0;
15.7565, 6366268440.0;
15.763166666666669, 6294690025.0;
15.769833333333334, 6341005470.0;
15.7765, 6471530815.0;
15.783166666666668, 6677845070.0;
15.789833333333334, 7014684670.0;
15.796500000000002, 7646258920.0;
15.803166666666668, 8122044855.0;
15.809833333333334, 8122044855.0;
15.816500000000001, 7890467630.0;
15.823166666666667, 7595732980.0;
15.829833333333335, 7220998925.0;
15.836500000000001, 6572582695.0;
15.843166666666669, 5924166465.0;
15.849833333333335, 5793641120.0;
15.8565, 5894693000.0;
15.863166666666668, 5983113395.0;
15.869833333333334, 5835746070.0;
15.876500000000002, 5562063895.0;
15.883166666666668, 5044173010.0;
15.889833333333334, 4261020940.0;
15.896500000000001, 3679972630.0;
15.903166666666667, 3326291050.0;
15.909833333333335, 3124187290.0;
15.916500000000001, 3031556400.0;
15.923166666666669, 2947346500.0;
15.929833333333335, 2909452045.0;
15.9365, 2602085910.0;
15.943166666666668, 2105247500.0;
15.949833333333334, 1616830080.0;
15.9565, 1107360185.0;
15.963166666666668, 892624940.0;
15.969833333333336, 728415635.0;
15.9765, 593679795.0;
15.983166666666667, 534732865.0;
15.989833333333335, 576837815.0;
15.996500000000003, 597890290.0;
16.003166666666665, 202103760.0;
16.009833333333333, -538943360.0;
16.0165, -1397884340.0;
16.023166666666665, -2244193835.0;
16.029833333333332, -2981030460.0;
16.0365, -3566289265.0;
16.043166666666664, -3894707875.0;
16.049833333333332, -4248389455.0;
16.0565, -4825227270.0;
16.063166666666667, -5886272010.0;
16.06983333333333, -7300998330.0;
16.0765, -8694672175.0;
16.083166666666667, -9999925625.0;
16.08983333333333, -11157811750.0;
16.0965, -12231487975.0;
16.103166666666667, -13073586975.0;
16.109833333333334, -13802002610.0;
16.1165, -14669364580.0;
16.123166666666666, -15823040210.0;
16.129833333333334, -17153556630.0;
16.136499999999998, -18745123740.0;
16.143166666666666, -20256691445.0;
16.149833333333333, -21502997965.0;
16.156499999999998, -22572463695.0;
16.163166666666665, -23570351010.0;
16.169833333333333, -24745079115.0;
16.1765, -25490336730.0;
16.183166666666665, -26126121475.0;
16.189833333333333, -26879800080.0;
16.1965, -27936634325.0;
16.203166666666664, -29052415500.0;
16.209833333333332, -29923987965.0;
16.2165, -30841875875.0;
16.223166666666668, -31806079230.0;
16.229833333333332, -32673441200.0;
16.2365, -33157648125.0;
16.243166666666667, -33355541390.0;
16.24983333333333, -33473435250.0;
16.2565, -33599750100.0;
16.263166666666667, -33486066735.0;
16.269833333333334, -33182911095.0;
16.2765, -32888176445.0;
16.283166666666666, -32837650505.0;
16.289833333333334, -32774493080.0;
16.296499999999998, -32715546150.0;
16.303166666666666, -32761861595.0;
16.309833333333334, -32833440010.0;
16.316499999999998, -33203963570.0;
16.323166666666665, -33553434655.0;
16.329833333333333, -34075536035.0;
16.3365, -34323955240.0;
16.343166666666665, -34585005930.0;
16.349833333333333, -35035528895.0;
16.3565, -35212369685.0;
16.363166666666665, -35195527705.0;
16.369833333333332, -35060791865.0;
16.3765, -35300790080.0;
16.383166666666668, -35540788295.0;
16.389833333333332, -35793417995.0;
16.3965, -35835522945.0;
16.403166666666667, -35784997005.0;
16.40983333333333, -35334474040.0;
16.4165, -34749215235.0;
16.423166666666667, -34185008905.0;
16.42983333333333, -33473435250.0;
16.4365, -33010280800.0;
16.443166666666666, -32711335655.0;
16.449833333333334, -32715546150.0;
16.4565, -32782914070.0;
16.463166666666666, -32681862190.0;
16.469833333333334, -32530284370.0;
16.476499999999998, -32054498435.0;
16.483166666666666, -31351345770.0;
16.489833333333333, -30597667165.0;
16.4965, -29612411335.0;
16.503166666666665, -28711365405.0;
16.509833333333333, -27810319475.0;
16.5165, -27439795915.0;
16.523166666666665, -27380848985.0;
16.529833333333332, -27406111955.0;
16.5365, -27347165025.0;
16.543166666666664, -27208218690.0;
16.549833333333332, -27233481660.0;
16.5565, -26997693940.0;
16.563166666666667, -26610328400.0;
16.56983333333333, -25886123260.0;
16.5765, -25334548415.0;
16.583166666666667, -24985077330.0;
16.58983333333333, -24538764860.0;
16.5965, -23915611600.0;
16.603166666666667, -22959829235.0;
16.609833333333334, -22084046275.0;
16.6165, -21393525095.0;
16.623166666666666, -20959844110.0;
16.629833333333334, -20783003320.0;
16.636499999999998, -20677740945.0;
16.643166666666666, -20572478570.0;
16.649833333333333, -20509321145.0;
16.6565, -20231428475.0;
16.663166666666665, -19595643730.0;
16.669833333333333, -18778807700.0;
16.6765, -18265127310.0;
16.683166666666665, -18197759390.0;
16.689833333333333, -18096707510.0;
16.6965, -17667237020.0;
16.703166666666664, -17153556630.0;
16.709833333333332, -16787243565.0;
16.7165, -16319878620.0;
16.723166666666668, -15566200015.0;
16.729833333333332, -14585154680.0;
16.7365, -14025158845.0;
16.743166666666667, -13625161820.0;
16.74983333333333, -13279901230.0;
16.7565, -12787273315.0;
16.763166666666667, -12345171340.0;
16.769833333333334, -12214645995.0;
16.7765, -11844122435.0;
16.783166666666666, -11498861845.0;
16.789833333333334, -10884129575.0;
16.796499999999998, -10395712155.0;
16.803166666666666, -10046241070.0;
16.809833333333334, -9835716320.0;
16.816499999999998, -10004136120.0;
16.823166666666665, -10265186810.0;
16.829833333333333, -10534658490.0;
16.8365, -10669394330.0;
16.843166666666665, -10509395520.0;
16.849833333333333, -10008346615.0;
16.8565, -9103090190.0;
16.863166666666665, -8235728220.0;
16.869833333333332, -7780994760.0;
16.8765, -7595732980.0;
16.883166666666668, -7519944070.0;
16.889833333333332, -7583101495.0;
16.8965, -7802047235.0;
16.903166666666667, -7772573770.0;
16.90983333333333, -7162051995.0;
16.9165, -6425215370.0;
16.923166666666667, -5751536170.0;
16.92983333333333, -5128382910.0;
16.9365, -4353651830.0;
16.943166666666666, -3637867680.0;
16.949833333333334, -3258923130.0;
16.9565, -2850505115.0;
16.963166666666666, -2686295810.0;
16.969833333333334, -2669453830.0;
16.976499999999998, -3119976795.0;
16.983166666666666, -3633657185.0;
16.989833333333333, -3856813420.0;
16.9965, -3726288075.0;
17.003166666666665, -3452605900.0;
17.009833333333333, -3267344120.0;
17.0165, -3010503925.0;
17.023166666666665, -2631559375.0;
17.029833333333332, -2130510470.0;
17.0365, -1823144335.0;
17.043166666666664, -1444199785.0;
17.049833333333332, -1056834245.0;
17.0565, -374734055.0;
17.063166666666667, 218945740.0;
17.06983333333333, 421049500.0;
17.0765, 277892670.0;
17.083166666666667, -42104950.0;
17.08983333333333, -63157425.0;
17.0965, -155788315.0;
17.103166666666667, -75788910.0;
17.109833333333334, 29473465.0;
17.1165, 408418015.0;
17.123166666666666, 947361375.0;
17.129833333333334, 1334726915.0;
17.136499999999998, 1583146120.0;
17.143166666666666, 1545251665.0;
17.149833333333333, 1654724535.0;
17.1565, 1797881365.0;
17.163166666666665, 2021037600.0;
17.169833333333333, 2336824725.0;
17.1765, 2635769870.0;
17.183166666666665, 2985240955.0;
17.189833333333333, 3187344715.0;
17.1965, 3317870060.0;
17.203166666666664, 3317870060.0;
17.209833333333332, 3355764515.0;
17.2165, 3448395405.0;
17.223166666666668, 3591552235.0;
17.229833333333332, 3519973820.0;
17.2365, 3157871250.0;
17.243166666666667, 2732611255.0;
17.24983333333333, 2530507495.0;
17.2565, 2871557590.0;
17.263166666666667, 3275765110.0;
17.269833333333334, 3726288075.0;
17.2765, 4303125890.0;
17.283166666666666, 5056804495.0;
17.289833333333334, 5583116370.0;
17.296499999999998, 5528379935.0;
17.303166666666666, 5469433005.0;
17.309833333333334, 5823114585.0;
17.316499999999998, 6286269035.0;
17.323166666666665, 6387320915.0;
17.329833333333333, 6265216560.0;
17.3365, 6202059135.0;
17.343166666666665, 6303111015.0;
17.349833333333333, 6252585075.0;
17.3565, 6193638145.0;
17.363166666666665, 6370478935.0;
17.369833333333332, 6677845070.0;
17.3765, 7098894570.0;
17.383166666666668, 7347313775.0;
17.389833333333332, 7620995950.0;
17.3965, 8109413370.0;
17.403166666666667, 8534673365.0;
17.40983333333333, 8791513560.0;
17.4165, 8917828410.0;
17.423166666666667, 9124142665.0;
17.42983333333333, 9410456325.0;
17.4365, 9393614345.0;
17.443166666666666, 9284141475.0;
17.449833333333334, 9322035930.0;
17.4565, 9305193950.0;
17.463166666666666, 9199931575.0;
17.469833333333334, 8989406825.0;
17.476499999999998, 8980985835.0;
17.483166666666666, 9338877910.0;
17.489833333333333, 9519929195.0;
17.4965, 9776769390.0;
17.503166666666665, 10054662060.0;
17.509833333333333, 10522027005.0;
17.5165, 10884129575.0;
17.523166666666665, 11086233335.0;
17.529833333333332, 11616755705.0;
17.5365, 12168330550.0;
17.543166666666668, 12391486785.0;
17.549833333333332, 12374644805.0;
17.5565, 12340960845.0;
17.563166666666667, 12484117675.0;
17.56983333333333, 12589380050.0;
17.5765, 12665168960.0;
17.583166666666667, 12799904800.0;
17.58983333333333, 12846220245.0;
17.5965, 12922009155.0;
17.603166666666667, 12972535095.0;
17.609833333333334, 12926219650.0;
17.6165, 12972535095.0;
17.623166666666666, 13220954300.0;
17.629833333333334, 13246217270.0;
17.636499999999998, 13423058060.0;
17.643166666666666, 13987264390.0;
17.649833333333333, 14951467745.0;
17.6565, 15797777240.0;
17.663166666666665, 16214616245.0;
17.669833333333333, 16909347920.0;
17.6765, 17625132070.0;
17.683166666666665, 17852498800.0;
17.689833333333333, 17583027120.0;
17.6965, 17103030690.0;
17.703166666666664, 17216714055.0;
17.709833333333332, 17667237020.0;
17.7165, 18020918600.0;
17.723166666666668, 18311442755.0;
17.729833333333332, 18597756415.0;
17.7365, 19183015220.0;
17.743166666666667, 19616696205.0;
17.74983333333333, 19599854225.0;
17.7565, 19330382545.0;
17.763166666666667, 18917754035.0;
17.769833333333334, 19018805915.0;
17.7765, 19115647300.0;
17.783166666666666, 19389329475.0;
17.789833333333334, 19890378380.0;
17.796499999999998, 20627215005.0;
17.803166666666666, 21507208460.0;
17.809833333333334, 21945099940.0;
17.816499999999998, 22597726665.0;
17.823166666666665, 23111407055.0;
17.829833333333333, 23296668835.0;
17.8365, 23528246060.0;
17.843166666666665, 23801928235.0;
17.849833333333333, 24374555555.0;
17.8565, 24606132780.0;
17.863166666666665, 24841920500.0;
17.869833333333332, 25368232375.0;
17.8765, 25772439895.0;
17.883166666666668, 26210331375.0;
17.889833333333332, 26656643845.0;
17.8965, 27351375520.0;
17.903166666666667, 28050317690.0;
17.90983333333333, 28420841250.0;
17.9165, 28812417285.0;
17.923166666666667, 29418728565.0;
17.92983333333333, 29978724400.0;
17.9365, 30197670140.0;
17.943166666666666, 30256617070.0;
17.949833333333334, 30778718450.0;
17.9565, 31431345175.0;
17.963166666666666, 31797658240.0;
17.969833333333334, 31915552100.0;
17.976499999999998, 32248181205.0;
17.983166666666666, 32808177040.0;
17.989833333333333, 33182911095.0;
17.9965, 33460803765.0;
18.003166666666665, 33667118020.0;
18.009833333333333, 33839748315.0;
18.0165, 34079746530.0;
18.023166666666665, 34395533655.0;
18.029833333333332, 35001844935.0;
18.0365, 35730260570.0;
18.043166666666668, 36736568875.0;
18.049833333333332, 37848139555.0;
18.0565, 38732343505.0;
18.063166666666667, 39229181915.0;
18.06983333333333, 39149182510.0;
18.0765, 38824974395.0;
18.083166666666667, 38349188460.0;
18.08983333333333, 38273399550.0;
18.0965, 38530239745.0;
18.103166666666667, 39144972015.0;
18.109833333333334, 40020754975.0;
18.1165, 40917590410.0;
18.123166666666666, 41696531985.0;
18.129833333333334, 41869162280.0;
18.136499999999998, 41835478320.0;
18.143166666666666, 41507059710.0;
18.149833333333333, 41406007830.0;
18.1565, 41486007235.0;
18.163166666666665, 41856530795.0;
18.169833333333333, 42513368015.0;
18.1765, 42968101475.0;
18.183166666666665, 43313362065.0;
18.189833333333333, 43224941670.0;
18.1965, 42854418110.0;
18.203166666666664, 42252317325.0;
18.209833333333332, 41675479510.0;
18.2165, 41481796740.0;
18.223166666666668, 41448112780.0;
18.229833333333332, 41418639315.0;
18.2365, 41123904665.0;
18.243166666666667, 40833380510.0;
18.24983333333333, 40429172990.0;
18.2565, 39827072205.0;
18.263166666666667, 39254444885.0;
18.269833333333334, 38829184890.0;
18.2765, 38728133010.0;
18.283166666666666, 38504976775.0;
18.289833333333334, 38235505095.0;
18.296499999999998, 38008138365.0;
18.303166666666666, 37877613020.0;
18.309833333333334, 37704982725.0;
18.316499999999998, 37144986890.0;
18.323166666666665, 36222888485.0;
18.329833333333333, 35178685725.0;
18.3365, 34142903955.0;
18.343166666666665, 33014491295.0;
18.349833333333333, 31810289725.0;
18.3565, 30972401220.0;
18.363166666666665, 30601877660.0;
18.369833333333332, 30218722615.0;
18.3765, 29486096485.0;
18.383166666666668, 28698733920.0;
18.389833333333332, 28054528185.0;
18.3965, 27284007600.0;
18.403166666666667, 26252436325.0;
18.40983333333333, 25250338515.0;
18.4165, 24555606840.0;
18.423166666666667, 23894559125.0;
18.429833333333335, 23018776165.0;
18.4365, 22016678355.0;
18.443166666666666, 21136684900.0;
18.449833333333334, 20673530450.0;
18.4565, 20353532830.0;
18.463166666666666, 19953535805.0;
18.469833333333334, 19587222740.0;
18.476499999999998, 19338803535.0;
18.483166666666666, 19132489280.0;
18.489833333333333, 18526178000.0;
18.4965, 17924077215.0;
18.503166666666665, 17663026525.0;
18.509833333333333, 17692499990.0;
18.5165, 17663026525.0;
18.523166666666665, 17330397420.0;
18.529833333333332, 16610402775.0;
18.5365, 15380938235.0;
18.543166666666668, 14147263200.0;
18.549833333333332, 13170428360.0;
18.5565, 12686221435.0;
18.563166666666667, 12564117080.0;
18.56983333333333, 12888325195.0;
18.5765, 13389374100.0;
18.583166666666667, 13654635285.0;
18.58983333333333, 13540951920.0;
18.5965, 13048324005.0;
18.603166666666667, 12378855300.0;
18.609833333333334, 11730439070.0;
18.6165, 11486230360.0;
18.623166666666666, 11204127195.0;
18.629833333333334, 10732551755.0;
18.636499999999998, 10168345425.0;
18.643166666666666, 9995715130.0;
18.649833333333333, 9957820675.0;
18.6565, 9671507015.0;
18.663166666666665, 9334667415.0;
18.669833333333333, 9115721675.0;
18.6765, 9132563655.0;
18.683166666666665, 8858881480.0;
18.689833333333333, 8420990000.0;
18.6965, 8050466440.0;
18.703166666666664, 7898888620.0;
18.709833333333332, 7987309015.0;
18.7165, 8063097925.0;
18.723166666666668, 8231517725.0;
18.729833333333332, 8408358515.0;
18.7365, 8593620295.0;
18.743166666666667, 8589409800.0;
18.74983333333333, 8265201685.0;
18.7565, 7823099710.0;
18.763166666666667, 7482049615.0;
18.769833333333334, 7225209420.0;
18.7765, 6631529625.0;
18.783166666666666, 5978902900.0;
18.789833333333334, 5646273795.0;
18.796499999999998, 5507327460.0;
18.803166666666666, 5132593405.0;
18.809833333333334, 4538913610.0;
18.8165, 4349441335.0;
18.823166666666665, 4551545095.0;
18.829833333333333, 4829437765.0;
18.8365, 4778911825.0;
18.843166666666665, 4618913015.0;
18.849833333333333, 4433651235.0;
18.8565, 4134706090.0;
18.863166666666665, 3932602330.0;
18.869833333333332, 3818918965.0;
18.8765, 3873655400.0;
18.883166666666668, 4235757970.0;
18.889833333333332, 4816806280.0;
18.8965, 5389433600.0;
18.903166666666667, 5389433600.0;
18.90983333333333, 4964173605.0;
18.9165, 4682070440.0;
18.923166666666667, 4408388265.0;
18.929833333333335, 4117864110.0;
18.9365, 3877865895.0;
18.943166666666666, 3755761540.0;
18.949833333333334, 3696814610.0;
18.9565, 3402079960.0;
18.963166666666666, 3111555805.0;
18.969833333333334, 2799979175.0;
18.976499999999998, 2597875415.0;
18.983166666666666, 2425245120.0;
18.989833333333333, 2345245715.0;
18.9965, 2311561755.0;
19.003166666666665, 2252614825.0;
19.009833333333333, 2227351855.0;
19.0165, 2033669085.0;
19.023166666666665, 1882091265.0;
19.029833333333332, 1688408495.0;
19.0365, 1625251070.0;
19.043166666666668, 1359989885.0;
19.049833333333332, 1086307710.0;
19.0565, 808415040.0;
19.063166666666667, 707363160.0;
19.06983333333333, 821046525.0;
19.0765, 955782365.0;
19.083166666666667, 1233675035.0;
19.08983333333333, 1595777605.0;
19.0965, 2071563540.0;
19.103166666666667, 2467350070.0;
19.109833333333334, 2564191455.0;
19.1165, 2458929080.0;
19.123166666666666, 2429455615.0;
19.129833333333334, 2172615420.0;
19.136499999999998, 1962090670.0;
19.143166666666666, 1743144930.0;
19.149833333333333, 1696829485.0;
19.1565, 1755776415.0;
19.163166666666665, 1675777010.0;
19.169833333333333, 1844196810.0;
19.1765, 1962090670.0;
19.183166666666665, 2012616610.0;
19.189833333333333, 2012616610.0;
19.1965, 1949459185.0;
19.203166666666664, 2176825915.0;
19.209833333333332, 2345245715.0;
19.2165, 2446297595.0;
19.223166666666668, 2298930270.0;
19.229833333333332, 2164194430.0;
19.2365, 1987353640.0;
19.243166666666667, 1709460970.0;
19.24983333333333, 1191570085.0;
19.2565, 568416825.0;
19.263166666666667, 353681580.0;
19.269833333333334, 206314255.0;
19.2765, 332629105.0;
19.283166666666666, 294734650.0;
19.289833333333334, 492627915.0;
19.296499999999998, 753678605.0;
19.303166666666666, 1052623750.0;
19.309833333333334, 1410515825.0;
19.3165, 1814723345.0;
19.323166666666665, 2168404925.0;
19.329833333333333, 2492613040.0;
19.3365, 2787347690.0;
19.343166666666665, 2682085315.0;
19.349833333333333, 2315772250.0;
19.3565, 1751565920.0;
19.363166666666665, 1490515230.0;
19.369833333333332, 1448410280.0;
19.3765, 1461041765.0;
19.383166666666668, 1806302355.0;
19.389833333333332, 2143141955.0;
19.3965, 2496823535.0;
19.403166666666667, 2648401355.0;
19.40983333333333, 2458929080.0;
19.4165, 2202088885.0;
19.423166666666667, 1844196810.0;
19.429833333333335, 1482094240.0;
19.4365, 947361375.0;
19.443166666666666, 585258805.0;
19.449833333333334, 724205140.0;
19.4565, 1115781175.0;
19.463166666666666, 1418936815.0;
19.469833333333334, 1629461565.0;
19.476499999999998, 1882091265.0;
19.483166666666666, 1962090670.0;
19.489833333333333, 1814723345.0;
19.4965, 1633672060.0;
19.503166666666665, 1414726320.0;
19.509833333333333, 1351568895.0;
19.5165, 1418936815.0;
19.523166666666665, 1696829485.0;
19.529833333333332, 1962090670.0;
19.5365, 1941038195.0;
19.543166666666668, 1936827700.0;
19.549833333333332, 1903143740.0;
19.5565, 1856828295.0;
19.563166666666667, 1713671465.0;
19.56983333333333, 1599988100.0;
19.5765, 1621040575.0;
19.583166666666667, 1524199190.0;
19.58983333333333, 1381042360.0;
19.5965, 1410515825.0;
19.603166666666667, 1532620180.0;
19.609833333333334, 1393673845.0;
19.6165, 985255830.0;
19.623166666666666, 774731080.0;
19.629833333333334, 871572465.0;
19.636499999999998, 1069465730.0;
19.643166666666666, 1141044145.0;
19.649833333333333, 1284200975.0;
19.6565, 1469462755.0;
19.663166666666665, 1557883150.0;
19.669833333333333, 1397884340.0;
19.6765, 1094728700.0;
19.683166666666665, 791573060.0;
19.689833333333333, 555785340.0;
19.6965, 614732270.0;
19.703166666666668, 959992860.0;
19.709833333333332, 1448410280.0;
19.7165, 1692618990.0;
19.723166666666668, 1726302950.0;
19.729833333333332, 1498936220.0;
19.7365, 1107360185.0;
19.743166666666667, 728415635.0;
19.74983333333333, 534732865.0;
19.7565, 568416825.0;
19.763166666666667, 496838410.0;
19.769833333333334, 732626130.0;
19.7765, 1065255235.0;
19.783166666666666, 1216833055.0;
19.789833333333334, 1002097810.0;
19.796499999999998, 669468705.0;
19.803166666666666, 656837220.0;
19.809833333333334, 505259400.0;
19.8165, 370523560.0;
19.823166666666665, 181051285.0;
19.829833333333333, 286313660.0;
19.8365, 719994645.0;
19.843166666666665, 1044202760.0;
19.849833333333333, 1157886125.0;
19.8565, 774731080.0;
19.863166666666665, 454733460.0;
19.869833333333332, 105262375.0;
19.8765, -425259995.0;
19.883166666666668, -875782960.0;
19.889833333333332, -938940385.0;
19.8965, -547364350.0;
19.903166666666667, -197893265.0;
19.90983333333333, -58946930.0;
19.9165, -29473465.0;
19.923166666666667, 16841980.0;
19.929833333333335, -189472275.0;
19.9365, -345260590.0;
19.943166666666666, -421049500.0;
19.949833333333334, -185261780.0;
19.9565, 42104950.0;
##END=

$$ === CHEMSPECTRA INTEGRALS AND MULTIPLETS ===
##PAGE=400
##$OBSERVEDINTEGRALS= (X Y Z)
##$OBSERVEDMULTIPLETS=
##$OBSERVEDMULTIPLETSPEAKS=
##END=

$$ === CHEMSPECTRA PEAK TABLE EDIT ===
##TITLE=618becfe-a0ce-4983-ba36-5fdcbb7ed595
##JCAMP-DX=5.00
##DATA TYPE=LC/MSPEAKTABLE
##DATA CLASS=PEAKTABLE
##$CSCATEGORY=EDIT_PEAK
##$CSTHRESHOLD=0.05
##MAXX=19.9565
##MAXY=133481112490.0
##MINX=-0.0435
##MINY=-87696189860.0
##PAGE=400
##NPOINTS=0
##PEAKTABLE= (XY..XY)
##END=

$$ === CHEMSPECTRA PEAK TABLE AUTO ===
##TITLE=618becfe-a0ce-4983-ba36-5fdcbb7ed595
##JCAMP-DX=5.00
##DATA TYPE=LC/MSPEAKTABLE
##DATA CLASS=PEAKTABLE
##$CSCATEGORY=AUTO_PEAK
##$CSTHRESHOLD=0.05
##MAXX=19.9565
##MAXY=133481112490.0
##MINX=-0.0435
##MINY=-87696189860.0
##PAGE=400
##NPOINTS=92
##PEAKTABLE= (XY..XY)
1.2098333333333333, 133481112490.0
18.183166666666665, 43313362065.0
18.129833333333334, 41869162280.0
18.063166666666667, 39229181915.0
2.6298333333333335, 28172422045.0
2.8298333333333336, 23751402295.0
17.743166666666667, 19616696205.0
17.683166666666665, 17852498800.0
18.509833333333333, 17692499990.0
12.249833333333335, 14690417055.0
12.669833333333335, 14677785570.0
12.463166666666668, 14572523195.0
12.563166666666667, 14425155870.0
12.723166666666668, 14324103990.0
12.336500000000001, 14185157655.0
12.289833333333334, 13911475480.0
12.123166666666668, 13793581620.0
18.583166666666667, 13654635285.0
12.0165, 13406216080.0
3.043166666666667, 13372532120.0
2.9498333333333338, 13145165390.0
3.0165, 13094639450.0
17.603166666666667, 12972535095.0
12.769833333333334, 12884114700.0
12.183166666666667, 12863062225.0
11.989833333333335, 12833588760.0
2.989833333333334, 12724115890.0
17.543166666666668, 12391486785.0
11.763166666666667, 12286224410.0
11.923166666666667, 12197804015.0
12.849833333333335, 12134646590.0
11.609833333333334, 11355705015.0
11.889833333333334, 11258863630.0
11.723166666666668, 10804130170.0
13.043166666666668, 10652552350.0
12.976500000000001, 10399922650.0
11.823166666666667, 10265186810.0
11.463166666666668, 10244134335.0
11.543166666666668, 9797821865.0
12.949833333333334, 9595718105.0
17.42983333333333, 9410456325.0
11.669833333333335, 9351509395.0
17.449833333333334, 9322035930.0
14.656500000000001, 9254668010.0
18.6765, 9132563655.0
14.309833333333334, 8892565440.0
13.989833333333335, 8669409205.0
18.7365, 8593620295.0
11.283166666666668, 8429410990.0
11.236500000000001, 8269412180.0
15.803166666666668, 8122044855.0
13.556500000000002, 8084150400.0
11.209833333333334, 8054676935.0
15.203166666666668, 8004150995.0
13.109833333333334, 7911520105.0
15.2765, 7882046640.0
13.736500000000001, 7776784265.0
14.483166666666667, 7705205850.0
15.629833333333334, 7705205850.0
15.643166666666668, 7692574365.0
11.363166666666668, 7688363870.0
11.1765, 7671521890.0
15.683166666666668, 7633627435.0
14.603166666666668, 7620995950.0
14.709833333333334, 7591522485.0
11.023166666666668, 7578891000.0
11.109833333333334, 7528365060.0
15.169833333333335, 7515733575.0
14.069833333333335, 7477839120.0
15.549833333333334, 7439944665.0
10.863166666666668, 7423102685.0
13.903166666666667, 7414681695.0
11.156500000000001, 7397839715.0
13.296500000000002, 7364155755.0
14.249833333333335, 7355734765.0
14.376500000000002, 7338892785.0
10.929833333333335, 7288366845.0
15.0165, 7288366845.0
15.529833333333334, 7288366845.0
13.216500000000002, 7254682885.0
15.376500000000002, 7250472390.0
14.769833333333334, 7098894570.0
13.363166666666668, 7077842095.0
14.429833333333335, 7018895165.0
15.403166666666667, 6917843285.0
13.789833333333334, 6888369820.0
13.669833333333335, 6875738335.0
14.2765, 6854685860.0
15.456500000000002, 6812580910.0
15.583166666666667, 6791528435.0
13.1765, 6757844475.0
15.429833333333335, 6715739525.0
##END=


`;

export default lcMsUvvisChemstationJcamp;
